/* tslint:disable */
/* eslint-disable */
/**
 * Api Mext
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import type {ExtendedAxiosRequestConfig} from './common';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, setBearerAuthToFormData } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export const defaultExtendedAxiosRequestConfig : ExtendedAxiosRequestConfig = {extensions: {}}

/**
 * 
 * @export
 * @interface AccesoExternoIaGestionModel
 */
export interface AccesoExternoIaGestionModel {
    /**
     * 
     * @type {number}
     * @memberof AccesoExternoIaGestionModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof AccesoExternoIaGestionModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AccesoExternoIaGestionModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof AccesoExternoIaGestionModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof AccesoExternoIaGestionModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof AccesoExternoIaGestionModel
     */
    'Telefono': string;
}
/**
 * 
 * @export
 * @interface ActivateTramiteEnergiaModel
 */
export interface ActivateTramiteEnergiaModel {
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof ActivateTramiteEnergiaModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof ActivateTramiteEnergiaModel
     */
    'Comentario': string | null;
    /**
     * 
     * @type {number}
     * @memberof ActivateTramiteEnergiaModel
     */
    'Consumo': number | null;
    /**
     * 
     * @type {Date}
     * @memberof ActivateTramiteEnergiaModel
     */
    'FechaActivacion': Date;
}


/**
 * 
 * @export
 * @interface AddFacturaInmuebleModel
 */
export interface AddFacturaInmuebleModel {
    /**
     * 
     * @type {Date}
     * @memberof AddFacturaInmuebleModel
     */
    'Fecha': Date;
    /**
     * 
     * @type {number}
     * @memberof AddFacturaInmuebleModel
     */
    'Importe': number;
    /**
     * 
     * @type {string}
     * @memberof AddFacturaInmuebleModel
     */
    'RutaTemporal': string;
    /**
     * 
     * @type {TipoSuministroInmuebleEnum}
     * @memberof AddFacturaInmuebleModel
     */
    'TipoSuministro': TipoSuministroInmuebleEnum;
}


/**
 * 
 * @export
 * @interface AddLecturaInmuebleModel
 */
export interface AddLecturaInmuebleModel {
    /**
     * 
     * @type {Date}
     * @memberof AddLecturaInmuebleModel
     */
    'Fecha': Date;
    /**
     * 
     * @type {number}
     * @memberof AddLecturaInmuebleModel
     */
    'Lectura': number;
    /**
     * 
     * @type {number}
     * @memberof AddLecturaInmuebleModel
     */
    'Lectura2': number | null;
    /**
     * 
     * @type {number}
     * @memberof AddLecturaInmuebleModel
     */
    'Lectura3': number | null;
    /**
     * 
     * @type {TipoSuministroInmuebleEnum}
     * @memberof AddLecturaInmuebleModel
     */
    'TipoSuministro': TipoSuministroInmuebleEnum;
    /**
     * 
     * @type {Array<AdjuntoLecturaInmuebleModel>}
     * @memberof AddLecturaInmuebleModel
     */
    'Adjuntos': Array<AdjuntoLecturaInmuebleModel>;
}


/**
 * 
 * @export
 * @interface AddRelacionClienteInmobiliarioInmuebleModel
 */
export interface AddRelacionClienteInmobiliarioInmuebleModel {
    /**
     * 
     * @type {string}
     * @memberof AddRelacionClienteInmobiliarioInmuebleModel
     */
    'IdClienteInmobiliario': string;
    /**
     * 
     * @type {TipoRelacionClienteInmobiliarioEnum}
     * @memberof AddRelacionClienteInmobiliarioInmuebleModel
     */
    'TipoRelacion': TipoRelacionClienteInmobiliarioEnum;
    /**
     * 
     * @type {Date}
     * @memberof AddRelacionClienteInmobiliarioInmuebleModel
     */
    'FechaInicio': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AddRelacionClienteInmobiliarioInmuebleModel
     */
    'FechaFin': Date | null;
}


/**
 * 
 * @export
 * @interface AdjuntoComunicacionOperacionModel
 */
export interface AdjuntoComunicacionOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoComunicacionOperacionModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoComunicacionOperacionModel
     */
    'Url': string;
}
/**
 * 
 * @export
 * @interface AdjuntoLecturaInmuebleModel
 */
export interface AdjuntoLecturaInmuebleModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoLecturaInmuebleModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoLecturaInmuebleModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoLecturaInmuebleModel
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface AdjuntoMensajeModel
 */
export interface AdjuntoMensajeModel {
    /**
     * 
     * @type {string}
     * @memberof AdjuntoMensajeModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoMensajeModel
     */
    'Url': string;
}
/**
 * 
 * @export
 * @interface AgenteComunicadoListModel
 */
export interface AgenteComunicadoListModel {
    /**
     * 
     * @type {string}
     * @memberof AgenteComunicadoListModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof AgenteComunicadoListModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof AgenteComunicadoListModel
     */
    'Denominacion': string;
    /**
     * 
     * @type {boolean}
     * @memberof AgenteComunicadoListModel
     */
    'Leido': boolean;
    /**
     * 
     * @type {Date}
     * @memberof AgenteComunicadoListModel
     */
    'FechaLeido': Date | null;
}
/**
 * 
 * @export
 * @interface AgenteComunicadoListModelArrayResponseDTO
 */
export interface AgenteComunicadoListModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<AgenteComunicadoListModel>}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'Data'?: Array<AgenteComunicadoListModel>;
    /**
     * 
     * @type {any}
     * @memberof AgenteComunicadoListModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface AnexoEmpresaServiciosDetailDto
 */
export interface AnexoEmpresaServiciosDetailDto {
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'ContenidoHtml': string;
    /**
     * 
     * @type {Array<DefinicionVariableAnexoDto>}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'DefinicionVariables': Array<DefinicionVariableAnexoDto>;
    /**
     * 
     * @type {Date}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'FechaAlta': Date;
    /**
     * 
     * @type {Date}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'FechaUltModificacion': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnexoEmpresaServiciosDetailDto
     */
    'AsociadoEnOfertasOServicios': boolean;
}
/**
 * 
 * @export
 * @interface AnexoEmpresaServiciosDetailDtoResponseDTO
 */
export interface AnexoEmpresaServiciosDetailDtoResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {AnexoEmpresaServiciosDetailDto}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'Data'?: AnexoEmpresaServiciosDetailDto;
    /**
     * 
     * @type {any}
     * @memberof AnexoEmpresaServiciosDetailDtoResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface AnexoEmpresaServiciosForGridRm
 */
export interface AnexoEmpresaServiciosForGridRm {
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosForGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosForGridRm
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosForGridRm
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof AnexoEmpresaServiciosForGridRm
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof AnexoEmpresaServiciosForGridRm
     */
    'FechaAlta': Date;
    /**
     * 
     * @type {Date}
     * @memberof AnexoEmpresaServiciosForGridRm
     */
    'FechaUltModificacion': Date | null;
    /**
     * 
     * @type {number}
     * @memberof AnexoEmpresaServiciosForGridRm
     */
    'NumVariables': number;
}
/**
 * 
 * @export
 * @interface AplicarReajustesConceptosFacturaModel
 */
export interface AplicarReajustesConceptosFacturaModel {
    /**
     * 
     * @type {string}
     * @memberof AplicarReajustesConceptosFacturaModel
     */
    'Motivo': string;
    /**
     * 
     * @type {Array<LineaReajusteConceptoFacturaModel>}
     * @memberof AplicarReajustesConceptosFacturaModel
     */
    'ReajustesComision': Array<LineaReajusteConceptoFacturaModel>;
    /**
     * 
     * @type {Array<LineaReajusteConceptoFacturaModel>}
     * @memberof AplicarReajustesConceptosFacturaModel
     */
    'ReajustesRetrocomision': Array<LineaReajusteConceptoFacturaModel>;
}
/**
 * 
 * @export
 * @interface ArchivoBorradorOperacionModel
 */
export interface ArchivoBorradorOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradorOperacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradorOperacionModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradorOperacionModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradorOperacionModel
     */
    'Descripcion': string;
}
/**
 * 
 * @export
 * @interface ArchivoBorradoresOperacionModel
 */
export interface ArchivoBorradoresOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradoresOperacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradoresOperacionModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradoresOperacionModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoBorradoresOperacionModel
     */
    'Descripcion': string;
}
/**
 * 
 * @export
 * @interface ArchivoOperacionAguaModel
 */
export interface ArchivoOperacionAguaModel {
    /**
     * 
     * @type {string}
     * @memberof ArchivoOperacionAguaModel
     */
    'IdTipoDocumento': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoOperacionAguaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoOperacionAguaModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof ArchivoOperacionAguaModel
     */
    'Descripcion': string | null;
}
/**
 * 
 * @export
 * @interface AssignExternalIdOperacionEnergiaModel
 */
export interface AssignExternalIdOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof AssignExternalIdOperacionEnergiaModel
     */
    'IdExterno': string | null;
}
/**
 * 
 * @export
 * @interface AssignExternalIdTramiteEnergiaModel
 */
export interface AssignExternalIdTramiteEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof AssignExternalIdTramiteEnergiaModel
     */
    'IdExterno': string | null;
}
/**
 * 
 * @export
 * @interface BooleanResponseDTO
 */
export interface BooleanResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof BooleanResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof BooleanResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof BooleanResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof BooleanResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'Data'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof BooleanResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface BorradorTramiteModel
 */
export interface BorradorTramiteModel {
    /**
     * 
     * @type {string}
     * @memberof BorradorTramiteModel
     */
    'Tipo': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof BorradorTramiteModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum | null;
    /**
     * 
     * @type {TipoTramiteOperacionEnum}
     * @memberof BorradorTramiteModel
     */
    'TipoTramite': TipoTramiteOperacionEnum;
    /**
     * 
     * @type {string}
     * @memberof BorradorTramiteModel
     */
    'Cups': string | null;
    /**
     * 
     * @type {string}
     * @memberof BorradorTramiteModel
     */
    'Observaciones': string;
    /**
     * 
     * @type {string}
     * @memberof BorradorTramiteModel
     */
    'Iban': string | null;
}


/**
 * 
 * @export
 * @interface ClienteLatestInfoModel
 */
export interface ClienteLatestInfoModel {
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'Nombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'Apellidos': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'TelefonoFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'TelefonoMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'Nacionalidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'RazonSocial': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModel
     */
    'CIF': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof ClienteLatestInfoModel
     */
    'Direccion': DireccionModel;
}
/**
 * 
 * @export
 * @interface ClienteLatestInfoModelResponseDTO
 */
export interface ClienteLatestInfoModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ClienteLatestInfoModel}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'Data'?: ClienteLatestInfoModel;
    /**
     * 
     * @type {any}
     * @memberof ClienteLatestInfoModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CometidoAgenteInmobiliariaEnum = {
    Director: 'DIRECTOR',
    Coordinador: 'COORDINADOR',
    Agente: 'AGENTE'
} as const;

export type CometidoAgenteInmobiliariaEnum = typeof CometidoAgenteInmobiliariaEnum[keyof typeof CometidoAgenteInmobiliariaEnum];


/**
 * 
 * @export
 * @interface ComisionEnergiaOfertaModel
 */
export interface ComisionEnergiaOfertaModel {
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaOfertaModel
     */
    'Id': string | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionEnergiaOfertaModel
     */
    'Importe': number;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionEnergiaOfertaModel
     */
    'AplicaPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof ComisionEnergiaOfertaModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionEnergiaOfertaModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionEnergiaOfertaModel
     */
    'AplicaConsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof ComisionEnergiaOfertaModel
     */
    'ConsumoMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionEnergiaOfertaModel
     */
    'ConsumoMax': number | null;
    /**
     * 
     * @type {TipoTramiteComisionEnergiaEnum}
     * @memberof ComisionEnergiaOfertaModel
     */
    'IdTipoTramite': TipoTramiteComisionEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaOfertaModel
     */
    'IdMarcoComisiones': string;
}


/**
 * 
 * @export
 * @interface ComisionEnergiaOfertaModelIListResponseDTO
 */
export interface ComisionEnergiaOfertaModelIListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ComisionEnergiaOfertaModel>}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'Data'?: Array<ComisionEnergiaOfertaModel>;
    /**
     * 
     * @type {any}
     * @memberof ComisionEnergiaOfertaModelIListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ComisionEnergiaServicioModel
 */
export interface ComisionEnergiaServicioModel {
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaServicioModel
     */
    'Id': string | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionEnergiaServicioModel
     */
    'Importe': number;
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaServicioModel
     */
    'IdMarcoComisiones': string;
}
/**
 * 
 * @export
 * @interface ComisionEnergiaServicioModelIListResponseDTO
 */
export interface ComisionEnergiaServicioModelIListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ComisionEnergiaServicioModel>}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'Data'?: Array<ComisionEnergiaServicioModel>;
    /**
     * 
     * @type {any}
     * @memberof ComisionEnergiaServicioModelIListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ComisionOfertaEnergiaBackofficeListItemModel
 */
export interface ComisionOfertaEnergiaBackofficeListItemModel {
    /**
     * 
     * @type {string}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoTramiteComisionEnergiaEnum}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'TipoTramite': TipoTramiteComisionEnergiaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'AplicaPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'AplicaConsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'ConsumoMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'ConsumoMax': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'ImporteBase': number;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'PorcentajeReajusteMarco': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'ImporteReajusteOferta': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaBackofficeListItemModel
     */
    'ImporteTotal': number;
}


/**
 * 
 * @export
 * @interface ComisionOfertaEnergiaColaboradoresListItemModel
 */
export interface ComisionOfertaEnergiaColaboradoresListItemModel {
    /**
     * 
     * @type {TipoTramiteComisionEnergiaEnum}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'TipoTramite': TipoTramiteComisionEnergiaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'AplicaPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'AplicaConsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'ConsumoMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'ConsumoMax': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionOfertaEnergiaColaboradoresListItemModel
     */
    'Importe': number;
}


/**
 * 
 * @export
 * @interface ComisionServicioEnergiaBackofficeListItemModel
 */
export interface ComisionServicioEnergiaBackofficeListItemModel {
    /**
     * 
     * @type {string}
     * @memberof ComisionServicioEnergiaBackofficeListItemModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ComisionServicioEnergiaBackofficeListItemModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof ComisionServicioEnergiaBackofficeListItemModel
     */
    'ImporteBase': number;
    /**
     * 
     * @type {number}
     * @memberof ComisionServicioEnergiaBackofficeListItemModel
     */
    'PorcentajeReajusteMarco': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionServicioEnergiaBackofficeListItemModel
     */
    'ImporteReajusteServicio': number | null;
    /**
     * 
     * @type {number}
     * @memberof ComisionServicioEnergiaBackofficeListItemModel
     */
    'ImporteTotal': number;
}
/**
 * 
 * @export
 * @interface ComisionServicioEnergiaColaboradoresListItemModel
 */
export interface ComisionServicioEnergiaColaboradoresListItemModel {
    /**
     * 
     * @type {string}
     * @memberof ComisionServicioEnergiaColaboradoresListItemModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof ComisionServicioEnergiaColaboradoresListItemModel
     */
    'Importe': number;
}
/**
 * 
 * @export
 * @interface ComisionSimuladaOfertaItemModel
 */
export interface ComisionSimuladaOfertaItemModel {
    /**
     * 
     * @type {string}
     * @memberof ComisionSimuladaOfertaItemModel
     */
    'IdOferta': string;
    /**
     * 
     * @type {number}
     * @memberof ComisionSimuladaOfertaItemModel
     */
    'ComisionTotal': number | null;
}
/**
 * 
 * @export
 * @interface ComunicacionOperacionModel
 */
export interface ComunicacionOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof ComunicacionOperacionModel
     */
    'Creador': string;
    /**
     * 
     * @type {Date}
     * @memberof ComunicacionOperacionModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof ComunicacionOperacionModel
     */
    'Formato': string;
    /**
     * 
     * @type {string}
     * @memberof ComunicacionOperacionModel
     */
    'Contenido': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComunicacionOperacionModel
     */
    'RutasAdjuntos': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ComunicacionOperacionModel
     */
    'LeidoPorRolContrario': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComunicacionOperacionModel
     */
    'EsComunicacionSistema': boolean;
}
/**
 * 
 * @export
 * @interface ComunicacionesOperacionModel
 */
export interface ComunicacionesOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof ComunicacionesOperacionModel
     */
    'IdOperacion': string;
    /**
     * 
     * @type {Array<ComunicacionOperacionModel>}
     * @memberof ComunicacionesOperacionModel
     */
    'Comunicaciones': Array<ComunicacionOperacionModel>;
}
/**
 * 
 * @export
 * @interface ComunicacionesOperacionModelResponseDTO
 */
export interface ComunicacionesOperacionModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ComunicacionesOperacionModel}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'Data'?: ComunicacionesOperacionModel;
    /**
     * 
     * @type {any}
     * @memberof ComunicacionesOperacionModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ConceptoEnergiaFacturaGridRm
 */
export interface ConceptoEnergiaFacturaGridRm {
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'IdOperacion': string;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'IdTramite': string;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'IdServicioIncluido': string | null;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'IdFactura': string;
    /**
     * 
     * @type {number}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'CodigoSecuencial': number;
    /**
     * 
     * @type {Date}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'FechaActivacion': Date;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'CodigoEstadoLiquidacion': string;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'DocumentoTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'DireccionTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'Cups': string | null;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'IdTipoSuministro': string;
    /**
     * 
     * @type {number}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'Comision': number | null;
    /**
     * 
     * @type {number}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'Retrocomision': number | null;
    /**
     * 
     * @type {number}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'ComisionEfectiva': number | null;
    /**
     * 
     * @type {number}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'RetrocomisionEfectiva': number | null;
    /**
     * 
     * @type {number}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'ReajusteComision': number | null;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'MotivoReajusteComision': string | null;
    /**
     * 
     * @type {number}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'ReajusteRetrocomision': number | null;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'MotivoReajusteRetrocomision': string | null;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'TipoConcepto': string;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'NombreTramite': string;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'Comercializadora': string;
    /**
     * 
     * @type {string}
     * @memberof ConceptoEnergiaFacturaGridRm
     */
    'NombreAgente': string;
}
/**
 * 
 * @export
 * @interface ConsultaLecturaComunicadoAgenteModel
 */
export interface ConsultaLecturaComunicadoAgenteModel {
    /**
     * 
     * @type {string}
     * @memberof ConsultaLecturaComunicadoAgenteModel
     */
    'Email': string;
    /**
     * 
     * @type {EstadoLecturaComunicadoAgenteEnum}
     * @memberof ConsultaLecturaComunicadoAgenteModel
     */
    'EstadoLectura': EstadoLecturaComunicadoAgenteEnum;
    /**
     * 
     * @type {Date}
     * @memberof ConsultaLecturaComunicadoAgenteModel
     */
    'FechaLeido': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConsultaLecturaComunicadoAgenteModel
     */
    'LecturaVerificable': boolean;
}


/**
 * 
 * @export
 * @interface ConsultaLecturaComunicadoAgenteModelResponseDTO
 */
export interface ConsultaLecturaComunicadoAgenteModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ConsultaLecturaComunicadoAgenteModel}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'Data'?: ConsultaLecturaComunicadoAgenteModel;
    /**
     * 
     * @type {any}
     * @memberof ConsultaLecturaComunicadoAgenteModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CoordenadaFirma
 */
export interface CoordenadaFirma {
    /**
     * 
     * @type {number}
     * @memberof CoordenadaFirma
     */
    'Pagina': number;
    /**
     * 
     * @type {number}
     * @memberof CoordenadaFirma
     */
    'X': number;
    /**
     * 
     * @type {number}
     * @memberof CoordenadaFirma
     */
    'Y': number;
}
/**
 * 
 * @export
 * @interface CreateAgenteInmobiliariaModel
 */
export interface CreateAgenteInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {CometidoAgenteInmobiliariaEnum}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'IdCometido': CometidoAgenteInmobiliariaEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAgenteInmobiliariaModel
     */
    'IdsDelegacionInmobiliaria': Array<string> | null;
}


/**
 * 
 * @export
 * @interface CreateAgenteModel
 */
export interface CreateAgenteModel {
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgenteModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof CreateAgenteModel
     */
    'Direccion': DireccionModel;
}
/**
 * 
 * @export
 * @interface CreateAnexoEmpresaServiciosDto
 */
export interface CreateAnexoEmpresaServiciosDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAnexoEmpresaServiciosDto
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAnexoEmpresaServiciosDto
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAnexoEmpresaServiciosDto
     */
    'ContenidoHtml': string;
    /**
     * 
     * @type {Array<DefinicionVariableAnexoDto>}
     * @memberof CreateAnexoEmpresaServiciosDto
     */
    'DefinicionVariables': Array<DefinicionVariableAnexoDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateAnexoEmpresaServiciosDto
     */
    'IdEmpresaServicios': string;
}
/**
 * 
 * @export
 * @interface CreateBorradoresOperacionModel
 */
export interface CreateBorradoresOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateBorradoresOperacionModel
     */
    'IdInmueble': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBorradoresOperacionModel
     */
    'IdCliente': string;
    /**
     * 
     * @type {Array<BorradorTramiteModel>}
     * @memberof CreateBorradoresOperacionModel
     */
    'Tramites': Array<BorradorTramiteModel>;
    /**
     * 
     * @type {Array<ArchivoBorradoresOperacionModel>}
     * @memberof CreateBorradoresOperacionModel
     */
    'Archivos': Array<ArchivoBorradoresOperacionModel>;
}
/**
 * 
 * @export
 * @interface CreateClienteInmobiliarioModel
 */
export interface CreateClienteInmobiliarioModel {
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof CreateClienteInmobiliarioModel
     */
    'TipoPersona': TipoPersonaEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'RazonSocial': string | null;
    /**
     * 
     * @type {SubtipoPersonaEnum}
     * @memberof CreateClienteInmobiliarioModel
     */
    'SubtipoPersona': SubtipoPersonaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'CIF': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'RutaDocumento': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'TelFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'TelMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'IbanPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'NombrePago': string | null;
    /**
     * 
     * @type {TipoDocumentoEnum}
     * @memberof CreateClienteInmobiliarioModel
     */
    'TipoDocumentoPago': TipoDocumentoEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'DocumentoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClienteInmobiliarioModel
     */
    'ApellidosPago': string | null;
}


/**
 * 
 * @export
 * @interface CreateComisionEnergiaOfertaModel
 */
export interface CreateComisionEnergiaOfertaModel {
    /**
     * 
     * @type {number}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'Importe': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'AplicaPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'AplicaConsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'ConsumoMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'ConsumoMax': number | null;
    /**
     * 
     * @type {TipoTramiteComisionEnergiaEnum}
     * @memberof CreateComisionEnergiaOfertaModel
     */
    'IdTipoTramite': TipoTramiteComisionEnergiaEnum;
}


/**
 * 
 * @export
 * @interface CreateComisionEnergiaServicioModel
 */
export interface CreateComisionEnergiaServicioModel {
    /**
     * 
     * @type {number}
     * @memberof CreateComisionEnergiaServicioModel
     */
    'Importe': number;
}
/**
 * 
 * @export
 * @interface CreateComparacionEnergiaResponse
 */
export interface CreateComparacionEnergiaResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateComparacionEnergiaResponse
     */
    'Id': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof CreateComparacionEnergiaResponse
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
}


/**
 * 
 * @export
 * @interface CreateComparacionEnergiaResponseResponseDTO
 */
export interface CreateComparacionEnergiaResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {CreateComparacionEnergiaResponse}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'Data'?: CreateComparacionEnergiaResponse;
    /**
     * 
     * @type {any}
     * @memberof CreateComparacionEnergiaResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CreateComunicacionOperacionModel
 */
export interface CreateComunicacionOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateComunicacionOperacionModel
     */
    'Contenido': string;
    /**
     * 
     * @type {string}
     * @memberof CreateComunicacionOperacionModel
     */
    'Formato': string;
    /**
     * 
     * @type {Array<AdjuntoComunicacionOperacionModel>}
     * @memberof CreateComunicacionOperacionModel
     */
    'Adjuntos': Array<AdjuntoComunicacionOperacionModel>;
}
/**
 * 
 * @export
 * @interface CreateContactoLeadModel
 */
export interface CreateContactoLeadModel {
    /**
     * 
     * @type {string}
     * @memberof CreateContactoLeadModel
     */
    'name_1': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactoLeadModel
     */
    'phone_1': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactoLeadModel
     */
    'hidden_1': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactoLeadModel
     */
    'hidden_2': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactoLeadModel
     */
    'hidden_3': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactoLeadModel
     */
    'entry_time': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactoLeadModel
     */
    'form_type': string | null;
}
/**
 * 
 * @export
 * @interface CreateCriterioRetrocomisionEnergiaModel
 */
export interface CreateCriterioRetrocomisionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateCriterioRetrocomisionEnergiaModel
     */
    'IdGrupo': string;
    /**
     * 
     * @type {TipoConceptoCriterioRetrocomisionEnergiaEnum}
     * @memberof CreateCriterioRetrocomisionEnergiaModel
     */
    'TipoConcepto': TipoConceptoCriterioRetrocomisionEnergiaEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateCriterioRetrocomisionEnergiaModel
     */
    'PeriodoHasta': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCriterioRetrocomisionEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCriterioRetrocomisionEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCriterioRetrocomisionEnergiaModel
     */
    'TarifaAcceso': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCriterioRetrocomisionEnergiaModel
     */
    'Importe': number;
}


/**
 * 
 * @export
 * @interface CreateDelegacionInmobiliariaModel
 */
export interface CreateDelegacionInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'IdEmpresaInmobiliaria': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'Web': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDelegacionInmobiliariaModel
     */
    'Coordinadores': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateEmpresaColaboradoraModel
 */
export interface CreateEmpresaColaboradoraModel {
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {FormaJuridicaEnum}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'FormaJuridica': FormaJuridicaEnum | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'PorcentajeIrpf': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'DiasAutofacturacion': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'ImagenB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'DenoFactura': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'TieneWhitelistServicios': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'WhitelistServicios': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'MarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'LogoPortalB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'UsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'IdComercial': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaColaboradoraModel
     */
    'IdSubtipo': string | null;
}


/**
 * 
 * @export
 * @interface CreateEmpresaInmobiliariaModel
 */
export interface CreateEmpresaInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {FormaJuridicaEnum}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'FormaJuridica': FormaJuridicaEnum | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'PorcentajeIrpf': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'DiasAutofacturacion': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'ImagenB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'DenoFactura': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'TieneWhitelistServicios': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'WhitelistServicios': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'MarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'LogoPortalB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'UsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'IdComercial': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmpresaInmobiliariaModel
     */
    'PuedeTramitarAgua': boolean;
}


/**
 * 
 * @export
 * @interface CreateEmpresaServiciosModel
 */
export interface CreateEmpresaServiciosModel {
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaServiciosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoEmpresaServiciosEnum}
     * @memberof CreateEmpresaServiciosModel
     */
    'Tipo': TipoEmpresaServiciosEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaServiciosModel
     */
    'DireccionContacto': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaServiciosModel
     */
    'NombreContacto': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaServiciosModel
     */
    'TelContacto': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaServiciosModel
     */
    'EmailContacto': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmpresaServiciosModel
     */
    'ImagenB64': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmpresaServiciosModel
     */
    'Activado': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmpresaServiciosModel
     */
    'IdsGestoresSoporte': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateEmpresaServiciosModel
     */
    'IdEsave': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmpresaServiciosModel
     */
    'SincronizaEsave': boolean | null;
    /**
     * 
     * @type {GrupoEmpresaEnergiaEnum}
     * @memberof CreateEmpresaServiciosModel
     */
    'IdGrupoEmpresa': GrupoEmpresaEnergiaEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmpresaServiciosModel
     */
    'RequiereConsentimientoPrevio': boolean;
    /**
     * 
     * @type {PlantillaConsentimientoPrevioEnum}
     * @memberof CreateEmpresaServiciosModel
     */
    'IdPlantillaConsentimiento': PlantillaConsentimientoPrevioEnum | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateEmpresaServiciosModel
     */
    'CodigosProvinciaDondeOpera': Array<number> | null;
}


/**
 * 
 * @export
 * @interface CreateFacturaModel
 */
export interface CreateFacturaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateFacturaModel
     */
    'CodigoBorrador': string;
    /**
     * 
     * @type {Date}
     * @memberof CreateFacturaModel
     */
    'FechaEmision': Date;
    /**
     * 
     * @type {string}
     * @memberof CreateFacturaModel
     */
    'IbanEmisor': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacturaModel
     */
    'NombreEmisor': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacturaModel
     */
    'NifEmisor': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof CreateFacturaModel
     */
    'DireccionEmisor': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof CreateFacturaModel
     */
    'Notas': string | null;
    /**
     * 
     * @type {Array<LiquidacionFacturaModel>}
     * @memberof CreateFacturaModel
     */
    'Liquidaciones': Array<LiquidacionFacturaModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFacturaModel
     */
    'RappelsMensuales': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateFacturaModel
     */
    'RutaTemporalFacturaPropia': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFacturaModel
     */
    'CodigoGestionadoPorColaborador': boolean;
}
/**
 * 
 * @export
 * @interface CreateGrupoCriterioRetrocomisionEnergiaModel
 */
export interface CreateGrupoCriterioRetrocomisionEnergiaModel {
    /**
     * 
     * @type {Date}
     * @memberof CreateGrupoCriterioRetrocomisionEnergiaModel
     */
    'FechaInicio': Date;
}
/**
 * 
 * @export
 * @interface CreateInmuebleModel
 */
export interface CreateInmuebleModel {
    /**
     * 
     * @type {TipoInmuebleEnum}
     * @memberof CreateInmuebleModel
     */
    'TipoInmueble': TipoInmuebleEnum;
    /**
     * 
     * @type {TipoObraEnum}
     * @memberof CreateInmuebleModel
     */
    'TipoObra': TipoObraEnum;
    /**
     * 
     * @type {DireccionModel}
     * @memberof CreateInmuebleModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {TipoCalentadorEnum}
     * @memberof CreateInmuebleModel
     */
    'TipoCalentador': TipoCalentadorEnum;
    /**
     * 
     * @type {TipoCocinaEnum}
     * @memberof CreateInmuebleModel
     */
    'TipoCocina': TipoCocinaEnum;
    /**
     * 
     * @type {TipoCalefaccionEnum}
     * @memberof CreateInmuebleModel
     */
    'TipoCalefaccion': TipoCalefaccionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInmuebleModel
     */
    'TieneCalefaccionCentral': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateInmuebleModel
     */
    'CapacidadMaxima': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInmuebleModel
     */
    'TieneServicioLuz': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateInmuebleModel
     */
    'CupsLuz': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInmuebleModel
     */
    'TieneServicioGas': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateInmuebleModel
     */
    'CupsGas': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInmuebleModel
     */
    'TieneServicioAgua': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateInmuebleModel
     */
    'IdDelegacionInmobiliaria': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInmuebleModel
     */
    'IdAgenteResponsable': string | null;
}


/**
 * 
 * @export
 * @interface CreateMarcoComisionesModel
 */
export interface CreateMarcoComisionesModel {
    /**
     * 
     * @type {string}
     * @memberof CreateMarcoComisionesModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface CreateMensajeTicketModel
 */
export interface CreateMensajeTicketModel {
    /**
     * 
     * @type {string}
     * @memberof CreateMensajeTicketModel
     */
    'Mensaje': string;
    /**
     * 
     * @type {Array<AdjuntoMensajeModel>}
     * @memberof CreateMensajeTicketModel
     */
    'Adjuntos': Array<AdjuntoMensajeModel>;
    /**
     * 
     * @type {string}
     * @memberof CreateMensajeTicketModel
     */
    'Formato': string;
}
/**
 * 
 * @export
 * @interface CreateNotaBorradorOperacionModel
 */
export interface CreateNotaBorradorOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateNotaBorradorOperacionModel
     */
    'Contenido': string;
}
/**
 * 
 * @export
 * @interface CreateNotaOperacionModel
 */
export interface CreateNotaOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof CreateNotaOperacionModel
     */
    'Contenido': string;
}
/**
 * 
 * @export
 * @interface CreateNotaTramiteEnergiaModel
 */
export interface CreateNotaTramiteEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateNotaTramiteEnergiaModel
     */
    'Contenido': string;
}
/**
 * 
 * @export
 * @interface CreateOfertaEndesaModel
 */
export interface CreateOfertaEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEndesaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEndesaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof CreateOfertaEndesaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateOfertaEndesaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof CreateOfertaEndesaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoTarifaEnergiaEnum}
     * @memberof CreateOfertaEndesaModel
     */
    'TipoTarifa': TipoTarifaEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEndesaModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEndesaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEndesaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {OfertaLuzModel}
     * @memberof CreateOfertaEndesaModel
     */
    'DatosLuz': OfertaLuzModel | null;
    /**
     * 
     * @type {OfertaGasModel}
     * @memberof CreateOfertaEndesaModel
     */
    'DatosGas': OfertaGasModel | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEndesaModel
     */
    'Observaciones': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEndesaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof CreateOfertaEndesaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEndesaModel
     */
    'RequiereRellenado': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEndesaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEndesaModel
     */
    'CodigoTalonario': string | null;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof CreateOfertaEndesaModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOfertaEndesaModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof CreateOfertaEndesaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {OfertaEndesaModel}
     * @memberof CreateOfertaEndesaModel
     */
    'DatosEndesa': OfertaEndesaModel;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEndesaModel
     */
    'IdAnexoEmpresaServicios': string | null;
    /**
     * 
     * @type {Array<VariableAnexoValor>}
     * @memberof CreateOfertaEndesaModel
     */
    'VariablesAnexo': Array<VariableAnexoValor> | null;
}


/**
 * 
 * @export
 * @interface CreateOfertaEnergiaModel
 */
export interface CreateOfertaEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof CreateOfertaEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateOfertaEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof CreateOfertaEnergiaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoTarifaEnergiaEnum}
     * @memberof CreateOfertaEnergiaModel
     */
    'TipoTarifa': TipoTarifaEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEnergiaModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {OfertaLuzModel}
     * @memberof CreateOfertaEnergiaModel
     */
    'DatosLuz': OfertaLuzModel | null;
    /**
     * 
     * @type {OfertaGasModel}
     * @memberof CreateOfertaEnergiaModel
     */
    'DatosGas': OfertaGasModel | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEnergiaModel
     */
    'Observaciones': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEnergiaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof CreateOfertaEnergiaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOfertaEnergiaModel
     */
    'RequiereRellenado': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEnergiaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOfertaEnergiaModel
     */
    'CodigoTalonario': string | null;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof CreateOfertaEnergiaModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOfertaEnergiaModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof CreateOfertaEnergiaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
}


/**
 * 
 * @export
 * @interface CreateOperacionAguaModel
 */
export interface CreateOperacionAguaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateOperacionAguaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {TitularModel}
     * @memberof CreateOperacionAguaModel
     */
    'Titular': TitularModel;
    /**
     * 
     * @type {SuministroAguaModel}
     * @memberof CreateOperacionAguaModel
     */
    'Suministro': SuministroAguaModel;
    /**
     * 
     * @type {FacturacionAguaModel}
     * @memberof CreateOperacionAguaModel
     */
    'Facturacion': FacturacionAguaModel;
    /**
     * 
     * @type {string}
     * @memberof CreateOperacionAguaModel
     */
    'IdBorradorOperacion': string | null;
    /**
     * 
     * @type {Array<ArchivoOperacionAguaModel>}
     * @memberof CreateOperacionAguaModel
     */
    'Archivos': Array<ArchivoOperacionAguaModel>;
}
/**
 * 
 * @export
 * @interface CreateOperacionEnergiaModel
 */
export interface CreateOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateOperacionEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {OrigenConocimientoCupsEnum}
     * @memberof CreateOperacionEnergiaModel
     */
    'OrigenConocimientoCups': OrigenConocimientoCupsEnum | null;
    /**
     * 
     * @type {TitularModel}
     * @memberof CreateOperacionEnergiaModel
     */
    'Titular': TitularModel;
    /**
     * 
     * @type {SuministroModel}
     * @memberof CreateOperacionEnergiaModel
     */
    'Suministro': SuministroModel;
    /**
     * 
     * @type {TramiteLuzModel}
     * @memberof CreateOperacionEnergiaModel
     */
    'TramiteLuz': TramiteLuzModel | null;
    /**
     * 
     * @type {TramiteGasModel}
     * @memberof CreateOperacionEnergiaModel
     */
    'TramiteGas': TramiteGasModel | null;
    /**
     * 
     * @type {FacturacionModel}
     * @memberof CreateOperacionEnergiaModel
     */
    'Facturacion': FacturacionModel;
    /**
     * 
     * @type {Array<DocumentosModel>}
     * @memberof CreateOperacionEnergiaModel
     */
    'Documentos': Array<DocumentosModel>;
    /**
     * 
     * @type {string}
     * @memberof CreateOperacionEnergiaModel
     */
    'IdBorradorOperacion': string | null;
}


/**
 * 
 * @export
 * @interface CreateRappelEnergiaModel
 */
export interface CreateRappelEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateRappelEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {TipoElementoOperacionEnergiaEnum}
     * @memberof CreateRappelEnergiaModel
     */
    'TipoElemento': TipoElementoOperacionEnergiaEnum;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof CreateRappelEnergiaModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateRappelEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateRappelEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof CreateRappelEnergiaModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateRappelEnergiaModel
     */
    'VolumenMin': number;
    /**
     * 
     * @type {number}
     * @memberof CreateRappelEnergiaModel
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof CreateRappelEnergiaModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRappelEnergiaModel
     */
    'Nombre': string | null;
}


/**
 * 
 * @export
 * @interface CreateServicioEndesaModel
 */
export interface CreateServicioEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEndesaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEndesaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof CreateServicioEndesaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateServicioEndesaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof CreateServicioEndesaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEndesaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof CreateServicioEndesaModel
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEndesaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEndesaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEndesaModel
     */
    'Excluyente': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEndesaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof CreateServicioEndesaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEndesaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEndesaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof CreateServicioEndesaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {ServicioEndesaModel}
     * @memberof CreateServicioEndesaModel
     */
    'DatosEndesa': ServicioEndesaModel;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEndesaModel
     */
    'IdAnexoEmpresaServicios': string | null;
    /**
     * 
     * @type {Array<VariableAnexoValor>}
     * @memberof CreateServicioEndesaModel
     */
    'VariablesAnexo': Array<VariableAnexoValor> | null;
}


/**
 * 
 * @export
 * @interface CreateServicioEnergiaModel
 */
export interface CreateServicioEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof CreateServicioEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateServicioEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof CreateServicioEnergiaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEnergiaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof CreateServicioEnergiaModel
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEnergiaModel
     */
    'Excluyente': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEnergiaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof CreateServicioEnergiaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServicioEnergiaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateServicioEnergiaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof CreateServicioEnergiaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
}


/**
 * 
 * @export
 * @interface CreateTicketModel
 */
export interface CreateTicketModel {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'IdUsuario': string | null;
    /**
     * 
     * @type {TipoTicketEnum}
     * @memberof CreateTicketModel
     */
    'Tipo': TipoTicketEnum;
    /**
     * 
     * @type {SubtipoTicketEnum}
     * @memberof CreateTicketModel
     */
    'Subtipo': SubtipoTicketEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'Portal': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketModel
     */
    'Asunto': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTicketModel
     */
    'RefEntidadesAsociadas': Array<string>;
    /**
     * 
     * @type {CreateMensajeTicketModel}
     * @memberof CreateTicketModel
     */
    'Mensaje': CreateMensajeTicketModel;
}


/**
 * 
 * @export
 * @interface CreateTipoDocumentoEmpresaServiciosModel
 */
export interface CreateTipoDocumentoEmpresaServiciosModel {
    /**
     * 
     * @type {string}
     * @memberof CreateTipoDocumentoEmpresaServiciosModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTipoDocumentoEmpresaServiciosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTipoDocumentoEmpresaServiciosModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTipoDocumentoEmpresaServiciosModel
     */
    'AplicaPersonaJuridica': boolean;
}
/**
 * 
 * @export
 * @interface CreateUserModel
 */
export interface CreateUserModel {
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Documento': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Telefono': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserModel
     */
    'Roles': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserModel
     */
    'Validado': boolean | null;
    /**
     * 
     * @type {DatosBOExternoModel}
     * @memberof CreateUserModel
     */
    'DatosBOExterno': DatosBOExternoModel | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserModel
     */
    'IdsDelegacionInmobiliaria': Array<string> | null;
}
/**
 * 
 * @export
 * @interface DXLoadOptions
 */
export interface DXLoadOptions {
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireTotalCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireGroupCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isCountQuery'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isSummaryQuery'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'skip'?: number;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'take'?: number;
    /**
     * 
     * @type {Array<SortingInfo>}
     * @memberof DXLoadOptions
     */
    'sort'?: Array<SortingInfo> | null;
    /**
     * 
     * @type {Array<GroupingInfo>}
     * @memberof DXLoadOptions
     */
    'group'?: Array<GroupingInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'totalSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'groupSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'select'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'preSelect'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteSelect'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteGrouping'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'expandLinqSumType'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'primaryKey'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DXLoadOptions
     */
    'defaultSort'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'stringToLower'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'paginateViaPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'sortByPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'allowAsyncOverSync'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof DXLoadOptions
     */
    'filter'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface DatosBOExternoModel
 */
export interface DatosBOExternoModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatosBOExternoModel
     */
    'IdsEmpresaAgentes': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DatosBOExternoModel
     */
    'AsociadoTodasEmpresas': boolean;
}
/**
 * 
 * @export
 * @interface DatosOfertaGasModel
 */
export interface DatosOfertaGasModel {
    /**
     * 
     * @type {number}
     * @memberof DatosOfertaGasModel
     */
    'TerminoFijo': number;
    /**
     * 
     * @type {number}
     * @memberof DatosOfertaGasModel
     */
    'TerminoVariable': number;
}
/**
 * 
 * @export
 * @interface DatosOfertaLuzModel
 */
export interface DatosOfertaLuzModel {
    /**
     * 
     * @type {boolean}
     * @memberof DatosOfertaLuzModel
     */
    'Autoconsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof DatosOfertaLuzModel
     */
    'PotenciaMin': number;
    /**
     * 
     * @type {number}
     * @memberof DatosOfertaLuzModel
     */
    'PotenciaMax': number;
    /**
     * 
     * @type {TerminoPotenciaModel}
     * @memberof DatosOfertaLuzModel
     */
    'TerminoPotencia': TerminoPotenciaModel;
    /**
     * 
     * @type {TerminoEnergiaModel}
     * @memberof DatosOfertaLuzModel
     */
    'TerminoEnergia': TerminoEnergiaModel;
}
/**
 * 
 * @export
 * @interface DatosSimulacionComisionGasModel
 */
export interface DatosSimulacionComisionGasModel {
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionGasModel
     */
    'Consumo': number | null;
}
/**
 * 
 * @export
 * @interface DatosSimulacionComisionLuzModel
 */
export interface DatosSimulacionComisionLuzModel {
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'PotenciaP1': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'PotenciaP2': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'PotenciaP3': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'PotenciaP4': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'PotenciaP5': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'PotenciaP6': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'ConsumoP1': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'ConsumoP2': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'ConsumoP3': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'ConsumoP4': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'ConsumoP5': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSimulacionComisionLuzModel
     */
    'ConsumoP6': number | null;
}
/**
 * 
 * @export
 * @interface DatosSuministroModel
 */
export interface DatosSuministroModel {
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroModel
     */
    'Cups': string;
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroModel
     */
    'IdCnae': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroModel
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroModel
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSuministroModel
     */
    'P1': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSuministroModel
     */
    'P2': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSuministroModel
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSuministroModel
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSuministroModel
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSuministroModel
     */
    'P6': number | null;
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroModel
     */
    'IdTension': string | null;
    /**
     * 
     * @type {number}
     * @memberof DatosSuministroModel
     */
    'ConsumoAnual': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSuministroModel
     */
    'CnaeOperable': boolean | null;
}
/**
 * 
 * @export
 * @interface DatosSuministroResponse
 */
export interface DatosSuministroResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DatosSuministroResponse
     */
    'Encontrado': boolean;
    /**
     * 
     * @type {DatosSuministroModel}
     * @memberof DatosSuministroResponse
     */
    'DatosSuministro': DatosSuministroModel | null;
}
/**
 * 
 * @export
 * @interface DatosSuministroResponseResponseDTO
 */
export interface DatosSuministroResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DatosSuministroResponse}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'Data'?: DatosSuministroResponse;
    /**
     * 
     * @type {any}
     * @memberof DatosSuministroResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DeactivateServicioIncluidoTramiteEnergiaModel
 */
export interface DeactivateServicioIncluidoTramiteEnergiaModel {
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DeactivateServicioIncluidoTramiteEnergiaModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {Date}
     * @memberof DeactivateServicioIncluidoTramiteEnergiaModel
     */
    'FechaBaja': Date;
}


/**
 * 
 * @export
 * @interface DeactivateTramiteEnergiaModel
 */
export interface DeactivateTramiteEnergiaModel {
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DeactivateTramiteEnergiaModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof DeactivateTramiteEnergiaModel
     */
    'Comentario': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DeactivateTramiteEnergiaModel
     */
    'FechaBaja': Date;
}


/**
 * 
 * @export
 * @interface DecimalNullableResponseDTO
 */
export interface DecimalNullableResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DecimalNullableResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DecimalNullableResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DecimalNullableResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DecimalNullableResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DecimalNullableResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DecimalNullableResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DecimalNullableResponseDTO
     */
    'Data'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DecimalNullableResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DefaultResponseDTO
 */
export interface DefaultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DefaultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DefaultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'CorrelationId'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatus = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    UnhandledException: 'UnhandledException',
    InvalidArguments: 'InvalidArguments',
    ConcurrencyError: 'ConcurrencyError',
    OutOfService: 'OutOfService',
    Unauthorized: 'Unauthorized'
} as const;

export type DefaultResponseStatus = typeof DefaultResponseStatus[keyof typeof DefaultResponseStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatusCategory = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    TransientError: 'TransientError',
    PermanentError: 'PermanentError'
} as const;

export type DefaultResponseStatusCategory = typeof DefaultResponseStatusCategory[keyof typeof DefaultResponseStatusCategory];


/**
 * 
 * @export
 * @interface DefinicionVariableAnexoDto
 */
export interface DefinicionVariableAnexoDto {
    /**
     * 
     * @type {string}
     * @memberof DefinicionVariableAnexoDto
     */
    'Codigo': string;
    /**
     * 
     * @type {string}
     * @memberof DefinicionVariableAnexoDto
     */
    'Tipo': string;
}
/**
 * 
 * @export
 * @interface DeleteMarcoComisionesModel
 */
export interface DeleteMarcoComisionesModel {
    /**
     * 
     * @type {string}
     * @memberof DeleteMarcoComisionesModel
     */
    'IdMarcoReasignacion': string;
}
/**
 * 
 * @export
 * @interface DescuentoEnergiaAplicableModel
 */
export interface DescuentoEnergiaAplicableModel {
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaAplicableModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaAplicableModel
     */
    'IdOferta': string | null;
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaAplicableModel
     */
    'IdServicio': string | null;
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaAplicableModel
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaAplicableModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DescuentoEnergiaAplicableModel
     */
    'Cuantia': number;
    /**
     * 
     * @type {boolean}
     * @memberof DescuentoEnergiaAplicableModel
     */
    'AplicaPorDefecto': boolean;
}
/**
 * 
 * @export
 * @interface DescuentoEnergiaListItemModel
 */
export interface DescuentoEnergiaListItemModel {
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaListItemModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DescuentoEnergiaListItemModel
     */
    'Cuantia': number;
}
/**
 * 
 * @export
 * @interface DescuentoEnergiaModel
 */
export interface DescuentoEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaModel
     */
    'Id': string | null;
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DescuentoEnergiaModel
     */
    'NombreTecnico': string;
    /**
     * 
     * @type {number}
     * @memberof DescuentoEnergiaModel
     */
    'Cuantia': number;
}
/**
 * 
 * @export
 * @interface DescuentosEnergiaAplicablesModel
 */
export interface DescuentosEnergiaAplicablesModel {
    /**
     * 
     * @type {Array<DescuentoEnergiaAplicableModel>}
     * @memberof DescuentosEnergiaAplicablesModel
     */
    'DescuentosTramiteLuz': Array<DescuentoEnergiaAplicableModel>;
    /**
     * 
     * @type {Array<DescuentoEnergiaAplicableModel>}
     * @memberof DescuentosEnergiaAplicablesModel
     */
    'DescuentosTramiteGas': Array<DescuentoEnergiaAplicableModel>;
}
/**
 * 
 * @export
 * @interface DescuentosEnergiaAplicablesModelResponseDTO
 */
export interface DescuentosEnergiaAplicablesModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DescuentosEnergiaAplicablesModel}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'Data'?: DescuentosEnergiaAplicablesModel;
    /**
     * 
     * @type {any}
     * @memberof DescuentosEnergiaAplicablesModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailAdjuntoComunicadoModel
 */
export interface DetailAdjuntoComunicadoModel {
    /**
     * 
     * @type {string}
     * @memberof DetailAdjuntoComunicadoModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAdjuntoComunicadoModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAdjuntoComunicadoModel
     */
    'Ruta': string;
}
/**
 * 
 * @export
 * @interface DetailAgenteInmobiliariaModel
 */
export interface DetailAgenteInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {CometidoAgenteInmobiliariaEnum}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'IdCometido': CometidoAgenteInmobiliariaEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailAgenteInmobiliariaModel
     */
    'IdsDelegacionInmobiliaria': Array<string> | null;
}


/**
 * 
 * @export
 * @interface DetailAgenteInmobiliariaModelResponseDTO
 */
export interface DetailAgenteInmobiliariaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailAgenteInmobiliariaModel}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'Data'?: DetailAgenteInmobiliariaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailAgenteInmobiliariaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailAgenteModel
 */
export interface DetailAgenteModel {
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModel
     */
    'Telefono': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof DetailAgenteModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {number}
     * @memberof DetailAgenteModel
     */
    'TramitesActivadosUltimoMes': number;
    /**
     * 
     * @type {number}
     * @memberof DetailAgenteModel
     */
    'TramitesActivadosTotales': number;
    /**
     * 
     * @type {number}
     * @memberof DetailAgenteModel
     */
    'ComparacionesDisponibles': number;
}
/**
 * 
 * @export
 * @interface DetailAgenteModelResponseDTO
 */
export interface DetailAgenteModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailAgenteModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailAgenteModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailAgenteModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailAgenteModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailAgenteModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailAgenteModel}
     * @memberof DetailAgenteModelResponseDTO
     */
    'Data'?: DetailAgenteModel;
    /**
     * 
     * @type {any}
     * @memberof DetailAgenteModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailBorradorOperacionModel
 */
export interface DetailBorradorOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModel
     */
    'Id': string;
    /**
     * 
     * @type {DetailDireccionModel}
     * @memberof DetailBorradorOperacionModel
     */
    'DireccionInmueble': DetailDireccionModel;
    /**
     * 
     * @type {InfoBorradorOperacionClienteModel}
     * @memberof DetailBorradorOperacionModel
     */
    'Cliente': InfoBorradorOperacionClienteModel;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModel
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DetailBorradorOperacionModel
     */
    'TipoSuministroEnergia': TipoSuministroTramiteEnergiaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModel
     */
    'Cups': string | null;
    /**
     * 
     * @type {Array<ArchivoBorradorOperacionModel>}
     * @memberof DetailBorradorOperacionModel
     */
    'ArchivosAdjuntos': Array<ArchivoBorradorOperacionModel>;
    /**
     * 
     * @type {TipoTramiteOperacionEnum}
     * @memberof DetailBorradorOperacionModel
     */
    'TipoTramite': TipoTramiteOperacionEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModel
     */
    'IdEmpresaAgentes': string;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModel
     */
    'IdOperacionAsociada': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailBorradorOperacionModel
     */
    'TieneOperacionAsociada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailBorradorOperacionModel
     */
    'PuedeEditarOperacion': boolean;
    /**
     * 
     * @type {Date}
     * @memberof DetailBorradorOperacionModel
     */
    'FechaBaja': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModel
     */
    'MotivoBaja': string | null;
}


/**
 * 
 * @export
 * @interface DetailBorradorOperacionModelResponseDTO
 */
export interface DetailBorradorOperacionModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailBorradorOperacionModel}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'Data'?: DetailBorradorOperacionModel;
    /**
     * 
     * @type {any}
     * @memberof DetailBorradorOperacionModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailClienteInmobiliarioModel
 */
export interface DetailClienteInmobiliarioModel {
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof DetailClienteInmobiliarioModel
     */
    'TipoPersona': TipoPersonaEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'RazonSocial': string | null;
    /**
     * 
     * @type {SubtipoPersonaEnum}
     * @memberof DetailClienteInmobiliarioModel
     */
    'SubtipoPersona': SubtipoPersonaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'CIF': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'RutaDocumento': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'TelFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'TelMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'IbanPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'NombrePago': string | null;
    /**
     * 
     * @type {TipoDocumentoEnum}
     * @memberof DetailClienteInmobiliarioModel
     */
    'TipoDocumentoPago': TipoDocumentoEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'DocumentoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'ApellidosPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModel
     */
    'RutaAutorizacionFirmada': string | null;
}


/**
 * 
 * @export
 * @interface DetailClienteInmobiliarioModelResponseDTO
 */
export interface DetailClienteInmobiliarioModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailClienteInmobiliarioModel}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'Data'?: DetailClienteInmobiliarioModel;
    /**
     * 
     * @type {any}
     * @memberof DetailClienteInmobiliarioModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailClienteInmuebleModel
 */
export interface DetailClienteInmuebleModel {
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'RazonSocial': string | null;
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof DetailClienteInmuebleModel
     */
    'TipoPersona': TipoPersonaEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'CIF': string | null;
    /**
     * 
     * @type {SubtipoPersonaEnum}
     * @memberof DetailClienteInmuebleModel
     */
    'SubtipoPersona': SubtipoPersonaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'RutaDocumento': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'TelFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'TelMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'IbanPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'NombrePago': string | null;
    /**
     * 
     * @type {TipoDocumentoEnum}
     * @memberof DetailClienteInmuebleModel
     */
    'TipoDocumentoPago': TipoDocumentoEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'DocumentoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModel
     */
    'ApellidosPago': string | null;
    /**
     * 
     * @type {TipoRelacionClienteInmobiliarioEnum}
     * @memberof DetailClienteInmuebleModel
     */
    'TipoRelacion': TipoRelacionClienteInmobiliarioEnum;
    /**
     * 
     * @type {Date}
     * @memberof DetailClienteInmuebleModel
     */
    'FechaInicio': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailClienteInmuebleModel
     */
    'FechaFin': Date | null;
}


/**
 * 
 * @export
 * @interface DetailClienteInmuebleModelResponseDTO
 */
export interface DetailClienteInmuebleModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailClienteInmuebleModel}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'Data'?: DetailClienteInmuebleModel;
    /**
     * 
     * @type {any}
     * @memberof DetailClienteInmuebleModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailComparacionEnergiaModel
 */
export interface DetailComparacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'IdEmpresaAgentes': string;
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof DetailComparacionEnergiaModel
     */
    'TipoPersona': TipoPersonaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'NombreTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'ApellidosTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DocumentoTitular': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DireccionSuministroCodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DireccionSuministroProvincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DireccionSuministroMunicipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DireccionSuministroNombreVia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DireccionSuministroNumero': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DireccionSuministroPiso': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'DireccionSuministroPuerta': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'CupsLuz': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'ComercializadoraAnteriorLuz': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaModel
     */
    'P1': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaModel
     */
    'P2': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaModel
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaModel
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaModel
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaModel
     */
    'P6': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'CupsGas': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModel
     */
    'ComercializadoraAnteriorGas': string | null;
}


/**
 * 
 * @export
 * @interface DetailComparacionEnergiaModelResponseDTO
 */
export interface DetailComparacionEnergiaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailComparacionEnergiaModel}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'Data'?: DetailComparacionEnergiaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailComparacionEnergiaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailComparacionEnergiaOfertaModel
 */
export interface DetailComparacionEnergiaOfertaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaOfertaModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaOfertaModel
     */
    'IdEsave': number;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaOfertaModel
     */
    'ImagenB64': string;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaOfertaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaOfertaModel
     */
    'TotalAPagar': number;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaOfertaModel
     */
    'AhorroCuantia': number;
    /**
     * 
     * @type {number}
     * @memberof DetailComparacionEnergiaOfertaModel
     */
    'AhorroPorcentaje': number;
}
/**
 * 
 * @export
 * @interface DetailComparacionEnergiaOfertaModelListResponseDTO
 */
export interface DetailComparacionEnergiaOfertaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<DetailComparacionEnergiaOfertaModel>}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'Data'?: Array<DetailComparacionEnergiaOfertaModel>;
    /**
     * 
     * @type {any}
     * @memberof DetailComparacionEnergiaOfertaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailComunicadoColaboradorModel
 */
export interface DetailComunicadoColaboradorModel {
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoColaboradorModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoComunicadoEnum}
     * @memberof DetailComunicadoColaboradorModel
     */
    'Tipo': TipoComunicadoEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoColaboradorModel
     */
    'Asunto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoColaboradorModel
     */
    'Cuerpo': string;
    /**
     * 
     * @type {Array<DetailAdjuntoComunicadoModel>}
     * @memberof DetailComunicadoColaboradorModel
     */
    'Adjuntos': Array<DetailAdjuntoComunicadoModel>;
    /**
     * 
     * @type {Date}
     * @memberof DetailComunicadoColaboradorModel
     */
    'FechaEnvio': Date | null;
}


/**
 * 
 * @export
 * @interface DetailComunicadoColaboradorModelResponseDTO
 */
export interface DetailComunicadoColaboradorModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailComunicadoColaboradorModel}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'Data'?: DetailComunicadoColaboradorModel;
    /**
     * 
     * @type {any}
     * @memberof DetailComunicadoColaboradorModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailComunicadoModel
 */
export interface DetailComunicadoModel {
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoComunicadoEnum}
     * @memberof DetailComunicadoModel
     */
    'Tipo': TipoComunicadoEnum;
    /**
     * 
     * @type {EstadoComunicadoEnum}
     * @memberof DetailComunicadoModel
     */
    'Estado': EstadoComunicadoEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoModel
     */
    'Asunto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoModel
     */
    'Cuerpo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoModel
     */
    'TipoEmpresaAgenteDirigido': string | null;
    /**
     * 
     * @type {Array<RolComunicadoModel>}
     * @memberof DetailComunicadoModel
     */
    'RolesDirigidos': Array<RolComunicadoModel>;
    /**
     * 
     * @type {Array<EmpresaAgenteComunicadoModel>}
     * @memberof DetailComunicadoModel
     */
    'EmpresasAgentesDirigidos': Array<EmpresaAgenteComunicadoModel>;
    /**
     * 
     * @type {Array<DetailAdjuntoComunicadoModel>}
     * @memberof DetailComunicadoModel
     */
    'Adjuntos': Array<DetailAdjuntoComunicadoModel>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComunicadoModel
     */
    'PuedeEditarse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComunicadoModel
     */
    'PuedeEliminarse': boolean;
    /**
     * 
     * @type {Date}
     * @memberof DetailComunicadoModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailComunicadoModel
     */
    'FechaUltModificacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailComunicadoModel
     */
    'FechaEnvio': Date | null;
}


/**
 * 
 * @export
 * @interface DetailComunicadoModelResponseDTO
 */
export interface DetailComunicadoModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailComunicadoModel}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'Data'?: DetailComunicadoModel;
    /**
     * 
     * @type {any}
     * @memberof DetailComunicadoModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailCriterioRetrocomisionEnergiaModel
 */
export interface DetailCriterioRetrocomisionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'IdGrupo': string;
    /**
     * 
     * @type {TipoConceptoCriterioRetrocomisionEnergiaEnum}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'TipoConcepto': TipoConceptoCriterioRetrocomisionEnergiaEnum;
    /**
     * 
     * @type {number}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'PeriodoHasta': number;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'TarifaAcceso': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DetailCriterioRetrocomisionEnergiaModel
     */
    'Importe': number;
}


/**
 * 
 * @export
 * @interface DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
 */
export interface DetailCriterioRetrocomisionEnergiaModelIListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<DetailCriterioRetrocomisionEnergiaModel>}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'Data'?: Array<DetailCriterioRetrocomisionEnergiaModel>;
    /**
     * 
     * @type {any}
     * @memberof DetailCriterioRetrocomisionEnergiaModelIListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailCriterioRetrocomisionEnergiaModelResponseDTO
 */
export interface DetailCriterioRetrocomisionEnergiaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailCriterioRetrocomisionEnergiaModel}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'Data'?: DetailCriterioRetrocomisionEnergiaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailCriterioRetrocomisionEnergiaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailDelegacionInmobiliariaModel
 */
export interface DetailDelegacionInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'IdEmpresaInmobiliaria': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'RazonSocialEmpresaInmobiliaria': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'ImagenB64EmpresaInmobiliaria': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Web': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailDelegacionInmobiliariaModel
     */
    'Coordinadores': Array<string>;
}
/**
 * 
 * @export
 * @interface DetailDelegacionInmobiliariaModelResponseDTO
 */
export interface DetailDelegacionInmobiliariaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailDelegacionInmobiliariaModel}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'Data'?: DetailDelegacionInmobiliariaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailDelegacionInmobiliariaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailDescuentoTramiteOperacionEnergiaModel
 */
export interface DetailDescuentoTramiteOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailDescuentoTramiteOperacionEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDescuentoTramiteOperacionEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DetailDescuentoTramiteOperacionEnergiaModel
     */
    'Cuantia': number;
}
/**
 * 
 * @export
 * @interface DetailDireccionModel
 */
export interface DetailDireccionModel {
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'TipoVia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'NombreVia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'Numero': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'Escalera': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'Piso': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'Puerta': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'DireccionCompleta': string;
    /**
     * 
     * @type {string}
     * @memberof DetailDireccionModel
     */
    'DireccionSinCodigoPostal': string;
}
/**
 * 
 * @export
 * @interface DetailEmpresaAgentesModel
 */
export interface DetailEmpresaAgentesModel {
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailEmpresaAgentesModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof DetailEmpresaAgentesModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {Date}
     * @memberof DetailEmpresaAgentesModel
     */
    'FechaBaja': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {FormaJuridicaEnum}
     * @memberof DetailEmpresaAgentesModel
     */
    'FormaJuridica': FormaJuridicaEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailEmpresaAgentesModel
     */
    'PorcentajeIrpf': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DetailEmpresaAgentesModel
     */
    'DiasAutofacturacion': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'ImagenB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'DenoFactura': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaAgentesModel
     */
    'TieneWhitelistServicios': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'NombreCompletoRepresentante': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'DocumentoRepresentante': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'EmailRepresentante': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'TelefonoRepresentante': string | null;
    /**
     * 
     * @type {EstadoEmpresaAgentesEnum}
     * @memberof DetailEmpresaAgentesModel
     */
    'IdEstado': EstadoEmpresaAgentesEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'NombreUsuarioRechazo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModel
     */
    'MotivoRechazo': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailEmpresaAgentesModel
     */
    'FechaRechazo': Date | null;
    /**
     * 
     * @type {Array<EstructuraDocumentalEmpresaAgentesModel>}
     * @memberof DetailEmpresaAgentesModel
     */
    'EstructuraDocumental': Array<EstructuraDocumentalEmpresaAgentesModel>;
}


/**
 * 
 * @export
 * @interface DetailEmpresaAgentesModelResponseDTO
 */
export interface DetailEmpresaAgentesModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailEmpresaAgentesModel}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'Data'?: DetailEmpresaAgentesModel;
    /**
     * 
     * @type {any}
     * @memberof DetailEmpresaAgentesModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailEmpresaColaboradoraModel
 */
export interface DetailEmpresaColaboradoraModel {
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {FormaJuridicaEnum}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'FormaJuridica': FormaJuridicaEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'PorcentajeIrpf': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'DiasAutofacturacion': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'ImagenB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'LogoPortalB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'DenoFactura': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'TieneWhitelistServicios': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'WhitelistServicios': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'WhitelistServiciosNombres': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'MarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'NombreMarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'UsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'NombreUsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'IdComercial': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'NombreComercial': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'IdSubtipo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'NombreSubtipo': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'Autoregistro': boolean;
    /**
     * 
     * @type {EstadoEmpresaAgentesEnum}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'IdEstado': EstadoEmpresaAgentesEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModel
     */
    'MotivoRechazo': string | null;
}


/**
 * 
 * @export
 * @interface DetailEmpresaColaboradoraModelResponseDTO
 */
export interface DetailEmpresaColaboradoraModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailEmpresaColaboradoraModel}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'Data'?: DetailEmpresaColaboradoraModel;
    /**
     * 
     * @type {any}
     * @memberof DetailEmpresaColaboradoraModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailEmpresaInmobiliariaModel
 */
export interface DetailEmpresaInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DetailDireccionModel}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Direccion': DetailDireccionModel;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {FormaJuridicaEnum}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'FormaJuridica': FormaJuridicaEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'PorcentajeIrpf': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'DiasAutofacturacion': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'ImagenB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'LogoPortalB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'DenoFactura': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'TieneWhitelistServicios': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'WhitelistServicios': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'WhitelistServiciosNombres': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'MarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'NombreMarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'UsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'NombreUsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'IdComercial': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'NombreComercial': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'PuedeTramitarAgua': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'Autoregistro': boolean;
    /**
     * 
     * @type {EstadoEmpresaAgentesEnum}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'IdEstado': EstadoEmpresaAgentesEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModel
     */
    'MotivoRechazo': string | null;
}


/**
 * 
 * @export
 * @interface DetailEmpresaInmobiliariaModelResponseDTO
 */
export interface DetailEmpresaInmobiliariaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailEmpresaInmobiliariaModel}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'Data'?: DetailEmpresaInmobiliariaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailEmpresaInmobiliariaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailEmpresaServiciosAguaModel
 */
export interface DetailEmpresaServiciosAguaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoEmpresaServiciosEnum}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'Tipo': TipoEmpresaServiciosEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'DireccionContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'NombreContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'TelContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'EmailContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'ImagenB64': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'Activado': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'IdsGestoresSoporte': Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DetailEmpresaServiciosAguaModel
     */
    'CodigosProvinciaDondeOpera': Array<number>;
}


/**
 * 
 * @export
 * @interface DetailEmpresaServiciosAguaModelResponseDTO
 */
export interface DetailEmpresaServiciosAguaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailEmpresaServiciosAguaModel}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'Data'?: DetailEmpresaServiciosAguaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailEmpresaServiciosAguaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailEmpresaServiciosEnergiaModel
 */
export interface DetailEmpresaServiciosEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoEmpresaServiciosEnum}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'Tipo': TipoEmpresaServiciosEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'DireccionContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'NombreContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'TelContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'EmailContacto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'ImagenB64': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'Activado': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'IdsGestoresSoporte': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'IdEsave': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'SincronizaEsave': boolean;
    /**
     * 
     * @type {GrupoEmpresaEnergiaEnum}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'IdGrupoEmpresa': GrupoEmpresaEnergiaEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'RequiereConsentimientoPrevio': boolean;
    /**
     * 
     * @type {PlantillaConsentimientoPrevioEnum}
     * @memberof DetailEmpresaServiciosEnergiaModel
     */
    'IdPlantillaConsentimiento': PlantillaConsentimientoPrevioEnum | null;
}


/**
 * 
 * @export
 * @interface DetailEmpresaServiciosEnergiaModelResponseDTO
 */
export interface DetailEmpresaServiciosEnergiaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailEmpresaServiciosEnergiaModel}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'Data'?: DetailEmpresaServiciosEnergiaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailEmpresaServiciosEnergiaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailInmuebleModel
 */
export interface DetailInmuebleModel {
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoInmuebleEnum}
     * @memberof DetailInmuebleModel
     */
    'TipoInmueble': TipoInmuebleEnum;
    /**
     * 
     * @type {TipoObraEnum}
     * @memberof DetailInmuebleModel
     */
    'TipoObra': TipoObraEnum;
    /**
     * 
     * @type {DireccionModel}
     * @memberof DetailInmuebleModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {TipoCalentadorEnum}
     * @memberof DetailInmuebleModel
     */
    'TipoCalentador': TipoCalentadorEnum;
    /**
     * 
     * @type {TipoCocinaEnum}
     * @memberof DetailInmuebleModel
     */
    'TipoCocina': TipoCocinaEnum;
    /**
     * 
     * @type {TipoCalefaccionEnum}
     * @memberof DetailInmuebleModel
     */
    'TipoCalefaccion': TipoCalefaccionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DetailInmuebleModel
     */
    'TieneCalefaccionCentral': boolean;
    /**
     * 
     * @type {number}
     * @memberof DetailInmuebleModel
     */
    'CapacidadMaxima': number;
    /**
     * 
     * @type {boolean}
     * @memberof DetailInmuebleModel
     */
    'TieneServicioLuz': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModel
     */
    'CupsLuz': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailInmuebleModel
     */
    'TieneServicioGas': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModel
     */
    'CupsGas': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailInmuebleModel
     */
    'TieneServicioAgua': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModel
     */
    'IdDelegacionInmobiliaria': string;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModel
     */
    'DelegacionResponsable': string;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModel
     */
    'IdAgenteResponsable': string;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModel
     */
    'AgenteResponsable': string;
}


/**
 * 
 * @export
 * @interface DetailInmuebleModelResponseDTO
 */
export interface DetailInmuebleModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailInmuebleModel}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'Data'?: DetailInmuebleModel;
    /**
     * 
     * @type {any}
     * @memberof DetailInmuebleModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailNotaBorradorOperacionModel
 */
export interface DetailNotaBorradorOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof DetailNotaBorradorOperacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaBorradorOperacionModel
     */
    'NombreCreador': string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaBorradorOperacionModel
     */
    'ApellidosCreador': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailNotaBorradorOperacionModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailNotaBorradorOperacionModel
     */
    'FechaModificacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaBorradorOperacionModel
     */
    'Contenido': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaBorradorOperacionModel
     */
    'PuedeEditar': boolean;
}
/**
 * 
 * @export
 * @interface DetailNotaBorradorOperacionModelListResponseDTO
 */
export interface DetailNotaBorradorOperacionModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<DetailNotaBorradorOperacionModel>}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'Data'?: Array<DetailNotaBorradorOperacionModel>;
    /**
     * 
     * @type {any}
     * @memberof DetailNotaBorradorOperacionModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailNotaOperacionModel
 */
export interface DetailNotaOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof DetailNotaOperacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaOperacionModel
     */
    'NombreCreador': string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaOperacionModel
     */
    'ApellidosCreador': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailNotaOperacionModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailNotaOperacionModel
     */
    'FechaModificacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaOperacionModel
     */
    'Contenido': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaOperacionModel
     */
    'PuedeEditar': boolean;
}
/**
 * 
 * @export
 * @interface DetailNotaOperacionModelListResponseDTO
 */
export interface DetailNotaOperacionModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<DetailNotaOperacionModel>}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'Data'?: Array<DetailNotaOperacionModel>;
    /**
     * 
     * @type {any}
     * @memberof DetailNotaOperacionModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailNotaTramiteEnergiaModel
 */
export interface DetailNotaTramiteEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailNotaTramiteEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaTramiteEnergiaModel
     */
    'NombreCreador': string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaTramiteEnergiaModel
     */
    'ApellidosCreador': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailNotaTramiteEnergiaModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailNotaTramiteEnergiaModel
     */
    'FechaModificacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaTramiteEnergiaModel
     */
    'Contenido': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaTramiteEnergiaModel
     */
    'PuedeEditar': boolean;
}
/**
 * 
 * @export
 * @interface DetailNotaTramiteEnergiaModelListResponseDTO
 */
export interface DetailNotaTramiteEnergiaModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<DetailNotaTramiteEnergiaModel>}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'Data'?: Array<DetailNotaTramiteEnergiaModel>;
    /**
     * 
     * @type {any}
     * @memberof DetailNotaTramiteEnergiaModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailOfertaEndesaModel
 */
export interface DetailOfertaEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'EmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailOfertaEndesaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailOfertaEndesaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DetailOfertaEndesaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoTarifaEnergiaEnum}
     * @memberof DetailOfertaEndesaModel
     */
    'TipoTarifa': TipoTarifaEnergiaEnum;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof DetailOfertaEndesaModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaEndesaModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEndesaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEndesaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEndesaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {InfoOfertaEnergiaLuz}
     * @memberof DetailOfertaEndesaModel
     */
    'DatosLuz': InfoOfertaEnergiaLuz | null;
    /**
     * 
     * @type {InfoOfertaEnergiaGas}
     * @memberof DetailOfertaEndesaModel
     */
    'DatosGas': InfoOfertaEnergiaGas | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'AnexoPrecios': string | null;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof DetailOfertaEndesaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEndesaModel
     */
    'RequiereRellenado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEndesaModel
     */
    'TieneTramitesAsociados': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'DenominacionInterna': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'CodigoTalonario': string | null;
    /**
     * 
     * @type {InfoOfertaEnergiaEndesa}
     * @memberof DetailOfertaEndesaModel
     */
    'DatosEndesa': InfoOfertaEnergiaEndesa;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof DetailOfertaEndesaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaEndesaModel
     */
    'IdEsave': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'ImagenB64': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModel
     */
    'IdAnexoEmpresaServicios': string | null;
    /**
     * 
     * @type {Array<VariableAnexoValor>}
     * @memberof DetailOfertaEndesaModel
     */
    'VariablesAnexo': Array<VariableAnexoValor> | null;
}


/**
 * 
 * @export
 * @interface DetailOfertaEndesaModelResponseDTO
 */
export interface DetailOfertaEndesaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailOfertaEndesaModel}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'Data'?: DetailOfertaEndesaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailOfertaEndesaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailOfertaEnergiaModel
 */
export interface DetailOfertaEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'EmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailOfertaEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailOfertaEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DetailOfertaEnergiaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoTarifaEnergiaEnum}
     * @memberof DetailOfertaEnergiaModel
     */
    'TipoTarifa': TipoTarifaEnergiaEnum;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof DetailOfertaEnergiaModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaEnergiaModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEnergiaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {InfoOfertaEnergiaLuz}
     * @memberof DetailOfertaEnergiaModel
     */
    'DatosLuz': InfoOfertaEnergiaLuz | null;
    /**
     * 
     * @type {InfoOfertaEnergiaGas}
     * @memberof DetailOfertaEnergiaModel
     */
    'DatosGas': InfoOfertaEnergiaGas | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'AnexoPrecios': string | null;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof DetailOfertaEnergiaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEnergiaModel
     */
    'RequiereRellenado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEnergiaModel
     */
    'TieneTramitesAsociados': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'CodigoTalonario': string | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof DetailOfertaEnergiaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaEnergiaModel
     */
    'IdEsave': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModel
     */
    'ImagenB64': string;
}


/**
 * 
 * @export
 * @interface DetailOfertaEnergiaModelResponseDTO
 */
export interface DetailOfertaEnergiaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailOfertaEnergiaModel}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'Data'?: DetailOfertaEnergiaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailOfertaEnergiaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailOfertaGas
 */
export interface DetailOfertaGas {
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaGas
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaGas
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaGas
     */
    'TerminoFijo': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaGas
     */
    'TerminoVariable': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaGas
     */
    'TerminoVariableConDescuentos': number;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof DetailOfertaGas
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaGas
     */
    'CosteGestion': number | null;
}


/**
 * 
 * @export
 * @interface DetailOfertaLuz
 */
export interface DetailOfertaLuz {
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaLuz
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOfertaLuz
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP1': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP2': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP3': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP4': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP5': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP6': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoPotenciaP1': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoPotenciaP2': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoPotenciaP3': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoPotenciaP4': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoPotenciaP5': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoPotenciaP6': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP1ConDescuentos': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP2ConDescuentos': number;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP3ConDescuentos': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP4ConDescuentos': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP5ConDescuentos': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'TerminoEnergiaP6ConDescuentos': number | null;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof DetailOfertaLuz
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof DetailOfertaLuz
     */
    'CosteGestion': number | null;
}


/**
 * 
 * @export
 * @interface DetailOperacionAguaModel
 */
export interface DetailOperacionAguaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'IdEmpresaAgentes': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'UserNameResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'NombreCompletoResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'IdClienteInmobiliario': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'IdInmueble': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'IdBorrador': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'LogoEmpresaServiciosB64': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModel
     */
    'CodigoEstado': string;
    /**
     * 
     * @type {TitularModel}
     * @memberof DetailOperacionAguaModel
     */
    'Titular': TitularModel;
    /**
     * 
     * @type {SuministroAguaModel}
     * @memberof DetailOperacionAguaModel
     */
    'Suministro': SuministroAguaModel;
    /**
     * 
     * @type {FacturacionAguaModel}
     * @memberof DetailOperacionAguaModel
     */
    'Facturacion': FacturacionAguaModel;
    /**
     * 
     * @type {Array<DocumentosAguaModel>}
     * @memberof DetailOperacionAguaModel
     */
    'Documentos': Array<DocumentosAguaModel>;
    /**
     * 
     * @type {number}
     * @memberof DetailOperacionAguaModel
     */
    'CodigoSecuencial': number;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModel
     */
    'EsEditable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModel
     */
    'PuedeMarcarEnCurso': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModel
     */
    'PuedeMarcarIncidencia': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModel
     */
    'PuedeActivarse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModel
     */
    'PuedeCancelarse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModel
     */
    'PuedeDarseBaja': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModel
     */
    'EstaFinalizada': boolean;
    /**
     * 
     * @type {Date}
     * @memberof DetailOperacionAguaModel
     */
    'FechaActivacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailOperacionAguaModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface DetailOperacionAguaModelResponseDTO
 */
export interface DetailOperacionAguaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailOperacionAguaModel}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'Data'?: DetailOperacionAguaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailOperacionAguaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailOperacionEnergiaInmuebleModel
 */
export interface DetailOperacionEnergiaInmuebleModel {
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'IdEmpresaAgentes': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroCodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroProvincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroMunicipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroTipoVia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroNombreVia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroNumero': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroEscalera': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroPiso': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'DireccionSuministroPuerta': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'CupsLuz': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModel
     */
    'CupsGas': string | null;
}
/**
 * 
 * @export
 * @interface DetailOperacionEnergiaInmuebleModelResponseDTO
 */
export interface DetailOperacionEnergiaInmuebleModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailOperacionEnergiaInmuebleModel}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'Data'?: DetailOperacionEnergiaInmuebleModel;
    /**
     * 
     * @type {any}
     * @memberof DetailOperacionEnergiaInmuebleModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailOperacionEnergiaModel
 */
export interface DetailOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'IdEmpresaAgentes': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'UserNameResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'NombreCompletoResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'IdClienteInmobiliario': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'IdInmueble': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'IdBorrador': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'PosibleFraude': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'LogoEmpresaServiciosB64': string;
    /**
     * 
     * @type {EstadoOperacionEnergiaEnum}
     * @memberof DetailOperacionEnergiaModel
     */
    'IdEstado': EstadoOperacionEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'CodigoEstado': string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModel
     */
    'IdExterno': string | null;
    /**
     * 
     * @type {OrigenConocimientoCupsEnum}
     * @memberof DetailOperacionEnergiaModel
     */
    'OrigenConocimientoCups': OrigenConocimientoCupsEnum | null;
    /**
     * 
     * @type {TitularModel}
     * @memberof DetailOperacionEnergiaModel
     */
    'Titular': TitularModel;
    /**
     * 
     * @type {SuministroModel}
     * @memberof DetailOperacionEnergiaModel
     */
    'Suministro': SuministroModel;
    /**
     * 
     * @type {DetailTramiteLuzOperacionEnergiaModel}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteLuz': DetailTramiteLuzOperacionEnergiaModel | null;
    /**
     * 
     * @type {DetailTramiteGasOperacionEnergiaModel}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteGas': DetailTramiteGasOperacionEnergiaModel | null;
    /**
     * 
     * @type {FacturacionModel}
     * @memberof DetailOperacionEnergiaModel
     */
    'Facturacion': FacturacionModel;
    /**
     * 
     * @type {Array<DocumentosModel>}
     * @memberof DetailOperacionEnergiaModel
     */
    'Documentos': Array<DocumentosModel>;
    /**
     * 
     * @type {number}
     * @memberof DetailOperacionEnergiaModel
     */
    'CodigoSecuencial': number;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'EsEditable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'EsEditableBo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'EsEnviableBo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'EsAceptableBo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'EsRechazableBo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'EsDeshacibleBo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'EstaFinalizada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'PuedeEnviarseFirmaManualBo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'PuedeFirmarseManualBo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'PuedeDescargarFicheroEmpresaServicios': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'PuedeAnularse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'PuedeGenerarConsentimientoPrevio': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'PuedeGestionarConsentimientoPrevio': boolean;
    /**
     * 
     * @type {Date}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteLuzFechaActivacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteLuzFechaBaja': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteLuzPuedeAnularse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteLuzPuedeActivarse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteLuzPuedeDarseBaja': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteLuzPuedeCambiarEstadoLibre': boolean;
    /**
     * 
     * @type {Date}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteGasFechaActivacion': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteGasFechaBaja': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteGasPuedeAnularse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteGasPuedeActivarse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteGasPuedeDarseBaja': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModel
     */
    'TramiteGasPuedeCambiarEstadoLibre': boolean;
}


/**
 * 
 * @export
 * @interface DetailOperacionEnergiaModelResponseDTO
 */
export interface DetailOperacionEnergiaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailOperacionEnergiaModel}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'Data'?: DetailOperacionEnergiaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailOperacionEnergiaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailRappelEnergiaModel
 */
export interface DetailRappelEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailRappelEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailRappelEnergiaModel
     */
    'EmpresaServicios': string;
    /**
     * 
     * @type {Date}
     * @memberof DetailRappelEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailRappelEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoElementoOperacionEnergiaEnum}
     * @memberof DetailRappelEnergiaModel
     */
    'TipoElemento': TipoElementoOperacionEnergiaEnum;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DetailRappelEnergiaModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailRappelEnergiaModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailRappelEnergiaModel
     */
    'VolumenMin': number;
    /**
     * 
     * @type {number}
     * @memberof DetailRappelEnergiaModel
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof DetailRappelEnergiaModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailRappelEnergiaModel
     */
    'Nombre': string | null;
}


/**
 * 
 * @export
 * @interface DetailRappelEnergiaModelResponseDTO
 */
export interface DetailRappelEnergiaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailRappelEnergiaModel}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'Data'?: DetailRappelEnergiaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailRappelEnergiaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailRelacionClienteInmuebleModel
 */
export interface DetailRelacionClienteInmuebleModel {
    /**
     * 
     * @type {TipoInmuebleEnum}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'TipoInmueble': TipoInmuebleEnum;
    /**
     * 
     * @type {DetailDireccionModel}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'DireccionInmueble': DetailDireccionModel;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'CupsLuz': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'CupsGas': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'TelFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'TelMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {TipoRelacionClienteInmobiliarioEnum}
     * @memberof DetailRelacionClienteInmuebleModel
     */
    'TipoRelacion': TipoRelacionClienteInmobiliarioEnum;
}


/**
 * 
 * @export
 * @interface DetailRelacionClienteInmuebleModelResponseDTO
 */
export interface DetailRelacionClienteInmuebleModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailRelacionClienteInmuebleModel}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'Data'?: DetailRelacionClienteInmuebleModel;
    /**
     * 
     * @type {any}
     * @memberof DetailRelacionClienteInmuebleModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailServicioEndesaModel
 */
export interface DetailServicioEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'EmpresaServicios': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DetailServicioEndesaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {Date}
     * @memberof DetailServicioEndesaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailServicioEndesaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioEndesaModel
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEndesaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEndesaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEndesaModel
     */
    'Excluyente': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'Anexo': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEndesaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof DetailServicioEndesaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEndesaModel
     */
    'TieneTramitesAsociados': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof DetailServicioEndesaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {InfoServicioEnergiaEndesa}
     * @memberof DetailServicioEndesaModel
     */
    'DatosEndesa': InfoServicioEnergiaEndesa;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModel
     */
    'IdAnexoEmpresaServicios': string | null;
    /**
     * 
     * @type {Array<VariableAnexoValor>}
     * @memberof DetailServicioEndesaModel
     */
    'VariablesAnexo': Array<VariableAnexoValor> | null;
}


/**
 * 
 * @export
 * @interface DetailServicioEndesaModelResponseDTO
 */
export interface DetailServicioEndesaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailServicioEndesaModel}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'Data'?: DetailServicioEndesaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailServicioEndesaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailServicioEnergiaModel
 */
export interface DetailServicioEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'EmpresaServicios': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof DetailServicioEnergiaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {Date}
     * @memberof DetailServicioEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof DetailServicioEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioEnergiaModel
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEnergiaModel
     */
    'Excluyente': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'Anexo': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEnergiaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof DetailServicioEnergiaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEnergiaModel
     */
    'TieneTramitesAsociados': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof DetailServicioEnergiaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
}


/**
 * 
 * @export
 * @interface DetailServicioEnergiaModelResponseDTO
 */
export interface DetailServicioEnergiaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailServicioEnergiaModel}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'Data'?: DetailServicioEnergiaModel;
    /**
     * 
     * @type {any}
     * @memberof DetailServicioEnergiaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailServicioTramiteOperacionEnergiaModel
 */
export interface DetailServicioTramiteOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'Coste': number;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'CosteConDescuentos': number;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'Comision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'Retrocomision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'ReajusteComision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'ReajusteRetrocomision': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'MotivoReajusteComision': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'MotivoReajusteRetrocomision': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'ComisionEfectiva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'RetrocomisionEfectiva': number | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailServicioTramiteOperacionEnergiaModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface DetailTicketModel
 */
export interface DetailTicketModel {
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof DetailTicketModel
     */
    'CodigoSecuencial': number;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'Creador': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'Subtipo': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'Asunto': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'Estado': string;
    /**
     * 
     * @type {PrioridadTicketEnum}
     * @memberof DetailTicketModel
     */
    'Prioridad': PrioridadTicketEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTicketModel
     */
    'PuedeCerrarse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTicketModel
     */
    'PuedeSolicitarseCierre': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTicketModel
     */
    'PuedeEscribirMensajes': boolean;
    /**
     * 
     * @type {Array<MensajeTicketModel>}
     * @memberof DetailTicketModel
     */
    'Mensajes': Array<MensajeTicketModel>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DetailTicketModel
     */
    'EntidadesAsociadas': { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'Responsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModel
     */
    'UserNameResponsable': string | null;
}


/**
 * 
 * @export
 * @interface DetailTicketModelResponseDTO
 */
export interface DetailTicketModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailTicketModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailTicketModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTicketModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTicketModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailTicketModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailTicketModel}
     * @memberof DetailTicketModelResponseDTO
     */
    'Data'?: DetailTicketModel;
    /**
     * 
     * @type {any}
     * @memberof DetailTicketModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailTipoDocumentoEmpresaServiciosModel
 */
export interface DetailTipoDocumentoEmpresaServiciosModel {
    /**
     * 
     * @type {string}
     * @memberof DetailTipoDocumentoEmpresaServiciosModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTipoDocumentoEmpresaServiciosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTipoDocumentoEmpresaServiciosModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTipoDocumentoEmpresaServiciosModel
     */
    'AplicaPersonaJuridica': boolean;
}
/**
 * 
 * @export
 * @interface DetailTipoDocumentoEmpresaServiciosModelResponseDTO
 */
export interface DetailTipoDocumentoEmpresaServiciosModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailTipoDocumentoEmpresaServiciosModel}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'Data'?: DetailTipoDocumentoEmpresaServiciosModel;
    /**
     * 
     * @type {any}
     * @memberof DetailTipoDocumentoEmpresaServiciosModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DetailTramiteGasOperacionEnergiaModel
 */
export interface DetailTramiteGasOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'CodigoEstado': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'CUPS': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'TarifaAcceso': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'IdExterno': string | null;
    /**
     * 
     * @type {Array<DetailServicioTramiteOperacionEnergiaModel>}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Servicios': Array<DetailServicioTramiteOperacionEnergiaModel>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Alta': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'ConexionPrevia': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'DistintaComercializadoraMismoGrupo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'ComercializadoraAnterior': string | null;
    /**
     * 
     * @type {Array<DetailDescuentoTramiteOperacionEnergiaModel>}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Descuentos': Array<DetailDescuentoTramiteOperacionEnergiaModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'IdsDescuentos': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Consumo': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Comision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Retrocomision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'ReajusteComision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'ReajusteRetrocomision': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'MotivoReajusteComision': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'MotivoReajusteRetrocomision': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'ComisionEfectiva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'RetrocomisionEfectiva': number | null;
    /**
     * 
     * @type {DetailOfertaGas}
     * @memberof DetailTramiteGasOperacionEnergiaModel
     */
    'Oferta': DetailOfertaGas;
}
/**
 * 
 * @export
 * @interface DetailTramiteLuzOperacionEnergiaModel
 */
export interface DetailTramiteLuzOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'CodigoEstado': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'CUPS': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'TarifaAcceso': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'IdExterno': string | null;
    /**
     * 
     * @type {Array<DetailServicioTramiteOperacionEnergiaModel>}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Servicios': Array<DetailServicioTramiteOperacionEnergiaModel>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Alta': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'ConexionPrevia': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'DistintaComercializadoraMismoGrupo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'ComercializadoraAnterior': string | null;
    /**
     * 
     * @type {Array<DetailDescuentoTramiteOperacionEnergiaModel>}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Descuentos': Array<DetailDescuentoTramiteOperacionEnergiaModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'IdsDescuentos': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Consumo': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Comision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Retrocomision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'ReajusteComision': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'ReajusteRetrocomision': number | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'MotivoReajusteComision': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'MotivoReajusteRetrocomision': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'ComisionEfectiva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'RetrocomisionEfectiva': number | null;
    /**
     * 
     * @type {DetailOfertaLuz}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Oferta': DetailOfertaLuz;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'IdTension': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Tension': string | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P1': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P2': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P6': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P1_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P2_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P3_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P4_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P5_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'P6_Nueva': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'CambioPotenciaContratada': boolean;
    /**
     * 
     * @type {TipoAutoconsumoEnum}
     * @memberof DetailTramiteLuzOperacionEnergiaModel
     */
    'Autoconsumo': TipoAutoconsumoEnum | null;
}


/**
 * 
 * @export
 * @interface DetailUsuarioModel
 */
export interface DetailUsuarioModel {
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'Documento': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'Telefono': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'EmpresaAgentes': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailUsuarioModel
     */
    'Roles': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailUsuarioModel
     */
    'Validado': boolean | null;
    /**
     * 
     * @type {EstadoAgenteEnum}
     * @memberof DetailUsuarioModel
     */
    'IdEstado': EstadoAgenteEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModel
     */
    'CodigoEstado': string | null;
    /**
     * 
     * @type {Date}
     * @memberof DetailUsuarioModel
     */
    'FechaUltimoAcceso': Date | null;
    /**
     * 
     * @type {number}
     * @memberof DetailUsuarioModel
     */
    'ComparacionesDisponibles': number | null;
    /**
     * 
     * @type {DatosBOExternoModel}
     * @memberof DetailUsuarioModel
     */
    'DatosBOExterno': DatosBOExternoModel | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailUsuarioModel
     */
    'IdsDelegacionInmobiliaria': Array<string> | null;
}


/**
 * 
 * @export
 * @interface DetailUsuarioModelResponseDTO
 */
export interface DetailUsuarioModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {DetailUsuarioModel}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'Data'?: DetailUsuarioModel;
    /**
     * 
     * @type {any}
     * @memberof DetailUsuarioModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DireccionModel
 */
export interface DireccionModel {
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'CodigoPostal': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'Provincia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'Municipio': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'TipoVia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'NombreVia': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'Numero': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'Escalera': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'Piso': string | null;
    /**
     * 
     * @type {string}
     * @memberof DireccionModel
     */
    'Puerta': string | null;
}
/**
 * 
 * @export
 * @interface DocumentacionAutoregistroPorTipoModel
 */
export interface DocumentacionAutoregistroPorTipoModel {
    /**
     * 
     * @type {TipoDocumentoEmpresaAgentesEnum}
     * @memberof DocumentacionAutoregistroPorTipoModel
     */
    'TipoDocumento': TipoDocumentoEmpresaAgentesEnum;
    /**
     * 
     * @type {Array<File>}
     * @memberof DocumentacionAutoregistroPorTipoModel
     */
    'Archivos': Array<File>;
}


/**
 * 
 * @export
 * @interface DocumentosAguaModel
 */
export interface DocumentosAguaModel {
    /**
     * 
     * @type {string}
     * @memberof DocumentosAguaModel
     */
    'Id': string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAguaModel
     */
    'IdTipoDocumento': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAguaModel
     */
    'Tipo': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAguaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAguaModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosAguaModel
     */
    'Descripcion': string | null;
}
/**
 * 
 * @export
 * @interface DocumentosModel
 */
export interface DocumentosModel {
    /**
     * 
     * @type {string}
     * @memberof DocumentosModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoDocumentoOperacionEnergiaEnum}
     * @memberof DocumentosModel
     */
    'Tipo': TipoDocumentoOperacionEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosModel
     */
    'Ruta': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentosModel
     */
    'Descripcion': string | null;
}


/**
 * 
 * @export
 * @interface EditAgenteInmobiliariaModel
 */
export interface EditAgenteInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof EditAgenteInmobiliariaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteInmobiliariaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteInmobiliariaModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteInmobiliariaModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof EditAgenteInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteInmobiliariaModel
     */
    'IdEmpresaInmobiliaria': string | null;
    /**
     * 
     * @type {CometidoAgenteInmobiliariaEnum}
     * @memberof EditAgenteInmobiliariaModel
     */
    'IdCometido': CometidoAgenteInmobiliariaEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditAgenteInmobiliariaModel
     */
    'IdsDelegacionInmobiliaria': Array<string> | null;
}


/**
 * 
 * @export
 * @interface EditAgenteModel
 */
export interface EditAgenteModel {
    /**
     * 
     * @type {string}
     * @memberof EditAgenteModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgenteModel
     */
    'Telefono': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof EditAgenteModel
     */
    'Direccion': DireccionModel;
}
/**
 * 
 * @export
 * @interface EditAgentePersonalDataModel
 */
export interface EditAgentePersonalDataModel {
    /**
     * 
     * @type {string}
     * @memberof EditAgentePersonalDataModel
     */
    'IdUsuario': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgentePersonalDataModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgentePersonalDataModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgentePersonalDataModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgentePersonalDataModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof EditAgentePersonalDataModel
     */
    'Documento': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof EditAgentePersonalDataModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof EditAgentePersonalDataModel
     */
    'IdEmpresa': string;
}
/**
 * 
 * @export
 * @interface EditAnexoEmpresaServiciosDto
 */
export interface EditAnexoEmpresaServiciosDto {
    /**
     * 
     * @type {string}
     * @memberof EditAnexoEmpresaServiciosDto
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditAnexoEmpresaServiciosDto
     */
    'Descripcion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAnexoEmpresaServiciosDto
     */
    'ContenidoHtml': string;
    /**
     * 
     * @type {Array<DefinicionVariableAnexoDto>}
     * @memberof EditAnexoEmpresaServiciosDto
     */
    'DefinicionVariables': Array<DefinicionVariableAnexoDto>;
    /**
     * 
     * @type {string}
     * @memberof EditAnexoEmpresaServiciosDto
     */
    'Id': string;
}
/**
 * 
 * @export
 * @interface EditClienteInmobiliarioModel
 */
export interface EditClienteInmobiliarioModel {
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof EditClienteInmobiliarioModel
     */
    'TipoPersona': TipoPersonaEnum;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'RazonSocial': string | null;
    /**
     * 
     * @type {SubtipoPersonaEnum}
     * @memberof EditClienteInmobiliarioModel
     */
    'SubtipoPersona': SubtipoPersonaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'CIF': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'RutaDocumento': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'TelFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'TelMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'IbanPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'NombrePago': string | null;
    /**
     * 
     * @type {TipoDocumentoEnum}
     * @memberof EditClienteInmobiliarioModel
     */
    'TipoDocumentoPago': TipoDocumentoEnum | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'DocumentoPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClienteInmobiliarioModel
     */
    'ApellidosPago': string | null;
}


/**
 * 
 * @export
 * @interface EditComisionEnergiaOfertaModel
 */
export interface EditComisionEnergiaOfertaModel {
    /**
     * 
     * @type {string}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'Importe': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'AplicaPotencia': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'AplicaConsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'ConsumoMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'ConsumoMax': number | null;
    /**
     * 
     * @type {TipoTramiteComisionEnergiaEnum}
     * @memberof EditComisionEnergiaOfertaModel
     */
    'IdTipoTramite': TipoTramiteComisionEnergiaEnum;
}


/**
 * 
 * @export
 * @interface EditComisionEnergiaServicioModel
 */
export interface EditComisionEnergiaServicioModel {
    /**
     * 
     * @type {string}
     * @memberof EditComisionEnergiaServicioModel
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof EditComisionEnergiaServicioModel
     */
    'Importe': number;
}
/**
 * 
 * @export
 * @interface EditCriterioRetrocomisionEnergiaModel
 */
export interface EditCriterioRetrocomisionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'IdGrupo': string;
    /**
     * 
     * @type {TipoConceptoCriterioRetrocomisionEnergiaEnum}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'TipoConcepto': TipoConceptoCriterioRetrocomisionEnergiaEnum;
    /**
     * 
     * @type {number}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'PeriodoHasta': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'TarifaAcceso': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'Importe': number;
    /**
     * 
     * @type {string}
     * @memberof EditCriterioRetrocomisionEnergiaModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditDelegacionInmobiliariaModel
 */
export interface EditDelegacionInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'IdEmpresaInmobiliaria': string;
    /**
     * 
     * @type {string}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {string}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Web': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Coordinadores': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditDelegacionInmobiliariaModel
     */
    'Id': string;
}
/**
 * 
 * @export
 * @interface EditEmpresaColaboradoraModel
 */
export interface EditEmpresaColaboradoraModel {
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof EditEmpresaColaboradoraModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof EditEmpresaColaboradoraModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {FormaJuridicaEnum}
     * @memberof EditEmpresaColaboradoraModel
     */
    'FormaJuridica': FormaJuridicaEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EditEmpresaColaboradoraModel
     */
    'PorcentajeIrpf': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditEmpresaColaboradoraModel
     */
    'DiasAutofacturacion': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'ImagenB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'DenoFactura': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditEmpresaColaboradoraModel
     */
    'TieneWhitelistServicios': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditEmpresaColaboradoraModel
     */
    'WhitelistServicios': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'MarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'LogoPortalB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'UsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'IdComercial': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'IdSubtipo': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaColaboradoraModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditEmpresaInmobiliariaModel
 */
export interface EditEmpresaInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'Documento': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DireccionModel}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'Iban': string | null;
    /**
     * 
     * @type {FormaJuridicaEnum}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'FormaJuridica': FormaJuridicaEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'PorcentajeIrpf': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'DiasAutofacturacion': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'ImagenB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'DenoFactura': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'TieneWhitelistServicios': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'WhitelistServicios': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'MarcoComisiones': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'LogoPortalB64': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'UsuarioResponsable': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'IdComercial': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'PuedeTramitarAgua': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaInmobiliariaModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditEmpresaServiciosModel
 */
export interface EditEmpresaServiciosModel {
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaServiciosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoEmpresaServiciosEnum}
     * @memberof EditEmpresaServiciosModel
     */
    'Tipo': TipoEmpresaServiciosEnum;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaServiciosModel
     */
    'DireccionContacto': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaServiciosModel
     */
    'NombreContacto': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaServiciosModel
     */
    'TelContacto': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaServiciosModel
     */
    'EmailContacto': string;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaServiciosModel
     */
    'ImagenB64': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditEmpresaServiciosModel
     */
    'Activado': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditEmpresaServiciosModel
     */
    'IdsGestoresSoporte': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EditEmpresaServiciosModel
     */
    'IdEsave': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditEmpresaServiciosModel
     */
    'SincronizaEsave': boolean | null;
    /**
     * 
     * @type {GrupoEmpresaEnergiaEnum}
     * @memberof EditEmpresaServiciosModel
     */
    'IdGrupoEmpresa': GrupoEmpresaEnergiaEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditEmpresaServiciosModel
     */
    'RequiereConsentimientoPrevio': boolean;
    /**
     * 
     * @type {PlantillaConsentimientoPrevioEnum}
     * @memberof EditEmpresaServiciosModel
     */
    'IdPlantillaConsentimiento': PlantillaConsentimientoPrevioEnum | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditEmpresaServiciosModel
     */
    'CodigosProvinciaDondeOpera': Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof EditEmpresaServiciosModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditInmuebleModel
 */
export interface EditInmuebleModel {
    /**
     * 
     * @type {string}
     * @memberof EditInmuebleModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoInmuebleEnum}
     * @memberof EditInmuebleModel
     */
    'TipoInmueble': TipoInmuebleEnum;
    /**
     * 
     * @type {TipoObraEnum}
     * @memberof EditInmuebleModel
     */
    'TipoObra': TipoObraEnum;
    /**
     * 
     * @type {DireccionModel}
     * @memberof EditInmuebleModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {TipoCalentadorEnum}
     * @memberof EditInmuebleModel
     */
    'TipoCalentador': TipoCalentadorEnum;
    /**
     * 
     * @type {TipoCocinaEnum}
     * @memberof EditInmuebleModel
     */
    'TipoCocina': TipoCocinaEnum;
    /**
     * 
     * @type {TipoCalefaccionEnum}
     * @memberof EditInmuebleModel
     */
    'TipoCalefaccion': TipoCalefaccionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EditInmuebleModel
     */
    'TieneCalefaccionCentral': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditInmuebleModel
     */
    'CapacidadMaxima': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditInmuebleModel
     */
    'TieneServicioLuz': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditInmuebleModel
     */
    'CupsLuz': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditInmuebleModel
     */
    'TieneServicioGas': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditInmuebleModel
     */
    'CupsGas': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditInmuebleModel
     */
    'TieneServicioAgua': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditInmuebleModel
     */
    'IdDelegacionInmobiliaria': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditInmuebleModel
     */
    'IdAgenteResponsable': string | null;
}


/**
 * 
 * @export
 * @interface EditMarcoComisionesEmpresaAgentesModel
 */
export interface EditMarcoComisionesEmpresaAgentesModel {
    /**
     * 
     * @type {string}
     * @memberof EditMarcoComisionesEmpresaAgentesModel
     */
    'IdMarcoComisiones': string;
}
/**
 * 
 * @export
 * @interface EditMarcoComisionesModel
 */
export interface EditMarcoComisionesModel {
    /**
     * 
     * @type {string}
     * @memberof EditMarcoComisionesModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditMarcoComisionesModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface EditNotaBorradorOperacionModel
 */
export interface EditNotaBorradorOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditNotaBorradorOperacionModel
     */
    'IdNota': string;
    /**
     * 
     * @type {string}
     * @memberof EditNotaBorradorOperacionModel
     */
    'Contenido': string;
}
/**
 * 
 * @export
 * @interface EditNotaOperacionModel
 */
export interface EditNotaOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof EditNotaOperacionModel
     */
    'IdNota': string;
    /**
     * 
     * @type {string}
     * @memberof EditNotaOperacionModel
     */
    'Contenido': string;
}
/**
 * 
 * @export
 * @interface EditNotaTramiteEnergiaModel
 */
export interface EditNotaTramiteEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof EditNotaTramiteEnergiaModel
     */
    'IdNota': string;
    /**
     * 
     * @type {string}
     * @memberof EditNotaTramiteEnergiaModel
     */
    'Contenido': string;
}
/**
 * 
 * @export
 * @interface EditOfertaEndesaModel
 */
export interface EditOfertaEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof EditOfertaEndesaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof EditOfertaEndesaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof EditOfertaEndesaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoTarifaEnergiaEnum}
     * @memberof EditOfertaEndesaModel
     */
    'TipoTarifa': TipoTarifaEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEndesaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEndesaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {OfertaLuzModel}
     * @memberof EditOfertaEndesaModel
     */
    'DatosLuz': OfertaLuzModel | null;
    /**
     * 
     * @type {OfertaGasModel}
     * @memberof EditOfertaEndesaModel
     */
    'DatosGas': OfertaGasModel | null;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'Observaciones': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEndesaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof EditOfertaEndesaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEndesaModel
     */
    'RequiereRellenado': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'CodigoTalonario': string | null;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof EditOfertaEndesaModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EditOfertaEndesaModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof EditOfertaEndesaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {OfertaEndesaModel}
     * @memberof EditOfertaEndesaModel
     */
    'DatosEndesa': OfertaEndesaModel;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'IdAnexoEmpresaServicios': string | null;
    /**
     * 
     * @type {Array<VariableAnexoValor>}
     * @memberof EditOfertaEndesaModel
     */
    'VariablesAnexo': Array<VariableAnexoValor> | null;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEndesaModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditOfertaEnergiaModel
 */
export interface EditOfertaEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof EditOfertaEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof EditOfertaEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof EditOfertaEnergiaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoTarifaEnergiaEnum}
     * @memberof EditOfertaEnergiaModel
     */
    'TipoTarifa': TipoTarifaEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEnergiaModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {OfertaLuzModel}
     * @memberof EditOfertaEnergiaModel
     */
    'DatosLuz': OfertaLuzModel | null;
    /**
     * 
     * @type {OfertaGasModel}
     * @memberof EditOfertaEnergiaModel
     */
    'DatosGas': OfertaGasModel | null;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEnergiaModel
     */
    'Observaciones': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEnergiaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof EditOfertaEnergiaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof EditOfertaEnergiaModel
     */
    'RequiereRellenado': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEnergiaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEnergiaModel
     */
    'CodigoTalonario': string | null;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof EditOfertaEnergiaModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EditOfertaEnergiaModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof EditOfertaEnergiaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {string}
     * @memberof EditOfertaEnergiaModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditOperacionAguaModel
 */
export interface EditOperacionAguaModel {
    /**
     * 
     * @type {string}
     * @memberof EditOperacionAguaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {TitularModel}
     * @memberof EditOperacionAguaModel
     */
    'Titular': TitularModel;
    /**
     * 
     * @type {SuministroAguaModel}
     * @memberof EditOperacionAguaModel
     */
    'Suministro': SuministroAguaModel;
    /**
     * 
     * @type {FacturacionAguaModel}
     * @memberof EditOperacionAguaModel
     */
    'Facturacion': FacturacionAguaModel;
    /**
     * 
     * @type {string}
     * @memberof EditOperacionAguaModel
     */
    'IdBorradorOperacion': string | null;
    /**
     * 
     * @type {Array<ArchivoOperacionAguaModel>}
     * @memberof EditOperacionAguaModel
     */
    'Archivos': Array<ArchivoOperacionAguaModel>;
    /**
     * 
     * @type {string}
     * @memberof EditOperacionAguaModel
     */
    'Id': string;
}
/**
 * 
 * @export
 * @interface EditOperacionEnergiaDto
 */
export interface EditOperacionEnergiaDto {
    /**
     * 
     * @type {boolean}
     * @memberof EditOperacionEnergiaDto
     */
    'PermiteResetOperacionEnergia': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditOperacionEnergiaDto
     */
    'OperacionId': string;
}
/**
 * 
 * @export
 * @interface EditOperacionEnergiaDtoResponseDTO
 */
export interface EditOperacionEnergiaDtoResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {EditOperacionEnergiaDto}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'Data'?: EditOperacionEnergiaDto;
    /**
     * 
     * @type {any}
     * @memberof EditOperacionEnergiaDtoResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface EditOperacionEnergiaModel
 */
export interface EditOperacionEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof EditOperacionEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {OrigenConocimientoCupsEnum}
     * @memberof EditOperacionEnergiaModel
     */
    'OrigenConocimientoCups': OrigenConocimientoCupsEnum | null;
    /**
     * 
     * @type {TitularModel}
     * @memberof EditOperacionEnergiaModel
     */
    'Titular': TitularModel;
    /**
     * 
     * @type {SuministroModel}
     * @memberof EditOperacionEnergiaModel
     */
    'Suministro': SuministroModel;
    /**
     * 
     * @type {TramiteLuzModel}
     * @memberof EditOperacionEnergiaModel
     */
    'TramiteLuz': TramiteLuzModel | null;
    /**
     * 
     * @type {TramiteGasModel}
     * @memberof EditOperacionEnergiaModel
     */
    'TramiteGas': TramiteGasModel | null;
    /**
     * 
     * @type {FacturacionModel}
     * @memberof EditOperacionEnergiaModel
     */
    'Facturacion': FacturacionModel;
    /**
     * 
     * @type {Array<DocumentosModel>}
     * @memberof EditOperacionEnergiaModel
     */
    'Documentos': Array<DocumentosModel>;
    /**
     * 
     * @type {string}
     * @memberof EditOperacionEnergiaModel
     */
    'IdBorradorOperacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditOperacionEnergiaModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditRappelEnergiaModel
 */
export interface EditRappelEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof EditRappelEnergiaModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoElementoOperacionEnergiaEnum}
     * @memberof EditRappelEnergiaModel
     */
    'TipoElemento': TipoElementoOperacionEnergiaEnum;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof EditRappelEnergiaModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {Date}
     * @memberof EditRappelEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof EditRappelEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof EditRappelEnergiaModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditRappelEnergiaModel
     */
    'VolumenMin': number;
    /**
     * 
     * @type {number}
     * @memberof EditRappelEnergiaModel
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof EditRappelEnergiaModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {string}
     * @memberof EditRappelEnergiaModel
     */
    'Nombre': string | null;
}


/**
 * 
 * @export
 * @interface EditReajusteComisionEnergiaOfertaEmpresaAgentesModel
 */
export interface EditReajusteComisionEnergiaOfertaEmpresaAgentesModel {
    /**
     * 
     * @type {string}
     * @memberof EditReajusteComisionEnergiaOfertaEmpresaAgentesModel
     */
    'IdMarcoComisiones': string;
    /**
     * 
     * @type {string}
     * @memberof EditReajusteComisionEnergiaOfertaEmpresaAgentesModel
     */
    'IdComision': string;
    /**
     * 
     * @type {number}
     * @memberof EditReajusteComisionEnergiaOfertaEmpresaAgentesModel
     */
    'Importe': number | null;
}
/**
 * 
 * @export
 * @interface EditReajusteComisionEnergiaServicioEmpresaAgentesModel
 */
export interface EditReajusteComisionEnergiaServicioEmpresaAgentesModel {
    /**
     * 
     * @type {string}
     * @memberof EditReajusteComisionEnergiaServicioEmpresaAgentesModel
     */
    'IdMarcoComisiones': string;
    /**
     * 
     * @type {string}
     * @memberof EditReajusteComisionEnergiaServicioEmpresaAgentesModel
     */
    'IdComision': string;
    /**
     * 
     * @type {number}
     * @memberof EditReajusteComisionEnergiaServicioEmpresaAgentesModel
     */
    'Importe': number | null;
}
/**
 * 
 * @export
 * @interface EditReajusteMarcoComisionEmpresaAgentesModel
 */
export interface EditReajusteMarcoComisionEmpresaAgentesModel {
    /**
     * 
     * @type {string}
     * @memberof EditReajusteMarcoComisionEmpresaAgentesModel
     */
    'IdMarcoComisiones': string;
    /**
     * 
     * @type {string}
     * @memberof EditReajusteMarcoComisionEmpresaAgentesModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {number}
     * @memberof EditReajusteMarcoComisionEmpresaAgentesModel
     */
    'Porcentaje': number | null;
}
/**
 * 
 * @export
 * @interface EditRelacionClienteInmobiliarioInmuebleModel
 */
export interface EditRelacionClienteInmobiliarioInmuebleModel {
    /**
     * 
     * @type {string}
     * @memberof EditRelacionClienteInmobiliarioInmuebleModel
     */
    'Id': string;
    /**
     * 
     * @type {Date}
     * @memberof EditRelacionClienteInmobiliarioInmuebleModel
     */
    'FechaInicio': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EditRelacionClienteInmobiliarioInmuebleModel
     */
    'FechaFin': Date | null;
}
/**
 * 
 * @export
 * @interface EditServicioEndesaModel
 */
export interface EditServicioEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof EditServicioEndesaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEndesaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof EditServicioEndesaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof EditServicioEndesaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof EditServicioEndesaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEndesaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof EditServicioEndesaModel
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEndesaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEndesaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEndesaModel
     */
    'Excluyente': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEndesaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof EditServicioEndesaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEndesaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEndesaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof EditServicioEndesaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {ServicioEndesaModel}
     * @memberof EditServicioEndesaModel
     */
    'DatosEndesa': ServicioEndesaModel;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEndesaModel
     */
    'IdAnexoEmpresaServicios': string | null;
    /**
     * 
     * @type {Array<VariableAnexoValor>}
     * @memberof EditServicioEndesaModel
     */
    'VariablesAnexo': Array<VariableAnexoValor> | null;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEndesaModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditServicioEnergiaModel
 */
export interface EditServicioEnergiaModel {
    /**
     * 
     * @type {string}
     * @memberof EditServicioEnergiaModel
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEnergiaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof EditServicioEnergiaModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof EditServicioEnergiaModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof EditServicioEnergiaModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEnergiaModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof EditServicioEnergiaModel
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEnergiaModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEnergiaModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEnergiaModel
     */
    'Excluyente': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEnergiaModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {Array<CoordenadaFirma>}
     * @memberof EditServicioEnergiaModel
     */
    'CoordenadasFirma': Array<CoordenadaFirma>;
    /**
     * 
     * @type {boolean}
     * @memberof EditServicioEnergiaModel
     */
    'Activa': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEnergiaModel
     */
    'DenominacionInterna': string | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaModel>}
     * @memberof EditServicioEnergiaModel
     */
    'Descuentos': Array<DescuentoEnergiaModel>;
    /**
     * 
     * @type {string}
     * @memberof EditServicioEnergiaModel
     */
    'Id': string;
}


/**
 * 
 * @export
 * @interface EditTipoDocumentoEmpresaServiciosModel
 */
export interface EditTipoDocumentoEmpresaServiciosModel {
    /**
     * 
     * @type {string}
     * @memberof EditTipoDocumentoEmpresaServiciosModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditTipoDocumentoEmpresaServiciosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditTipoDocumentoEmpresaServiciosModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditTipoDocumentoEmpresaServiciosModel
     */
    'AplicaPersonaJuridica': boolean;
}
/**
 * 
 * @export
 * @interface EditUserModel
 */
export interface EditUserModel {
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Documento': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Telefono': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUserModel
     */
    'Roles': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EditUserModel
     */
    'Validado': boolean | null;
    /**
     * 
     * @type {EstadoAgenteEnum}
     * @memberof EditUserModel
     */
    'Estado': EstadoAgenteEnum | null;
    /**
     * 
     * @type {number}
     * @memberof EditUserModel
     */
    'ComparacionesDisponibles': number | null;
    /**
     * 
     * @type {DatosBOExternoModel}
     * @memberof EditUserModel
     */
    'DatosBOExterno': DatosBOExternoModel | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUserModel
     */
    'IdsDelegacionInmobiliaria': Array<string> | null;
}


/**
 * 
 * @export
 * @interface EmpresaAgenteComunicadoModel
 */
export interface EmpresaAgenteComunicadoModel {
    /**
     * 
     * @type {string}
     * @memberof EmpresaAgenteComunicadoModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EmpresaAgenteComunicadoModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface EmpresaServiciosModel
 */
export interface EmpresaServiciosModel {
    /**
     * 
     * @type {string}
     * @memberof EmpresaServiciosModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof EmpresaServiciosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EmpresaServiciosModel
     */
    'ImagenB64': string;
}
/**
 * 
 * @export
 * @interface EmpresaServiciosModelListResponseDTO
 */
export interface EmpresaServiciosModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<EmpresaServiciosModel>}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'Data'?: Array<EmpresaServiciosModel>;
    /**
     * 
     * @type {any}
     * @memberof EmpresaServiciosModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoAgenteEnum = {
    Activado: 'ACTIVADO',
    PteActivacion: 'PTE_ACTIVACION',
    Borrado: 'BORRADO'
} as const;

export type EstadoAgenteEnum = typeof EstadoAgenteEnum[keyof typeof EstadoAgenteEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoComunicadoEnum = {
    Borrador: 'BORRADOR',
    Enviado: 'ENVIADO'
} as const;

export type EstadoComunicadoEnum = typeof EstadoComunicadoEnum[keyof typeof EstadoComunicadoEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoEmpresaAgentesEnum = {
    Validada: 'VALIDADA',
    PdtValidar: 'PDT_VALIDAR',
    Baja: 'BAJA',
    Rechazada: 'RECHAZADA',
    PdtFirma: 'PDT_FIRMA'
} as const;

export type EstadoEmpresaAgentesEnum = typeof EstadoEmpresaAgentesEnum[keyof typeof EstadoEmpresaAgentesEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoLecturaComunicadoAgenteEnum = {
    NoEnviado: 'NO_ENVIADO',
    Enviado: 'ENVIADO',
    Leido: 'LEIDO'
} as const;

export type EstadoLecturaComunicadoAgenteEnum = typeof EstadoLecturaComunicadoAgenteEnum[keyof typeof EstadoLecturaComunicadoAgenteEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoLibreTramiteEnergiaEnum = {
    OperacionFirmada: 'OPERACION_FIRMADA',
    PdtValidar: 'PDT_VALIDAR',
    PdtTareas: 'PDT_TAREAS',
    PdtRecuperacion: 'PDT_RECUPERACION',
    Enviada: 'ENVIADA',
    Aceptada: 'ACEPTADA',
    RechazadoEnFirme: 'RECHAZADO_EN_FIRME',
    RechazadoReprocesable: 'RECHAZADO_REPROCESABLE',
    RechazadoPdtGestion: 'RECHAZADO_PDT_GESTION',
    Cancelado: 'CANCELADO'
} as const;

export type EstadoLibreTramiteEnergiaEnum = typeof EstadoLibreTramiteEnergiaEnum[keyof typeof EstadoLibreTramiteEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const EstadoOperacionEnergiaEnum = {
    PdtCompletar: 'PDT_COMPLETAR',
    PdtEnvioFirma: 'PDT_ENVIO_FIRMA',
    PdtFirma: 'PDT_FIRMA',
    Firmado: 'FIRMADO',
    PendienteBo: 'PENDIENTE_BO',
    AceptadaBo: 'ACEPTADA_BO',
    PdtGestionConsentimiento: 'PDT_GESTION_CONSENTIMIENTO',
    PdtRecepcionConsentimiento: 'PDT_RECEPCION_CONSENTIMIENTO'
} as const;

export type EstadoOperacionEnergiaEnum = typeof EstadoOperacionEnergiaEnum[keyof typeof EstadoOperacionEnergiaEnum];


/**
 * 
 * @export
 * @interface EstructuraDocumentalEmpresaAgentesModel
 */
export interface EstructuraDocumentalEmpresaAgentesModel {
    /**
     * 
     * @type {TipoDocumentoEmpresaAgentesEnum}
     * @memberof EstructuraDocumentalEmpresaAgentesModel
     */
    'TipoDocumento': TipoDocumentoEmpresaAgentesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalEmpresaAgentesModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalEmpresaAgentesModel
     */
    'Destacado': boolean;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalEmpresaAgentesModel
     */
    'CodigoAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalEmpresaAgentesModel
     */
    'IdDocumentoAdjunto': string | null;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalEmpresaAgentesModel
     */
    'NombreAdjunto': string | null;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalEmpresaAgentesModel
     */
    'RutaAdjunto': string | null;
}


/**
 * 
 * @export
 * @interface EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
 */
export interface EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<EstructuraDocumentalEmpresaAgentesModel>}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'Data'?: Array<EstructuraDocumentalEmpresaAgentesModel>;
    /**
     * 
     * @type {any}
     * @memberof EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface EstructuraDocumentalOperacionEnergiaModel
 */
export interface EstructuraDocumentalOperacionEnergiaModel {
    /**
     * 
     * @type {TipoDocumentoOperacionEnergiaEnum}
     * @memberof EstructuraDocumentalOperacionEnergiaModel
     */
    'TipoDocumento': TipoDocumentoOperacionEnergiaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionEnergiaModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionEnergiaModel
     */
    'Destacado': boolean;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionEnergiaModel
     */
    'CodigoAgrupacion': string | null;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionEnergiaModel
     */
    'Plantilla': string | null;
}


/**
 * 
 * @export
 * @interface EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
 */
export interface EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<EstructuraDocumentalOperacionEnergiaModel>}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'Data'?: Array<EstructuraDocumentalOperacionEnergiaModel>;
    /**
     * 
     * @type {any}
     * @memberof EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface EstructuraDocumentalOperacionModel
 */
export interface EstructuraDocumentalOperacionModel {
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionModel
     */
    'IdTipoDocumento': string;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionModel
     */
    'TipoDocumento': string;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionModel
     */
    'Requerido': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionModel
     */
    'Destacado': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionModel
     */
    'RequiereDescripcion': boolean;
}
/**
 * 
 * @export
 * @interface EstructuraDocumentalOperacionModelArrayResponseDTO
 */
export interface EstructuraDocumentalOperacionModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<EstructuraDocumentalOperacionModel>}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'Data'?: Array<EstructuraDocumentalOperacionModel>;
    /**
     * 
     * @type {any}
     * @memberof EstructuraDocumentalOperacionModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ExistsContactoLeadByMobileModel
 */
export interface ExistsContactoLeadByMobileModel {
    /**
     * 
     * @type {string}
     * @memberof ExistsContactoLeadByMobileModel
     */
    'Telefono': string;
}
/**
 * 
 * @export
 * @interface FacturaConfigModel
 */
export interface FacturaConfigModel {
    /**
     * 
     * @type {string}
     * @memberof FacturaConfigModel
     */
    'CodigoFactura': string;
    /**
     * 
     * @type {Date}
     * @memberof FacturaConfigModel
     */
    'FechaEmision': Date;
    /**
     * 
     * @type {Date}
     * @memberof FacturaConfigModel
     */
    'FechaAlta': Date;
    /**
     * 
     * @type {string}
     * @memberof FacturaConfigModel
     */
    'IbanEmisor': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaConfigModel
     */
    'NombreEmisor': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaConfigModel
     */
    'NifEmisor': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof FacturaConfigModel
     */
    'DireccionEmisor': DireccionModel;
    /**
     * 
     * @type {number}
     * @memberof FacturaConfigModel
     */
    'IrpfEmpresa': number | null;
}
/**
 * 
 * @export
 * @interface FacturaConfigModelResponseDTO
 */
export interface FacturaConfigModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof FacturaConfigModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof FacturaConfigModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FacturaConfigModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacturaConfigModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacturaConfigModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacturaConfigModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {FacturaConfigModel}
     * @memberof FacturaConfigModelResponseDTO
     */
    'Data'?: FacturaConfigModel;
    /**
     * 
     * @type {any}
     * @memberof FacturaConfigModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface FacturaDetailModel
 */
export interface FacturaDetailModel {
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'IdentificadorBorrador': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'Identificador': string | null;
    /**
     * 
     * @type {Date}
     * @memberof FacturaDetailModel
     */
    'FechaEmision': Date;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'Notas': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'NombreEmisor': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'TipoEmpresaAgentes': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'EmpresaAgentes': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'Estado': string;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'MotivoRechazo': string | null;
    /**
     * 
     * @type {number}
     * @memberof FacturaDetailModel
     */
    'BaseImponible': number;
    /**
     * 
     * @type {number}
     * @memberof FacturaDetailModel
     */
    'ImpuestoIva': number;
    /**
     * 
     * @type {number}
     * @memberof FacturaDetailModel
     */
    'RetencionIrpf': number;
    /**
     * 
     * @type {number}
     * @memberof FacturaDetailModel
     */
    'ImporteTotal': number;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'RutaDescarga': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'RutaFacturaPropia': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModel
     */
    'IdTicketAbierto': string | null;
}
/**
 * 
 * @export
 * @interface FacturaDetailModelResponseDTO
 */
export interface FacturaDetailModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof FacturaDetailModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof FacturaDetailModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FacturaDetailModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacturaDetailModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacturaDetailModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {FacturaDetailModel}
     * @memberof FacturaDetailModelResponseDTO
     */
    'Data'?: FacturaDetailModel;
    /**
     * 
     * @type {any}
     * @memberof FacturaDetailModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface FacturacionAguaModel
 */
export interface FacturacionAguaModel {
    /**
     * 
     * @type {string}
     * @memberof FacturacionAguaModel
     */
    'IBAN': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FacturacionAguaModel
     */
    'TitularDistintoContrato': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacturacionAguaModel
     */
    'Nombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacturacionAguaModel
     */
    'Apellidos': string | null;
    /**
     * 
     * @type {TipoDocumentoEnum}
     * @memberof FacturacionAguaModel
     */
    'TipoDocumento': TipoDocumentoEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FacturacionAguaModel
     */
    'Documento': string | null;
}


/**
 * 
 * @export
 * @interface FacturacionModel
 */
export interface FacturacionModel {
    /**
     * 
     * @type {string}
     * @memberof FacturacionModel
     */
    'IBAN': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FacturacionModel
     */
    'TitularDistintoContrato': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacturacionModel
     */
    'Nombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacturacionModel
     */
    'Apellidos': string | null;
    /**
     * 
     * @type {TipoDocumentoEnum}
     * @memberof FacturacionModel
     */
    'TipoDocumento': TipoDocumentoEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FacturacionModel
     */
    'Documento': string | null;
}


/**
 * 
 * @export
 * @interface FileStreamResultResponseDTO
 */
export interface FileStreamResultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof FileStreamResultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof FileStreamResultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FileStreamResultResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileStreamResultResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof FileStreamResultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileStreamResultResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {File}
     * @memberof FileStreamResultResponseDTO
     */
    'Data'?: File;
    /**
     * 
     * @type {any}
     * @memberof FileStreamResultResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FormaJuridicaEnum = {
    Autonomo: 'AUTONOMO',
    SociedadLimitada: 'SOCIEDAD_LIMITADA'
} as const;

export type FormaJuridicaEnum = typeof FormaJuridicaEnum[keyof typeof FormaJuridicaEnum];


/**
 * 
 * @export
 * @interface GetAgentePersonalDataModel
 */
export interface GetAgentePersonalDataModel {
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModel
     */
    'IdUsuario': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModel
     */
    'Documento': string;
    /**
     * 
     * @type {DireccionModel}
     * @memberof GetAgentePersonalDataModel
     */
    'Direccion': DireccionModel;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModel
     */
    'RutaDocumentoDni': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetAgentePersonalDataModel
     */
    'ComparacionesDisponibles': number;
}
/**
 * 
 * @export
 * @interface GetAgentePersonalDataModelResponseDTO
 */
export interface GetAgentePersonalDataModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetAgentePersonalDataModel}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'Data'?: GetAgentePersonalDataModel;
    /**
     * 
     * @type {any}
     * @memberof GetAgentePersonalDataModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GetEmpresasServiciosByTipoModel
 */
export interface GetEmpresasServiciosByTipoModel {
    /**
     * 
     * @type {string}
     * @memberof GetEmpresasServiciosByTipoModel
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {Array<TipoEmpresaServiciosEnum>}
     * @memberof GetEmpresasServiciosByTipoModel
     */
    'Tipos': Array<TipoEmpresaServiciosEnum>;
}
/**
 * 
 * @export
 * @interface GetNotificacionesModel
 */
export interface GetNotificacionesModel {
    /**
     * 
     * @type {Array<NotificacionModel>}
     * @memberof GetNotificacionesModel
     */
    'NotificacionesSinLeer': Array<NotificacionModel>;
    /**
     * 
     * @type {Array<NotificacionModel>}
     * @memberof GetNotificacionesModel
     */
    'NotificacionesLeidas': Array<NotificacionModel>;
}
/**
 * 
 * @export
 * @interface GetNotificacionesModelResponseDTO
 */
export interface GetNotificacionesModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {GetNotificacionesModel}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Data'?: GetNotificacionesModel;
    /**
     * 
     * @type {any}
     * @memberof GetNotificacionesModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GroupingInfo
 */
export interface GroupingInfo {
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'desc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'groupInterval'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'isExpanded'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GrupoEmpresaEnergiaEnum = {
    Endesa: 'ENDESA',
    Iberdrola: 'IBERDROLA',
    Naturgy: 'NATURGY',
    Repsol: 'REPSOL',
    Edp: 'EDP',
    TotalEnergies: 'TOTAL_ENERGIES',
    Audax: 'AUDAX',
    Holaluz: 'HOLALUZ',
    Plenitude: 'PLENITUDE',
    FactorEnergia: 'FACTOR_ENERGIA',
    Visalia: 'VISALIA',
    GanaEnergia: 'GANA_ENERGIA',
    ContigoEnergia: 'CONTIGO_ENERGIA',
    LuzRural: 'LUZ_RURAL',
    AdxEnergia: 'ADX_ENERGIA',
    Energya: 'ENERGYA'
} as const;

export type GrupoEmpresaEnergiaEnum = typeof GrupoEmpresaEnergiaEnum[keyof typeof GrupoEmpresaEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const GrupoUsuarioEnum = {
    Backoffice: 'BACKOFFICE',
    Inmobiliaria: 'INMOBILIARIA',
    Colaboradores: 'COLABORADORES'
} as const;

export type GrupoUsuarioEnum = typeof GrupoUsuarioEnum[keyof typeof GrupoUsuarioEnum];


/**
 * 
 * @export
 * @interface GuidArrayResponseDTO
 */
export interface GuidArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GuidArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GuidArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GuidArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GuidArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GuidArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuidArrayResponseDTO
     */
    'Data'?: Array<string>;
    /**
     * 
     * @type {any}
     * @memberof GuidArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GuidListResponseDTO
 */
export interface GuidListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof GuidListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof GuidListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GuidListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GuidListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof GuidListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuidListResponseDTO
     */
    'Data'?: Array<string>;
    /**
     * 
     * @type {any}
     * @memberof GuidListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ImportResultDto
 */
export interface ImportResultDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof ImportResultDto
     */
    'RegistrosProcesadosCorrectamente': Array<number>;
    /**
     * 
     * @type {Array<RowImportResultDto>}
     * @memberof ImportResultDto
     */
    'RegistrosOmitidos': Array<RowImportResultDto>;
    /**
     * 
     * @type {Array<RowImportResultDto>}
     * @memberof ImportResultDto
     */
    'RegistrosAdvertencia': Array<RowImportResultDto>;
    /**
     * 
     * @type {Array<RowImportResultDto>}
     * @memberof ImportResultDto
     */
    'RegistrosFallidos': Array<RowImportResultDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ImportResultDto
     */
    'EsSimulacion': boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportResultDto
     */
    'FicheroSimulacionBase64': string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportResultDto
     */
    'NombreFicheroSimulacion': string | null;
}
/**
 * 
 * @export
 * @interface ImportResultDtoResponseDTO
 */
export interface ImportResultDtoResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ImportResultDtoResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ImportResultDtoResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ImportResultDtoResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportResultDtoResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportResultDtoResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportResultDtoResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ImportResultDto}
     * @memberof ImportResultDtoResponseDTO
     */
    'Data'?: ImportResultDto;
    /**
     * 
     * @type {any}
     * @memberof ImportResultDtoResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface InfoBorradorOperacionClienteModel
 */
export interface InfoBorradorOperacionClienteModel {
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'Documento': string;
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'TipoPersona': TipoPersonaEnum;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'RazonSocial': string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'CIF': string | null;
    /**
     * 
     * @type {SubtipoPersonaEnum}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'SubtipoPersona': SubtipoPersonaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'TelefonoMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'TelefonoFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'IbanPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'NombrePago': string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'ApellidosPago': string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'DocumentoPago': string | null;
    /**
     * 
     * @type {TipoDocumentoEnum}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'TipoDocumentoPago': TipoDocumentoEnum | null;
    /**
     * 
     * @type {string}
     * @memberof InfoBorradorOperacionClienteModel
     */
    'NombreCompleto': string;
}


/**
 * 
 * @export
 * @interface InfoOfertaEnergiaEndesa
 */
export interface InfoOfertaEnergiaEndesa {
    /**
     * 
     * @type {string}
     * @memberof InfoOfertaEnergiaEndesa
     */
    'Miscelanea': string;
    /**
     * 
     * @type {string}
     * @memberof InfoOfertaEnergiaEndesa
     */
    'CodigoAnexo': string | null;
}
/**
 * 
 * @export
 * @interface InfoOfertaEnergiaGas
 */
export interface InfoOfertaEnergiaGas {
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaGas
     */
    'TerminoFijo': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaGas
     */
    'TerminoVariable': number;
}
/**
 * 
 * @export
 * @interface InfoOfertaEnergiaGasModel
 */
export interface InfoOfertaEnergiaGasModel {
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaGasModel
     */
    'TerminoFijo': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaGasModel
     */
    'TerminoVariable': number;
}
/**
 * 
 * @export
 * @interface InfoOfertaEnergiaLuz
 */
export interface InfoOfertaEnergiaLuz {
    /**
     * 
     * @type {boolean}
     * @memberof InfoOfertaEnergiaLuz
     */
    'Autoconsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaLuz
     */
    'PotenciaMin': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaLuz
     */
    'PotenciaMax': number;
    /**
     * 
     * @type {InfoOfertaEnergiaTermino}
     * @memberof InfoOfertaEnergiaLuz
     */
    'TerminoEnergia': InfoOfertaEnergiaTermino;
    /**
     * 
     * @type {InfoOfertaEnergiaTermino}
     * @memberof InfoOfertaEnergiaLuz
     */
    'TerminoPotencia': InfoOfertaEnergiaTermino;
}
/**
 * 
 * @export
 * @interface InfoOfertaEnergiaLuzModel
 */
export interface InfoOfertaEnergiaLuzModel {
    /**
     * 
     * @type {boolean}
     * @memberof InfoOfertaEnergiaLuzModel
     */
    'Autoconsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaLuzModel
     */
    'PotenciaMin': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaLuzModel
     */
    'PotenciaMax': number;
    /**
     * 
     * @type {InfoOfertaEnergiaTerminoModel}
     * @memberof InfoOfertaEnergiaLuzModel
     */
    'TerminoEnergia': InfoOfertaEnergiaTerminoModel;
    /**
     * 
     * @type {InfoOfertaEnergiaTerminoModel}
     * @memberof InfoOfertaEnergiaLuzModel
     */
    'TerminoPotencia': InfoOfertaEnergiaTerminoModel;
}
/**
 * 
 * @export
 * @interface InfoOfertaEnergiaTermino
 */
export interface InfoOfertaEnergiaTermino {
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTermino
     */
    'P1': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTermino
     */
    'P2': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTermino
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTermino
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTermino
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTermino
     */
    'P6': number | null;
}
/**
 * 
 * @export
 * @interface InfoOfertaEnergiaTerminoModel
 */
export interface InfoOfertaEnergiaTerminoModel {
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTerminoModel
     */
    'P1': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTerminoModel
     */
    'P2': number;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTerminoModel
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTerminoModel
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTerminoModel
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof InfoOfertaEnergiaTerminoModel
     */
    'P6': number | null;
}
/**
 * 
 * @export
 * @interface InfoServicioEnergiaEndesa
 */
export interface InfoServicioEnergiaEndesa {
    /**
     * 
     * @type {string}
     * @memberof InfoServicioEnergiaEndesa
     */
    'Miscelanea': string;
}
/**
 * 
 * @export
 * @interface IniciarFirmaAutorizacionClienteInmobiliarioModel
 */
export interface IniciarFirmaAutorizacionClienteInmobiliarioModel {
    /**
     * 
     * @type {string}
     * @memberof IniciarFirmaAutorizacionClienteInmobiliarioModel
     */
    'Email': string | null;
}
/**
 * 
 * @export
 * @interface Int32ResponseDTO
 */
export interface Int32ResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof Int32ResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof Int32ResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof Int32ResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof Int32ResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Int32ResponseDTO
     */
    'Data'?: number;
    /**
     * 
     * @type {any}
     * @memberof Int32ResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface LineaReajusteConceptoFacturaModel
 */
export interface LineaReajusteConceptoFacturaModel {
    /**
     * 
     * @type {string}
     * @memberof LineaReajusteConceptoFacturaModel
     */
    'IdTramite': string;
    /**
     * 
     * @type {string}
     * @memberof LineaReajusteConceptoFacturaModel
     */
    'IdServicioIncluido': string | null;
    /**
     * 
     * @type {number}
     * @memberof LineaReajusteConceptoFacturaModel
     */
    'Cantidad': number;
}
/**
 * 
 * @export
 * @interface LiquidacionFacturaModel
 */
export interface LiquidacionFacturaModel {
    /**
     * 
     * @type {string}
     * @memberof LiquidacionFacturaModel
     */
    'IdTramite': string;
    /**
     * 
     * @type {string}
     * @memberof LiquidacionFacturaModel
     */
    'IdServicioIncluido': string | null;
}
/**
 * 
 * @export
 * @interface LoadResult
 */
export interface LoadResult {
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'data'?: Array<any> | null;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'groupCount'?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'summary'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface LoadResultResponseDTO
 */
export interface LoadResultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof LoadResultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof LoadResultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof LoadResultResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoadResultResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoadResultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoadResultResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {LoadResult}
     * @memberof LoadResultResponseDTO
     */
    'Data'?: LoadResult;
    /**
     * 
     * @type {any}
     * @memberof LoadResultResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface MensajeTicketModel
 */
export interface MensajeTicketModel {
    /**
     * 
     * @type {string}
     * @memberof MensajeTicketModel
     */
    'Emisor': string;
    /**
     * 
     * @type {string}
     * @memberof MensajeTicketModel
     */
    'Mensaje': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MensajeTicketModel
     */
    'Adjuntos': Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof MensajeTicketModel
     */
    'Fecha': Date;
    /**
     * 
     * @type {boolean}
     * @memberof MensajeTicketModel
     */
    'EsMensajeSistema': boolean;
    /**
     * 
     * @type {string}
     * @memberof MensajeTicketModel
     */
    'Formato': string;
    /**
     * 
     * @type {boolean}
     * @memberof MensajeTicketModel
     */
    'LeidoPorRolContrario': boolean;
}
/**
 * 
 * @export
 * @interface NotificacionModel
 */
export interface NotificacionModel {
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Tipo': string;
    /**
     * 
     * @type {Date}
     * @memberof NotificacionModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Titulo': string;
    /**
     * 
     * @type {string}
     * @memberof NotificacionModel
     */
    'Mensaje': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificacionModel
     */
    'Referencias': Array<string>;
}
/**
 * 
 * @export
 * @interface OfertaEndesaModel
 */
export interface OfertaEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof OfertaEndesaModel
     */
    'Miscelanea': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEndesaModel
     */
    'CodigoAnexo': string | null;
}
/**
 * 
 * @export
 * @interface OfertaEnergiaForGridRm
 */
export interface OfertaEnergiaForGridRm {
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaForGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaForGridRm
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaForGridRm
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof OfertaEnergiaForGridRm
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof OfertaEnergiaForGridRm
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaForGridRm
     */
    'TipoEnergia': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaForGridRm
     */
    'TipoTarifa': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaForGridRm
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaForGridRm
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaForGridRm
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaForGridRm
     */
    'Autoconsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaForGridRm
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaForGridRm
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaForGridRm
     */
    'Activa': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaForGridRm
     */
    'TieneTramitesAsociados': boolean;
    /**
     * 
     * @type {Date}
     * @memberof OfertaEnergiaForGridRm
     */
    'FechaModificacion': Date;
    /**
     * 
     * @type {Date}
     * @memberof OfertaEnergiaForGridRm
     */
    'FechaUltSincronizacion': Date | null;
}
/**
 * 
 * @export
 * @interface OfertaEnergiaListItemModel
 */
export interface OfertaEnergiaListItemModel {
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaListItemModel
     */
    'ImagenEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaListItemModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaListItemModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertaEnergiaListItemModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoTarifaEnergiaEnum}
     * @memberof OfertaEnergiaListItemModel
     */
    'TipoTarifa': TipoTarifaEnergiaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaListItemModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaListItemModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {Date}
     * @memberof OfertaEnergiaListItemModel
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof OfertaEnergiaListItemModel
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaListItemModel
     */
    'Observaciones': string | null;
    /**
     * 
     * @type {InfoOfertaEnergiaLuzModel}
     * @memberof OfertaEnergiaListItemModel
     */
    'DatosLuz': InfoOfertaEnergiaLuzModel | null;
    /**
     * 
     * @type {InfoOfertaEnergiaGasModel}
     * @memberof OfertaEnergiaListItemModel
     */
    'DatosGas': InfoOfertaEnergiaGasModel | null;
    /**
     * 
     * @type {Array<DescuentoEnergiaListItemModel>}
     * @memberof OfertaEnergiaListItemModel
     */
    'Descuentos': Array<DescuentoEnergiaListItemModel>;
    /**
     * 
     * @type {Array<ServicioEnergiaListItemModel>}
     * @memberof OfertaEnergiaListItemModel
     */
    'Servicios': Array<ServicioEnergiaListItemModel>;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof OfertaEnergiaListItemModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaListItemModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {Array<ComisionOfertaEnergiaColaboradoresListItemModel>}
     * @memberof OfertaEnergiaListItemModel
     */
    'Comisiones': Array<ComisionOfertaEnergiaColaboradoresListItemModel> | null;
}


/**
 * 
 * @export
 * @interface OfertaEnergiaListItemModelPagedResultModel
 */
export interface OfertaEnergiaListItemModelPagedResultModel {
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaListItemModelPagedResultModel
     */
    'TotalCount': number;
    /**
     * 
     * @type {Array<OfertaEnergiaListItemModel>}
     * @memberof OfertaEnergiaListItemModelPagedResultModel
     */
    'Items': Array<OfertaEnergiaListItemModel>;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaListItemModelPagedResultModel
     */
    'PageSize': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaListItemModelPagedResultModel
     */
    'PageIndex': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaListItemModelPagedResultModel
     */
    'TotalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaListItemModelPagedResultModel
     */
    'HasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaListItemModelPagedResultModel
     */
    'HasPreviousPage': boolean;
}
/**
 * 
 * @export
 * @interface OfertaEnergiaListItemModelPagedResultModelResponseDTO
 */
export interface OfertaEnergiaListItemModelPagedResultModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OfertaEnergiaListItemModelPagedResultModel}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'Data'?: OfertaEnergiaListItemModelPagedResultModel;
    /**
     * 
     * @type {any}
     * @memberof OfertaEnergiaListItemModelPagedResultModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OfertaEnergiaRetribucionesBackofficeListItemModel
 */
export interface OfertaEnergiaRetribucionesBackofficeListItemModel {
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'ImagenEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'LuzConAutoconsumo': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'LuzPotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'LuzPotenciaMax': number | null;
    /**
     * 
     * @type {Array<ComisionOfertaEnergiaBackofficeListItemModel>}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'ComisionesOferta': Array<ComisionOfertaEnergiaBackofficeListItemModel>;
    /**
     * 
     * @type {Array<ComisionServicioEnergiaBackofficeListItemModel>}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'ComisionesServicios': Array<ComisionServicioEnergiaBackofficeListItemModel>;
    /**
     * 
     * @type {Array<RetrocomisionListItemModel>}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'Retrocomisiones': Array<RetrocomisionListItemModel>;
    /**
     * 
     * @type {Array<RappelListItemModel>}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModel
     */
    'Rappels': Array<RappelListItemModel>;
}


/**
 * 
 * @export
 * @interface OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
 */
export interface OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel {
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
     */
    'TotalCount': number;
    /**
     * 
     * @type {Array<OfertaEnergiaRetribucionesBackofficeListItemModel>}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
     */
    'Items': Array<OfertaEnergiaRetribucionesBackofficeListItemModel>;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
     */
    'PageSize': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
     */
    'PageIndex': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
     */
    'TotalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
     */
    'HasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel
     */
    'HasPreviousPage': boolean;
}
/**
 * 
 * @export
 * @interface OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
 */
export interface OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'Data'?: OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModel;
    /**
     * 
     * @type {any}
     * @memberof OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OfertaEnergiaRetribucionesColaboradoresListItemModel
 */
export interface OfertaEnergiaRetribucionesColaboradoresListItemModel {
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'ImagenEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'LuzConAutoconsumo': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'LuzPotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'LuzPotenciaMax': number | null;
    /**
     * 
     * @type {Array<ComisionOfertaEnergiaColaboradoresListItemModel>}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'ComisionesOferta': Array<ComisionOfertaEnergiaColaboradoresListItemModel>;
    /**
     * 
     * @type {Array<ComisionServicioEnergiaColaboradoresListItemModel>}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'ComisionesServicios': Array<ComisionServicioEnergiaColaboradoresListItemModel>;
    /**
     * 
     * @type {Array<RetrocomisionListItemModel>}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'Retrocomisiones': Array<RetrocomisionListItemModel>;
    /**
     * 
     * @type {Array<RappelListItemModel>}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModel
     */
    'Rappels': Array<RappelListItemModel>;
}


/**
 * 
 * @export
 * @interface OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
 */
export interface OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel {
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
     */
    'TotalCount': number;
    /**
     * 
     * @type {Array<OfertaEnergiaRetribucionesColaboradoresListItemModel>}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
     */
    'Items': Array<OfertaEnergiaRetribucionesColaboradoresListItemModel>;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
     */
    'PageSize': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
     */
    'PageIndex': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
     */
    'TotalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
     */
    'HasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel
     */
    'HasPreviousPage': boolean;
}
/**
 * 
 * @export
 * @interface OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
 */
export interface OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'Data'?: OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModel;
    /**
     * 
     * @type {any}
     * @memberof OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OfertaGasModel
 */
export interface OfertaGasModel {
    /**
     * 
     * @type {number}
     * @memberof OfertaGasModel
     */
    'TerminoFijo': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaGasModel
     */
    'TerminoVariable': number;
}
/**
 * 
 * @export
 * @interface OfertaLuzModel
 */
export interface OfertaLuzModel {
    /**
     * 
     * @type {boolean}
     * @memberof OfertaLuzModel
     */
    'Autoconsumo': boolean;
    /**
     * 
     * @type {number}
     * @memberof OfertaLuzModel
     */
    'PotenciaMin': number;
    /**
     * 
     * @type {number}
     * @memberof OfertaLuzModel
     */
    'PotenciaMax': number;
    /**
     * 
     * @type {TerminoEnergia}
     * @memberof OfertaLuzModel
     */
    'TerminoEnergia': TerminoEnergia;
    /**
     * 
     * @type {TerminoEnergia}
     * @memberof OfertaLuzModel
     */
    'TerminoPotencia': TerminoEnergia;
}
/**
 * 
 * @export
 * @interface OfertasEmpresaServiciosModel
 */
export interface OfertasEmpresaServiciosModel {
    /**
     * 
     * @type {string}
     * @memberof OfertasEmpresaServiciosModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof OfertasEmpresaServiciosModel
     */
    'Nombre': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertasEmpresaServiciosModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {TipoCosteGestionEnum}
     * @memberof OfertasEmpresaServiciosModel
     */
    'TipoCosteGestion': TipoCosteGestionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof OfertasEmpresaServiciosModel
     */
    'CosteGestion': number | null;
    /**
     * 
     * @type {string}
     * @memberof OfertasEmpresaServiciosModel
     */
    'TarifaAcceso': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfertasEmpresaServiciosModel
     */
    'AnexosDocumentacion': Array<string>;
    /**
     * 
     * @type {DatosOfertaLuzModel}
     * @memberof OfertasEmpresaServiciosModel
     */
    'DatosOfertaLuz': DatosOfertaLuzModel | null;
    /**
     * 
     * @type {DatosOfertaGasModel}
     * @memberof OfertasEmpresaServiciosModel
     */
    'DatosOfertaGas': DatosOfertaGasModel | null;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasEmpresaServiciosModel
     */
    'RequierePostRellenado': boolean;
    /**
     * 
     * @type {string}
     * @memberof OfertasEmpresaServiciosModel
     */
    'Observaciones': string;
}


/**
 * 
 * @export
 * @interface OfertasEmpresaServiciosModelListResponseDTO
 */
export interface OfertasEmpresaServiciosModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<OfertasEmpresaServiciosModel>}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'Data'?: Array<OfertasEmpresaServiciosModel>;
    /**
     * 
     * @type {any}
     * @memberof OfertasEmpresaServiciosModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OfertasEnergiaListFiltrosModel
 */
export interface OfertasEnergiaListFiltrosModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'Comercializadoras': Array<string> | null;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum | null;
    /**
     * 
     * @type {string}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'TarifaAcceso': string | null;
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'TipoPersona': TipoPersonaEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'ConAutoconsumo': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {Date}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'FechaInicio': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'FechaFin': Date | null;
    /**
     * 
     * @type {string}
     * @memberof OfertasEnergiaListFiltrosModel
     */
    'Texto': string | null;
}


/**
 * 
 * @export
 * @interface OfertasEnergiaRetribucionesBackofficeListFiltrosModel
 */
export interface OfertasEnergiaRetribucionesBackofficeListFiltrosModel {
    /**
     * 
     * @type {string}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'Comercializadora': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum | null;
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'TipoPersona': TipoPersonaEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'ConAutoconsumo': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {string}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'EmpresaAgentes': string;
    /**
     * 
     * @type {string}
     * @memberof OfertasEnergiaRetribucionesBackofficeListFiltrosModel
     */
    'MarcoComisiones': string;
}


/**
 * 
 * @export
 * @interface OfertasEnergiaRetribucionesListFiltrosModel
 */
export interface OfertasEnergiaRetribucionesListFiltrosModel {
    /**
     * 
     * @type {string}
     * @memberof OfertasEnergiaRetribucionesListFiltrosModel
     */
    'Comercializadora': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertasEnergiaRetribucionesListFiltrosModel
     */
    'TipoEnergia': TipoSuministroTramiteEnergiaEnum | null;
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof OfertasEnergiaRetribucionesListFiltrosModel
     */
    'TipoPersona': TipoPersonaEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasEnergiaRetribucionesListFiltrosModel
     */
    'ConAutoconsumo': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OfertasEnergiaRetribucionesListFiltrosModel
     */
    'PotenciaMin': number | null;
    /**
     * 
     * @type {number}
     * @memberof OfertasEnergiaRetribucionesListFiltrosModel
     */
    'PotenciaMax': number | null;
}


/**
 * 
 * @export
 * @interface OfertasServicioDistribuidoraModel
 */
export interface OfertasServicioDistribuidoraModel {
    /**
     * 
     * @type {string}
     * @memberof OfertasServicioDistribuidoraModel
     */
    'Id': string;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof OfertasServicioDistribuidoraModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof OfertasServicioDistribuidoraModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof OfertasServicioDistribuidoraModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof OfertasServicioDistribuidoraModel
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasServicioDistribuidoraModel
     */
    'Excluyente': boolean;
}


/**
 * 
 * @export
 * @interface OfertasServicioDistribuidoraModelListResponseDTO
 */
export interface OfertasServicioDistribuidoraModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<OfertasServicioDistribuidoraModel>}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'Data'?: Array<OfertasServicioDistribuidoraModel>;
    /**
     * 
     * @type {any}
     * @memberof OfertasServicioDistribuidoraModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OperacionEnergiaClienteModel
 */
export interface OperacionEnergiaClienteModel {
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'IdOperacion': string;
    /**
     * 
     * @type {number}
     * @memberof OperacionEnergiaClienteModel
     */
    'CodigoSecuencial': number;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'TelefonoMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'TelefonoFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'NombreAgente': string;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'Comercializadora': string;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'Direccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'TipoPersona': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'TarifaAccesoLuz': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'CupsLuz': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'TarifaAccesoGas': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'CupsGas': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionEnergiaClienteModel
     */
    'CodigoEstado': string;
    /**
     * 
     * @type {number}
     * @memberof OperacionEnergiaClienteModel
     */
    'Comision': number | null;
    /**
     * 
     * @type {number}
     * @memberof OperacionEnergiaClienteModel
     */
    'Retrocomision': number | null;
}
/**
 * 
 * @export
 * @interface OperacionInmobiliariaClienteModel
 */
export interface OperacionInmobiliariaClienteModel {
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'IdOperacion': string;
    /**
     * 
     * @type {number}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'CodigoSecuencial': number;
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'TelefonoMovil': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'TelefonoFijo': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'NombreAgente': string;
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'Comercializadora': string;
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'Direccion': string | null;
    /**
     * 
     * @type {string}
     * @memberof OperacionInmobiliariaClienteModel
     */
    'TipoPersona': string | null;
}
/**
 * 
 * @export
 * @interface OperacionPotencialmenteFraudulentaRm
 */
export interface OperacionPotencialmenteFraudulentaRm {
    /**
     * 
     * @type {string}
     * @memberof OperacionPotencialmenteFraudulentaRm
     */
    'TipoConflicto': string;
    /**
     * 
     * @type {string}
     * @memberof OperacionPotencialmenteFraudulentaRm
     */
    'ValorConflicto': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OperacionPotencialmenteFraudulentaRm
     */
    'DocumentosIdentidad': Array<string>;
}
/**
 * 
 * @export
 * @interface OperacionPotencialmenteFraudulentaRmListResponseDTO
 */
export interface OperacionPotencialmenteFraudulentaRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<OperacionPotencialmenteFraudulentaRm>}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'Data'?: Array<OperacionPotencialmenteFraudulentaRm>;
    /**
     * 
     * @type {any}
     * @memberof OperacionPotencialmenteFraudulentaRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OperacionesClienteModel
 */
export interface OperacionesClienteModel {
    /**
     * 
     * @type {Array<OperacionEnergiaClienteModel>}
     * @memberof OperacionesClienteModel
     */
    'OperacionesEnergia': Array<OperacionEnergiaClienteModel>;
    /**
     * 
     * @type {Array<OperacionInmobiliariaClienteModel>}
     * @memberof OperacionesClienteModel
     */
    'OperacionesInmobiliaria': Array<OperacionInmobiliariaClienteModel>;
}
/**
 * 
 * @export
 * @interface OperacionesClienteModelResponseDTO
 */
export interface OperacionesClienteModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OperacionesClienteModel}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'Data'?: OperacionesClienteModel;
    /**
     * 
     * @type {any}
     * @memberof OperacionesClienteModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrigenConocimientoCupsEnum = {
    FacturaActualTitular: 'FACTURA_ACTUAL_TITULAR',
    FacturaAnteriorTitular: 'FACTURA_ANTERIOR_TITULAR',
    ContratoAnterior: 'CONTRATO_ANTERIOR',
    Distribuidora: 'DISTRIBUIDORA'
} as const;

export type OrigenConocimientoCupsEnum = typeof OrigenConocimientoCupsEnum[keyof typeof OrigenConocimientoCupsEnum];


/**
 * 
 * @export
 * @interface ParametrosSimulacionComisionComparacionModel
 */
export interface ParametrosSimulacionComisionComparacionModel {
    /**
     * 
     * @type {DatosSimulacionComisionLuzModel}
     * @memberof ParametrosSimulacionComisionComparacionModel
     */
    'DatosLuz': DatosSimulacionComisionLuzModel | null;
    /**
     * 
     * @type {DatosSimulacionComisionGasModel}
     * @memberof ParametrosSimulacionComisionComparacionModel
     */
    'DatosGas': DatosSimulacionComisionGasModel | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PlantillaConsentimientoPrevioEnum = {
    GanaEnergia: 'GANA_ENERGIA',
    Repsol: 'REPSOL',
    EndesaDomestico: 'ENDESA_DOMESTICO',
    Naturgy: 'NATURGY'
} as const;

export type PlantillaConsentimientoPrevioEnum = typeof PlantillaConsentimientoPrevioEnum[keyof typeof PlantillaConsentimientoPrevioEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const PrioridadTicketEnum = {
    Baja: 'BAJA',
    Media: 'MEDIA',
    Alta: 'ALTA'
} as const;

export type PrioridadTicketEnum = typeof PrioridadTicketEnum[keyof typeof PrioridadTicketEnum];


/**
 * 
 * @export
 * @interface PublicInformationEmpresaInmobiliariaModel
 */
export interface PublicInformationEmpresaInmobiliariaModel {
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'RazonSocial': string;
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'Web': string;
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'Telefono': string;
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'Email': string;
    /**
     * 
     * @type {Date}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'RedesSociales': string | null;
    /**
     * 
     * @type {DetailDireccionModel}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'Direccion': DetailDireccionModel;
    /**
     * 
     * @type {boolean}
     * @memberof PublicInformationEmpresaInmobiliariaModel
     */
    'PuedeTramitarAgua': boolean;
}
/**
 * 
 * @export
 * @interface PublicInformationEmpresaInmobiliariaModelResponseDTO
 */
export interface PublicInformationEmpresaInmobiliariaModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {PublicInformationEmpresaInmobiliariaModel}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'Data'?: PublicInformationEmpresaInmobiliariaModel;
    /**
     * 
     * @type {any}
     * @memberof PublicInformationEmpresaInmobiliariaModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface RappelEnergiaForGridRm
 */
export interface RappelEnergiaForGridRm {
    /**
     * 
     * @type {string}
     * @memberof RappelEnergiaForGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RappelEnergiaForGridRm
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {Date}
     * @memberof RappelEnergiaForGridRm
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof RappelEnergiaForGridRm
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof RappelEnergiaForGridRm
     */
    'TipoElemento': string;
    /**
     * 
     * @type {string}
     * @memberof RappelEnergiaForGridRm
     */
    'TipoSuministro': string;
    /**
     * 
     * @type {string}
     * @memberof RappelEnergiaForGridRm
     */
    'EmpresaAgentes': string | null;
    /**
     * 
     * @type {number}
     * @memberof RappelEnergiaForGridRm
     */
    'VolumenMin': number;
    /**
     * 
     * @type {number}
     * @memberof RappelEnergiaForGridRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof RappelEnergiaForGridRm
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {string}
     * @memberof RappelEnergiaForGridRm
     */
    'Nombre': string | null;
}
/**
 * 
 * @export
 * @interface RappelListItemModel
 */
export interface RappelListItemModel {
    /**
     * 
     * @type {TipoElementoOperacionEnergiaEnum}
     * @memberof RappelListItemModel
     */
    'TipoElemento': TipoElementoOperacionEnergiaEnum;
    /**
     * 
     * @type {TipoSuministroTramiteEnergiaEnum}
     * @memberof RappelListItemModel
     */
    'TipoSuministro': TipoSuministroTramiteEnergiaEnum;
    /**
     * 
     * @type {string}
     * @memberof RappelListItemModel
     */
    'Nombre': string | null;
    /**
     * 
     * @type {number}
     * @memberof RappelListItemModel
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {number}
     * @memberof RappelListItemModel
     */
    'VolumenMin': number;
    /**
     * 
     * @type {number}
     * @memberof RappelListItemModel
     */
    'Importe': number;
}


/**
 * 
 * @export
 * @interface RappelMensualEnergiaForGridRm
 */
export interface RappelMensualEnergiaForGridRm {
    /**
     * 
     * @type {string}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'Anyo': number;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'Mes': number;
    /**
     * 
     * @type {string}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'TipoSuministro': string;
    /**
     * 
     * @type {string}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'TipoElemento': string;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'NumOperaciones': number;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'ComisionTotal': number;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'ComisionPorOperacion': number;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'PotenciaMax': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'Facturado': boolean;
    /**
     * 
     * @type {string}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'EmpresaServicios': string;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'Importe': number;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'ImporteEfectivo': number;
    /**
     * 
     * @type {number}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'ReajusteImporte': number | null;
    /**
     * 
     * @type {string}
     * @memberof RappelMensualEnergiaForGridRm
     */
    'MotivoReajusteImporte': string | null;
}
/**
 * 
 * @export
 * @interface RetrocomisionListItemModel
 */
export interface RetrocomisionListItemModel {
    /**
     * 
     * @type {TipoConceptoCriterioRetrocomisionEnergiaEnum}
     * @memberof RetrocomisionListItemModel
     */
    'TipoConcepto': TipoConceptoCriterioRetrocomisionEnergiaEnum;
    /**
     * 
     * @type {number}
     * @memberof RetrocomisionListItemModel
     */
    'PeriodoHasta': number;
    /**
     * 
     * @type {boolean}
     * @memberof RetrocomisionListItemModel
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetrocomisionListItemModel
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {number}
     * @memberof RetrocomisionListItemModel
     */
    'Importe': number;
}


/**
 * 
 * @export
 * @interface RolComunicadoModel
 */
export interface RolComunicadoModel {
    /**
     * 
     * @type {string}
     * @memberof RolComunicadoModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RolComunicadoModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface RolesRm
 */
export interface RolesRm {
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'NormalizedName': string;
}
/**
 * 
 * @export
 * @interface RolesRmListResponseDTO
 */
export interface RolesRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RolesRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RolesRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RolesRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolesRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof RolesRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RolesRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<RolesRm>}
     * @memberof RolesRmListResponseDTO
     */
    'Data'?: Array<RolesRm>;
    /**
     * 
     * @type {any}
     * @memberof RolesRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface RowImportResultDto
 */
export interface RowImportResultDto {
    /**
     * 
     * @type {number}
     * @memberof RowImportResultDto
     */
    'Fila': number;
    /**
     * 
     * @type {string}
     * @memberof RowImportResultDto
     */
    'Mensaje': string;
}
/**
 * 
 * @export
 * @interface SelectBoxEntityModel
 */
export interface SelectBoxEntityModel {
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface SelectBoxEntityModelArrayResponseDTO
 */
export interface SelectBoxEntityModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SelectBoxEntityModel>}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Data'?: Array<SelectBoxEntityModel>;
    /**
     * 
     * @type {any}
     * @memberof SelectBoxEntityModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SelectBoxEntityModelListResponseDTO
 */
export interface SelectBoxEntityModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SelectBoxEntityModel>}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'Data'?: Array<SelectBoxEntityModel>;
    /**
     * 
     * @type {any}
     * @memberof SelectBoxEntityModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SelectBoxGuidEntityModel
 */
export interface SelectBoxGuidEntityModel {
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface SelectBoxGuidEntityModelArrayResponseDTO
 */
export interface SelectBoxGuidEntityModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SelectBoxGuidEntityModel>}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Data'?: Array<SelectBoxGuidEntityModel>;
    /**
     * 
     * @type {any}
     * @memberof SelectBoxGuidEntityModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SelectBoxGuidEntityWithDefaultModel
 */
export interface SelectBoxGuidEntityWithDefaultModel {
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityWithDefaultModel
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityWithDefaultModel
     */
    'Denominacion': string;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxGuidEntityWithDefaultModel
     */
    'PorDefecto': boolean;
}
/**
 * 
 * @export
 * @interface SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
 */
export interface SelectBoxGuidEntityWithDefaultModelArrayResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SelectBoxGuidEntityWithDefaultModel>}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'Data'?: Array<SelectBoxGuidEntityWithDefaultModel>;
    /**
     * 
     * @type {any}
     * @memberof SelectBoxGuidEntityWithDefaultModelArrayResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SelectBoxIntEntityModel
 */
export interface SelectBoxIntEntityModel {
    /**
     * 
     * @type {number}
     * @memberof SelectBoxIntEntityModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxIntEntityModel
     */
    'Denominacion': string;
}
/**
 * 
 * @export
 * @interface SelectBoxIntEntityModelListResponseDTO
 */
export interface SelectBoxIntEntityModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SelectBoxIntEntityModel>}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'Data'?: Array<SelectBoxIntEntityModel>;
    /**
     * 
     * @type {any}
     * @memberof SelectBoxIntEntityModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ServicioEndesaModel
 */
export interface ServicioEndesaModel {
    /**
     * 
     * @type {string}
     * @memberof ServicioEndesaModel
     */
    'Miscelanea': string;
}
/**
 * 
 * @export
 * @interface ServicioEnergiaForGridRm
 */
export interface ServicioEnergiaForGridRm {
    /**
     * 
     * @type {string}
     * @memberof ServicioEnergiaForGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof ServicioEnergiaForGridRm
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof ServicioEnergiaForGridRm
     */
    'Nombre': string;
    /**
     * 
     * @type {Date}
     * @memberof ServicioEnergiaForGridRm
     */
    'FechaInicio': Date;
    /**
     * 
     * @type {Date}
     * @memberof ServicioEnergiaForGridRm
     */
    'FechaFin': Date;
    /**
     * 
     * @type {string}
     * @memberof ServicioEnergiaForGridRm
     */
    'TipoEnergia': string;
    /**
     * 
     * @type {number}
     * @memberof ServicioEnergiaForGridRm
     */
    'Coste': number;
    /**
     * 
     * @type {boolean}
     * @memberof ServicioEnergiaForGridRm
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServicioEnergiaForGridRm
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServicioEnergiaForGridRm
     */
    'Activa': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ServicioEnergiaForGridRm
     */
    'TieneTramitesAsociados': boolean;
}
/**
 * 
 * @export
 * @interface ServicioEnergiaListItemModel
 */
export interface ServicioEnergiaListItemModel {
    /**
     * 
     * @type {string}
     * @memberof ServicioEnergiaListItemModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof ServicioEnergiaListItemModel
     */
    'Coste': number;
    /**
     * 
     * @type {Array<DescuentoEnergiaListItemModel>}
     * @memberof ServicioEnergiaListItemModel
     */
    'Descuentos': Array<DescuentoEnergiaListItemModel>;
    /**
     * 
     * @type {number}
     * @memberof ServicioEnergiaListItemModel
     */
    'Comision': number | null;
}
/**
 * 
 * @export
 * @interface SimularComisionesComparacionEnergiaRequest
 */
export interface SimularComisionesComparacionEnergiaRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SimularComisionesComparacionEnergiaRequest
     */
    'IdsOferta': Array<string>;
    /**
     * 
     * @type {ParametrosSimulacionComisionComparacionModel}
     * @memberof SimularComisionesComparacionEnergiaRequest
     */
    'Parametros': ParametrosSimulacionComisionComparacionModel | null;
}
/**
 * 
 * @export
 * @interface SimularComisionesComparacionEnergiaResponse
 */
export interface SimularComisionesComparacionEnergiaResponse {
    /**
     * 
     * @type {Array<ComisionSimuladaOfertaItemModel>}
     * @memberof SimularComisionesComparacionEnergiaResponse
     */
    'Comisiones': Array<ComisionSimuladaOfertaItemModel>;
    /**
     * 
     * @type {ParametrosSimulacionComisionComparacionModel}
     * @memberof SimularComisionesComparacionEnergiaResponse
     */
    'ParametrosAplicados': ParametrosSimulacionComisionComparacionModel;
}
/**
 * 
 * @export
 * @interface SimularComisionesComparacionEnergiaResponseResponseDTO
 */
export interface SimularComisionesComparacionEnergiaResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {SimularComisionesComparacionEnergiaResponse}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'Data'?: SimularComisionesComparacionEnergiaResponse;
    /**
     * 
     * @type {any}
     * @memberof SimularComisionesComparacionEnergiaResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SortingInfo
 */
export interface SortingInfo {
    /**
     * 
     * @type {string}
     * @memberof SortingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SortingInfo
     */
    'desc'?: boolean;
}
/**
 * 
 * @export
 * @interface StringIListResponseDTO
 */
export interface StringIListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof StringIListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof StringIListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof StringIListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StringIListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof StringIListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringIListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringIListResponseDTO
     */
    'Data'?: Array<string>;
    /**
     * 
     * @type {any}
     * @memberof StringIListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface StringResponseDTO
 */
export interface StringResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof StringResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof StringResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof StringResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StringResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'Data'?: string;
    /**
     * 
     * @type {any}
     * @memberof StringResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SubtipoPersonaEnum = {
    Pyme: 'PYME',
    Ccpp: 'CCPP'
} as const;

export type SubtipoPersonaEnum = typeof SubtipoPersonaEnum[keyof typeof SubtipoPersonaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SubtipoTicketEnum = {
    OperacionesDatosTitular: 'OPERACIONES_DATOS_TITULAR',
    OperacionesDocumentacion: 'OPERACIONES_DOCUMENTACION',
    OperacionesContrato: 'OPERACIONES_CONTRATO',
    OtrosIncidencia: 'OTROS_INCIDENCIA',
    OtrosDuda: 'OTROS_DUDA',
    OtrosSugerencia: 'OTROS_SUGERENCIA'
} as const;

export type SubtipoTicketEnum = typeof SubtipoTicketEnum[keyof typeof SubtipoTicketEnum];


/**
 * 
 * @export
 * @interface SuministroAguaModel
 */
export interface SuministroAguaModel {
    /**
     * 
     * @type {DireccionModel}
     * @memberof SuministroAguaModel
     */
    'Direccion': DireccionModel | null;
}
/**
 * 
 * @export
 * @interface SuministroModel
 */
export interface SuministroModel {
    /**
     * 
     * @type {DireccionModel}
     * @memberof SuministroModel
     */
    'Direccion': DireccionModel | null;
    /**
     * 
     * @type {string}
     * @memberof SuministroModel
     */
    'IdCNAE': string | null;
    /**
     * 
     * @type {string}
     * @memberof SuministroModel
     */
    'CNAE': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SuministroModel
     */
    'FacturaDigital': boolean | null;
}
/**
 * 
 * @export
 * @interface SummaryInfo
 */
export interface SummaryInfo {
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'summaryType'?: string | null;
}
/**
 * 
 * @export
 * @interface TerminoEnergia
 */
export interface TerminoEnergia {
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergia
     */
    'P1': number;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergia
     */
    'P2': number;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergia
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergia
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergia
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergia
     */
    'P6': number | null;
}
/**
 * 
 * @export
 * @interface TerminoEnergiaModel
 */
export interface TerminoEnergiaModel {
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergiaModel
     */
    'P1': number;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergiaModel
     */
    'P2': number;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergiaModel
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergiaModel
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergiaModel
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoEnergiaModel
     */
    'P6': number | null;
}
/**
 * 
 * @export
 * @interface TerminoPotenciaModel
 */
export interface TerminoPotenciaModel {
    /**
     * 
     * @type {number}
     * @memberof TerminoPotenciaModel
     */
    'P1': number;
    /**
     * 
     * @type {number}
     * @memberof TerminoPotenciaModel
     */
    'P2': number;
    /**
     * 
     * @type {number}
     * @memberof TerminoPotenciaModel
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoPotenciaModel
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoPotenciaModel
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof TerminoPotenciaModel
     */
    'P6': number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TipoAutoconsumoEnum = {
    Interior: 'COMP_INTERIOR',
    ColectInterior: 'COMP_COLECT_INTERIOR',
    ColectRed: 'COMP_COLECT_RED'
} as const;

export type TipoAutoconsumoEnum = typeof TipoAutoconsumoEnum[keyof typeof TipoAutoconsumoEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoCalefaccionEnum = {
    Electrica: 'ELECTRICA',
    Gas: 'GAS'
} as const;

export type TipoCalefaccionEnum = typeof TipoCalefaccionEnum[keyof typeof TipoCalefaccionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoCalentadorEnum = {
    Electrico: 'ELECTRICO',
    Gas: 'GAS'
} as const;

export type TipoCalentadorEnum = typeof TipoCalentadorEnum[keyof typeof TipoCalentadorEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoCocinaEnum = {
    Electrica: 'ELECTRICA',
    Gas: 'GAS',
    Mixta: 'MIXTA'
} as const;

export type TipoCocinaEnum = typeof TipoCocinaEnum[keyof typeof TipoCocinaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoComunicadoEnum = {
    Mail: 'MAIL',
    Portal: 'PORTAL'
} as const;

export type TipoComunicadoEnum = typeof TipoComunicadoEnum[keyof typeof TipoComunicadoEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoConceptoCriterioRetrocomisionEnergiaEnum = {
    Oferta: 'OFERTA',
    Servicio: 'SERVICIO'
} as const;

export type TipoConceptoCriterioRetrocomisionEnergiaEnum = typeof TipoConceptoCriterioRetrocomisionEnergiaEnum[keyof typeof TipoConceptoCriterioRetrocomisionEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoCosteGestionEnum = {
    Mensual: 'MENSUAL',
    Diario: 'DIARIO',
    Consumo: 'CONSUMO'
} as const;

export type TipoCosteGestionEnum = typeof TipoCosteGestionEnum[keyof typeof TipoCosteGestionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoDocumentoEmpresaAgentesEnum = {
    Dni: 'DNI',
    Cif: 'CIF',
    AcreditacionAutonomo: 'ACREDITACION_AUTONOMO',
    CertificadoPagoSeguridadSocial: 'CERTIFICADO_PAGO_SEGURIDAD_SOCIAL',
    CertificadoPagoHacienda: 'CERTIFICADO_PAGO_HACIENDA',
    TitularidadCuentaBancaria: 'TITULARIDAD_CUENTA_BANCARIA',
    EscrituraSociedad: 'ESCRITURA_SOCIEDAD',
    ContratoColaboracion: 'CONTRATO_COLABORACION',
    ContratoColaboracionFirmado: 'CONTRATO_COLABORACION_FIRMADO',
    TratamientoDatos: 'TRATAMIENTO_DATOS',
    TratamientoDatosFirmado: 'TRATAMIENTO_DATOS_FIRMADO',
    DeclaracionResponsabilidad: 'DECLARACION_RESPONSABILIDAD',
    DeclaracionResponsabilidadFirmado: 'DECLARACION_RESPONSABILIDAD_FIRMADO'
} as const;

export type TipoDocumentoEmpresaAgentesEnum = typeof TipoDocumentoEmpresaAgentesEnum[keyof typeof TipoDocumentoEmpresaAgentesEnum];


/**
 * 
 * @export
 * @interface TipoDocumentoEmpresaServiciosForGridRm
 */
export interface TipoDocumentoEmpresaServiciosForGridRm {
    /**
     * 
     * @type {string}
     * @memberof TipoDocumentoEmpresaServiciosForGridRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof TipoDocumentoEmpresaServiciosForGridRm
     */
    'IdEmpresaServicios': string;
    /**
     * 
     * @type {string}
     * @memberof TipoDocumentoEmpresaServiciosForGridRm
     */
    'Nombre': string;
    /**
     * 
     * @type {boolean}
     * @memberof TipoDocumentoEmpresaServiciosForGridRm
     */
    'AplicaPersonaFisica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TipoDocumentoEmpresaServiciosForGridRm
     */
    'AplicaPersonaJuridica': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TipoDocumentoEmpresaServiciosForGridRm
     */
    'GestionadaSistema': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TipoDocumentoEnum = {
    Nif: 'NIF',
    Cif: 'CIF'
} as const;

export type TipoDocumentoEnum = typeof TipoDocumentoEnum[keyof typeof TipoDocumentoEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoDocumentoOperacionEnergiaEnum = {
    Nif: 'NIF',
    Nie: 'NIE',
    Pasaporte: 'PASAPORTE',
    TarjetaFiscal: 'TARJETA_FISCAL',
    Autorizacion: 'AUTORIZACION',
    Cie: 'CIE',
    Cig: 'CIG',
    Factura: 'FACTURA',
    Habitabilidad: 'HABITABILIDAD',
    AnexoOfertaLuz: 'ANEXO_OFERTA_LUZ',
    AnexoOfertaGas: 'ANEXO_OFERTA_GAS',
    Contrato: 'CONTRATO',
    AnexoServicio: 'ANEXO_SERVICIO',
    CopiaContrato: 'COPIA_CONTRATO',
    ContratoFirmado: 'CONTRATO_FIRMADO',
    AutorizacionContrato: 'AUTORIZACION_CONTRATO',
    AnexoOfertaLuzFirmado: 'ANEXO_OFERTA_LUZ_FIRMADO',
    AnexoOfertaGasFirmado: 'ANEXO_OFERTA_GAS_FIRMADO',
    AnexoServicioFirmado: 'ANEXO_SERVICIO_FIRMADO',
    CopiaContratoFirmado: 'COPIA_CONTRATO_FIRMADO',
    AutorizacionContratoFirmado: 'AUTORIZACION_CONTRATO_FIRMADO',
    DocumentoFirma: 'DOCUMENTO_FIRMA',
    Otros: 'OTROS',
    AutorizacionFirmada: 'AUTORIZACION_FIRMADA',
    LlamadaCalidad: 'LLAMADA_CALIDAD',
    UltimoReciboAutonomo: 'ULTIMO_RECIBO_AUTONOMO',
    AnexoOfertaDual: 'ANEXO_OFERTA_DUAL',
    AnexoServicioDual: 'ANEXO_SERVICIO_DUAL',
    ConsentimientoPrevio: 'CONSENTIMIENTO_PREVIO',
    ConsentimientoPrevioFirmado: 'CONSENTIMIENTO_PREVIO_FIRMADO',
    ResumenElectricidad: 'RESUMEN_ELECTRICIDAD',
    ResumenElectricidadFirmado: 'RESUMEN_ELECTRICIDAD_FIRMADO',
    ResumenContrato: 'RESUMEN_CONTRATO',
    JustoTitulo: 'JUSTO_TITULO'
} as const;

export type TipoDocumentoOperacionEnergiaEnum = typeof TipoDocumentoOperacionEnergiaEnum[keyof typeof TipoDocumentoOperacionEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoElementoOperacionEnergiaEnum = {
    Oferta: 'OFERTA',
    Servicio: 'SERVICIO'
} as const;

export type TipoElementoOperacionEnergiaEnum = typeof TipoElementoOperacionEnergiaEnum[keyof typeof TipoElementoOperacionEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoEmpresaAgentesEnum = {
    Colaboradora: 'COLABORADORA',
    Inmobiliaria: 'INMOBILIARIA'
} as const;

export type TipoEmpresaAgentesEnum = typeof TipoEmpresaAgentesEnum[keyof typeof TipoEmpresaAgentesEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoEmpresaServiciosEnum = {
    Energia: 'ENERGIA',
    Agua: 'AGUA'
} as const;

export type TipoEmpresaServiciosEnum = typeof TipoEmpresaServiciosEnum[keyof typeof TipoEmpresaServiciosEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoInmuebleEnum = {
    ViviendaUnifamiliar: 'VIVIENDA_UNIFAMILIAR',
    Local: 'LOCAL',
    Apartamento: 'APARTAMENTO'
} as const;

export type TipoInmuebleEnum = typeof TipoInmuebleEnum[keyof typeof TipoInmuebleEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoObraEnum = {
    Nueva: 'NUEVA',
    SegundaOcupacion: 'SEGUNDA_OCUPACION'
} as const;

export type TipoObraEnum = typeof TipoObraEnum[keyof typeof TipoObraEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoPersonaEnum = {
    Fisica: 'FISICA',
    Juridica: 'JURIDICA'
} as const;

export type TipoPersonaEnum = typeof TipoPersonaEnum[keyof typeof TipoPersonaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoRelacionClienteInmobiliarioEnum = {
    Propietario: 'PROPIETARIO',
    Inquilino: 'INQUILINO'
} as const;

export type TipoRelacionClienteInmobiliarioEnum = typeof TipoRelacionClienteInmobiliarioEnum[keyof typeof TipoRelacionClienteInmobiliarioEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoRepresentanteCcppEnum = {
    AdministradorFincas: 'ADMINISTRADOR_FINCAS',
    Presidente: 'PRESIDENTE'
} as const;

export type TipoRepresentanteCcppEnum = typeof TipoRepresentanteCcppEnum[keyof typeof TipoRepresentanteCcppEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoSuministroInmuebleEnum = {
    Luz: 'LUZ',
    Gas: 'GAS',
    Agua: 'AGUA'
} as const;

export type TipoSuministroInmuebleEnum = typeof TipoSuministroInmuebleEnum[keyof typeof TipoSuministroInmuebleEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoSuministroTramiteEnergiaEnum = {
    Luz: 'LUZ',
    Gas: 'GAS'
} as const;

export type TipoSuministroTramiteEnergiaEnum = typeof TipoSuministroTramiteEnergiaEnum[keyof typeof TipoSuministroTramiteEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoTarifaEnergiaEnum = {
    Libre: 'LIBRE',
    Regulada: 'REGULADA'
} as const;

export type TipoTarifaEnergiaEnum = typeof TipoTarifaEnergiaEnum[keyof typeof TipoTarifaEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoTicketEnum = {
    Operaciones: 'OPERACIONES',
    Liquidaciones: 'LIQUIDACIONES',
    Facturas: 'FACTURAS',
    Rappels: 'RAPPELS',
    Otros: 'OTROS'
} as const;

export type TipoTicketEnum = typeof TipoTicketEnum[keyof typeof TipoTicketEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoTramiteComisionEnergiaEnum = {
    Alta: 'ALTA',
    CambioComercializadora: 'CAMBIO_COMERCIALIZADORA',
    CambioMismoGrupo: 'CAMBIO_MISMO_GRUPO'
} as const;

export type TipoTramiteComisionEnergiaEnum = typeof TipoTramiteComisionEnergiaEnum[keyof typeof TipoTramiteComisionEnergiaEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoTramiteOperacionEnum = {
    Alta: 'ALTA',
    Modificacion: 'MODIFICACION',
    CambioTitularidad: 'CAMBIO_TITULARIDAD'
} as const;

export type TipoTramiteOperacionEnum = typeof TipoTramiteOperacionEnum[keyof typeof TipoTramiteOperacionEnum];


/**
 * 
 * @export
 * @interface TitularModel
 */
export interface TitularModel {
    /**
     * 
     * @type {TipoPersonaEnum}
     * @memberof TitularModel
     */
    'TipoPersona': TipoPersonaEnum;
    /**
     * 
     * @type {SubtipoPersonaEnum}
     * @memberof TitularModel
     */
    'SubtipoPersona': SubtipoPersonaEnum | null;
    /**
     * 
     * @type {TipoRepresentanteCcppEnum}
     * @memberof TitularModel
     */
    'IdTipoRepresentanteCcPp': TipoRepresentanteCcppEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'Nombre': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'Apellidos': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'Nacionalidad': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'Documento': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'Movil': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'Telefono': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'RazonSocial': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'CIF': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'NumeroColegiadoAdministradorFincas': string | null;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'ColegioAdministradorFincas': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TitularModel
     */
    'DireccionIgualSuministro': boolean;
    /**
     * 
     * @type {DireccionModel}
     * @memberof TitularModel
     */
    'Direccion': DireccionModel | null;
    /**
     * 
     * @type {boolean}
     * @memberof TitularModel
     */
    'CambioTitular': boolean;
    /**
     * 
     * @type {string}
     * @memberof TitularModel
     */
    'DocumentoEfectivo': string | null;
}


/**
 * 
 * @export
 * @interface TramiteGasModel
 */
export interface TramiteGasModel {
    /**
     * 
     * @type {string}
     * @memberof TramiteGasModel
     */
    'CUPS': string | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteGasModel
     */
    'TarifaAcceso': string | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteGasModel
     */
    'IdOferta': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TramiteGasModel
     */
    'IdsServicios': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TramiteGasModel
     */
    'Alta': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TramiteGasModel
     */
    'ConexionPrevia': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TramiteGasModel
     */
    'DistintaComercializadoraMismoGrupo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteGasModel
     */
    'ComercializadoraAnterior': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TramiteGasModel
     */
    'IdsDescuentos': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TramiteGasModel
     */
    'Consumo': number | null;
}
/**
 * 
 * @export
 * @interface TramiteLuzModel
 */
export interface TramiteLuzModel {
    /**
     * 
     * @type {string}
     * @memberof TramiteLuzModel
     */
    'CUPS': string | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteLuzModel
     */
    'TarifaAcceso': string | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteLuzModel
     */
    'IdOferta': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TramiteLuzModel
     */
    'IdsServicios': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TramiteLuzModel
     */
    'Alta': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TramiteLuzModel
     */
    'ConexionPrevia': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TramiteLuzModel
     */
    'DistintaComercializadoraMismoGrupo': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteLuzModel
     */
    'ComercializadoraAnterior': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TramiteLuzModel
     */
    'IdsDescuentos': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'Consumo': number | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteLuzModel
     */
    'IdTension': string | null;
    /**
     * 
     * @type {string}
     * @memberof TramiteLuzModel
     */
    'Tension': string | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P1': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P2': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P3': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P4': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P5': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P6': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P1_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P2_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P3_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P4_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P5_Nueva': number | null;
    /**
     * 
     * @type {number}
     * @memberof TramiteLuzModel
     */
    'P6_Nueva': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TramiteLuzModel
     */
    'CambioPotenciaContratada': boolean;
    /**
     * 
     * @type {TipoAutoconsumoEnum}
     * @memberof TramiteLuzModel
     */
    'Autoconsumo': TipoAutoconsumoEnum | null;
}


/**
 * 
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'Email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserProfileResponse
     */
    'Permissions': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'IdEmpresaAgentes': string | null;
    /**
     * 
     * @type {EstadoEmpresaAgentesEnum}
     * @memberof UserProfileResponse
     */
    'IdEstadoEmpresaAgentes': EstadoEmpresaAgentesEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    'Autoregistro': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'IdUsuario': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'GrupoUsuario': string | null;
}


/**
 * 
 * @export
 * @interface UserProfileResponseResponseDTO
 */
export interface UserProfileResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof UserProfileResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof UserProfileResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {UserProfileResponse}
     * @memberof UserProfileResponseResponseDTO
     */
    'Data'?: UserProfileResponse;
    /**
     * 
     * @type {any}
     * @memberof UserProfileResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ValidateEmailResponse
 */
export interface ValidateEmailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateEmailResponse
     */
    'IsValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailResponse
     */
    'Reason': string | null;
}
/**
 * 
 * @export
 * @interface ValidateEmailResponseResponseDTO
 */
export interface ValidateEmailResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ValidateEmailResponse}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'Data'?: ValidateEmailResponse;
    /**
     * 
     * @type {any}
     * @memberof ValidateEmailResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ValidateEmailTitularModel
 */
export interface ValidateEmailTitularModel {
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailTitularModel
     */
    'Email': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailTitularModel
     */
    'DocumentoTitular': string;
}
/**
 * 
 * @export
 * @interface ValidateMovilResponse
 */
export interface ValidateMovilResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateMovilResponse
     */
    'IsValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateMovilResponse
     */
    'Reason': string | null;
}
/**
 * 
 * @export
 * @interface ValidateMovilResponseResponseDTO
 */
export interface ValidateMovilResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {ValidateMovilResponse}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'Data'?: ValidateMovilResponse;
    /**
     * 
     * @type {any}
     * @memberof ValidateMovilResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ValidateMovilTitularModel
 */
export interface ValidateMovilTitularModel {
    /**
     * 
     * @type {string}
     * @memberof ValidateMovilTitularModel
     */
    'Movil': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateMovilTitularModel
     */
    'DocumentoTitular': string;
}
/**
 * 
 * @export
 * @interface VariableAnexoValor
 */
export interface VariableAnexoValor {
    /**
     * 
     * @type {string}
     * @memberof VariableAnexoValor
     */
    'Codigo': string;
    /**
     * 
     * @type {boolean}
     * @memberof VariableAnexoValor
     */
    'ValorBool': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VariableAnexoValor
     */
    'ValorString': string | null;
}

  
export const ApiApiRoutes = {
    acceptCloseTicket: "/api/Commons/Ticket/{id}/aceptar-cierre",
    accesoExternoAgenteIaGestion: "/api/Commons/Agente/ia-gestion/acceso",
    aceptarBackofficeOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/aceptar-backoffice",
    activarOperacionAgua: "/api/Operaciones/OperacionAgua/{id}/activar",
    activarTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idOperacion}/activar",
    addComunicacionOperacion: "/api/Operaciones/Operacion/{id}/comunicacion",
    addFacturaInmueble: "/api/Commons/Inmueble/{id}/factura",
    addLecturaInmueble: "/api/Commons/Inmueble/{id}/lectura",
    addMessageTicket: "/api/Commons/Ticket/{id}/message",
    addObservacionOperacionAgua: "/api/Operaciones/OperacionAgua/{idOperacion}/observacion",
    addObservacionOperacionEnergia: "/api/Operaciones/OperacionEnergia/{idOperacion}/observacion",
    addObservacionTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idOperacion}/observacion",
    addRelacionClienteInmobiliarioInmueble: "/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario",
    adjuntarConsentimientoPrevioOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/adjuntar-consentimiento-previo",
    anularOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/anular",
    anularTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idOperacion}/anular",
    aplicarReajustesConceptosFactura: "/api/Operaciones/Factura/{id}/reajustar-conceptos",
    askCloseTicket: "/api/Commons/Ticket/{id}/solicitar-cierre",
    assignExternalIdOperacionEnergia: "/api/Operaciones/OperacionEnergia/{idOperacion}/id-externo",
    assignExternalIdTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idTramite}/id-externo",
    assignResponsableOperacion: "/api/Operaciones/Operacion/{id}/asignar-responsable/{idUsuario}",
    assignResponsableTicket: "/api/Commons/Ticket/{id}/asignar-responsable/{idUsuario}",
    autoregistroEmpresaAgentes: "/api/_public/commons/empresas-agentes/autoregistro",
    bajaOperacionAgua: "/api/Operaciones/OperacionAgua/{id}/baja",
    bajaServicioIncluidoTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idOperacion}/baja-servicio/{idServicio}",
    bajaTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idOperacion}/baja",
    cambiarEstadoLibreTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idOperacion}/cambiar-estado-libre",
    cancelBorradorOperacion: "/api/Operaciones/BorradorOperacion/{id}/cancel",
    cancelSignEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/cancel-sign",
    cancelarFirmaAutorizacionClienteInmobiliario: "/api/Commons/ClienteInmobiliario/{id}/cancelar-firma-autorizacion",
    cancelarOperacionAgua: "/api/Operaciones/OperacionAgua/{id}/cancelar",
    checkPotentialFraudOperacion: "/api/Operaciones/Operacion/check-fraud",
    createAgente: "/api/Commons/Agente",
    createAgenteInmobiliaria: "/api/Commons/Agente/inmobiliaria",
    createAnexoEmpresaServicios: "/api/Operaciones/AnexoEmpresaServicios",
    createAutorizacionCesionDatosContactoLead: "/api/Operaciones/ContactoLead/{id}/autorizacion-cesion-datos",
    createBorradoresOperacion: "/api/Operaciones/BorradorOperacion",
    createClienteInmobiliario: "/api/Commons/ClienteInmobiliario",
    createComisionesEnergiaOferta: "/api/Operaciones/OfertaEnergia/{id}/comision/{idMarco}",
    createComisionesEnergiaServicio: "/api/Operaciones/ServicioEnergia/{id}/comision/{idMarco}",
    createComparacionEnergia: "/api/Operaciones/ComparacionEnergia",
    createComunicado: "/api/Commons/Comunicado",
    createCriterioRetrocomisionEnergia: "/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision",
    createDelegacionInmobiliaria: "/api/Commons/DelegacionInmobiliaria",
    createEmpresaColaboradora: "/api/Operaciones/EmpresaAgentes/colaboradora",
    createEmpresaInmobiliaria: "/api/Operaciones/EmpresaAgentes/inmobiliaria",
    createEmpresaServicios: "/api/Operaciones/EmpresaServicios",
    createFactura: "/api/Operaciones/Factura",
    createGrupoCriterioRetrocomisionEnergia: "/api/Operaciones/EmpresaServicios/{idEmpresa}/grupo-criterio-retrocomision",
    createInmueble: "/api/Commons/Inmueble",
    createMarcoComisiones: "/api/Commons/MarcoComisiones",
    createNotaBorradorOperacion: "/api/Operaciones/BorradorOperacion/{id}/notas",
    createNotaOperacion: "/api/Operaciones/Operacion/{id}/notas",
    createNotaTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idTramite}/notas",
    createOfertaEndesa: "/api/Operaciones/OfertaEnergia/endesa",
    createOfertaEnergia: "/api/Operaciones/OfertaEnergia",
    createOperacionAgua: "/api/Operaciones/OperacionAgua",
    createOperacionEnergia: "/api/Operaciones/OperacionEnergia",
    createRappelEnergia: "/api/Operaciones/RappelEnergia",
    createServicioEndesa: "/api/Operaciones/ServicioEnergia/endesa",
    createServicioEnergia: "/api/Operaciones/ServicioEnergia",
    createTicket: "/api/Commons/Ticket",
    createTipoDocumentoEmpresaServicios: "/api/Operaciones/TipoDocumentoEmpresaServicios",
    createUsuario: "/api/Commons/Usuario",
    deleteAgente: "/api/Commons/Agente/{id}",
    deleteAgenteInmobiliaria: "/api/Commons/Agente/inmobiliaria/{id}",
    deleteAnexoEmpresaServicios: "/api/Operaciones/AnexoEmpresaServicios/{id}",
    deleteBorradorOperacion: "/api/Operaciones/BorradorOperacion/{id}",
    deleteComisionEnergiaOferta: "/api/Operaciones/OfertaEnergia/comision/{id}",
    deleteComisionEnergiaServicio: "/api/Operaciones/ServicioEnergia/comision/{id}",
    deleteComunicado: "/api/Commons/Comunicado/{id}",
    deleteCriterioRetrocomisionEnergia: "/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision/{id}",
    deleteDelegacionInmobiliaria: "/api/Commons/DelegacionInmobiliaria/{id}",
    deleteDocumentoEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/documento/{idDocumento}",
    deleteDocumentoOperacionAgua: "/api/Operaciones/OperacionAgua/{id}/eliminar-documento/{idDocumento}",
    deleteDocumentoOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/eliminar-documento/{idDocumento}",
    deleteEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}",
    deleteEmpresaColaboradora: "/api/Commons/EmpresaColaboradora/{id}",
    deleteEmpresaInmobiliaria: "/api/Commons/EmpresaInmobiliaria/{id}",
    deleteEmpresaServicios: "/api/Operaciones/EmpresaServicios/{id}",
    deleteFacturaInmueble: "/api/Commons/Inmueble/{idInmueble}/factura/{idFactura}",
    deleteInmueble: "/api/Commons/Inmueble/{id}",
    deleteLecturaInmueble: "/api/Commons/Inmueble/{idInmueble}/lectura/{idLectura}",
    deleteMarcoComisiones: "/api/Commons/MarcoComisiones/{id}",
    deleteOfertaEnergia: "/api/Operaciones/OfertaEnergia/{id}",
    deleteRappelEnergia: "/api/Operaciones/RappelEnergia/{id}",
    deleteRelacionClienteInmobiliarioInmueble: "/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario/{idRelacion}",
    deleteServicioEnergia: "/api/Operaciones/ServicioEnergia/{id}",
    deleteTipoDocumentoEmpresaServicios: "/api/Operaciones/TipoDocumentoEmpresaServicios/{id}",
    deleteUsuario: "/api/Commons/Usuario/{id}",
    deshacerEstadoOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/deshacer-estado",
    documentosGenerateTempUrl: "/api/Commons/Documentos/url",
    downloadFicheroEmpresaServicios: "/api/Operaciones/OperacionEnergia/{id}/download-fichero-empresa-servicios",
    duplicateMarcoComisiones: "/api/Operaciones/MarcoComisiones/{id}/duplicar",
    duplicateOfertaEnergia: "/api/Operaciones/OfertaEnergia/{id}/duplicar",
    duplicateServicioEnergia: "/api/Operaciones/ServicioEnergia/{id}/duplicar",
    editAgente: "/api/Commons/Agente",
    editAgenteInmobiliaria: "/api/Commons/Agente/inmobiliaria",
    editAnexoEmpresaServicios: "/api/Operaciones/AnexoEmpresaServicios",
    editClienteInmobiliario: "/api/Commons/ClienteInmobiliario",
    editComisionEnergiaOferta: "/api/Operaciones/OfertaEnergia/comision",
    editComisionEnergiaServicio: "/api/Operaciones/ServicioEnergia/comision",
    editComunicado: "/api/Commons/Comunicado",
    editCriterioRetrocomisionEnergia: "/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision",
    editCurrentAgentePersonalData: "/api/Commons/Agente/me/personal-data",
    editDelegacionInmobiliaria: "/api/Commons/DelegacionInmobiliaria",
    editEmpresaColaboradora: "/api/Operaciones/EmpresaAgentes/colaboradora",
    editEmpresaInmobiliaria: "/api/Operaciones/EmpresaAgentes/inmobiliaria",
    editEmpresaServicios: "/api/Operaciones/EmpresaServicios",
    editInmueble: "/api/Commons/Inmueble",
    editMarcoComisiones: "/api/Commons/MarcoComisiones",
    editMarcoComisionesEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/marco-comisiones",
    editNotaBorradorOperacion: "/api/Operaciones/BorradorOperacion/{id}/notas",
    editNotaOperacion: "/api/Operaciones/Operacion/{id}/notas",
    editNotaTramiteEnergia: "/api/Operaciones/TramiteEnergia/{id}/notas",
    editOfertaEndesa: "/api/Operaciones/OfertaEnergia/endesa",
    editOfertaEnergia: "/api/Operaciones/OfertaEnergia",
    editOperacionAgua: "/api/Operaciones/OperacionAgua",
    editOperacionEnergia: "/api/Operaciones/OperacionEnergia",
    editRappelEnergia: "/api/Operaciones/RappelEnergia",
    editReajusteComisionEnergiaOfertaEmpresaAgentes: "/api/Operaciones/EmpresaAgentes/{id}/reajuste-comision-energia-oferta",
    editReajusteComisionEnergiaServicioEmpresaAgentes: "/api/Operaciones/EmpresaAgentes/{id}/reajuste-comision-energia-servicio",
    editReajusteMarcoComisionEmpresaAgentes: "/api/Operaciones/EmpresaAgentes/{id}/reajuste-marco-comision",
    editRelacionClienteInmobiliarioInmueble: "/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario",
    editServicioEndesa: "/api/Operaciones/ServicioEnergia/endesa",
    editServicioEnergia: "/api/Operaciones/ServicioEnergia",
    editTipoDocumentoEmpresaServicios: "/api/Operaciones/TipoDocumentoEmpresaServicios",
    editUsuario: "/api/Commons/Usuario",
    enviarComunicado: "/api/Commons/Comunicado/{id}/enviar",
    enviarOperacionEnergiaBackoffice: "/api/Operaciones/OperacionEnergia/{id}/enviar-backoffice",
    enviarRecordatorioFirmaAutorizacionClienteInmobiliario: "/api/Commons/ClienteInmobiliario/{id}/enviar-recordatorio-firma-autorizacion",
    existsContactoLeadByMobile: "/api/Operaciones/ContactoLead/existe-por-telefono",
    exportComisionesComercializadoraEmpresaAgentesExcel: "/api/Operaciones/EmpresaAgentes/{id}/comisiones/export-excel",
    exportComisionesComercializadoraEmpresaAgentesPdf: "/api/Operaciones/EmpresaAgentes/{id}/comisiones/export-pdf",
    exportComisionesComercializadoraMiEmpresaExcel: "/api/Operaciones/EmpresaAgentes/mine/comisiones/export-excel",
    exportComisionesComercializadoraMiEmpresaPdf: "/api/Operaciones/EmpresaAgentes/mine/comisiones/export-pdf",
    featuresGet: "/api/_public/features/{featureName}",
    featuresList: "/api/_public/features",
    finalizarProcesoFirmaAutorizacionClienteInmobiliario: "/api/Commons/ClienteInmobiliario/autorizacion-firmada",
    finalizarProcesoFirmaEmpresaAgentes: "/api/Commons/EmpresaAgentes/firmada",
    finalizarProcesoFirmaOperacionEnergia: "/api/Operaciones/OperacionEnergia/firmada",
    firmaAutorizacionOperacionEnergia: "/api/Operaciones/OperacionEnergia/autorizacion-firmada",
    firmaConsentimientoPrevioOperacionEnergia: "/api/Operaciones/OperacionEnergia/consentimiento-previo-firmado",
    firmarOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/firmar",
    generarConsentimientoPrevioOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/generar-consentimiento-previo",
    generarContratoOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/generar-contrato",
    generateBorradorFactura: "/api/Operaciones/Factura/download-draft",
    generateComparacionEnergiaPdf: "/api/Operaciones/ComparacionEnergia/{id}/generate-pdf",
    getAgenteById: "/api/Commons/Agente/{id}/detail",
    getAgenteInmobiliariaById: "/api/Commons/Agente/inmobiliaria/{id}/detail",
    getAgentesForGrid: "/api/Commons/Agente/grid",
    getAgentesInmobiliariaByDelegacionSelector: "/api/Commons/Agente/inmobiliaria/selector",
    getAgentesInmobiliariaForGrid: "/api/Commons/Agente/inmobiliaria/grid",
    getAgentesSelector: "/api/Commons/Agente",
    getAnexoEmpresaServiciosById: "/api/Operaciones/AnexoEmpresaServicios/{id}",
    getAnexosEmpresaServiciosForGrid: "/api/Operaciones/AnexoEmpresaServicios/grid",
    getBorradorOperacionDetail: "/api/Operaciones/BorradorOperacion/{id}/detail",
    getBorradoresOperacionAguaForGrid: "/api/Operaciones/BorradorOperacion/grid/agua",
    getBorradoresOperacionEnergiaForGrid: "/api/Operaciones/BorradorOperacion/grid/energia",
    getClienteInmobiliarioById: "/api/Commons/ClienteInmobiliario/{id}/detail",
    getClienteInmuebleById: "/api/Commons/Inmueble/{id}/cliente-inmobiliario/{idRelacion}/detail",
    getClienteLatestInfoForCurrentUser: "/api/Operaciones/Operacion/cliente-latest-info",
    getClientesAgenteForGrid: "/api/Operaciones/Operacion/clientes-grid",
    getClientesEmpresaInmobiliariaForGrid: "/api/Commons/EmpresaInmobiliaria/me/clientes/grid",
    getClientesForGrid: "/api/Commons/Cliente/grid",
    getClientesInmuebleForGrid: "/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario/grid",
    getCnaeSelector: "/api/Operaciones/Cnae",
    getCometidoAgentesInmobiliariaSelector: "/api/Commons/Agente/cometidos-inmobiliaria",
    getComisionesPorMarcoByIdOferta: "/api/Operaciones/OfertaEnergia/{id}/comisiones/{idMarco}",
    getComisionesPorMarcoByIdServicio: "/api/Operaciones/ServicioEnergia/{id}/comisiones/{idMarco}",
    getComparacionesEnergiaAgenteForGrid: "/api/Operaciones/ComparacionEnergia/grid-agente",
    getComunicacionesOperacionById: "/api/Operaciones/Operacion/{id}/comunicaciones",
    getComunicadoDetail: "/api/Commons/Comunicado/{id}",
    getComunicadoDetailForColaborador: "/api/Commons/Comunicado/{id}/colaborador",
    getComunicadoLecturaAgente: "/api/Commons/Comunicado/{id}/estado-lectura-agente",
    getComunicadosForGrid: "/api/Commons/Comunicado/grid",
    getComunicadosForGridColaborador: "/api/Commons/Comunicado/grid-colaborador",
    getComunicadosPortalSinLeerForColaborador: "/api/Commons/Comunicado/portal/sin-leer",
    getContactosLeadForGrid: "/api/Operaciones/ContactoLead/grid",
    getCoordinadoresDelegacionSelector: "/api/Commons/EmpresaInmobiliaria/{id}/coordinadores-delegacion",
    getCriterioRetrocomisionEnergiaById: "/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision/{id}/detail",
    getCriteriosRetrocomisionEnergiaByIdEmpresa: "/api/Operaciones/EmpresaServicios/{id}/criterios-retrocomision",
    getCurrentAgentePersonalData: "/api/Commons/Agente/me/personal-data",
    getDatosPuntoSuministro: "/api/Operaciones/Cups/{codigo}/datos-suministro",
    getDelegacionInmobiliariaById: "/api/Commons/DelegacionInmobiliaria/{id}/detail",
    getDelegacionInmobiliariaSelector: "/api/Commons/DelegacionInmobiliaria/selector",
    getDelegacionInmobiliariaSelectorByInmobiliaria: "/api/Commons/DelegacionInmobiliaria/selector-by-inmobiliaria/{idInmobiliaria}",
    getDelegacionesInmobiliariasForGrid: "/api/Commons/DelegacionInmobiliaria/grid",
    getDescuentosEnergiaAplicables: "/api/Operaciones/DescuentoEnergia/aplicables",
    getDetailComparacionEnergiaById: "/api/Operaciones/ComparacionEnergia/{id}/detail",
    getDocumentosFirmaManualOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/documentos-firma-manual",
    getEmpresaAgentesDetail: "/api/Commons/EmpresaAgentes/{id}",
    getEmpresaAgentesSelector: "/api/Commons/EmpresaAgentes",
    getEmpresaColaboradoraById: "/api/Commons/EmpresaColaboradora/{id}/detail",
    getEmpresaColaboradoraByUserId: "/api/Commons/EmpresaColaboradora/detail-by-user",
    getEmpresaInmobiliariaById: "/api/Commons/EmpresaInmobiliaria/{id}/detail",
    getEmpresaInmobiliariaUsuarioRequest: "/api/Commons/EmpresaInmobiliaria/usuario-request",
    getEmpresaServiciosAguaById: "/api/Operaciones/EmpresaServicios/{id}/detail/agua",
    getEmpresaServiciosEnergiaById: "/api/Operaciones/EmpresaServicios/{id}/detail/energia",
    getEmpresasAgentesForGrid: "/api/Commons/EmpresaAgentes/grid",
    getEmpresasColaboradoraForGrid: "/api/Commons/EmpresaColaboradora/grid",
    getEmpresasInmobiliariasForGrid: "/api/Commons/EmpresaInmobiliaria/grid",
    getEmpresasServiciosAguaForGrid: "/api/Operaciones/EmpresaServicios/grid/agua",
    getEmpresasServiciosAguaOperables: "/api/Operaciones/EmpresaServicios/operables/agua",
    getEmpresasServiciosEnergiaForGrid: "/api/Operaciones/EmpresaServicios/grid/energia",
    getEmpresasServiciosOperables: "/api/Operaciones/EmpresaServicios/operables",
    getEmpresasServiciosOperablesSelector: "/api/Operaciones/EmpresaServicios/operables-selector",
    getEmpresasServiciosSelector: "/api/Operaciones/EmpresaServicios/selector",
    getEstructuraDocumentalEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/estructura-documental",
    getEstructuraDocumentalEmpresaAgentesByFormaJuridica: "/api/_public/commons/estructura-documental-by-forma-juridica",
    getEstructuraDocumentalEmpresaServicios: "/api/Operaciones/EmpresaServicios/{id}/estructura-documental",
    getEstructuraDocumentalOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/estructura-documental",
    getExportacionExcelRepsol: "/api/Operaciones/TramiteEnergia/exportacion-repsol",
    getFacturaDetailById: "/api/Operaciones/Factura/{id}/detail",
    getFacturasForGrid: "/api/Operaciones/Factura/all/grid",
    getFacturasForGridSoporte: "/api/Operaciones/Factura/soporte/grid",
    getFacturasInmuebleForGrid: "/api/Commons/Inmueble/{id}/facturas/grid",
    getFacturasMyCompanyForGrid: "/api/Operaciones/Factura/my-company/grid",
    getGruposCriteriosRetrocomisionEnergiaByIdEmpresa: "/api/Operaciones/EmpresaServicios/{idEmpresa}/grupos-criterios-retrocomision",
    getInmuebleById: "/api/Commons/Inmueble/{id}/detail",
    getInmueblesForGrid: "/api/Commons/Inmueble/grid",
    getLecturasInmuebleForGrid: "/api/Commons/Inmueble/{id}/lecturas/grid",
    getLiquidacionesForGrid: "/api/Operaciones/TramiteEnergia/liquidaciones-grid",
    getListadoAgentesComunicado: "/api/Commons/Comunicado/{id}/agentes",
    getListadoNotasBorradorOperacion: "/api/Operaciones/BorradorOperacion/{id}/notas",
    getListadoNotasOperacion: "/api/Operaciones/Operacion/{id}/notas",
    getListadoNotasTramiteEnergia: "/api/Operaciones/TramiteEnergia/{idTramite}/notas",
    getLogoPortalEmpresaAgentes: "/api/Operaciones/EmpresaAgentes/{id}/logo-portal",
    getMarcosComisionesForGrid: "/api/Commons/MarcoComisiones/grid",
    getMarcosComisionesList: "/api/Commons/MarcoComisiones/selector",
    getNextFacturaConfig: "/api/Operaciones/Factura/next-config",
    getNotificaciones: "/api/Commons/Notificacion",
    getOfertaEndesaById: "/api/Operaciones/OfertaEnergia/endesa/{id}",
    getOfertaEnergiaById: "/api/Operaciones/OfertaEnergia/{id}/detail",
    getOfertasEnergiaForGrid: "/api/Operaciones/OfertaEnergia/grid",
    getOfertasEnergiaList: "/api/Operaciones/OfertaEnergia/list",
    getOfertasEnergiaOperables: "/api/Operaciones/EmpresaServicios/{id}/ofertas/{tipoPersona}",
    getOfertasEnergiaRetribucionesBackofficeList: "/api/Operaciones/OfertaEnergia/retribuciones/backoffice",
    getOfertasEnergiaRetribucionesColaboradoresList: "/api/Operaciones/OfertaEnergia/retribuciones/colaboradores",
    getOperacionAguaDetail: "/api/Operaciones/OperacionAgua/{id}/detail",
    getOperacionEnergiaDetail: "/api/Operaciones/OperacionEnergia/{id}/detail",
    getOperacionEnergiaDetailFromComparison: "/api/Operaciones/OperacionEnergia/{idComparacion}/detail-from-comparison",
    getOperacionEnergiaDetailFromProperty: "/api/Operaciones/OperacionEnergia/{idInmueble}/detail-from-property",
    getOperacionesAguaForGrid: "/api/Operaciones/OperacionAgua/grid",
    getOperacionesAguaHistoricoEstados: "/api/Operaciones/OperacionAgua/historico-estados-grid",
    getOperacionesByIdCliente: "/api/Operaciones/Operacion/listado-operaciones",
    getOperacionesEnergiaAgenteForGrid: "/api/Operaciones/OperacionEnergia/clientes-agente-grid",
    getOperacionesEnergiaForGrid: "/api/Operaciones/OperacionEnergia/grid",
    getOperacionesHistoricoEstados: "/api/Operaciones/Operacion/historico-estados-grid",
    getPlantillaAutorizacionClienteInmobiliario: "/api/Commons/ClienteInmobiliario/{id}/plantilla-autorizacion",
    getPrioridadesTicketSelector: "/api/Commons/Ticket/prioridades",
    getProvincias: "/api/Commons/Provincia",
    getPublicInformationSelfEmpresaInmobiliaria: "/api/Commons/EmpresaInmobiliaria/public-info-usuario-request",
    getRappelEnergiaById: "/api/Operaciones/RappelEnergia/{id}/detail",
    getRappelsEnergiaForGrid: "/api/Operaciones/RappelEnergia/grid",
    getRappelsMensualesEnergiaFacturaForGrid: "/api/Operaciones/RappelEnergia/rappels-mensuales-factura-grid",
    getRappelsMensualesEnergiaForGrid: "/api/Operaciones/RappelEnergia/rappels-mensuales-grid",
    getReajusteMarcoComisionEmpresaAgentes: "/api/Operaciones/EmpresaAgentes/{id}/reajuste-marco-comision",
    getRelacionClienteInmuebleDetail: "/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario/{idClienteInmobiliario}/full-detail",
    getResponsablesSelectorByIdEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/selector-responsables",
    getRolesAll: "/api/Commons/Usuario/Roles/all",
    getRolesSelector: "/api/Commons/Usuario/Roles",
    getServicioEndesaById: "/api/Operaciones/ServicioEnergia/endesa/{id}/detail",
    getServicioEnergiaById: "/api/Operaciones/ServicioEnergia/{id}/detail",
    getServiciosEnergiaForGrid: "/api/Operaciones/ServicioEnergia/grid",
    getServiciosEnergiaOperables: "/api/Operaciones/EmpresaServicios/{id}/oferta-servicios/{tipoPersona}",
    getSubtipoEmpresaColaboradoraSelector: "/api/Commons/EmpresaColaboradora/subtipos/selector",
    getSubtipoPersonasSelector: "/api/Commons/SubtipoPersona/selector",
    getSubtiposTicketSelectorByIdTipo: "/api/Commons/Ticket/subtipos",
    getTensionSuministroSelector: "/api/Operaciones/TensionSuministro",
    getTicketById: "/api/Commons/Ticket/{id}/detail",
    getTicketsForGrid: "/api/Commons/Ticket/grid",
    getTipoDocumentoEmpresaServiciosById: "/api/Operaciones/TipoDocumentoEmpresaServicios/{id}/detail",
    getTiposDocumentosEmpresaServiciosForGrid: "/api/Operaciones/TipoDocumentoEmpresaServicios/grid",
    getTiposTicketSelector: "/api/Commons/Ticket/tipos",
    getTramitesEnergiaFacturaForGrid: "/api/Operaciones/TramiteEnergia/factura-grid",
    getTramitesEnergiaForGrid: "/api/Operaciones/TramiteEnergia/grid",
    getTramitesEnergiaHistoricoEstados: "/api/Operaciones/TramiteEnergia/historico-estados-grid",
    getTramitesEnergiaRappelMensualForGrid: "/api/Operaciones/TramiteEnergia/rappel-mensual-grid",
    getTramitesForGridColaboradores: "/api/Operaciones/Operacion/tramites/grid-agentes-inmobiliarios",
    getTramitesForGridSoporte: "/api/Operaciones/Operacion/tramites/grid-soporte-inmobiliarios",
    getUsuarioById: "/api/Commons/Usuario/{id}/detail",
    getUsuarioCurrentProfile: "/api/Commons/Usuario/me/Profile",
    getUsuariosBackofficeSelector: "/api/Commons/Usuario/selector-backoffice",
    getUsuariosBackofficeSelectorByIdTicket: "/api/Commons/Ticket/{id}/selector-usuarios-backoffice",
    getUsuariosComercialesSelector: "/api/Commons/Usuario/selector-comerciales",
    getUsuariosForGrid: "/api/Commons/Usuario/grid",
    importEndesaBajasOperacionEnergia: "/api/Operaciones/Importaciones/operacion-energia/endesa/bajas",
    importEndesaCosmosOperacionEnergia: "/api/Operaciones/Importaciones/operacion-energia/endesa/cosmos",
    importEndesaNuevosEstadosOperacionEnergia: "/api/Operaciones/Importaciones/operacion-energia/endesa/nuevos-estados",
    importNaturgyNuevosEstadosOperacionEnergia: "/api/Operaciones/Importaciones/operacion-energia/naturgy/nuevos-estados",
    iniciarFirmaAutorizacionClienteInmobiliario: "/api/Commons/ClienteInmobiliario/{id}/iniciar-firma-autorizacion",
    iniciarFirmaBackofficeOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/enviar-firma-backoffice",
    iniciarFirmaConsentimientoPrevioOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/iniciar-firma-consentimiento-previo",
    iniciarProcesoFirmaOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/iniciar-firma",
    marcarIncidenciaOperacionAgua: "/api/Operaciones/OperacionAgua/{id}/incidencia",
    markPendingReviewFactura: "/api/Operaciones/Factura/{id}/mark-pending-review",
    ponerEnCursoOperacionAgua: "/api/Operaciones/OperacionAgua/{id}/en-curso",
    postDocumentoEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/upload-documento",
    postDocumentoOperacionAgua: "/api/Operaciones/OperacionAgua/{id}/adjuntar-documento",
    postDocumentoOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/adjuntar-documento",
    postDocumentoTemp: "/api/Commons/Documentos/adjuntar-documento-temp",
    putAnexoOfertaEnergia: "/api/Operaciones/OfertaEnergia/{id}/actualizar-anexo",
    putAnexoServicioEnergia: "/api/Operaciones/ServicioEnergia/{id}/actualizar-anexo",
    putDocumentoAgente: "/api/Commons/Agente/{id}/actualizar-dni",
    putFacturaPropia: "/api/Operaciones/Factura/{id}/actualizar-factura-propia",
    reactivateEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/reactivate",
    reactivateUsuario: "/api/Commons/Usuario/{id}/reactivate",
    readComunicacionesOperacion: "/api/Operaciones/Operacion/{id}/leer-comunicaciones",
    readComunicadoForColaborador: "/api/Commons/Comunicado/{id}/colaborador/read",
    readMensajesTicket: "/api/Commons/Ticket/{id}/leer-mensajes",
    readNotificacion: "/api/Commons/Notificacion/{id}/read",
    rechazarAutorizacionClienteInmobiliario: "/api/Operaciones/ClienteInmobiliario/{id}/autorizacion-rechazada",
    rechazarBackofficeOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/rechazar-backoffice",
    rejectCloseTicket: "/api/Commons/Ticket/{id}/rechazar-cierre",
    rejectEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/reject",
    rejectFactura: "/api/Operaciones/Factura/{id}/reject",
    rejectPendingReviewFactura: "/api/Operaciones/Factura/{id}/reject-pending-review",
    resetOperacionEnergia: "/api/Operaciones/OperacionEnergia/{id}/reiniciar",
    selfAssignResponsableOperacion: "/api/Operaciones/Operacion/{id}/asignarse-responsable",
    selfAssignResponsableTicket: "/api/Commons/Ticket/{id}/asignarse-responsable",
    sendToSignEmpresaAgentes: "/api/Commons/EmpresaAgentes/{id}/send-to-sign",
    setPrioridadTicket: "/api/Commons/Ticket/{id}/prioridad/{prioridad}",
    settleFactura: "/api/Operaciones/Factura/{id}/settle",
    settlePendingReviewFactura: "/api/Operaciones/Factura/{id}/settle-pending-review",
    simularComisionesComparacionEnergia: "/api/Operaciones/ComparacionEnergia/{id}/simular-comisiones",
    subirAutorizacionClienteInmobiliario: "/api/Commons/ClienteInmobiliario/{id}/subir-autorizacion-firmada",
    usuarioCheckEmail: "/api/Commons/Usuario/{Email}/{IdUsuario}/EmailAvailable",
    usuarioCheckUsername: "/api/Commons/Usuario/{Username}/Available",
    validarAutorizacionClienteInmobiliario: "/api/Commons/ClienteInmobiliario/{id}/autorizacion-validada",
    validateContactoLeadOperacion: "/api/Operaciones/ContactoLead/validate",
    validateEmailTitular: "/api/Operaciones/OperacionEnergia/validate-email-titular",
    validateMovilTitular: "/api/Operaciones/OperacionEnergia/validate-movil-titular",
    webhookAltaNuevoContadoLead: "/api/Operaciones/ContactoLead/webhook-alta",
}
  
/**
 * ApiApi - axios parameter creator
 * @export
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
  

         
      
      
        /**
         * 
         * @summary Acepta un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCloseTicket: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('acceptCloseTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/aceptar-cierre`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Maneja el acceso desde el CRM externo IA Gestion
         * @param {AccesoExternoIaGestionModel} [AccesoExternoIaGestionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accesoExternoAgenteIaGestion: async (AccesoExternoIaGestionModel?: AccesoExternoIaGestionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/ia-gestion/acceso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AccesoExternoIaGestionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Acepta una operación de energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aceptarBackofficeOperacionEnergia: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('aceptarBackofficeOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/aceptar-backoffice`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca como activada la operación de agua.
         * @param {string} Id 
         * @param {Date} [FechaActivacion] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activarOperacionAgua: async (Id: string, FechaActivacion?: Date, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('activarOperacionAgua', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/activar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaActivacion !== undefined) {
                localVarQueryParameter['fechaActivacion'] = (FechaActivacion as any instanceof Date) ?
                    (FechaActivacion as any).toISOString() :
                    FechaActivacion;
            }

            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Activa un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {ActivateTramiteEnergiaModel} [ActivateTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activarTramiteEnergia: async (IdOperacion: string, ActivateTramiteEnergiaModel?: ActivateTramiteEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('activarTramiteEnergia', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idOperacion}/activar`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ActivateTramiteEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade una comunicación a una operación.
         * @param {string} Id 
         * @param {CreateComunicacionOperacionModel} [CreateComunicacionOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComunicacionOperacion: async (Id: string, CreateComunicacionOperacionModel?: CreateComunicacionOperacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('addComunicacionOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/Operacion/{id}/comunicacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateComunicacionOperacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade una factura a un inmueble.
         * @param {string} Id 
         * @param {AddFacturaInmuebleModel} [AddFacturaInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacturaInmueble: async (Id: string, AddFacturaInmuebleModel?: AddFacturaInmuebleModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('addFacturaInmueble', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/factura`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AddFacturaInmuebleModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade una lectura a un inmueble.
         * @param {string} Id 
         * @param {AddLecturaInmuebleModel} [AddLecturaInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLecturaInmueble: async (Id: string, AddLecturaInmuebleModel?: AddLecturaInmuebleModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('addLecturaInmueble', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/lectura`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AddLecturaInmuebleModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade un mensaje a un ticket.
         * @param {string} Id 
         * @param {CreateMensajeTicketModel} [CreateMensajeTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMessageTicket: async (Id: string, CreateMensajeTicketModel?: CreateMensajeTicketModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('addMessageTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/message`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateMensajeTicketModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade a la operación de agua indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObservacionOperacionAgua: async (IdOperacion: string, Observacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('addObservacionOperacionAgua', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/OperacionAgua/{idOperacion}/observacion`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Observacion !== undefined) {
                localVarQueryParameter['observacion'] = Observacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade a la operación indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObservacionOperacionEnergia: async (IdOperacion: string, Observacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('addObservacionOperacionEnergia', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{idOperacion}/observacion`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Observacion !== undefined) {
                localVarQueryParameter['observacion'] = Observacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade al trámite de la operación indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObservacionTramiteEnergia: async (IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Observacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('addObservacionTramiteEnergia', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idOperacion}/observacion`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoSuministro !== undefined) {
                localVarQueryParameter['tipoSuministro'] = TipoSuministro;
            }

            if (Observacion !== undefined) {
                localVarQueryParameter['observacion'] = Observacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Añade una nueva relación de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {AddRelacionClienteInmobiliarioInmuebleModel} [AddRelacionClienteInmobiliarioInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRelacionClienteInmobiliarioInmueble: async (Id: string, AddRelacionClienteInmobiliarioInmuebleModel?: AddRelacionClienteInmobiliarioInmuebleModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('addRelacionClienteInmobiliarioInmueble', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AddRelacionClienteInmobiliarioInmuebleModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta el consentimiento previo firmado manualmente.
         * @param {string} Id 
         * @param {File} [Fichero] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjuntarConsentimientoPrevioOperacionEnergia: async (Id: string, Fichero?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('adjuntarConsentimientoPrevioOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/adjuntar-consentimiento-previo`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Fichero !== undefined) { 
                localVarFormParams.append('fichero', Fichero as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Anula una operación de energía, junto a sus trámites.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anularOperacionEnergia: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('anularOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/anular`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca el trámite de la operación indicada como anulada.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anularTramiteEnergia: async (IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('anularTramiteEnergia', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idOperacion}/anular`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoSuministro !== undefined) {
                localVarQueryParameter['tipoSuministro'] = TipoSuministro;
            }

            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Aplica reajustes de comisión y/o retrocomisión a los conceptos de trámite/servicio de una factura revisable.
         * @param {string} Id 
         * @param {AplicarReajustesConceptosFacturaModel} [AplicarReajustesConceptosFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aplicarReajustesConceptosFactura: async (Id: string, AplicarReajustesConceptosFacturaModel?: AplicarReajustesConceptosFacturaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('aplicarReajustesConceptosFactura', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/reajustar-conceptos`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AplicarReajustesConceptosFacturaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Solicita un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askCloseTicket: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('askCloseTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/solicitar-cierre`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna el identificador externo de una operación de energía.
         * @param {string} IdOperacion 
         * @param {AssignExternalIdOperacionEnergiaModel} [AssignExternalIdOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExternalIdOperacionEnergia: async (IdOperacion: string, AssignExternalIdOperacionEnergiaModel?: AssignExternalIdOperacionEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('assignExternalIdOperacionEnergia', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{idOperacion}/id-externo`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AssignExternalIdOperacionEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna el identificador externo de un trámite de energía.
         * @param {string} IdTramite 
         * @param {AssignExternalIdTramiteEnergiaModel} [AssignExternalIdTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExternalIdTramiteEnergia: async (IdTramite: string, AssignExternalIdTramiteEnergiaModel?: AssignExternalIdTramiteEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdTramite' is not null or undefined
            assertParamExists('assignExternalIdTramiteEnergia', 'IdTramite', IdTramite)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idTramite}/id-externo`
                .replace(`{${"idTramite"}}`, encodeURIComponent(String(IdTramite)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AssignExternalIdTramiteEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna un usuario como responsable de una operacion.
         * @param {string} Id 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignResponsableOperacion: async (Id: string, IdUsuario: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('assignResponsableOperacion', 'Id', Id)
            // verify required parameter 'IdUsuario' is not null or undefined
            assertParamExists('assignResponsableOperacion', 'IdUsuario', IdUsuario)
            const localVarPath = `/api/Operaciones/Operacion/{id}/asignar-responsable/{idUsuario}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idUsuario"}}`, encodeURIComponent(String(IdUsuario)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna un usuario como responsable de un ticket.
         * @param {string} Id 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignResponsableTicket: async (Id: string, IdUsuario: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('assignResponsableTicket', 'Id', Id)
            // verify required parameter 'IdUsuario' is not null or undefined
            assertParamExists('assignResponsableTicket', 'IdUsuario', IdUsuario)
            const localVarPath = `/api/Commons/Ticket/{id}/asignar-responsable/{idUsuario}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idUsuario"}}`, encodeURIComponent(String(IdUsuario)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Autoregistro de una empresa de agentes.
         * @param {TipoEmpresaAgentesEnum} [TipoEmpresaAgentes] 
         * @param {FormaJuridicaEnum} [FormaJuridicaTitular] 
         * @param {string} [RazonSocial] 
         * @param {string} [NifCif] 
         * @param {string} [Email] 
         * @param {string} [DireccionCodigoPostal] 
         * @param {string} [DireccionProvincia] 
         * @param {string} [DireccionMunicipio] 
         * @param {string} [DireccionTipoVia] 
         * @param {string} [DireccionNombreVia] 
         * @param {string} [DireccionNumero] 
         * @param {string} [DireccionEscalera] 
         * @param {string} [DireccionPiso] 
         * @param {string} [DireccionPuerta] 
         * @param {string} [NombreRepresentante] 
         * @param {string} [NifRepresentante] 
         * @param {string} [EmailRepresentante] 
         * @param {string} [TelefonoRepresentante] 
         * @param {Array<DocumentacionAutoregistroPorTipoModel>} [Documentacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoregistroEmpresaAgentes: async (TipoEmpresaAgentes?: TipoEmpresaAgentesEnum, FormaJuridicaTitular?: FormaJuridicaEnum, RazonSocial?: string, NifCif?: string, Email?: string, DireccionCodigoPostal?: string, DireccionProvincia?: string, DireccionMunicipio?: string, DireccionTipoVia?: string, DireccionNombreVia?: string, DireccionNumero?: string, DireccionEscalera?: string, DireccionPiso?: string, DireccionPuerta?: string, NombreRepresentante?: string, NifRepresentante?: string, EmailRepresentante?: string, TelefonoRepresentante?: string, Documentacion?: Array<DocumentacionAutoregistroPorTipoModel>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/_public/commons/empresas-agentes/autoregistro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (TipoEmpresaAgentes !== undefined) { 
                localVarFormParams.append('TipoEmpresaAgentes', TipoEmpresaAgentes as any);
            }
    
            if (FormaJuridicaTitular !== undefined) { 
                localVarFormParams.append('FormaJuridicaTitular', FormaJuridicaTitular as any);
            }
    
            if (RazonSocial !== undefined) { 
                localVarFormParams.append('RazonSocial', RazonSocial as any);
            }
    
            if (NifCif !== undefined) { 
                localVarFormParams.append('NifCif', NifCif as any);
            }
    
            if (Email !== undefined) { 
                localVarFormParams.append('Email', Email as any);
            }
    
            if (DireccionCodigoPostal !== undefined) { 
                localVarFormParams.append('Direccion.CodigoPostal', DireccionCodigoPostal as any);
            }
    
            if (DireccionProvincia !== undefined) { 
                localVarFormParams.append('Direccion.Provincia', DireccionProvincia as any);
            }
    
            if (DireccionMunicipio !== undefined) { 
                localVarFormParams.append('Direccion.Municipio', DireccionMunicipio as any);
            }
    
            if (DireccionTipoVia !== undefined) { 
                localVarFormParams.append('Direccion.TipoVia', DireccionTipoVia as any);
            }
    
            if (DireccionNombreVia !== undefined) { 
                localVarFormParams.append('Direccion.NombreVia', DireccionNombreVia as any);
            }
    
            if (DireccionNumero !== undefined) { 
                localVarFormParams.append('Direccion.Numero', DireccionNumero as any);
            }
    
            if (DireccionEscalera !== undefined) { 
                localVarFormParams.append('Direccion.Escalera', DireccionEscalera as any);
            }
    
            if (DireccionPiso !== undefined) { 
                localVarFormParams.append('Direccion.Piso', DireccionPiso as any);
            }
    
            if (DireccionPuerta !== undefined) { 
                localVarFormParams.append('Direccion.Puerta', DireccionPuerta as any);
            }
    
            if (NombreRepresentante !== undefined) { 
                localVarFormParams.append('NombreRepresentante', NombreRepresentante as any);
            }
    
            if (NifRepresentante !== undefined) { 
                localVarFormParams.append('NifRepresentante', NifRepresentante as any);
            }
    
            if (EmailRepresentante !== undefined) { 
                localVarFormParams.append('EmailRepresentante', EmailRepresentante as any);
            }
    
            if (TelefonoRepresentante !== undefined) { 
                localVarFormParams.append('TelefonoRepresentante', TelefonoRepresentante as any);
            }
                if (Documentacion) {
                Documentacion.forEach((element) => {
                    localVarFormParams.append('Documentacion', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca como baja la operación de agua.
         * @param {string} Id 
         * @param {Date} [FechaBaja] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bajaOperacionAgua: async (Id: string, FechaBaja?: Date, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('bajaOperacionAgua', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/baja`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FechaBaja !== undefined) {
                localVarQueryParameter['fechaBaja'] = (FechaBaja as any instanceof Date) ?
                    (FechaBaja as any).toISOString() :
                    FechaBaja;
            }

            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Da de baja un servicio incluido en un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {string} IdServicio 
         * @param {DeactivateServicioIncluidoTramiteEnergiaModel} [DeactivateServicioIncluidoTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bajaServicioIncluidoTramiteEnergia: async (IdOperacion: string, IdServicio: string, DeactivateServicioIncluidoTramiteEnergiaModel?: DeactivateServicioIncluidoTramiteEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('bajaServicioIncluidoTramiteEnergia', 'IdOperacion', IdOperacion)
            // verify required parameter 'IdServicio' is not null or undefined
            assertParamExists('bajaServicioIncluidoTramiteEnergia', 'IdServicio', IdServicio)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idOperacion}/baja-servicio/{idServicio}`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)))
                .replace(`{${"idServicio"}}`, encodeURIComponent(String(IdServicio)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeactivateServicioIncluidoTramiteEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Da de baja un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {DeactivateTramiteEnergiaModel} [DeactivateTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bajaTramiteEnergia: async (IdOperacion: string, DeactivateTramiteEnergiaModel?: DeactivateTramiteEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('bajaTramiteEnergia', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idOperacion}/baja`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeactivateTramiteEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cambia el estado libre del trámite de la operación indicada.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {EstadoLibreTramiteEnergiaEnum} [NuevoEstado] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambiarEstadoLibreTramiteEnergia: async (IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, NuevoEstado?: EstadoLibreTramiteEnergiaEnum, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOperacion' is not null or undefined
            assertParamExists('cambiarEstadoLibreTramiteEnergia', 'IdOperacion', IdOperacion)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idOperacion}/cambiar-estado-libre`
                .replace(`{${"idOperacion"}}`, encodeURIComponent(String(IdOperacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoSuministro !== undefined) {
                localVarQueryParameter['tipoSuministro'] = TipoSuministro;
            }

            if (NuevoEstado !== undefined) {
                localVarQueryParameter['nuevoEstado'] = NuevoEstado;
            }

            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cancela un borrador de operación
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBorradorOperacion: async (Id: string, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('cancelBorradorOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/BorradorOperacion/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cancela el proceso de firma de docuemntación para el registro de una empresa de agentes.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSignEmpresaAgentes: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('cancelSignEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/cancel-sign`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cancela el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarFirmaAutorizacionClienteInmobiliario: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('cancelarFirmaAutorizacionClienteInmobiliario', 'Id', Id)
            const localVarPath = `/api/Commons/ClienteInmobiliario/{id}/cancelar-firma-autorizacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca como cancelada la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarOperacionAgua: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('cancelarOperacionAgua', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/cancelar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Comprueba si el email o tel. móvil se ha usado en otras operaciones con distinto documento de identidad.
         * @param {string} [Email] 
         * @param {string} [TelMovil] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPotentialFraudOperacion: async (Email?: string, TelMovil?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Operacion/check-fraud`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }

            if (TelMovil !== undefined) {
                localVarQueryParameter['telMovil'] = TelMovil;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo agente
         * @param {CreateAgenteModel} [CreateAgenteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgente: async (CreateAgenteModel?: CreateAgenteModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateAgenteModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo agente inmobiliario
         * @param {CreateAgenteInmobiliariaModel} [CreateAgenteInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgenteInmobiliaria: async (CreateAgenteInmobiliariaModel?: CreateAgenteInmobiliariaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/inmobiliaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateAgenteInmobiliariaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un anexo de empresa de servicios.
         * @param {CreateAnexoEmpresaServiciosDto} [CreateAnexoEmpresaServiciosDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnexoEmpresaServicios: async (CreateAnexoEmpresaServiciosDto?: CreateAnexoEmpresaServiciosDto, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/AnexoEmpresaServicios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateAnexoEmpresaServiciosDto, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea la autorización de cesión de datos para un contacto lead.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutorizacionCesionDatosContactoLead: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('createAutorizacionCesionDatosContactoLead', 'Id', Id)
            const localVarPath = `/api/Operaciones/ContactoLead/{id}/autorizacion-cesion-datos`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea los borradores de operación
         * @param {CreateBorradoresOperacionModel} [CreateBorradoresOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBorradoresOperacion: async (CreateBorradoresOperacionModel?: CreateBorradoresOperacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/BorradorOperacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateBorradoresOperacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo cliente inmobiliario.
         * @param {CreateClienteInmobiliarioModel} [CreateClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClienteInmobiliario: async (CreateClienteInmobiliarioModel?: CreateClienteInmobiliarioModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ClienteInmobiliario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateClienteInmobiliarioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una lista de comisiones de energia por oferta para un marco de comisiones.
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {Array<CreateComisionEnergiaOfertaModel>} [CreateComisionEnergiaOfertaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComisionesEnergiaOferta: async (Id: string, IdMarco: string, CreateComisionEnergiaOfertaModel?: Array<CreateComisionEnergiaOfertaModel>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('createComisionesEnergiaOferta', 'Id', Id)
            // verify required parameter 'IdMarco' is not null or undefined
            assertParamExists('createComisionesEnergiaOferta', 'IdMarco', IdMarco)
            const localVarPath = `/api/Operaciones/OfertaEnergia/{id}/comision/{idMarco}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idMarco"}}`, encodeURIComponent(String(IdMarco)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateComisionEnergiaOfertaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una lista de comisiones de energia por servicio para un marco de comisiones.
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {Array<CreateComisionEnergiaServicioModel>} [CreateComisionEnergiaServicioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComisionesEnergiaServicio: async (Id: string, IdMarco: string, CreateComisionEnergiaServicioModel?: Array<CreateComisionEnergiaServicioModel>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('createComisionesEnergiaServicio', 'Id', Id)
            // verify required parameter 'IdMarco' is not null or undefined
            assertParamExists('createComisionesEnergiaServicio', 'IdMarco', IdMarco)
            const localVarPath = `/api/Operaciones/ServicioEnergia/{id}/comision/{idMarco}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idMarco"}}`, encodeURIComponent(String(IdMarco)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateComisionEnergiaServicioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nueva comparacion de energia.
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparacionEnergia: async (File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ComparacionEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (File !== undefined) { 
                localVarFormParams.append('file', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo comunicado.
         * @param {TipoComunicadoEnum} [Tipo] 
         * @param {string} [Asunto] 
         * @param {string} [Cuerpo] 
         * @param {string} [TipoEmpresaAgenteDirigido] 
         * @param {Array<string>} [RolesDirigidos] 
         * @param {Array<string>} [EmpresasAgentesDirigidos] 
         * @param {Array<File>} [Adjuntos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComunicado: async (Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Comunicado`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Tipo !== undefined) { 
                localVarFormParams.append('Tipo', Tipo as any);
            }
    
            if (Asunto !== undefined) { 
                localVarFormParams.append('Asunto', Asunto as any);
            }
    
            if (Cuerpo !== undefined) { 
                localVarFormParams.append('Cuerpo', Cuerpo as any);
            }
    
            if (TipoEmpresaAgenteDirigido !== undefined) { 
                localVarFormParams.append('TipoEmpresaAgenteDirigido', TipoEmpresaAgenteDirigido as any);
            }
                if (RolesDirigidos) {
                RolesDirigidos.forEach((element) => {
                    localVarFormParams.append('RolesDirigidos', element as any);
                })
            }

                if (EmpresasAgentesDirigidos) {
                EmpresasAgentesDirigidos.forEach((element) => {
                    localVarFormParams.append('EmpresasAgentesDirigidos', element as any);
                })
            }

                if (Adjuntos) {
                Adjuntos.forEach((element) => {
                    localVarFormParams.append('Adjuntos', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {CreateCriterioRetrocomisionEnergiaModel} [CreateCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCriterioRetrocomisionEnergia: async (IdEmpresa: string, CreateCriterioRetrocomisionEnergiaModel?: CreateCriterioRetrocomisionEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdEmpresa' is not null or undefined
            assertParamExists('createCriterioRetrocomisionEnergia', 'IdEmpresa', IdEmpresa)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision`
                .replace(`{${"idEmpresa"}}`, encodeURIComponent(String(IdEmpresa)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateCriterioRetrocomisionEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una delegación de inmobiliaria.
         * @param {CreateDelegacionInmobiliariaModel} [CreateDelegacionInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDelegacionInmobiliaria: async (CreateDelegacionInmobiliariaModel?: CreateDelegacionInmobiliariaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DelegacionInmobiliaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateDelegacionInmobiliariaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una empresa colaboradora.
         * @param {CreateEmpresaColaboradoraModel} [CreateEmpresaColaboradoraModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmpresaColaboradora: async (CreateEmpresaColaboradoraModel?: CreateEmpresaColaboradoraModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaAgentes/colaboradora`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateEmpresaColaboradoraModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una empresa Inmobiliaria.
         * @param {CreateEmpresaInmobiliariaModel} [CreateEmpresaInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmpresaInmobiliaria: async (CreateEmpresaInmobiliariaModel?: CreateEmpresaInmobiliariaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaAgentes/inmobiliaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateEmpresaInmobiliariaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una empresa de servicios.
         * @param {CreateEmpresaServiciosModel} [CreateEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmpresaServicios: async (CreateEmpresaServiciosModel?: CreateEmpresaServiciosModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateEmpresaServiciosModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una factura.
         * @param {CreateFacturaModel} [CreateFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactura: async (CreateFacturaModel?: CreateFacturaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Factura`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateFacturaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un grupo de criterios de retrocomisión de energía.
         * @param {string} IdEmpresa 
         * @param {CreateGrupoCriterioRetrocomisionEnergiaModel} [CreateGrupoCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrupoCriterioRetrocomisionEnergia: async (IdEmpresa: string, CreateGrupoCriterioRetrocomisionEnergiaModel?: CreateGrupoCriterioRetrocomisionEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdEmpresa' is not null or undefined
            assertParamExists('createGrupoCriterioRetrocomisionEnergia', 'IdEmpresa', IdEmpresa)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{idEmpresa}/grupo-criterio-retrocomision`
                .replace(`{${"idEmpresa"}}`, encodeURIComponent(String(IdEmpresa)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateGrupoCriterioRetrocomisionEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo inmueble.
         * @param {CreateInmuebleModel} [CreateInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInmueble: async (CreateInmuebleModel?: CreateInmuebleModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Inmueble`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateInmuebleModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo marco de comisiones
         * @param {CreateMarcoComisionesModel} [CreateMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarcoComisiones: async (CreateMarcoComisionesModel?: CreateMarcoComisionesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MarcoComisiones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateMarcoComisionesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nota para un borrador de operación.
         * @param {string} Id 
         * @param {CreateNotaBorradorOperacionModel} [CreateNotaBorradorOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotaBorradorOperacion: async (Id: string, CreateNotaBorradorOperacionModel?: CreateNotaBorradorOperacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('createNotaBorradorOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/BorradorOperacion/{id}/notas`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateNotaBorradorOperacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nota para una operación.
         * @param {string} Id 
         * @param {CreateNotaOperacionModel} [CreateNotaOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotaOperacion: async (Id: string, CreateNotaOperacionModel?: CreateNotaOperacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('createNotaOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/Operacion/{id}/notas`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateNotaOperacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una nota para un trámite de energía.
         * @param {string} IdTramite 
         * @param {CreateNotaTramiteEnergiaModel} [CreateNotaTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotaTramiteEnergia: async (IdTramite: string, CreateNotaTramiteEnergiaModel?: CreateNotaTramiteEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdTramite' is not null or undefined
            assertParamExists('createNotaTramiteEnergia', 'IdTramite', IdTramite)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idTramite}/notas`
                .replace(`{${"idTramite"}}`, encodeURIComponent(String(IdTramite)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateNotaTramiteEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una oferta de energía de Endesa.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoOferta] 
         * @param {CreateOfertaEndesaModel} [CreateOfertaEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfertaEndesa: async (Filename?: string, RutaAnexoOferta?: string, CreateOfertaEndesaModel?: CreateOfertaEndesaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia/endesa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Filename !== undefined) {
                localVarQueryParameter['filename'] = Filename;
            }

            if (RutaAnexoOferta !== undefined) {
                localVarQueryParameter['rutaAnexoOferta'] = RutaAnexoOferta;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateOfertaEndesaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una oferta de energía.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoOferta] 
         * @param {CreateOfertaEnergiaModel} [CreateOfertaEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfertaEnergia: async (Filename?: string, RutaAnexoOferta?: string, CreateOfertaEnergiaModel?: CreateOfertaEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Filename !== undefined) {
                localVarQueryParameter['filename'] = Filename;
            }

            if (RutaAnexoOferta !== undefined) {
                localVarQueryParameter['rutaAnexoOferta'] = RutaAnexoOferta;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateOfertaEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una operación de agua.
         * @param {CreateOperacionAguaModel} [CreateOperacionAguaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperacionAgua: async (CreateOperacionAguaModel?: CreateOperacionAguaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionAgua`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateOperacionAguaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea una operación de energía.
         * @param {CreateOperacionEnergiaModel} [CreateOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperacionEnergia: async (CreateOperacionEnergiaModel?: CreateOperacionEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateOperacionEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un rappel de energía.
         * @param {CreateRappelEnergiaModel} [CreateRappelEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRappelEnergia: async (CreateRappelEnergiaModel?: CreateRappelEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/RappelEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateRappelEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un servicio de endesa.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoServicio] 
         * @param {CreateServicioEndesaModel} [CreateServicioEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServicioEndesa: async (Filename?: string, RutaAnexoServicio?: string, CreateServicioEndesaModel?: CreateServicioEndesaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ServicioEnergia/endesa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Filename !== undefined) {
                localVarQueryParameter['filename'] = Filename;
            }

            if (RutaAnexoServicio !== undefined) {
                localVarQueryParameter['rutaAnexoServicio'] = RutaAnexoServicio;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateServicioEndesaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un servicio de energía.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoServicio] 
         * @param {CreateServicioEnergiaModel} [CreateServicioEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServicioEnergia: async (Filename?: string, RutaAnexoServicio?: string, CreateServicioEnergiaModel?: CreateServicioEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ServicioEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Filename !== undefined) {
                localVarQueryParameter['filename'] = Filename;
            }

            if (RutaAnexoServicio !== undefined) {
                localVarQueryParameter['rutaAnexoServicio'] = RutaAnexoServicio;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateServicioEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo ticket.
         * @param {CreateTicketModel} [CreateTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket: async (CreateTicketModel?: CreateTicketModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateTicketModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un tipo de documento para una empresa de servicios.
         * @param {CreateTipoDocumentoEmpresaServiciosModel} [CreateTipoDocumentoEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTipoDocumentoEmpresaServicios: async (CreateTipoDocumentoEmpresaServiciosModel?: CreateTipoDocumentoEmpresaServiciosModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TipoDocumentoEmpresaServicios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateTipoDocumentoEmpresaServiciosModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsuario: async (CreateUserModel?: CreateUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un agente.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgente: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteAgente', 'Id', Id)
            const localVarPath = `/api/Commons/Agente/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un agente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgenteInmobiliaria: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteAgenteInmobiliaria', 'Id', Id)
            const localVarPath = `/api/Commons/Agente/inmobiliaria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un anexo de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnexoEmpresaServicios: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteAnexoEmpresaServicios', 'Id', Id)
            const localVarPath = `/api/Operaciones/AnexoEmpresaServicios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un borrador de operación
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBorradorOperacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteBorradorOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/BorradorOperacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una comisión de energía por oferta.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComisionEnergiaOferta: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteComisionEnergiaOferta', 'Id', Id)
            const localVarPath = `/api/Operaciones/OfertaEnergia/comision/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una comisión de energía por servicio.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComisionEnergiaServicio: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteComisionEnergiaServicio', 'Id', Id)
            const localVarPath = `/api/Operaciones/ServicioEnergia/comision/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComunicado: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteComunicado', 'Id', Id)
            const localVarPath = `/api/Commons/Comunicado/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCriterioRetrocomisionEnergia: async (IdEmpresa: string, Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdEmpresa' is not null or undefined
            assertParamExists('deleteCriterioRetrocomisionEnergia', 'IdEmpresa', IdEmpresa)
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteCriterioRetrocomisionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision/{id}`
                .replace(`{${"idEmpresa"}}`, encodeURIComponent(String(IdEmpresa)))
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina o da de baja una delegación inmobiliaria en función del valor del parámetro \'borradoFisico\'.
         * @param {string} Id 
         * @param {boolean} [BorradoFisico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDelegacionInmobiliaria: async (Id: string, BorradoFisico?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteDelegacionInmobiliaria', 'Id', Id)
            const localVarPath = `/api/Commons/DelegacionInmobiliaria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (BorradoFisico !== undefined) {
                localVarQueryParameter['borradoFisico'] = BorradoFisico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un documento adjunto de la empresa de agentes.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentoEmpresaAgentes: async (Id: string, IdDocumento: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteDocumentoEmpresaAgentes', 'Id', Id)
            // verify required parameter 'IdDocumento' is not null or undefined
            assertParamExists('deleteDocumentoEmpresaAgentes', 'IdDocumento', IdDocumento)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/documento/{idDocumento}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idDocumento"}}`, encodeURIComponent(String(IdDocumento)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un documento adjuntado de la operación de agua.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentoOperacionAgua: async (Id: string, IdDocumento: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteDocumentoOperacionAgua', 'Id', Id)
            // verify required parameter 'IdDocumento' is not null or undefined
            assertParamExists('deleteDocumentoOperacionAgua', 'IdDocumento', IdDocumento)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/eliminar-documento/{idDocumento}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idDocumento"}}`, encodeURIComponent(String(IdDocumento)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un documento adjuntado de la operación de energía.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentoOperacionEnergia: async (Id: string, IdDocumento: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteDocumentoOperacionEnergia', 'Id', Id)
            // verify required parameter 'IdDocumento' is not null or undefined
            assertParamExists('deleteDocumentoOperacionEnergia', 'IdDocumento', IdDocumento)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/eliminar-documento/{idDocumento}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idDocumento"}}`, encodeURIComponent(String(IdDocumento)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una empresa de agentes
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaAgentes: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una empresa colaboradora.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaColaboradora: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteEmpresaColaboradora', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaColaboradora/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una empresa inmobiliaria.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaInmobiliaria: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteEmpresaInmobiliaria', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaInmobiliaria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una empresa de servicios, con parámetro opcional de borrado físico.
         * @param {string} Id 
         * @param {boolean} [BorradoFisico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaServicios: async (Id: string, BorradoFisico?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteEmpresaServicios', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (BorradoFisico !== undefined) {
                localVarQueryParameter['borradoFisico'] = BorradoFisico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una factura de un inmueble.
         * @param {string} IdInmueble 
         * @param {string} IdFactura 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacturaInmueble: async (IdInmueble: string, IdFactura: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdInmueble' is not null or undefined
            assertParamExists('deleteFacturaInmueble', 'IdInmueble', IdInmueble)
            // verify required parameter 'IdFactura' is not null or undefined
            assertParamExists('deleteFacturaInmueble', 'IdFactura', IdFactura)
            const localVarPath = `/api/Commons/Inmueble/{idInmueble}/factura/{idFactura}`
                .replace(`{${"idInmueble"}}`, encodeURIComponent(String(IdInmueble)))
                .replace(`{${"idFactura"}}`, encodeURIComponent(String(IdFactura)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un inmueble.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInmueble: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteInmueble', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una lectura de un inmueble.
         * @param {string} IdInmueble 
         * @param {string} IdLectura 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLecturaInmueble: async (IdInmueble: string, IdLectura: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdInmueble' is not null or undefined
            assertParamExists('deleteLecturaInmueble', 'IdInmueble', IdInmueble)
            // verify required parameter 'IdLectura' is not null or undefined
            assertParamExists('deleteLecturaInmueble', 'IdLectura', IdLectura)
            const localVarPath = `/api/Commons/Inmueble/{idInmueble}/lectura/{idLectura}`
                .replace(`{${"idInmueble"}}`, encodeURIComponent(String(IdInmueble)))
                .replace(`{${"idLectura"}}`, encodeURIComponent(String(IdLectura)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un marco de comisiones.
         * @param {string} Id 
         * @param {DeleteMarcoComisionesModel} [DeleteMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarcoComisiones: async (Id: string, DeleteMarcoComisionesModel?: DeleteMarcoComisionesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteMarcoComisiones', 'Id', Id)
            const localVarPath = `/api/Commons/MarcoComisiones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeleteMarcoComisionesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina una oferta de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfertaEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteOfertaEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OfertaEnergia/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un rappel de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRappelEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteRappelEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/RappelEnergia/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un relación existente de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {string} IdRelacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelacionClienteInmobiliarioInmueble: async (Id: string, IdRelacion: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteRelacionClienteInmobiliarioInmueble', 'Id', Id)
            // verify required parameter 'IdRelacion' is not null or undefined
            assertParamExists('deleteRelacionClienteInmobiliarioInmueble', 'IdRelacion', IdRelacion)
            const localVarPath = `/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario/{idRelacion}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idRelacion"}}`, encodeURIComponent(String(IdRelacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un servicio de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServicioEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteServicioEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/ServicioEnergia/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un tipo de documento de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTipoDocumentoEmpresaServicios: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteTipoDocumentoEmpresaServicios', 'Id', Id)
            const localVarPath = `/api/Operaciones/TipoDocumentoEmpresaServicios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un usuario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsuario: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deleteUsuario', 'Id', Id)
            const localVarPath = `/api/Commons/Usuario/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Deshace el estado actual de una operación de energía, devolviéndola al estado previo.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deshacerEstadoOperacionEnergia: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('deshacerEstadoOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/deshacer-estado`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un enlace temporal al documento indicado
         * @param {string} [Key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentosGenerateTempUrl: async (Key?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Documentos/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Key !== undefined) {
                localVarQueryParameter['key'] = Key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Genera un zip con los ficheros asociados a una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFicheroEmpresaServicios: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('downloadFicheroEmpresaServicios', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/download-fichero-empresa-servicios`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Duplica un marco de comisiones.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateMarcoComisiones: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('duplicateMarcoComisiones', 'Id', Id)
            const localVarPath = `/api/Operaciones/MarcoComisiones/{id}/duplicar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Duplica una oferta de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateOfertaEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('duplicateOfertaEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OfertaEnergia/{id}/duplicar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Duplica un servicio de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateServicioEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('duplicateServicioEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/ServicioEnergia/{id}/duplicar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un agente existente
         * @param {EditAgenteModel} [EditAgenteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAgente: async (EditAgenteModel?: EditAgenteModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditAgenteModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un agente inmobiliario existente
         * @param {EditAgenteInmobiliariaModel} [EditAgenteInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAgenteInmobiliaria: async (EditAgenteInmobiliariaModel?: EditAgenteInmobiliariaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/inmobiliaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditAgenteInmobiliariaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un anexo de empresa de servicios.
         * @param {EditAnexoEmpresaServiciosDto} [EditAnexoEmpresaServiciosDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAnexoEmpresaServicios: async (EditAnexoEmpresaServiciosDto?: EditAnexoEmpresaServiciosDto, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/AnexoEmpresaServicios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditAnexoEmpresaServiciosDto, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un cliente inmobiliario existente
         * @param {EditClienteInmobiliarioModel} [EditClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editClienteInmobiliario: async (EditClienteInmobiliarioModel?: EditClienteInmobiliarioModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ClienteInmobiliario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditClienteInmobiliarioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza una comisión de energia por oferta.
         * @param {EditComisionEnergiaOfertaModel} [EditComisionEnergiaOfertaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComisionEnergiaOferta: async (EditComisionEnergiaOfertaModel?: EditComisionEnergiaOfertaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia/comision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditComisionEnergiaOfertaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza una comisión de energia por servicio.
         * @param {EditComisionEnergiaServicioModel} [EditComisionEnergiaServicioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComisionEnergiaServicio: async (EditComisionEnergiaServicioModel?: EditComisionEnergiaServicioModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ServicioEnergia/comision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditComisionEnergiaServicioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un comunicado existente.
         * @param {string} [Id] 
         * @param {Array<string>} [IdsAdjuntosExistentes] 
         * @param {TipoComunicadoEnum} [Tipo] 
         * @param {string} [Asunto] 
         * @param {string} [Cuerpo] 
         * @param {string} [TipoEmpresaAgenteDirigido] 
         * @param {Array<string>} [RolesDirigidos] 
         * @param {Array<string>} [EmpresasAgentesDirigidos] 
         * @param {Array<File>} [Adjuntos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComunicado: async (Id?: string, IdsAdjuntosExistentes?: Array<string>, Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Comunicado`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Id !== undefined) { 
                localVarFormParams.append('Id', Id as any);
            }
                if (IdsAdjuntosExistentes) {
                IdsAdjuntosExistentes.forEach((element) => {
                    localVarFormParams.append('IdsAdjuntosExistentes', element as any);
                })
            }

    
            if (Tipo !== undefined) { 
                localVarFormParams.append('Tipo', Tipo as any);
            }
    
            if (Asunto !== undefined) { 
                localVarFormParams.append('Asunto', Asunto as any);
            }
    
            if (Cuerpo !== undefined) { 
                localVarFormParams.append('Cuerpo', Cuerpo as any);
            }
    
            if (TipoEmpresaAgenteDirigido !== undefined) { 
                localVarFormParams.append('TipoEmpresaAgenteDirigido', TipoEmpresaAgenteDirigido as any);
            }
                if (RolesDirigidos) {
                RolesDirigidos.forEach((element) => {
                    localVarFormParams.append('RolesDirigidos', element as any);
                })
            }

                if (EmpresasAgentesDirigidos) {
                EmpresasAgentesDirigidos.forEach((element) => {
                    localVarFormParams.append('EmpresasAgentesDirigidos', element as any);
                })
            }

                if (Adjuntos) {
                Adjuntos.forEach((element) => {
                    localVarFormParams.append('Adjuntos', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {EditCriterioRetrocomisionEnergiaModel} [EditCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCriterioRetrocomisionEnergia: async (IdEmpresa: string, EditCriterioRetrocomisionEnergiaModel?: EditCriterioRetrocomisionEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdEmpresa' is not null or undefined
            assertParamExists('editCriterioRetrocomisionEnergia', 'IdEmpresa', IdEmpresa)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision`
                .replace(`{${"idEmpresa"}}`, encodeURIComponent(String(IdEmpresa)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditCriterioRetrocomisionEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita los datos personales del agente actual
         * @param {EditAgentePersonalDataModel} [EditAgentePersonalDataModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCurrentAgentePersonalData: async (EditAgentePersonalDataModel?: EditAgentePersonalDataModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/me/personal-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditAgentePersonalDataModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una empresa de servicios.
         * @param {EditDelegacionInmobiliariaModel} [EditDelegacionInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDelegacionInmobiliaria: async (EditDelegacionInmobiliariaModel?: EditDelegacionInmobiliariaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DelegacionInmobiliaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditDelegacionInmobiliariaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una empresa colaboradora.
         * @param {EditEmpresaColaboradoraModel} [EditEmpresaColaboradoraModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEmpresaColaboradora: async (EditEmpresaColaboradoraModel?: EditEmpresaColaboradoraModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaAgentes/colaboradora`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditEmpresaColaboradoraModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una empresa Inmobiliaria.
         * @param {EditEmpresaInmobiliariaModel} [EditEmpresaInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEmpresaInmobiliaria: async (EditEmpresaInmobiliariaModel?: EditEmpresaInmobiliariaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaAgentes/inmobiliaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditEmpresaInmobiliariaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una empresa de servicios.
         * @param {EditEmpresaServiciosModel} [EditEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEmpresaServicios: async (EditEmpresaServiciosModel?: EditEmpresaServiciosModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditEmpresaServiciosModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un inmueble existente
         * @param {EditInmuebleModel} [EditInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInmueble: async (EditInmuebleModel?: EditInmuebleModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Inmueble`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditInmuebleModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un marco de comisiones existente
         * @param {EditMarcoComisionesModel} [EditMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMarcoComisiones: async (EditMarcoComisionesModel?: EditMarcoComisionesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MarcoComisiones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditMarcoComisionesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza el marco de comisiones de una empresa de agentes.
         * @param {string} Id 
         * @param {EditMarcoComisionesEmpresaAgentesModel} [EditMarcoComisionesEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMarcoComisionesEmpresaAgentes: async (Id: string, EditMarcoComisionesEmpresaAgentesModel?: EditMarcoComisionesEmpresaAgentesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editMarcoComisionesEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/marco-comisiones`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditMarcoComisionesEmpresaAgentesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una nota de un borrador de operación.
         * @param {string} Id 
         * @param {EditNotaBorradorOperacionModel} [EditNotaBorradorOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotaBorradorOperacion: async (Id: string, EditNotaBorradorOperacionModel?: EditNotaBorradorOperacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editNotaBorradorOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/BorradorOperacion/{id}/notas`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditNotaBorradorOperacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una nota de una operación.
         * @param {string} Id 
         * @param {EditNotaOperacionModel} [EditNotaOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotaOperacion: async (Id: string, EditNotaOperacionModel?: EditNotaOperacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editNotaOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/Operacion/{id}/notas`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditNotaOperacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una nota de un trámite de energía.
         * @param {string} Id 
         * @param {EditNotaTramiteEnergiaModel} [EditNotaTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotaTramiteEnergia: async (Id: string, EditNotaTramiteEnergiaModel?: EditNotaTramiteEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editNotaTramiteEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{id}/notas`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditNotaTramiteEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una oferta de Endesa.
         * @param {EditOfertaEndesaModel} [EditOfertaEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOfertaEndesa: async (EditOfertaEndesaModel?: EditOfertaEndesaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia/endesa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditOfertaEndesaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una oferta de energía.
         * @param {EditOfertaEnergiaModel} [EditOfertaEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOfertaEnergia: async (EditOfertaEnergiaModel?: EditOfertaEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditOfertaEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una operación de agua.
         * @param {EditOperacionAguaModel} [EditOperacionAguaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOperacionAgua: async (EditOperacionAguaModel?: EditOperacionAguaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionAgua`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditOperacionAguaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una operación de energía.
         * @param {EditOperacionEnergiaModel} [EditOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOperacionEnergia: async (EditOperacionEnergiaModel?: EditOperacionEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditOperacionEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un rappel de energía.
         * @param {EditRappelEnergiaModel} [EditRappelEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRappelEnergia: async (EditRappelEnergiaModel?: EditRappelEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/RappelEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditRappelEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece o elimina el reajuste de comisión de oferta de energía para una empresa de agentes.
         * @param {string} Id 
         * @param {EditReajusteComisionEnergiaOfertaEmpresaAgentesModel} [EditReajusteComisionEnergiaOfertaEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReajusteComisionEnergiaOfertaEmpresaAgentes: async (Id: string, EditReajusteComisionEnergiaOfertaEmpresaAgentesModel?: EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editReajusteComisionEnergiaOfertaEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaAgentes/{id}/reajuste-comision-energia-oferta`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece o elimina el reajuste de comisión de servicio de energía para una empresa de agentes.
         * @param {string} Id 
         * @param {EditReajusteComisionEnergiaServicioEmpresaAgentesModel} [EditReajusteComisionEnergiaServicioEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReajusteComisionEnergiaServicioEmpresaAgentes: async (Id: string, EditReajusteComisionEnergiaServicioEmpresaAgentesModel?: EditReajusteComisionEnergiaServicioEmpresaAgentesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editReajusteComisionEnergiaServicioEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaAgentes/{id}/reajuste-comision-energia-servicio`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditReajusteComisionEnergiaServicioEmpresaAgentesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece o elimina el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
         * @param {string} Id 
         * @param {EditReajusteMarcoComisionEmpresaAgentesModel} [EditReajusteMarcoComisionEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReajusteMarcoComisionEmpresaAgentes: async (Id: string, EditReajusteMarcoComisionEmpresaAgentesModel?: EditReajusteMarcoComisionEmpresaAgentesModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editReajusteMarcoComisionEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaAgentes/{id}/reajuste-marco-comision`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditReajusteMarcoComisionEmpresaAgentesModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una relación existente de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {EditRelacionClienteInmobiliarioInmuebleModel} [EditRelacionClienteInmobiliarioInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRelacionClienteInmobiliarioInmueble: async (Id: string, EditRelacionClienteInmobiliarioInmuebleModel?: EditRelacionClienteInmobiliarioInmuebleModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('editRelacionClienteInmobiliarioInmueble', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditRelacionClienteInmobiliarioInmuebleModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un servicio de Endesa.
         * @param {EditServicioEndesaModel} [EditServicioEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServicioEndesa: async (EditServicioEndesaModel?: EditServicioEndesaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ServicioEnergia/endesa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditServicioEndesaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un servicio de energía.
         * @param {EditServicioEnergiaModel} [EditServicioEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServicioEnergia: async (EditServicioEnergiaModel?: EditServicioEnergiaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ServicioEnergia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditServicioEnergiaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un tipo de documento de empresa de servicios.
         * @param {EditTipoDocumentoEmpresaServiciosModel} [EditTipoDocumentoEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTipoDocumentoEmpresaServicios: async (EditTipoDocumentoEmpresaServiciosModel?: EditTipoDocumentoEmpresaServiciosModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TipoDocumentoEmpresaServicios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditTipoDocumentoEmpresaServiciosModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUsuario: async (EditUserModel?: EditUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Envía un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarComunicado: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('enviarComunicado', 'Id', Id)
            const localVarPath = `/api/Commons/Comunicado/{id}/enviar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Envia una operación de energía a backoffice.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarOperacionEnergiaBackoffice: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('enviarOperacionEnergiaBackoffice', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/enviar-backoffice`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Envia un recordatorio para la firma de la autorización de tratamiento de datos de cliente inmobiliario
         * @param {string} Id 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarRecordatorioFirmaAutorizacionClienteInmobiliario: async (Id: string, Email?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('enviarRecordatorioFirmaAutorizacionClienteInmobiliario', 'Id', Id)
            const localVarPath = `/api/Commons/ClienteInmobiliario/{id}/enviar-recordatorio-firma-autorizacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Comprueba si existe un contacto lead cuyo teléfono coincide con el indicado.
         * @param {ExistsContactoLeadByMobileModel} [ExistsContactoLeadByMobileModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsContactoLeadByMobile: async (ExistsContactoLeadByMobileModel?: ExistsContactoLeadByMobileModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ContactoLead/existe-por-telefono`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ExistsContactoLeadByMobileModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones para una empresa de agentes desde backoffice.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraEmpresaAgentesExcel: async (Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('exportComisionesComercializadoraEmpresaAgentesExcel', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaAgentes/{id}/comisiones/export-excel`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }

            if (IdMarcoComisiones !== undefined) {
                localVarQueryParameter['idMarcoComisiones'] = IdMarcoComisiones;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones a PDF para una empresa de agentes desde backoffice.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraEmpresaAgentesPdf: async (Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('exportComisionesComercializadoraEmpresaAgentesPdf', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaAgentes/{id}/comisiones/export-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }

            if (IdMarcoComisiones !== undefined) {
                localVarQueryParameter['idMarcoComisiones'] = IdMarcoComisiones;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones para la empresa de agentes del colaborador autenticado.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraMiEmpresaExcel: async (IdEmpresaServicios?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaAgentes/mine/comisiones/export-excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones a PDF para la empresa de agentes del colaborador autenticado.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraMiEmpresaPdf: async (IdEmpresaServicios?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaAgentes/mine/comisiones/export-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet: async (FeatureName: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'FeatureName' is not null or undefined
            assertParamExists('featuresGet', 'FeatureName', FeatureName)
            const localVarPath = `/api/_public/features/{featureName}`
                .replace(`{${"featureName"}}`, encodeURIComponent(String(FeatureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/_public/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Finaliza el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarProcesoFirmaAutorizacionClienteInmobiliario: async (Id?: string, DocumentosFirmados?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/ClienteInmobiliario/autorizacion-firmada`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Id !== undefined) { 
                localVarFormParams.append('Id', Id as any);
            }
                if (DocumentosFirmados) {
                DocumentosFirmados.forEach((element) => {
                    localVarFormParams.append('DocumentosFirmados', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Finaliza el proceso de firma de contrato de una empresa de agentes.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarProcesoFirmaEmpresaAgentes: async (Id?: string, DocumentosFirmados?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaAgentes/firmada`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Id !== undefined) { 
                localVarFormParams.append('Id', Id as any);
            }
                if (DocumentosFirmados) {
                DocumentosFirmados.forEach((element) => {
                    localVarFormParams.append('DocumentosFirmados', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Finaliza el proceso de firma de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarProcesoFirmaOperacionEnergia: async (Id?: string, DocumentosFirmados?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia/firmada`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Id !== undefined) { 
                localVarFormParams.append('Id', Id as any);
            }
                if (DocumentosFirmados) {
                DocumentosFirmados.forEach((element) => {
                    localVarFormParams.append('DocumentosFirmados', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Finaliza el proceso de firma de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmaAutorizacionOperacionEnergia: async (Id?: string, DocumentosFirmados?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia/autorizacion-firmada`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Id !== undefined) { 
                localVarFormParams.append('Id', Id as any);
            }
                if (DocumentosFirmados) {
                DocumentosFirmados.forEach((element) => {
                    localVarFormParams.append('DocumentosFirmados', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Finaliza el proceso de firma del consentimiento previo de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmaConsentimientoPrevioOperacionEnergia: async (Id?: string, DocumentosFirmados?: Array<File>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia/consentimiento-previo-firmado`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Id !== undefined) { 
                localVarFormParams.append('Id', Id as any);
            }
                if (DocumentosFirmados) {
                DocumentosFirmados.forEach((element) => {
                    localVarFormParams.append('DocumentosFirmados', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece una operación de energía como firmada.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarOperacionEnergia: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('firmarOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/firmar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Genera el consentimiento previo de una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generarConsentimientoPrevioOperacionEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('generarConsentimientoPrevioOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/generar-consentimiento-previo`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Genera el contrato de una operación energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generarContratoOperacionEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('generarContratoOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/generar-contrato`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Genera y descarga el borrador de una factura.
         * @param {CreateFacturaModel} [CreateFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBorradorFactura: async (CreateFacturaModel?: CreateFacturaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Factura/download-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateFacturaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una comparación dado su id
         * @param {string} Id 
         * @param {Array<number>} [RequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateComparacionEnergiaPdf: async (Id: string, RequestBody?: Array<number>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('generateComparacionEnergiaPdf', 'Id', Id)
            const localVarPath = `/api/Operaciones/ComparacionEnergia/{id}/generate-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(RequestBody, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el agente dado su id de usuario
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgenteById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getAgenteById', 'Id', Id)
            const localVarPath = `/api/Commons/Agente/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el agente de inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgenteInmobiliariaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getAgenteInmobiliariaById', 'Id', Id)
            const localVarPath = `/api/Commons/Agente/inmobiliaria/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de agentes para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de agentes de inmobiliaria dada la delegación
         * @param {string} [IdDelegacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesInmobiliariaByDelegacionSelector: async (IdDelegacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/inmobiliaria/selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdDelegacion !== undefined) {
                localVarQueryParameter['idDelegacion'] = IdDelegacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de agentes de inmobiliaria para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesInmobiliariaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/inmobiliaria/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de agentes para selectores de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesSelector: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de un anexo de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnexoEmpresaServiciosById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getAnexoEmpresaServiciosById', 'Id', Id)
            const localVarPath = `/api/Operaciones/AnexoEmpresaServicios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los anexos de empresa de servicios para la grid de Devextreme.
         * @param {string} [IdEmpresaServicios] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnexosEmpresaServiciosForGrid: async (IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/AnexoEmpresaServicios/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de un borrador de operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorradorOperacionDetail: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getBorradorOperacionDetail', 'Id', Id)
            const localVarPath = `/api/Operaciones/BorradorOperacion/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de borradores de operaciones de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorradoresOperacionAguaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/BorradorOperacion/grid/agua`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de borradores de operaciones de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorradoresOperacionEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/BorradorOperacion/grid/energia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle del cliente inmobiliario dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClienteInmobiliarioById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getClienteInmobiliarioById', 'Id', Id)
            const localVarPath = `/api/Commons/ClienteInmobiliario/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle del cliente inmobiliario dado su id.
         * @param {string} Id 
         * @param {string} IdRelacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClienteInmuebleById: async (Id: string, IdRelacion: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getClienteInmuebleById', 'Id', Id)
            // verify required parameter 'IdRelacion' is not null or undefined
            assertParamExists('getClienteInmuebleById', 'IdRelacion', IdRelacion)
            const localVarPath = `/api/Commons/Inmueble/{id}/cliente-inmobiliario/{idRelacion}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idRelacion"}}`, encodeURIComponent(String(IdRelacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos más recientes de un cliente dado su documento de identidad o CIF para las operaciones del usuario actual
         * @param {string} [DocumentoIdentidad] 
         * @param {string} [Cif] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClienteLatestInfoForCurrentUser: async (DocumentoIdentidad?: string, Cif?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Operacion/cliente-latest-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (DocumentoIdentidad !== undefined) {
                localVarQueryParameter['documentoIdentidad'] = DocumentoIdentidad;
            }

            if (Cif !== undefined) {
                localVarQueryParameter['cif'] = Cif;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de clientes de un agente para la grid de Devextreme a partir de sus operaciones.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesAgenteForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Operacion/clientes-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de clientes de la empresa inmobiliaria del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdInmueble] 
         * @param {boolean} [PuedeCrearBorrador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesEmpresaInmobiliariaForGrid: async (LoadOptions?: DXLoadOptions, IdInmueble?: string, PuedeCrearBorrador?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaInmobiliaria/me/clientes/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdInmueble !== undefined) {
                localVarQueryParameter['idInmueble'] = IdInmueble;
            }

            if (PuedeCrearBorrador !== undefined) {
                localVarQueryParameter['puedeCrearBorrador'] = PuedeCrearBorrador;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de clientes para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Cliente/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de relaciones de clientes inmobiliarios con un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {TipoRelacionClienteInmobiliarioEnum} [TipoRelacion] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesInmuebleForGrid: async (Id: string, TipoRelacion?: TipoRelacionClienteInmobiliarioEnum, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getClientesInmuebleForGrid', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario/grid`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoRelacion !== undefined) {
                localVarQueryParameter['tipoRelacion'] = TipoRelacion;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de CNAEs para su uso en un selector.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCnaeSelector: async (IdEmpresaServicios?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Cnae`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de los cometidos de agentes de inmobiliaria para su uso en un selector.
         * @param {object} [Model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCometidoAgentesInmobiliariaSelector: async (Model?: object, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/cometidos-inmobiliaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Model !== undefined) {
                for (const [key, value] of Object.entries(Model)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las comisiones por marco de comision para una oferta dado el id de oferta
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComisionesPorMarcoByIdOferta: async (Id: string, IdMarco: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getComisionesPorMarcoByIdOferta', 'Id', Id)
            // verify required parameter 'IdMarco' is not null or undefined
            assertParamExists('getComisionesPorMarcoByIdOferta', 'IdMarco', IdMarco)
            const localVarPath = `/api/Operaciones/OfertaEnergia/{id}/comisiones/{idMarco}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idMarco"}}`, encodeURIComponent(String(IdMarco)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las comisiones por marco de comision para un servicio dado el id de servicio
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComisionesPorMarcoByIdServicio: async (Id: string, IdMarco: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getComisionesPorMarcoByIdServicio', 'Id', Id)
            // verify required parameter 'IdMarco' is not null or undefined
            assertParamExists('getComisionesPorMarcoByIdServicio', 'IdMarco', IdMarco)
            const localVarPath = `/api/Operaciones/ServicioEnergia/{id}/comisiones/{idMarco}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idMarco"}}`, encodeURIComponent(String(IdMarco)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de comparaciones de energia del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparacionesEnergiaAgenteForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ComparacionEnergia/grid-agente`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de comunicaciones de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicacionesOperacionById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getComunicacionesOperacionById', 'Id', Id)
            const localVarPath = `/api/Operaciones/Operacion/{id}/comunicaciones`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de un comunicado por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadoDetail: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getComunicadoDetail', 'Id', Id)
            const localVarPath = `/api/Commons/Comunicado/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de un comunicado dirigido al colaborador autenticado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadoDetailForColaborador: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getComunicadoDetailForColaborador', 'Id', Id)
            const localVarPath = `/api/Commons/Comunicado/{id}/colaborador`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Consulta si un comunicado ha sido leído por un agente a partir de su email.
         * @param {string} Id 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadoLecturaAgente: async (Id: string, Email?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getComunicadoLecturaAgente', 'Id', Id)
            const localVarPath = `/api/Commons/Comunicado/{id}/estado-lectura-agente`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Email !== undefined) {
                localVarQueryParameter['email'] = Email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de comunicados para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadosForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Comunicado/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de comunicados para la grid de DevExtreme de un colaborador.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadosForGridColaborador: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Comunicado/grid-colaborador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los ids de los comunicados de portal sin leer del colaborador autenticado.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadosPortalSinLeerForColaborador: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Comunicado/portal/sin-leer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de contactos lead para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactosLeadForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ContactoLead/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de agentes, con rol de coordinador de delegación, para una empresa inmobiliaria dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoordinadoresDelegacionSelector: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCoordinadoresDelegacionSelector', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaInmobiliaria/{id}/coordinadores-delegacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el criterio de retrocomision de energia para una empresa y dado su id
         * @param {string} IdEmpresa 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriterioRetrocomisionEnergiaById: async (IdEmpresa: string, Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdEmpresa' is not null or undefined
            assertParamExists('getCriterioRetrocomisionEnergiaById', 'IdEmpresa', IdEmpresa)
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCriterioRetrocomisionEnergiaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{idEmpresa}/criterio-retrocomision/{id}/detail`
                .replace(`{${"idEmpresa"}}`, encodeURIComponent(String(IdEmpresa)))
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de criterios de retrocomision de energia para una empresa y un grupo de configuración
         * @param {string} Id 
         * @param {string} [IdGrupo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriosRetrocomisionEnergiaByIdEmpresa: async (Id: string, IdGrupo?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getCriteriosRetrocomisionEnergiaByIdEmpresa', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{id}/criterios-retrocomision`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdGrupo !== undefined) {
                localVarQueryParameter['idGrupo'] = IdGrupo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos personales del agente actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAgentePersonalData: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Agente/me/personal-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los datos de un punto de suministro a partir de su Cups.
         * @param {string} Codigo 
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosPuntoSuministro: async (Codigo: string, IdEmpresaServicios?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Codigo' is not null or undefined
            assertParamExists('getDatosPuntoSuministro', 'Codigo', Codigo)
            const localVarPath = `/api/Operaciones/Cups/{codigo}/datos-suministro`
                .replace(`{${"codigo"}}`, encodeURIComponent(String(Codigo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la delegación inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionInmobiliariaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDelegacionInmobiliariaById', 'Id', Id)
            const localVarPath = `/api/Commons/DelegacionInmobiliaria/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
         * @param {object} [Model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionInmobiliariaSelector: async (Model?: object, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DelegacionInmobiliaria/selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Model !== undefined) {
                for (const [key, value] of Object.entries(Model)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
         * @param {string} IdInmobiliaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionInmobiliariaSelectorByInmobiliaria: async (IdInmobiliaria: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdInmobiliaria' is not null or undefined
            assertParamExists('getDelegacionInmobiliariaSelectorByInmobiliaria', 'IdInmobiliaria', IdInmobiliaria)
            const localVarPath = `/api/Commons/DelegacionInmobiliaria/selector-by-inmobiliaria/{idInmobiliaria}`
                .replace(`{${"idInmobiliaria"}}`, encodeURIComponent(String(IdInmobiliaria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de delegaciones inmobiliarias para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionesInmobiliariasForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/DelegacionInmobiliaria/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
         * @param {string} [IdEmpresaServicios] 
         * @param {Array<string>} [IdsOfertaEnergia] 
         * @param {Array<string>} [IdsServicioEnergia] 
         * @param {string} [IdOperacionEnergia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDescuentosEnergiaAplicables: async (IdEmpresaServicios?: string, IdsOfertaEnergia?: Array<string>, IdsServicioEnergia?: Array<string>, IdOperacionEnergia?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/DescuentoEnergia/aplicables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['IdEmpresaServicios'] = IdEmpresaServicios;
            }

            if (IdsOfertaEnergia) {
                localVarQueryParameter['IdsOfertaEnergia'] = IdsOfertaEnergia;
            }

            if (IdsServicioEnergia) {
                localVarQueryParameter['IdsServicioEnergia'] = IdsServicioEnergia;
            }

            if (IdOperacionEnergia !== undefined) {
                localVarQueryParameter['IdOperacionEnergia'] = IdOperacionEnergia;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una comparación dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailComparacionEnergiaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDetailComparacionEnergiaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/ComparacionEnergia/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Documentos de firma que deben aportarse firmados a mano (misma lógica que la firma digital).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosFirmaManualOperacionEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getDocumentosFirmaManualOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/documentos-firma-manual`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una empresa de agentes por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaAgentesDetail: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEmpresaAgentesDetail', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de las empresas de agentes para su uso en un selector.
         * @param {Array<string>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaAgentesSelector: async (Tipos?: Array<string>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaAgentes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Tipos) {
                localVarQueryParameter['Tipos'] = Tipos;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la empresa colaboradora dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaColaboradoraById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEmpresaColaboradoraById', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaColaboradora/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la empresa colaboradora dado el usuario que lo solicita
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaColaboradoraByUserId: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaColaboradora/detail-by-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la empresa inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaInmobiliariaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEmpresaInmobiliariaById', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaInmobiliaria/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de la empresa inmobiliaria asociada al usuario que realiza la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaInmobiliariaUsuarioRequest: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaInmobiliaria/usuario-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la empresa de servicios de energía dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaServiciosAguaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEmpresaServiciosAguaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{id}/detail/agua`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la empresa de servicios de energía dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaServiciosEnergiaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEmpresaServiciosEnergiaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{id}/detail/energia`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de empresas de agentes para la rejilla DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasAgentesForGrid: async (LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaAgentes/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdsEstados) {
                localVarQueryParameter['idsEstados'] = IdsEstados;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de empresas colaboradoras para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasColaboradoraForGrid: async (LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaColaboradora/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdsEstados) {
                localVarQueryParameter['idsEstados'] = IdsEstados;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de empresas inmobiliarias para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasInmobiliariasForGrid: async (LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaInmobiliaria/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdsEstados) {
                localVarQueryParameter['idsEstados'] = IdsEstados;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosAguaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios/grid/agua`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las empresas de servicio de agua que operan en una provincia concreta dado el codigo postal.
         * @param {string} [CodigoPostal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosAguaOperables: async (CodigoPostal?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios/operables/agua`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (CodigoPostal !== undefined) {
                localVarQueryParameter['codigoPostal'] = CodigoPostal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios/grid/energia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
         * @param {string} [IdEmpresaAgentes] 
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosOperables: async (IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios/operables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaAgentes !== undefined) {
                localVarQueryParameter['IdEmpresaAgentes'] = IdEmpresaAgentes;
            }

            if (Tipos) {
                localVarQueryParameter['Tipos'] = Tipos;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa, operables para la empresa de agentes indicada o, en su defecto, la del usuario que hace la petición.
         * @param {string} [IdEmpresaAgentes] 
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosOperablesSelector: async (IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios/operables-selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaAgentes !== undefined) {
                localVarQueryParameter['IdEmpresaAgentes'] = IdEmpresaAgentes;
            }

            if (Tipos) {
                localVarQueryParameter['Tipos'] = Tipos;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa.
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosSelector: async (Tipos?: Array<TipoEmpresaServiciosEnum>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/EmpresaServicios/selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Tipos) {
                localVarQueryParameter['tipos'] = Tipos;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la estructura documental requerida para una empresa de agentes (configuración y documentos ya adjuntos).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalEmpresaAgentes: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEstructuraDocumentalEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/estructura-documental`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la estructura documental requerida para una empresa de agentes según su forma jurídica.
         * @param {FormaJuridicaEnum} [FormaJuridica] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalEmpresaAgentesByFormaJuridica: async (FormaJuridica?: FormaJuridicaEnum, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/_public/commons/estructura-documental-by-forma-juridica`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FormaJuridica !== undefined) {
                localVarQueryParameter['formaJuridica'] = FormaJuridica;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la estructura documental de una empresa de servicios, con filtro opcional de tipo de persona (física o jurídica).
         * @param {string} Id 
         * @param {TipoPersonaEnum} [TipoPersona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalEmpresaServicios: async (Id: string, TipoPersona?: TipoPersonaEnum, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEstructuraDocumentalEmpresaServicios', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{id}/estructura-documental`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoPersona !== undefined) {
                localVarQueryParameter['tipoPersona'] = TipoPersona;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Dada una operación, obtiene su estructura documental.
         * @param {string} Id 
         * @param {boolean} [IncluirArchivosSistema] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalOperacionEnergia: async (Id: string, IncluirArchivosSistema?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getEstructuraDocumentalOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/estructura-documental`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IncluirArchivosSistema !== undefined) {
                localVarQueryParameter['incluirArchivosSistema'] = IncluirArchivosSistema;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Genera y descarga el Excel para su importación en Repsol.
         * @param {Array<string>} [RequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportacionExcelRepsol: async (RequestBody?: Array<string>, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TramiteEnergia/exportacion-repsol`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(RequestBody, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una factura por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturaDetailById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getFacturaDetailById', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de facturas para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Factura/all/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de facturas del agente creador seleccionado para soporte.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasForGridSoporte: async (IdUsuario?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Factura/soporte/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasInmuebleForGrid: async (Id: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getFacturasInmuebleForGrid', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/facturas/grid`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de facturas para la empresa de agentes del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasMyCompanyForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Factura/my-company/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de grupos de criterios de retrocomisión de energía para una empresa dado el id de empresa
         * @param {string} IdEmpresa 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGruposCriteriosRetrocomisionEnergiaByIdEmpresa: async (IdEmpresa: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdEmpresa' is not null or undefined
            assertParamExists('getGruposCriteriosRetrocomisionEnergiaByIdEmpresa', 'IdEmpresa', IdEmpresa)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{idEmpresa}/grupos-criterios-retrocomision`
                .replace(`{${"idEmpresa"}}`, encodeURIComponent(String(IdEmpresa)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle del inmueble dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInmuebleById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getInmuebleById', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de inmuebles para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdClienteInmobiliario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInmueblesForGrid: async (LoadOptions?: DXLoadOptions, IdClienteInmobiliario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Inmueble/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdClienteInmobiliario !== undefined) {
                localVarQueryParameter['idClienteInmobiliario'] = IdClienteInmobiliario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {TipoSuministroInmuebleEnum} [TipoSuministro] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLecturasInmuebleForGrid: async (Id: string, TipoSuministro?: TipoSuministroInmuebleEnum, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getLecturasInmuebleForGrid', 'Id', Id)
            const localVarPath = `/api/Commons/Inmueble/{id}/lecturas/grid`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoSuministro !== undefined) {
                localVarQueryParameter['tipoSuministro'] = TipoSuministro;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para el agente para la grid de liquidaciones de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidacionesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TramiteEnergia/liquidaciones-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de agentes a los que se ha enviado un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoAgentesComunicado: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getListadoAgentesComunicado', 'Id', Id)
            const localVarPath = `/api/Commons/Comunicado/{id}/agentes`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de notas de un borrador de operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoNotasBorradorOperacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getListadoNotasBorradorOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/BorradorOperacion/{id}/notas`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de notas de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoNotasOperacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getListadoNotasOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/Operacion/{id}/notas`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de notas de un trámite de energía.
         * @param {string} IdTramite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoNotasTramiteEnergia: async (IdTramite: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdTramite' is not null or undefined
            assertParamExists('getListadoNotasTramiteEnergia', 'IdTramite', IdTramite)
            const localVarPath = `/api/Operaciones/TramiteEnergia/{idTramite}/notas`
                .replace(`{${"idTramite"}}`, encodeURIComponent(String(IdTramite)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el logo de la empresa si lo hubiera.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogoPortalEmpresaAgentes: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getLogoPortalEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaAgentes/{id}/logo-portal`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de marcos de comisiones para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarcosComisionesForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MarcoComisiones/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de marcos de comisiones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarcosComisionesList: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/MarcoComisiones/selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el modelo de datos con el que confeccionar la siguiente factura para la empresa de agentes del agente que hace la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextFacturaConfig: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Factura/next-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las notificaciones para el usuario actual.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificaciones: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Notificacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la oferta de Endesa dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertaEndesaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getOfertaEndesaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/OfertaEnergia/endesa/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la oferta de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertaEnergiaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getOfertaEnergiaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/OfertaEnergia/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las ofertas de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado paginado de ofertas de energía.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {Array<string>} [FiltrosComercializadoras] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {string} [FiltrosTarifaAcceso] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {Date} [FiltrosFechaInicio] 
         * @param {Date} [FiltrosFechaFin] 
         * @param {string} [FiltrosTexto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaList: async (Take?: number, Skip?: number, FiltrosComercializadoras?: Array<string>, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTarifaAcceso?: string, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, FiltrosFechaInicio?: Date, FiltrosFechaFin?: Date, FiltrosTexto?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['Take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['Skip'] = Skip;
            }

            if (FiltrosComercializadoras) {
                localVarQueryParameter['Filtros.Comercializadoras'] = FiltrosComercializadoras;
            }

            if (FiltrosTipoEnergia !== undefined) {
                localVarQueryParameter['Filtros.TipoEnergia'] = FiltrosTipoEnergia;
            }

            if (FiltrosTarifaAcceso !== undefined) {
                localVarQueryParameter['Filtros.TarifaAcceso'] = FiltrosTarifaAcceso;
            }

            if (FiltrosTipoPersona !== undefined) {
                localVarQueryParameter['Filtros.TipoPersona'] = FiltrosTipoPersona;
            }

            if (FiltrosConAutoconsumo !== undefined) {
                localVarQueryParameter['Filtros.ConAutoconsumo'] = FiltrosConAutoconsumo;
            }

            if (FiltrosPotenciaMin !== undefined) {
                localVarQueryParameter['Filtros.PotenciaMin'] = FiltrosPotenciaMin;
            }

            if (FiltrosPotenciaMax !== undefined) {
                localVarQueryParameter['Filtros.PotenciaMax'] = FiltrosPotenciaMax;
            }

            if (FiltrosFechaInicio !== undefined) {
                localVarQueryParameter['Filtros.FechaInicio'] = (FiltrosFechaInicio as any instanceof Date) ?
                    (FiltrosFechaInicio as any).toISOString() :
                    FiltrosFechaInicio;
            }

            if (FiltrosFechaFin !== undefined) {
                localVarQueryParameter['Filtros.FechaFin'] = (FiltrosFechaFin as any instanceof Date) ?
                    (FiltrosFechaFin as any).toISOString() :
                    FiltrosFechaFin;
            }

            if (FiltrosTexto !== undefined) {
                localVarQueryParameter['Filtros.Texto'] = FiltrosTexto;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las ofertas de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
         * @param {string} Id 
         * @param {TipoPersonaEnum} TipoPersona 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaOperables: async (Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getOfertasEnergiaOperables', 'Id', Id)
            // verify required parameter 'TipoPersona' is not null or undefined
            assertParamExists('getOfertasEnergiaOperables', 'TipoPersona', TipoPersona)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{id}/ofertas/{tipoPersona}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"tipoPersona"}}`, encodeURIComponent(String(TipoPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdOperacion !== undefined) {
                localVarQueryParameter['IdOperacion'] = IdOperacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado paginado de ofertas de energía con retribuciones para backoffice.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {string} [FiltrosEmpresaAgentes] 
         * @param {string} [FiltrosMarcoComisiones] 
         * @param {string} [FiltrosComercializadora] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaRetribucionesBackofficeList: async (Take?: number, Skip?: number, FiltrosEmpresaAgentes?: string, FiltrosMarcoComisiones?: string, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia/retribuciones/backoffice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['Take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['Skip'] = Skip;
            }

            if (FiltrosEmpresaAgentes !== undefined) {
                localVarQueryParameter['Filtros.EmpresaAgentes'] = FiltrosEmpresaAgentes;
            }

            if (FiltrosMarcoComisiones !== undefined) {
                localVarQueryParameter['Filtros.MarcoComisiones'] = FiltrosMarcoComisiones;
            }

            if (FiltrosComercializadora !== undefined) {
                localVarQueryParameter['Filtros.Comercializadora'] = FiltrosComercializadora;
            }

            if (FiltrosTipoEnergia !== undefined) {
                localVarQueryParameter['Filtros.TipoEnergia'] = FiltrosTipoEnergia;
            }

            if (FiltrosTipoPersona !== undefined) {
                localVarQueryParameter['Filtros.TipoPersona'] = FiltrosTipoPersona;
            }

            if (FiltrosConAutoconsumo !== undefined) {
                localVarQueryParameter['Filtros.ConAutoconsumo'] = FiltrosConAutoconsumo;
            }

            if (FiltrosPotenciaMin !== undefined) {
                localVarQueryParameter['Filtros.PotenciaMin'] = FiltrosPotenciaMin;
            }

            if (FiltrosPotenciaMax !== undefined) {
                localVarQueryParameter['Filtros.PotenciaMax'] = FiltrosPotenciaMax;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Listado paginado de ofertas de energía con retribuciones para colaboradores.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {string} [FiltrosComercializadora] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaRetribucionesColaboradoresList: async (Take?: number, Skip?: number, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OfertaEnergia/retribuciones/colaboradores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Take !== undefined) {
                localVarQueryParameter['Take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['Skip'] = Skip;
            }

            if (FiltrosComercializadora !== undefined) {
                localVarQueryParameter['Filtros.Comercializadora'] = FiltrosComercializadora;
            }

            if (FiltrosTipoEnergia !== undefined) {
                localVarQueryParameter['Filtros.TipoEnergia'] = FiltrosTipoEnergia;
            }

            if (FiltrosTipoPersona !== undefined) {
                localVarQueryParameter['Filtros.TipoPersona'] = FiltrosTipoPersona;
            }

            if (FiltrosConAutoconsumo !== undefined) {
                localVarQueryParameter['Filtros.ConAutoconsumo'] = FiltrosConAutoconsumo;
            }

            if (FiltrosPotenciaMin !== undefined) {
                localVarQueryParameter['Filtros.PotenciaMin'] = FiltrosPotenciaMin;
            }

            if (FiltrosPotenciaMax !== undefined) {
                localVarQueryParameter['Filtros.PotenciaMax'] = FiltrosPotenciaMax;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una operación de agua.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionAguaDetail: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getOperacionAguaDetail', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionEnergiaDetail: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getOperacionEnergiaDetail', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de una comparación de energía.
         * @param {string} IdComparacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionEnergiaDetailFromComparison: async (IdComparacion: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdComparacion' is not null or undefined
            assertParamExists('getOperacionEnergiaDetailFromComparison', 'IdComparacion', IdComparacion)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{idComparacion}/detail-from-comparison`
                .replace(`{${"idComparacion"}}`, encodeURIComponent(String(IdComparacion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de un inmueble.
         * @param {string} IdInmueble 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionEnergiaDetailFromProperty: async (IdInmueble: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdInmueble' is not null or undefined
            assertParamExists('getOperacionEnergiaDetailFromProperty', 'IdInmueble', IdInmueble)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{idInmueble}/detail-from-property`
                .replace(`{${"idInmueble"}}`, encodeURIComponent(String(IdInmueble)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de operaciones de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesAguaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionAgua/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el histórico de estados de las operaciones de agua.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesAguaHistoricoEstados: async (LoadOptions?: DXLoadOptions, IdOperacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionAgua/historico-estados-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdOperacion !== undefined) {
                localVarQueryParameter['idOperacion'] = IdOperacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de operaciones de un cliente.
         * @param {string} [IdCliente] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesByIdCliente: async (IdCliente?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Operacion/listado-operaciones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdCliente !== undefined) {
                localVarQueryParameter['idCliente'] = IdCliente;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de operaciones de energia para el cliente de un agente para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesEnergiaAgenteForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia/clientes-agente-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de operaciones de energia para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el histórico de estados de las operaciones.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesHistoricoEstados: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Operacion/historico-estados-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la plantilla de autorización de tratamiento de datos de un cliente inmobiliario, lista para firmar.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantillaAutorizacionClienteInmobiliario: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getPlantillaAutorizacionClienteInmobiliario', 'Id', Id)
            const localVarPath = `/api/Commons/ClienteInmobiliario/{id}/plantilla-autorizacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de las prioridades de ticket para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrioridadesTicketSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/prioridades`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de provincias.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvincias: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Provincia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la información pública de la empresa inmobiliaria asociada al usuario que realiza la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicInformationSelfEmpresaInmobiliaria: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaInmobiliaria/public-info-usuario-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el rappel de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelEnergiaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getRappelEnergiaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/RappelEnergia/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los rappels de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelsEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/RappelEnergia/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los rappels de energía mensuales asociadas a una factura para la subrejilla de factura de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelsMensualesEnergiaFacturaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/RappelEnergia/rappels-mensuales-factura-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los rappels de energía mensuales para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelsMensualesEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/RappelEnergia/rappels-mensuales-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReajusteMarcoComisionEmpresaAgentes: async (Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getReajusteMarcoComisionEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Operaciones/EmpresaAgentes/{id}/reajuste-marco-comision`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }

            if (IdMarcoComisiones !== undefined) {
                localVarQueryParameter['idMarcoComisiones'] = IdMarcoComisiones;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de la relación entre un cliente inmobiliario e inmueble dado sus ids.
         * @param {string} Id 
         * @param {string} IdClienteInmobiliario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelacionClienteInmuebleDetail: async (Id: string, IdClienteInmobiliario: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getRelacionClienteInmuebleDetail', 'Id', Id)
            // verify required parameter 'IdClienteInmobiliario' is not null or undefined
            assertParamExists('getRelacionClienteInmuebleDetail', 'IdClienteInmobiliario', IdClienteInmobiliario)
            const localVarPath = `/api/Commons/Inmueble/{id}/relacion-cliente-inmobiliario/{idClienteInmobiliario}/full-detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idClienteInmobiliario"}}`, encodeURIComponent(String(IdClienteInmobiliario)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsablesSelectorByIdEmpresaAgentes: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getResponsablesSelectorByIdEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/selector-responsables`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesAll: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Roles/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene un listado de roles del sistema seleccionables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el servicio de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicioEndesaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getServicioEndesaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/ServicioEnergia/endesa/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el servicio de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicioEnergiaById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getServicioEnergiaById', 'Id', Id)
            const localVarPath = `/api/Operaciones/ServicioEnergia/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los servicios de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiciosEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ServicioEnergia/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene las ofertas de servicios extras de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
         * @param {string} Id 
         * @param {TipoPersonaEnum} TipoPersona 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiciosEnergiaOperables: async (Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getServiciosEnergiaOperables', 'Id', Id)
            // verify required parameter 'TipoPersona' is not null or undefined
            assertParamExists('getServiciosEnergiaOperables', 'TipoPersona', TipoPersona)
            const localVarPath = `/api/Operaciones/EmpresaServicios/{id}/oferta-servicios/{tipoPersona}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"tipoPersona"}}`, encodeURIComponent(String(TipoPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdOperacion !== undefined) {
                localVarQueryParameter['IdOperacion'] = IdOperacion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de subtipos de empresa colaboradora para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtipoEmpresaColaboradoraSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/EmpresaColaboradora/subtipos/selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de Subtipo persona para su uso en un selector.
         * @param {TipoPersonaEnum} [TipoPersona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtipoPersonasSelector: async (TipoPersona?: TipoPersonaEnum, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/SubtipoPersona/selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (TipoPersona !== undefined) {
                localVarQueryParameter['tipoPersona'] = TipoPersona;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de los subtipos de ticket a partir de un tipo para su uso en un selector.
         * @param {TipoTicketEnum} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtiposTicketSelectorByIdTipo: async (IdTipoTicket?: TipoTicketEnum, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/subtipos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdTipoTicket !== undefined) {
                localVarQueryParameter['idTipoTicket'] = IdTipoTicket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de las tensiones suministro para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTensionSuministroSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TensionSuministro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle del ticket dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getTicketById', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de tickets para la grid de DexExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el tipo de documento de empresa de servicios dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipoDocumentoEmpresaServiciosById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getTipoDocumentoEmpresaServiciosById', 'Id', Id)
            const localVarPath = `/api/Operaciones/TipoDocumentoEmpresaServicios/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los tipos de documento de empresa de servicios para la grid de Devextreme.
         * @param {string} [IdEmpresaServicios] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposDocumentosEmpresaServiciosForGrid: async (IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TipoDocumentoEmpresaServicios/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdEmpresaServicios !== undefined) {
                localVarQueryParameter['idEmpresaServicios'] = IdEmpresaServicios;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de los tipos de ticket para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposTicketSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Ticket/tipos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de trámites de energia asociadas a una factura para la subrejilla de factura de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaFacturaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TramiteEnergia/factura-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TramiteEnergia/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el histórico de estados de los trámites de energia.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaHistoricoEstados: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TramiteEnergia/historico-estados-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de trámites de energia asociadas a un rappel mensual para la grid del detalle de rappel mensual de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaRappelMensualForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/TramiteEnergia/rappel-mensual-grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesForGridColaboradores: async (IdUsuario?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Operacion/tramites/grid-agentes-inmobiliarios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesForGridSoporte: async (IdUsuario?: string, LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Operacion/tramites/grid-soporte-inmobiliarios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdUsuario !== undefined) {
                localVarQueryParameter['idUsuario'] = IdUsuario;
            }

            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el usuario dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioById: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getUsuarioById', 'Id', Id)
            const localVarPath = `/api/Commons/Usuario/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioCurrentProfile: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/me/Profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosBackofficeSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selector-backoffice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosBackofficeSelectorByIdTicket: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('getUsuariosBackofficeSelectorByIdTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/selector-usuarios-backoffice`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios comerciales (administrador o trabajador)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosComercialesSelector: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/selector-comerciales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el listado de usuarios para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosForGrid: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Realiza la importación de bajas de trámites y servicios a patir del fichero de Endesa.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEndesaBajasOperacionEnergia: async (EsSimulacion?: boolean, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Importaciones/operacion-energia/endesa/bajas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (EsSimulacion !== undefined) {
                localVarQueryParameter['esSimulacion'] = EsSimulacion;
            }


            if (File !== undefined) { 
                localVarFormParams.append('file', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Realiza la importación de códigos externos Cosmos a partir del fichero de Endesa, cruzando por CUPS y fecha de venta.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEndesaCosmosOperacionEnergia: async (EsSimulacion?: boolean, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Importaciones/operacion-energia/endesa/cosmos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (EsSimulacion !== undefined) {
                localVarQueryParameter['esSimulacion'] = EsSimulacion;
            }


            if (File !== undefined) { 
                localVarFormParams.append('file', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Realiza la importación de nuevos estados de trámites y servicios a partir del fichero de Endesa.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEndesaNuevosEstadosOperacionEnergia: async (EsSimulacion?: boolean, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Importaciones/operacion-energia/endesa/nuevos-estados`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (EsSimulacion !== undefined) {
                localVarQueryParameter['esSimulacion'] = EsSimulacion;
            }


            if (File !== undefined) { 
                localVarFormParams.append('file', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Realiza la importación de nuevos estados de trámites a partir del fichero de Naturgy.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importNaturgyNuevosEstadosOperacionEnergia: async (EsSimulacion?: boolean, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/Importaciones/operacion-energia/naturgy/nuevos-estados`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (EsSimulacion !== undefined) {
                localVarQueryParameter['esSimulacion'] = EsSimulacion;
            }


            if (File !== undefined) { 
                localVarFormParams.append('file', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Envia una solicitud de firma de autorización de tratamiento de datos al cliente inmobiliario.
         * @param {string} Id 
         * @param {IniciarFirmaAutorizacionClienteInmobiliarioModel} [IniciarFirmaAutorizacionClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarFirmaAutorizacionClienteInmobiliario: async (Id: string, IniciarFirmaAutorizacionClienteInmobiliarioModel?: IniciarFirmaAutorizacionClienteInmobiliarioModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('iniciarFirmaAutorizacionClienteInmobiliario', 'Id', Id)
            const localVarPath = `/api/Commons/ClienteInmobiliario/{id}/iniciar-firma-autorizacion`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(IniciarFirmaAutorizacionClienteInmobiliarioModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Inicia el proceso de firma de una operación energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarFirmaBackofficeOperacionEnergia: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('iniciarFirmaBackofficeOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/enviar-firma-backoffice`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Inicia el proceso de firma digital del consentimiento previo.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarFirmaConsentimientoPrevioOperacionEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('iniciarFirmaConsentimientoPrevioOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/iniciar-firma-consentimiento-previo`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Inicia el proceso de firma de una operación energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarProcesoFirmaOperacionEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('iniciarProcesoFirmaOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/iniciar-firma`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca como incidencia la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marcarIncidenciaOperacionAgua: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('marcarIncidenciaOperacionAgua', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/incidencia`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca una factura en borrador como pendiente de revisión por parte del colaborador.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markPendingReviewFactura: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('markPendingReviewFactura', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/mark-pending-review`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca en curso la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ponerEnCursoOperacionAgua: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('ponerEnCursoOperacionAgua', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/en-curso`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un documento de empresa de agentes.
         * @param {string} Id 
         * @param {TipoDocumentoEmpresaAgentesEnum} [TipoDocumento] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoEmpresaAgentes: async (Id: string, TipoDocumento?: TipoDocumentoEmpresaAgentesEnum, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('postDocumentoEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/upload-documento`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (TipoDocumento !== undefined) {
                localVarQueryParameter['tipoDocumento'] = TipoDocumento;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un tipo de documento a la operación de agua.
         * @param {string} Id 
         * @param {string} [IdTipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoOperacionAgua: async (Id: string, IdTipoDocumento?: string, Descripcion?: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('postDocumentoOperacionAgua', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionAgua/{id}/adjuntar-documento`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (IdTipoDocumento !== undefined) {
                localVarQueryParameter['idTipoDocumento'] = IdTipoDocumento;
            }

            if (Descripcion !== undefined) {
                localVarQueryParameter['descripcion'] = Descripcion;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Adjunta un tipo de documento a la operación de energía.
         * @param {string} Id 
         * @param {TipoDocumentoOperacionEnergiaEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoOperacionEnergia: async (Id: string, TipoDocumento?: TipoDocumentoOperacionEnergiaEnum, Descripcion?: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('postDocumentoOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/adjuntar-documento`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required



            if (TipoDocumento !== undefined) {
                localVarQueryParameter['tipoDocumento'] = TipoDocumento;
            }

            if (Descripcion !== undefined) {
                localVarQueryParameter['descripcion'] = Descripcion;
            }


            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero de forma temporal.
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoTemp: async (Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Documentos/adjuntar-documento-temp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza el anexo asociado a una oferta de energía.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAnexoOfertaEnergia: async (Id: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('putAnexoOfertaEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OfertaEnergia/{id}/actualizar-anexo`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza el anexo asociado a un servicio de energía.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAnexoServicioEnergia: async (Id: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('putAnexoServicioEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/ServicioEnergia/{id}/actualizar-anexo`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza el documento de dni asociado a un agente.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDocumentoAgente: async (Id: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('putDocumentoAgente', 'Id', Id)
            const localVarPath = `/api/Commons/Agente/{id}/actualizar-dni`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Actualiza la factura propia asociada a una factura.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFacturaPropia: async (Id: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('putFacturaPropia', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/actualizar-factura-propia`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Reactiva una empresa de agentes dada de baja
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateEmpresaAgentes: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('reactivateEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/reactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Reactiva un usuario dado de baja.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateUsuario: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('reactivateUsuario', 'Id', Id)
            const localVarPath = `/api/Commons/Usuario/{id}/reactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca como leída las comunicaciones de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readComunicacionesOperacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('readComunicacionesOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/Operacion/{id}/leer-comunicaciones`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca un comunicado de portal como leído para el colaborador autenticado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readComunicadoForColaborador: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('readComunicadoForColaborador', 'Id', Id)
            const localVarPath = `/api/Commons/Comunicado/{id}/colaborador/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca como leídos todos los mensajes de un ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMensajesTicket: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('readMensajesTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/leer-mensajes`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Marca una notificación como leída.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotificacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('readNotificacion', 'Id', Id)
            const localVarPath = `/api/Commons/Notificacion/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rechaza una autorización de consentimiento firmada por un cliente inmobiliario.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazarAutorizacionClienteInmobiliario: async (Id: string, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('rechazarAutorizacionClienteInmobiliario', 'Id', Id)
            const localVarPath = `/api/Operaciones/ClienteInmobiliario/{id}/autorizacion-rechazada`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rechaza una operación de energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazarBackofficeOperacionEnergia: async (Id: string, Comentario?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('rechazarBackofficeOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/rechazar-backoffice`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Comentario !== undefined) {
                localVarQueryParameter['comentario'] = Comentario;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rechaza un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCloseTicket: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('rejectCloseTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/rechazar-cierre`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rechaza la empresa de agentes
         * @param {string} Id 
         * @param {string} [MotivoRechazo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmpresaAgentes: async (Id: string, MotivoRechazo?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('rejectEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (MotivoRechazo !== undefined) {
                localVarQueryParameter['motivoRechazo'] = MotivoRechazo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rechaza una factura.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectFactura: async (Id: string, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('rejectFactura', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Rechaza una factura.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPendingReviewFactura: async (Id: string, Body?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('rejectPendingReviewFactura', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/reject-pending-review`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Body, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Cancela y reinicia una operación de energía al estado inicial.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOperacionEnergia: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('resetOperacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/OperacionEnergia/{id}/reiniciar`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna al usuario que realiza la petición como responsable de una operacion.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfAssignResponsableOperacion: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('selfAssignResponsableOperacion', 'Id', Id)
            const localVarPath = `/api/Operaciones/Operacion/{id}/asignarse-responsable`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Asigna al usuario que realiza la petición como responsable de un ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfAssignResponsableTicket: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('selfAssignResponsableTicket', 'Id', Id)
            const localVarPath = `/api/Commons/Ticket/{id}/asignarse-responsable`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Envía la empresa de agentes para firma
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToSignEmpresaAgentes: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('sendToSignEmpresaAgentes', 'Id', Id)
            const localVarPath = `/api/Commons/EmpresaAgentes/{id}/send-to-sign`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Establece la prioridad de un ticket.
         * @param {string} Id 
         * @param {PrioridadTicketEnum} Prioridad 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrioridadTicket: async (Id: string, Prioridad: PrioridadTicketEnum, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('setPrioridadTicket', 'Id', Id)
            // verify required parameter 'Prioridad' is not null or undefined
            assertParamExists('setPrioridadTicket', 'Prioridad', Prioridad)
            const localVarPath = `/api/Commons/Ticket/{id}/prioridad/{prioridad}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"prioridad"}}`, encodeURIComponent(String(Prioridad)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Liquida una factura.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settleFactura: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('settleFactura', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/settle`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Liquida una factura pendiente de revisión por parte del colaborador.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlePendingReviewFactura: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('settlePendingReviewFactura', 'Id', Id)
            const localVarPath = `/api/Operaciones/Factura/{id}/settle-pending-review`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Simula las comisiones de oferta para una comparación de energía.
         * @param {string} Id 
         * @param {SimularComisionesComparacionEnergiaRequest} [SimularComisionesComparacionEnergiaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simularComisionesComparacionEnergia: async (Id: string, SimularComisionesComparacionEnergiaRequest?: SimularComisionesComparacionEnergiaRequest, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('simularComisionesComparacionEnergia', 'Id', Id)
            const localVarPath = `/api/Operaciones/ComparacionEnergia/{id}/simular-comisiones`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(SimularComisionesComparacionEnergiaRequest, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube la autorización firmada de tratamiento de datos de un cliente inmobiliario.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subirAutorizacionClienteInmobiliario: async (Id: string, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('subirAutorizacionClienteInmobiliario', 'Id', Id)
            const localVarPath = `/api/Commons/ClienteInmobiliario/{id}/subir-autorizacion-firmada`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckEmail: async (Email: string, IdUsuario: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Email' is not null or undefined
            assertParamExists('usuarioCheckEmail', 'Email', Email)
            // verify required parameter 'IdUsuario' is not null or undefined
            assertParamExists('usuarioCheckEmail', 'IdUsuario', IdUsuario)
            const localVarPath = `/api/Commons/Usuario/{Email}/{IdUsuario}/EmailAvailable`
                .replace(`{${"Email"}}`, encodeURIComponent(String(Email)))
                .replace(`{${"IdUsuario"}}`, encodeURIComponent(String(IdUsuario)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckUsername: async (Username: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Username' is not null or undefined
            assertParamExists('usuarioCheckUsername', 'Username', Username)
            const localVarPath = `/api/Commons/Usuario/{Username}/Available`
                .replace(`{${"Username"}}`, encodeURIComponent(String(Username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Valida una autorización de consentimiento firmada por un cliente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarAutorizacionClienteInmobiliario: async (Id: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('validarAutorizacionClienteInmobiliario', 'Id', Id)
            const localVarPath = `/api/Commons/ClienteInmobiliario/{id}/autorizacion-validada`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Valida si un contacto lead de operación es válido, a partir de los datos de titular.
         * @param {TitularModel} [TitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactoLeadOperacion: async (TitularModel?: TitularModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ContactoLead/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TitularModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Comprueba si el email no se ha usado en otras operaciones asociadas a otros documentos de titular.
         * @param {ValidateEmailTitularModel} [ValidateEmailTitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailTitular: async (ValidateEmailTitularModel?: ValidateEmailTitularModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia/validate-email-titular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ValidateEmailTitularModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Comprueba si el móvil no se ha usado en otras operaciones asociadas a otros documentos de titular.
         * @param {ValidateMovilTitularModel} [ValidateMovilTitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMovilTitular: async (ValidateMovilTitularModel?: ValidateMovilTitularModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/OperacionEnergia/validate-movil-titular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ValidateMovilTitularModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Webhook para las altas de los contactos Lead.
         * @param {CreateContactoLeadModel} [CreateContactoLeadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAltaNuevoContadoLead: async (CreateContactoLeadModel?: CreateContactoLeadModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Operaciones/ContactoLead/webhook-alta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateContactoLeadModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiApi - functional programming interface
 * @export
 */
export const ApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Acepta un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptCloseTicket(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptCloseTicket(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.acceptCloseTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Maneja el acceso desde el CRM externo IA Gestion
         * @param {AccesoExternoIaGestionModel} [AccesoExternoIaGestionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accesoExternoAgenteIaGestion(AccesoExternoIaGestionModel?: AccesoExternoIaGestionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accesoExternoAgenteIaGestion(AccesoExternoIaGestionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.accesoExternoAgenteIaGestion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Acepta una operación de energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aceptarBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aceptarBackofficeOperacionEnergia(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.aceptarBackofficeOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca como activada la operación de agua.
         * @param {string} Id 
         * @param {Date} [FechaActivacion] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activarOperacionAgua(Id: string, FechaActivacion?: Date, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activarOperacionAgua(Id, FechaActivacion, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.activarOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Activa un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {ActivateTramiteEnergiaModel} [ActivateTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activarTramiteEnergia(IdOperacion: string, ActivateTramiteEnergiaModel?: ActivateTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activarTramiteEnergia(IdOperacion, ActivateTramiteEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.activarTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade una comunicación a una operación.
         * @param {string} Id 
         * @param {CreateComunicacionOperacionModel} [CreateComunicacionOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addComunicacionOperacion(Id: string, CreateComunicacionOperacionModel?: CreateComunicacionOperacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addComunicacionOperacion(Id, CreateComunicacionOperacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addComunicacionOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade una factura a un inmueble.
         * @param {string} Id 
         * @param {AddFacturaInmuebleModel} [AddFacturaInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFacturaInmueble(Id: string, AddFacturaInmuebleModel?: AddFacturaInmuebleModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFacturaInmueble(Id, AddFacturaInmuebleModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addFacturaInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade una lectura a un inmueble.
         * @param {string} Id 
         * @param {AddLecturaInmuebleModel} [AddLecturaInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLecturaInmueble(Id: string, AddLecturaInmuebleModel?: AddLecturaInmuebleModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLecturaInmueble(Id, AddLecturaInmuebleModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addLecturaInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade un mensaje a un ticket.
         * @param {string} Id 
         * @param {CreateMensajeTicketModel} [CreateMensajeTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMessageTicket(Id: string, CreateMensajeTicketModel?: CreateMensajeTicketModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMessageTicket(Id, CreateMensajeTicketModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addMessageTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade a la operación de agua indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addObservacionOperacionAgua(IdOperacion: string, Observacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addObservacionOperacionAgua(IdOperacion, Observacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addObservacionOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade a la operación indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addObservacionOperacionEnergia(IdOperacion: string, Observacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addObservacionOperacionEnergia(IdOperacion, Observacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addObservacionOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade al trámite de la operación indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addObservacionTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Observacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addObservacionTramiteEnergia(IdOperacion, TipoSuministro, Observacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addObservacionTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Añade una nueva relación de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {AddRelacionClienteInmobiliarioInmuebleModel} [AddRelacionClienteInmobiliarioInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRelacionClienteInmobiliarioInmueble(Id: string, AddRelacionClienteInmobiliarioInmuebleModel?: AddRelacionClienteInmobiliarioInmuebleModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRelacionClienteInmobiliarioInmueble(Id, AddRelacionClienteInmobiliarioInmuebleModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.addRelacionClienteInmobiliarioInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta el consentimiento previo firmado manualmente.
         * @param {string} Id 
         * @param {File} [Fichero] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjuntarConsentimientoPrevioOperacionEnergia(Id: string, Fichero?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjuntarConsentimientoPrevioOperacionEnergia(Id, Fichero, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.adjuntarConsentimientoPrevioOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Anula una operación de energía, junto a sus trámites.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anularOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anularOperacionEnergia(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.anularOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca el trámite de la operación indicada como anulada.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anularTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anularTramiteEnergia(IdOperacion, TipoSuministro, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.anularTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Aplica reajustes de comisión y/o retrocomisión a los conceptos de trámite/servicio de una factura revisable.
         * @param {string} Id 
         * @param {AplicarReajustesConceptosFacturaModel} [AplicarReajustesConceptosFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aplicarReajustesConceptosFactura(Id: string, AplicarReajustesConceptosFacturaModel?: AplicarReajustesConceptosFacturaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aplicarReajustesConceptosFactura(Id, AplicarReajustesConceptosFacturaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.aplicarReajustesConceptosFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Solicita un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askCloseTicket(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askCloseTicket(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.askCloseTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna el identificador externo de una operación de energía.
         * @param {string} IdOperacion 
         * @param {AssignExternalIdOperacionEnergiaModel} [AssignExternalIdOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignExternalIdOperacionEnergia(IdOperacion: string, AssignExternalIdOperacionEnergiaModel?: AssignExternalIdOperacionEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignExternalIdOperacionEnergia(IdOperacion, AssignExternalIdOperacionEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.assignExternalIdOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna el identificador externo de un trámite de energía.
         * @param {string} IdTramite 
         * @param {AssignExternalIdTramiteEnergiaModel} [AssignExternalIdTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignExternalIdTramiteEnergia(IdTramite: string, AssignExternalIdTramiteEnergiaModel?: AssignExternalIdTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignExternalIdTramiteEnergia(IdTramite, AssignExternalIdTramiteEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.assignExternalIdTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna un usuario como responsable de una operacion.
         * @param {string} Id 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignResponsableOperacion(Id: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignResponsableOperacion(Id, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.assignResponsableOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna un usuario como responsable de un ticket.
         * @param {string} Id 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignResponsableTicket(Id: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignResponsableTicket(Id, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.assignResponsableTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Autoregistro de una empresa de agentes.
         * @param {TipoEmpresaAgentesEnum} [TipoEmpresaAgentes] 
         * @param {FormaJuridicaEnum} [FormaJuridicaTitular] 
         * @param {string} [RazonSocial] 
         * @param {string} [NifCif] 
         * @param {string} [Email] 
         * @param {string} [DireccionCodigoPostal] 
         * @param {string} [DireccionProvincia] 
         * @param {string} [DireccionMunicipio] 
         * @param {string} [DireccionTipoVia] 
         * @param {string} [DireccionNombreVia] 
         * @param {string} [DireccionNumero] 
         * @param {string} [DireccionEscalera] 
         * @param {string} [DireccionPiso] 
         * @param {string} [DireccionPuerta] 
         * @param {string} [NombreRepresentante] 
         * @param {string} [NifRepresentante] 
         * @param {string} [EmailRepresentante] 
         * @param {string} [TelefonoRepresentante] 
         * @param {Array<DocumentacionAutoregistroPorTipoModel>} [Documentacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoregistroEmpresaAgentes(TipoEmpresaAgentes?: TipoEmpresaAgentesEnum, FormaJuridicaTitular?: FormaJuridicaEnum, RazonSocial?: string, NifCif?: string, Email?: string, DireccionCodigoPostal?: string, DireccionProvincia?: string, DireccionMunicipio?: string, DireccionTipoVia?: string, DireccionNombreVia?: string, DireccionNumero?: string, DireccionEscalera?: string, DireccionPiso?: string, DireccionPuerta?: string, NombreRepresentante?: string, NifRepresentante?: string, EmailRepresentante?: string, TelefonoRepresentante?: string, Documentacion?: Array<DocumentacionAutoregistroPorTipoModel>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoregistroEmpresaAgentes(TipoEmpresaAgentes, FormaJuridicaTitular, RazonSocial, NifCif, Email, DireccionCodigoPostal, DireccionProvincia, DireccionMunicipio, DireccionTipoVia, DireccionNombreVia, DireccionNumero, DireccionEscalera, DireccionPiso, DireccionPuerta, NombreRepresentante, NifRepresentante, EmailRepresentante, TelefonoRepresentante, Documentacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.autoregistroEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca como baja la operación de agua.
         * @param {string} Id 
         * @param {Date} [FechaBaja] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bajaOperacionAgua(Id: string, FechaBaja?: Date, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bajaOperacionAgua(Id, FechaBaja, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.bajaOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Da de baja un servicio incluido en un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {string} IdServicio 
         * @param {DeactivateServicioIncluidoTramiteEnergiaModel} [DeactivateServicioIncluidoTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bajaServicioIncluidoTramiteEnergia(IdOperacion: string, IdServicio: string, DeactivateServicioIncluidoTramiteEnergiaModel?: DeactivateServicioIncluidoTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bajaServicioIncluidoTramiteEnergia(IdOperacion, IdServicio, DeactivateServicioIncluidoTramiteEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.bajaServicioIncluidoTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Da de baja un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {DeactivateTramiteEnergiaModel} [DeactivateTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bajaTramiteEnergia(IdOperacion: string, DeactivateTramiteEnergiaModel?: DeactivateTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bajaTramiteEnergia(IdOperacion, DeactivateTramiteEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.bajaTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cambia el estado libre del trámite de la operación indicada.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {EstadoLibreTramiteEnergiaEnum} [NuevoEstado] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cambiarEstadoLibreTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, NuevoEstado?: EstadoLibreTramiteEnergiaEnum, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cambiarEstadoLibreTramiteEnergia(IdOperacion, TipoSuministro, NuevoEstado, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cambiarEstadoLibreTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancela un borrador de operación
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBorradorOperacion(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBorradorOperacion(Id, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cancelBorradorOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancela el proceso de firma de docuemntación para el registro de una empresa de agentes.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSignEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSignEmpresaAgentes(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cancelSignEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancela el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelarFirmaAutorizacionClienteInmobiliario(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelarFirmaAutorizacionClienteInmobiliario(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cancelarFirmaAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca como cancelada la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelarOperacionAgua(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelarOperacionAgua(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.cancelarOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Comprueba si el email o tel. móvil se ha usado en otras operaciones con distinto documento de identidad.
         * @param {string} [Email] 
         * @param {string} [TelMovil] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPotentialFraudOperacion(Email?: string, TelMovil?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperacionPotencialmenteFraudulentaRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPotentialFraudOperacion(Email, TelMovil, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.checkPotentialFraudOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo agente
         * @param {CreateAgenteModel} [CreateAgenteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgente(CreateAgenteModel?: CreateAgenteModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgente(CreateAgenteModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createAgente']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo agente inmobiliario
         * @param {CreateAgenteInmobiliariaModel} [CreateAgenteInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgenteInmobiliaria(CreateAgenteInmobiliariaModel?: CreateAgenteInmobiliariaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgenteInmobiliaria(CreateAgenteInmobiliariaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createAgenteInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un anexo de empresa de servicios.
         * @param {CreateAnexoEmpresaServiciosDto} [CreateAnexoEmpresaServiciosDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnexoEmpresaServicios(CreateAnexoEmpresaServiciosDto?: CreateAnexoEmpresaServiciosDto, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnexoEmpresaServicios(CreateAnexoEmpresaServiciosDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createAnexoEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea la autorización de cesión de datos para un contacto lead.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAutorizacionCesionDatosContactoLead(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAutorizacionCesionDatosContactoLead(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createAutorizacionCesionDatosContactoLead']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea los borradores de operación
         * @param {CreateBorradoresOperacionModel} [CreateBorradoresOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBorradoresOperacion(CreateBorradoresOperacionModel?: CreateBorradoresOperacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBorradoresOperacion(CreateBorradoresOperacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createBorradoresOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo cliente inmobiliario.
         * @param {CreateClienteInmobiliarioModel} [CreateClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClienteInmobiliario(CreateClienteInmobiliarioModel?: CreateClienteInmobiliarioModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClienteInmobiliario(CreateClienteInmobiliarioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una lista de comisiones de energia por oferta para un marco de comisiones.
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {Array<CreateComisionEnergiaOfertaModel>} [CreateComisionEnergiaOfertaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComisionesEnergiaOferta(Id: string, IdMarco: string, CreateComisionEnergiaOfertaModel?: Array<CreateComisionEnergiaOfertaModel>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringIListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComisionesEnergiaOferta(Id, IdMarco, CreateComisionEnergiaOfertaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createComisionesEnergiaOferta']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una lista de comisiones de energia por servicio para un marco de comisiones.
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {Array<CreateComisionEnergiaServicioModel>} [CreateComisionEnergiaServicioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComisionesEnergiaServicio(Id: string, IdMarco: string, CreateComisionEnergiaServicioModel?: Array<CreateComisionEnergiaServicioModel>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringIListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComisionesEnergiaServicio(Id, IdMarco, CreateComisionEnergiaServicioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createComisionesEnergiaServicio']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nueva comparacion de energia.
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComparacionEnergia(File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateComparacionEnergiaResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComparacionEnergia(File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createComparacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo comunicado.
         * @param {TipoComunicadoEnum} [Tipo] 
         * @param {string} [Asunto] 
         * @param {string} [Cuerpo] 
         * @param {string} [TipoEmpresaAgenteDirigido] 
         * @param {Array<string>} [RolesDirigidos] 
         * @param {Array<string>} [EmpresasAgentesDirigidos] 
         * @param {Array<File>} [Adjuntos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComunicado(Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComunicado(Tipo, Asunto, Cuerpo, TipoEmpresaAgenteDirigido, RolesDirigidos, EmpresasAgentesDirigidos, Adjuntos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createComunicado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {CreateCriterioRetrocomisionEnergiaModel} [CreateCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCriterioRetrocomisionEnergia(IdEmpresa: string, CreateCriterioRetrocomisionEnergiaModel?: CreateCriterioRetrocomisionEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCriterioRetrocomisionEnergia(IdEmpresa, CreateCriterioRetrocomisionEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createCriterioRetrocomisionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una delegación de inmobiliaria.
         * @param {CreateDelegacionInmobiliariaModel} [CreateDelegacionInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDelegacionInmobiliaria(CreateDelegacionInmobiliariaModel?: CreateDelegacionInmobiliariaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDelegacionInmobiliaria(CreateDelegacionInmobiliariaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createDelegacionInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una empresa colaboradora.
         * @param {CreateEmpresaColaboradoraModel} [CreateEmpresaColaboradoraModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmpresaColaboradora(CreateEmpresaColaboradoraModel?: CreateEmpresaColaboradoraModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmpresaColaboradora(CreateEmpresaColaboradoraModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createEmpresaColaboradora']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una empresa Inmobiliaria.
         * @param {CreateEmpresaInmobiliariaModel} [CreateEmpresaInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmpresaInmobiliaria(CreateEmpresaInmobiliariaModel?: CreateEmpresaInmobiliariaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmpresaInmobiliaria(CreateEmpresaInmobiliariaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createEmpresaInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una empresa de servicios.
         * @param {CreateEmpresaServiciosModel} [CreateEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmpresaServicios(CreateEmpresaServiciosModel?: CreateEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmpresaServicios(CreateEmpresaServiciosModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una factura.
         * @param {CreateFacturaModel} [CreateFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFactura(CreateFacturaModel?: CreateFacturaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFactura(CreateFacturaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un grupo de criterios de retrocomisión de energía.
         * @param {string} IdEmpresa 
         * @param {CreateGrupoCriterioRetrocomisionEnergiaModel} [CreateGrupoCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGrupoCriterioRetrocomisionEnergia(IdEmpresa: string, CreateGrupoCriterioRetrocomisionEnergiaModel?: CreateGrupoCriterioRetrocomisionEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGrupoCriterioRetrocomisionEnergia(IdEmpresa, CreateGrupoCriterioRetrocomisionEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createGrupoCriterioRetrocomisionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo inmueble.
         * @param {CreateInmuebleModel} [CreateInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInmueble(CreateInmuebleModel?: CreateInmuebleModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInmueble(CreateInmuebleModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo marco de comisiones
         * @param {CreateMarcoComisionesModel} [CreateMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMarcoComisiones(CreateMarcoComisionesModel?: CreateMarcoComisionesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMarcoComisiones(CreateMarcoComisionesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createMarcoComisiones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nota para un borrador de operación.
         * @param {string} Id 
         * @param {CreateNotaBorradorOperacionModel} [CreateNotaBorradorOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotaBorradorOperacion(Id: string, CreateNotaBorradorOperacionModel?: CreateNotaBorradorOperacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotaBorradorOperacion(Id, CreateNotaBorradorOperacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createNotaBorradorOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nota para una operación.
         * @param {string} Id 
         * @param {CreateNotaOperacionModel} [CreateNotaOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotaOperacion(Id: string, CreateNotaOperacionModel?: CreateNotaOperacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotaOperacion(Id, CreateNotaOperacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createNotaOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una nota para un trámite de energía.
         * @param {string} IdTramite 
         * @param {CreateNotaTramiteEnergiaModel} [CreateNotaTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotaTramiteEnergia(IdTramite: string, CreateNotaTramiteEnergiaModel?: CreateNotaTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotaTramiteEnergia(IdTramite, CreateNotaTramiteEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createNotaTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una oferta de energía de Endesa.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoOferta] 
         * @param {CreateOfertaEndesaModel} [CreateOfertaEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOfertaEndesa(Filename?: string, RutaAnexoOferta?: string, CreateOfertaEndesaModel?: CreateOfertaEndesaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOfertaEndesa(Filename, RutaAnexoOferta, CreateOfertaEndesaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createOfertaEndesa']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una oferta de energía.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoOferta] 
         * @param {CreateOfertaEnergiaModel} [CreateOfertaEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOfertaEnergia(Filename?: string, RutaAnexoOferta?: string, CreateOfertaEnergiaModel?: CreateOfertaEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOfertaEnergia(Filename, RutaAnexoOferta, CreateOfertaEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createOfertaEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una operación de agua.
         * @param {CreateOperacionAguaModel} [CreateOperacionAguaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOperacionAgua(CreateOperacionAguaModel?: CreateOperacionAguaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOperacionAgua(CreateOperacionAguaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea una operación de energía.
         * @param {CreateOperacionEnergiaModel} [CreateOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOperacionEnergia(CreateOperacionEnergiaModel?: CreateOperacionEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOperacionEnergia(CreateOperacionEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un rappel de energía.
         * @param {CreateRappelEnergiaModel} [CreateRappelEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRappelEnergia(CreateRappelEnergiaModel?: CreateRappelEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRappelEnergia(CreateRappelEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createRappelEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un servicio de endesa.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoServicio] 
         * @param {CreateServicioEndesaModel} [CreateServicioEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServicioEndesa(Filename?: string, RutaAnexoServicio?: string, CreateServicioEndesaModel?: CreateServicioEndesaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServicioEndesa(Filename, RutaAnexoServicio, CreateServicioEndesaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createServicioEndesa']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un servicio de energía.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoServicio] 
         * @param {CreateServicioEnergiaModel} [CreateServicioEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServicioEnergia(Filename?: string, RutaAnexoServicio?: string, CreateServicioEnergiaModel?: CreateServicioEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServicioEnergia(Filename, RutaAnexoServicio, CreateServicioEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createServicioEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo ticket.
         * @param {CreateTicketModel} [CreateTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicket(CreateTicketModel?: CreateTicketModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicket(CreateTicketModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un tipo de documento para una empresa de servicios.
         * @param {CreateTipoDocumentoEmpresaServiciosModel} [CreateTipoDocumentoEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTipoDocumentoEmpresaServicios(CreateTipoDocumentoEmpresaServiciosModel?: CreateTipoDocumentoEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTipoDocumentoEmpresaServicios(CreateTipoDocumentoEmpresaServiciosModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createTipoDocumentoEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUsuario(CreateUserModel?: CreateUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsuario(CreateUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.createUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un agente.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgente(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgente(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteAgente']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un agente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgenteInmobiliaria(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgenteInmobiliaria(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteAgenteInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un anexo de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnexoEmpresaServicios(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnexoEmpresaServicios(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteAnexoEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un borrador de operación
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBorradorOperacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBorradorOperacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteBorradorOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una comisión de energía por oferta.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComisionEnergiaOferta(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComisionEnergiaOferta(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteComisionEnergiaOferta']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una comisión de energía por servicio.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComisionEnergiaServicio(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComisionEnergiaServicio(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteComisionEnergiaServicio']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComunicado(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComunicado(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteComunicado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCriterioRetrocomisionEnergia(IdEmpresa: string, Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCriterioRetrocomisionEnergia(IdEmpresa, Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteCriterioRetrocomisionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina o da de baja una delegación inmobiliaria en función del valor del parámetro \'borradoFisico\'.
         * @param {string} Id 
         * @param {boolean} [BorradoFisico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDelegacionInmobiliaria(Id: string, BorradoFisico?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDelegacionInmobiliaria(Id, BorradoFisico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteDelegacionInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un documento adjunto de la empresa de agentes.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentoEmpresaAgentes(Id: string, IdDocumento: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentoEmpresaAgentes(Id, IdDocumento, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteDocumentoEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un documento adjuntado de la operación de agua.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentoOperacionAgua(Id: string, IdDocumento: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentoOperacionAgua(Id, IdDocumento, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteDocumentoOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un documento adjuntado de la operación de energía.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentoOperacionEnergia(Id: string, IdDocumento: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentoOperacionEnergia(Id, IdDocumento, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteDocumentoOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una empresa de agentes
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmpresaAgentes(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una empresa colaboradora.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmpresaColaboradora(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmpresaColaboradora(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteEmpresaColaboradora']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una empresa inmobiliaria.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmpresaInmobiliaria(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmpresaInmobiliaria(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteEmpresaInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una empresa de servicios, con parámetro opcional de borrado físico.
         * @param {string} Id 
         * @param {boolean} [BorradoFisico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmpresaServicios(Id: string, BorradoFisico?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmpresaServicios(Id, BorradoFisico, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una factura de un inmueble.
         * @param {string} IdInmueble 
         * @param {string} IdFactura 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFacturaInmueble(IdInmueble: string, IdFactura: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFacturaInmueble(IdInmueble, IdFactura, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteFacturaInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un inmueble.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInmueble(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInmueble(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una lectura de un inmueble.
         * @param {string} IdInmueble 
         * @param {string} IdLectura 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLecturaInmueble(IdInmueble: string, IdLectura: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLecturaInmueble(IdInmueble, IdLectura, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteLecturaInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un marco de comisiones.
         * @param {string} Id 
         * @param {DeleteMarcoComisionesModel} [DeleteMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMarcoComisiones(Id: string, DeleteMarcoComisionesModel?: DeleteMarcoComisionesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMarcoComisiones(Id, DeleteMarcoComisionesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteMarcoComisiones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina una oferta de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOfertaEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOfertaEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteOfertaEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un rappel de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRappelEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRappelEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteRappelEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un relación existente de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {string} IdRelacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelacionClienteInmobiliarioInmueble(Id: string, IdRelacion: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRelacionClienteInmobiliarioInmueble(Id, IdRelacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteRelacionClienteInmobiliarioInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un servicio de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteServicioEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteServicioEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteServicioEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un tipo de documento de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTipoDocumentoEmpresaServicios(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTipoDocumentoEmpresaServicios(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteTipoDocumentoEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un usuario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsuario(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsuario(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deleteUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Deshace el estado actual de una operación de energía, devolviéndola al estado previo.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deshacerEstadoOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deshacerEstadoOperacionEnergia(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.deshacerEstadoOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un enlace temporal al documento indicado
         * @param {string} [Key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentosGenerateTempUrl(Key?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentosGenerateTempUrl(Key, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.documentosGenerateTempUrl']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Genera un zip con los ficheros asociados a una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFicheroEmpresaServicios(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFicheroEmpresaServicios(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.downloadFicheroEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Duplica un marco de comisiones.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateMarcoComisiones(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateMarcoComisiones(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.duplicateMarcoComisiones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Duplica una oferta de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateOfertaEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateOfertaEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.duplicateOfertaEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Duplica un servicio de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateServicioEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateServicioEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.duplicateServicioEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un agente existente
         * @param {EditAgenteModel} [EditAgenteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAgente(EditAgenteModel?: EditAgenteModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editAgente(EditAgenteModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editAgente']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un agente inmobiliario existente
         * @param {EditAgenteInmobiliariaModel} [EditAgenteInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAgenteInmobiliaria(EditAgenteInmobiliariaModel?: EditAgenteInmobiliariaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editAgenteInmobiliaria(EditAgenteInmobiliariaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editAgenteInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un anexo de empresa de servicios.
         * @param {EditAnexoEmpresaServiciosDto} [EditAnexoEmpresaServiciosDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAnexoEmpresaServicios(EditAnexoEmpresaServiciosDto?: EditAnexoEmpresaServiciosDto, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editAnexoEmpresaServicios(EditAnexoEmpresaServiciosDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editAnexoEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un cliente inmobiliario existente
         * @param {EditClienteInmobiliarioModel} [EditClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editClienteInmobiliario(EditClienteInmobiliarioModel?: EditClienteInmobiliarioModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editClienteInmobiliario(EditClienteInmobiliarioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza una comisión de energia por oferta.
         * @param {EditComisionEnergiaOfertaModel} [EditComisionEnergiaOfertaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editComisionEnergiaOferta(EditComisionEnergiaOfertaModel?: EditComisionEnergiaOfertaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editComisionEnergiaOferta(EditComisionEnergiaOfertaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editComisionEnergiaOferta']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza una comisión de energia por servicio.
         * @param {EditComisionEnergiaServicioModel} [EditComisionEnergiaServicioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editComisionEnergiaServicio(EditComisionEnergiaServicioModel?: EditComisionEnergiaServicioModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editComisionEnergiaServicio(EditComisionEnergiaServicioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editComisionEnergiaServicio']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un comunicado existente.
         * @param {string} [Id] 
         * @param {Array<string>} [IdsAdjuntosExistentes] 
         * @param {TipoComunicadoEnum} [Tipo] 
         * @param {string} [Asunto] 
         * @param {string} [Cuerpo] 
         * @param {string} [TipoEmpresaAgenteDirigido] 
         * @param {Array<string>} [RolesDirigidos] 
         * @param {Array<string>} [EmpresasAgentesDirigidos] 
         * @param {Array<File>} [Adjuntos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editComunicado(Id?: string, IdsAdjuntosExistentes?: Array<string>, Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editComunicado(Id, IdsAdjuntosExistentes, Tipo, Asunto, Cuerpo, TipoEmpresaAgenteDirigido, RolesDirigidos, EmpresasAgentesDirigidos, Adjuntos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editComunicado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {EditCriterioRetrocomisionEnergiaModel} [EditCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCriterioRetrocomisionEnergia(IdEmpresa: string, EditCriterioRetrocomisionEnergiaModel?: EditCriterioRetrocomisionEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCriterioRetrocomisionEnergia(IdEmpresa, EditCriterioRetrocomisionEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editCriterioRetrocomisionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita los datos personales del agente actual
         * @param {EditAgentePersonalDataModel} [EditAgentePersonalDataModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCurrentAgentePersonalData(EditAgentePersonalDataModel?: EditAgentePersonalDataModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCurrentAgentePersonalData(EditAgentePersonalDataModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editCurrentAgentePersonalData']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una empresa de servicios.
         * @param {EditDelegacionInmobiliariaModel} [EditDelegacionInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDelegacionInmobiliaria(EditDelegacionInmobiliariaModel?: EditDelegacionInmobiliariaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDelegacionInmobiliaria(EditDelegacionInmobiliariaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editDelegacionInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una empresa colaboradora.
         * @param {EditEmpresaColaboradoraModel} [EditEmpresaColaboradoraModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editEmpresaColaboradora(EditEmpresaColaboradoraModel?: EditEmpresaColaboradoraModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editEmpresaColaboradora(EditEmpresaColaboradoraModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editEmpresaColaboradora']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una empresa Inmobiliaria.
         * @param {EditEmpresaInmobiliariaModel} [EditEmpresaInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editEmpresaInmobiliaria(EditEmpresaInmobiliariaModel?: EditEmpresaInmobiliariaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editEmpresaInmobiliaria(EditEmpresaInmobiliariaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editEmpresaInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una empresa de servicios.
         * @param {EditEmpresaServiciosModel} [EditEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editEmpresaServicios(EditEmpresaServiciosModel?: EditEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editEmpresaServicios(EditEmpresaServiciosModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un inmueble existente
         * @param {EditInmuebleModel} [EditInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editInmueble(EditInmuebleModel?: EditInmuebleModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editInmueble(EditInmuebleModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un marco de comisiones existente
         * @param {EditMarcoComisionesModel} [EditMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editMarcoComisiones(EditMarcoComisionesModel?: EditMarcoComisionesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editMarcoComisiones(EditMarcoComisionesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editMarcoComisiones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza el marco de comisiones de una empresa de agentes.
         * @param {string} Id 
         * @param {EditMarcoComisionesEmpresaAgentesModel} [EditMarcoComisionesEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editMarcoComisionesEmpresaAgentes(Id: string, EditMarcoComisionesEmpresaAgentesModel?: EditMarcoComisionesEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editMarcoComisionesEmpresaAgentes(Id, EditMarcoComisionesEmpresaAgentesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editMarcoComisionesEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una nota de un borrador de operación.
         * @param {string} Id 
         * @param {EditNotaBorradorOperacionModel} [EditNotaBorradorOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editNotaBorradorOperacion(Id: string, EditNotaBorradorOperacionModel?: EditNotaBorradorOperacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editNotaBorradorOperacion(Id, EditNotaBorradorOperacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editNotaBorradorOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una nota de una operación.
         * @param {string} Id 
         * @param {EditNotaOperacionModel} [EditNotaOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editNotaOperacion(Id: string, EditNotaOperacionModel?: EditNotaOperacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editNotaOperacion(Id, EditNotaOperacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editNotaOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una nota de un trámite de energía.
         * @param {string} Id 
         * @param {EditNotaTramiteEnergiaModel} [EditNotaTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editNotaTramiteEnergia(Id: string, EditNotaTramiteEnergiaModel?: EditNotaTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editNotaTramiteEnergia(Id, EditNotaTramiteEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editNotaTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una oferta de Endesa.
         * @param {EditOfertaEndesaModel} [EditOfertaEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOfertaEndesa(EditOfertaEndesaModel?: EditOfertaEndesaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOfertaEndesa(EditOfertaEndesaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editOfertaEndesa']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una oferta de energía.
         * @param {EditOfertaEnergiaModel} [EditOfertaEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOfertaEnergia(EditOfertaEnergiaModel?: EditOfertaEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOfertaEnergia(EditOfertaEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editOfertaEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una operación de agua.
         * @param {EditOperacionAguaModel} [EditOperacionAguaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOperacionAgua(EditOperacionAguaModel?: EditOperacionAguaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOperacionAgua(EditOperacionAguaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una operación de energía.
         * @param {EditOperacionEnergiaModel} [EditOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOperacionEnergia(EditOperacionEnergiaModel?: EditOperacionEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditOperacionEnergiaDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOperacionEnergia(EditOperacionEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un rappel de energía.
         * @param {EditRappelEnergiaModel} [EditRappelEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editRappelEnergia(EditRappelEnergiaModel?: EditRappelEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editRappelEnergia(EditRappelEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editRappelEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece o elimina el reajuste de comisión de oferta de energía para una empresa de agentes.
         * @param {string} Id 
         * @param {EditReajusteComisionEnergiaOfertaEmpresaAgentesModel} [EditReajusteComisionEnergiaOfertaEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editReajusteComisionEnergiaOfertaEmpresaAgentes(Id: string, EditReajusteComisionEnergiaOfertaEmpresaAgentesModel?: EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editReajusteComisionEnergiaOfertaEmpresaAgentes(Id, EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editReajusteComisionEnergiaOfertaEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece o elimina el reajuste de comisión de servicio de energía para una empresa de agentes.
         * @param {string} Id 
         * @param {EditReajusteComisionEnergiaServicioEmpresaAgentesModel} [EditReajusteComisionEnergiaServicioEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editReajusteComisionEnergiaServicioEmpresaAgentes(Id: string, EditReajusteComisionEnergiaServicioEmpresaAgentesModel?: EditReajusteComisionEnergiaServicioEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editReajusteComisionEnergiaServicioEmpresaAgentes(Id, EditReajusteComisionEnergiaServicioEmpresaAgentesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editReajusteComisionEnergiaServicioEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece o elimina el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
         * @param {string} Id 
         * @param {EditReajusteMarcoComisionEmpresaAgentesModel} [EditReajusteMarcoComisionEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editReajusteMarcoComisionEmpresaAgentes(Id: string, EditReajusteMarcoComisionEmpresaAgentesModel?: EditReajusteMarcoComisionEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editReajusteMarcoComisionEmpresaAgentes(Id, EditReajusteMarcoComisionEmpresaAgentesModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editReajusteMarcoComisionEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una relación existente de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {EditRelacionClienteInmobiliarioInmuebleModel} [EditRelacionClienteInmobiliarioInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editRelacionClienteInmobiliarioInmueble(Id: string, EditRelacionClienteInmobiliarioInmuebleModel?: EditRelacionClienteInmobiliarioInmuebleModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editRelacionClienteInmobiliarioInmueble(Id, EditRelacionClienteInmobiliarioInmuebleModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editRelacionClienteInmobiliarioInmueble']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un servicio de Endesa.
         * @param {EditServicioEndesaModel} [EditServicioEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editServicioEndesa(EditServicioEndesaModel?: EditServicioEndesaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editServicioEndesa(EditServicioEndesaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editServicioEndesa']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un servicio de energía.
         * @param {EditServicioEnergiaModel} [EditServicioEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editServicioEnergia(EditServicioEnergiaModel?: EditServicioEnergiaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editServicioEnergia(EditServicioEnergiaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editServicioEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un tipo de documento de empresa de servicios.
         * @param {EditTipoDocumentoEmpresaServiciosModel} [EditTipoDocumentoEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTipoDocumentoEmpresaServicios(EditTipoDocumentoEmpresaServiciosModel?: EditTipoDocumentoEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editTipoDocumentoEmpresaServicios(EditTipoDocumentoEmpresaServiciosModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editTipoDocumentoEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUsuario(EditUserModel?: EditUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editUsuario(EditUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.editUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Envía un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enviarComunicado(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enviarComunicado(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.enviarComunicado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Envia una operación de energía a backoffice.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enviarOperacionEnergiaBackoffice(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enviarOperacionEnergiaBackoffice(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.enviarOperacionEnergiaBackoffice']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Envia un recordatorio para la firma de la autorización de tratamiento de datos de cliente inmobiliario
         * @param {string} Id 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enviarRecordatorioFirmaAutorizacionClienteInmobiliario(Id: string, Email?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enviarRecordatorioFirmaAutorizacionClienteInmobiliario(Id, Email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.enviarRecordatorioFirmaAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Comprueba si existe un contacto lead cuyo teléfono coincide con el indicado.
         * @param {ExistsContactoLeadByMobileModel} [ExistsContactoLeadByMobileModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsContactoLeadByMobile(ExistsContactoLeadByMobileModel?: ExistsContactoLeadByMobileModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsContactoLeadByMobile(ExistsContactoLeadByMobileModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.existsContactoLeadByMobile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones para una empresa de agentes desde backoffice.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportComisionesComercializadoraEmpresaAgentesExcel(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportComisionesComercializadoraEmpresaAgentesExcel(Id, IdEmpresaServicios, IdMarcoComisiones, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.exportComisionesComercializadoraEmpresaAgentesExcel']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones a PDF para una empresa de agentes desde backoffice.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportComisionesComercializadoraEmpresaAgentesPdf(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportComisionesComercializadoraEmpresaAgentesPdf(Id, IdEmpresaServicios, IdMarcoComisiones, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.exportComisionesComercializadoraEmpresaAgentesPdf']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones para la empresa de agentes del colaborador autenticado.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportComisionesComercializadoraMiEmpresaExcel(IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportComisionesComercializadoraMiEmpresaExcel(IdEmpresaServicios, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.exportComisionesComercializadoraMiEmpresaExcel']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones a PDF para la empresa de agentes del colaborador autenticado.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportComisionesComercializadoraMiEmpresaPdf(IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportComisionesComercializadoraMiEmpresaPdf(IdEmpresaServicios, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.exportComisionesComercializadoraMiEmpresaPdf']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresGet(FeatureName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.featuresGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresList(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresList(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.featuresList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizarProcesoFirmaAutorizacionClienteInmobiliario(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizarProcesoFirmaAutorizacionClienteInmobiliario(Id, DocumentosFirmados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.finalizarProcesoFirmaAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de contrato de una empresa de agentes.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizarProcesoFirmaEmpresaAgentes(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizarProcesoFirmaEmpresaAgentes(Id, DocumentosFirmados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.finalizarProcesoFirmaEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizarProcesoFirmaOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizarProcesoFirmaOperacionEnergia(Id, DocumentosFirmados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.finalizarProcesoFirmaOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmaAutorizacionOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmaAutorizacionOperacionEnergia(Id, DocumentosFirmados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.firmaAutorizacionOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Finaliza el proceso de firma del consentimiento previo de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmaConsentimientoPrevioOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmaConsentimientoPrevioOperacionEnergia(Id, DocumentosFirmados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.firmaConsentimientoPrevioOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece una operación de energía como firmada.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmarOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmarOperacionEnergia(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.firmarOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Genera el consentimiento previo de una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generarConsentimientoPrevioOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generarConsentimientoPrevioOperacionEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.generarConsentimientoPrevioOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Genera el contrato de una operación energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generarContratoOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generarContratoOperacionEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.generarContratoOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Genera y descarga el borrador de una factura.
         * @param {CreateFacturaModel} [CreateFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBorradorFactura(CreateFacturaModel?: CreateFacturaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBorradorFactura(CreateFacturaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.generateBorradorFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una comparación dado su id
         * @param {string} Id 
         * @param {Array<number>} [RequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateComparacionEnergiaPdf(Id: string, RequestBody?: Array<number>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateComparacionEnergiaPdf(Id, RequestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.generateComparacionEnergiaPdf']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el agente dado su id de usuario
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgenteById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailAgenteModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgenteById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAgenteById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el agente de inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgenteInmobiliariaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailAgenteInmobiliariaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgenteInmobiliariaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAgenteInmobiliariaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de agentes para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAgentesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de agentes de inmobiliaria dada la delegación
         * @param {string} [IdDelegacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentesInmobiliariaByDelegacionSelector(IdDelegacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentesInmobiliariaByDelegacionSelector(IdDelegacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAgentesInmobiliariaByDelegacionSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de agentes de inmobiliaria para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentesInmobiliariaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentesInmobiliariaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAgentesInmobiliariaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de agentes para selectores de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentesSelector(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentesSelector(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAgentesSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de un anexo de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnexoEmpresaServiciosById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnexoEmpresaServiciosDetailDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnexoEmpresaServiciosById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAnexoEmpresaServiciosById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los anexos de empresa de servicios para la grid de Devextreme.
         * @param {string} [IdEmpresaServicios] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnexosEmpresaServiciosForGrid(IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnexosEmpresaServiciosForGrid(IdEmpresaServicios, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getAnexosEmpresaServiciosForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de un borrador de operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorradorOperacionDetail(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailBorradorOperacionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorradorOperacionDetail(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getBorradorOperacionDetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de borradores de operaciones de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorradoresOperacionAguaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorradoresOperacionAguaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getBorradoresOperacionAguaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de borradores de operaciones de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorradoresOperacionEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBorradoresOperacionEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getBorradoresOperacionEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle del cliente inmobiliario dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClienteInmobiliarioById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailClienteInmobiliarioModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClienteInmobiliarioById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getClienteInmobiliarioById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle del cliente inmobiliario dado su id.
         * @param {string} Id 
         * @param {string} IdRelacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClienteInmuebleById(Id: string, IdRelacion: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailClienteInmuebleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClienteInmuebleById(Id, IdRelacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getClienteInmuebleById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos más recientes de un cliente dado su documento de identidad o CIF para las operaciones del usuario actual
         * @param {string} [DocumentoIdentidad] 
         * @param {string} [Cif] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClienteLatestInfoForCurrentUser(DocumentoIdentidad?: string, Cif?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClienteLatestInfoModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClienteLatestInfoForCurrentUser(DocumentoIdentidad, Cif, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getClienteLatestInfoForCurrentUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de clientes de un agente para la grid de Devextreme a partir de sus operaciones.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientesAgenteForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientesAgenteForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getClientesAgenteForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de clientes de la empresa inmobiliaria del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdInmueble] 
         * @param {boolean} [PuedeCrearBorrador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientesEmpresaInmobiliariaForGrid(LoadOptions?: DXLoadOptions, IdInmueble?: string, PuedeCrearBorrador?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientesEmpresaInmobiliariaForGrid(LoadOptions, IdInmueble, PuedeCrearBorrador, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getClientesEmpresaInmobiliariaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de clientes para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getClientesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de relaciones de clientes inmobiliarios con un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {TipoRelacionClienteInmobiliarioEnum} [TipoRelacion] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientesInmuebleForGrid(Id: string, TipoRelacion?: TipoRelacionClienteInmobiliarioEnum, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientesInmuebleForGrid(Id, TipoRelacion, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getClientesInmuebleForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de CNAEs para su uso en un selector.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCnaeSelector(IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailOperacionEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCnaeSelector(IdEmpresaServicios, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCnaeSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de los cometidos de agentes de inmobiliaria para su uso en un selector.
         * @param {object} [Model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCometidoAgentesInmobiliariaSelector(Model?: object, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCometidoAgentesInmobiliariaSelector(Model, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCometidoAgentesInmobiliariaSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las comisiones por marco de comision para una oferta dado el id de oferta
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComisionesPorMarcoByIdOferta(Id: string, IdMarco: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComisionEnergiaOfertaModelIListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComisionesPorMarcoByIdOferta(Id, IdMarco, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComisionesPorMarcoByIdOferta']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las comisiones por marco de comision para un servicio dado el id de servicio
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComisionesPorMarcoByIdServicio(Id: string, IdMarco: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComisionEnergiaServicioModelIListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComisionesPorMarcoByIdServicio(Id, IdMarco, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComisionesPorMarcoByIdServicio']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de comparaciones de energia del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComparacionesEnergiaAgenteForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComparacionesEnergiaAgenteForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComparacionesEnergiaAgenteForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de comunicaciones de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComunicacionesOperacionById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComunicacionesOperacionModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComunicacionesOperacionById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComunicacionesOperacionById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de un comunicado por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComunicadoDetail(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailComunicadoModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComunicadoDetail(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComunicadoDetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de un comunicado dirigido al colaborador autenticado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComunicadoDetailForColaborador(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailComunicadoColaboradorModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComunicadoDetailForColaborador(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComunicadoDetailForColaborador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Consulta si un comunicado ha sido leído por un agente a partir de su email.
         * @param {string} Id 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComunicadoLecturaAgente(Id: string, Email?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsultaLecturaComunicadoAgenteModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComunicadoLecturaAgente(Id, Email, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComunicadoLecturaAgente']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de comunicados para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComunicadosForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComunicadosForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComunicadosForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de comunicados para la grid de DevExtreme de un colaborador.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComunicadosForGridColaborador(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComunicadosForGridColaborador(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComunicadosForGridColaborador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los ids de los comunicados de portal sin leer del colaborador autenticado.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComunicadosPortalSinLeerForColaborador(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComunicadosPortalSinLeerForColaborador(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getComunicadosPortalSinLeerForColaborador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de contactos lead para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactosLeadForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactosLeadForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getContactosLeadForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de agentes, con rol de coordinador de delegación, para una empresa inmobiliaria dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoordinadoresDelegacionSelector(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoordinadoresDelegacionSelector(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCoordinadoresDelegacionSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el criterio de retrocomision de energia para una empresa y dado su id
         * @param {string} IdEmpresa 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriterioRetrocomisionEnergiaById(IdEmpresa: string, Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCriterioRetrocomisionEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriterioRetrocomisionEnergiaById(IdEmpresa, Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCriterioRetrocomisionEnergiaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de criterios de retrocomision de energia para una empresa y un grupo de configuración
         * @param {string} Id 
         * @param {string} [IdGrupo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriteriosRetrocomisionEnergiaByIdEmpresa(Id: string, IdGrupo?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCriterioRetrocomisionEnergiaModelIListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriteriosRetrocomisionEnergiaByIdEmpresa(Id, IdGrupo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCriteriosRetrocomisionEnergiaByIdEmpresa']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos personales del agente actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentAgentePersonalData(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAgentePersonalDataModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentAgentePersonalData(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getCurrentAgentePersonalData']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los datos de un punto de suministro a partir de su Cups.
         * @param {string} Codigo 
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosPuntoSuministro(Codigo: string, IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSuministroResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosPuntoSuministro(Codigo, IdEmpresaServicios, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDatosPuntoSuministro']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la delegación inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelegacionInmobiliariaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailDelegacionInmobiliariaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelegacionInmobiliariaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDelegacionInmobiliariaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
         * @param {object} [Model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelegacionInmobiliariaSelector(Model?: object, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelegacionInmobiliariaSelector(Model, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDelegacionInmobiliariaSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
         * @param {string} IdInmobiliaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelegacionInmobiliariaSelectorByInmobiliaria(IdInmobiliaria: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelegacionInmobiliariaSelectorByInmobiliaria(IdInmobiliaria, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDelegacionInmobiliariaSelectorByInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de delegaciones inmobiliarias para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelegacionesInmobiliariasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelegacionesInmobiliariasForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDelegacionesInmobiliariasForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
         * @param {string} [IdEmpresaServicios] 
         * @param {Array<string>} [IdsOfertaEnergia] 
         * @param {Array<string>} [IdsServicioEnergia] 
         * @param {string} [IdOperacionEnergia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDescuentosEnergiaAplicables(IdEmpresaServicios?: string, IdsOfertaEnergia?: Array<string>, IdsServicioEnergia?: Array<string>, IdOperacionEnergia?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DescuentosEnergiaAplicablesModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDescuentosEnergiaAplicables(IdEmpresaServicios, IdsOfertaEnergia, IdsServicioEnergia, IdOperacionEnergia, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDescuentosEnergiaAplicables']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una comparación dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailComparacionEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailComparacionEnergiaOfertaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailComparacionEnergiaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDetailComparacionEnergiaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Documentos de firma que deben aportarse firmados a mano (misma lógica que la firma digital).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentosFirmaManualOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentosFirmaManualOperacionEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getDocumentosFirmaManualOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una empresa de agentes por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaAgentesDetail(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailEmpresaAgentesModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaAgentesDetail(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaAgentesDetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de las empresas de agentes para su uso en un selector.
         * @param {Array<string>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaAgentesSelector(Tipos?: Array<string>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaAgentesSelector(Tipos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaAgentesSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la empresa colaboradora dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaColaboradoraById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailEmpresaColaboradoraModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaColaboradoraById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaColaboradoraById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la empresa colaboradora dado el usuario que lo solicita
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaColaboradoraByUserId(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailEmpresaColaboradoraModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaColaboradoraByUserId(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaColaboradoraByUserId']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la empresa inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaInmobiliariaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailEmpresaInmobiliariaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaInmobiliariaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaInmobiliariaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de la empresa inmobiliaria asociada al usuario que realiza la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaInmobiliariaUsuarioRequest(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailEmpresaInmobiliariaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaInmobiliariaUsuarioRequest(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaInmobiliariaUsuarioRequest']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la empresa de servicios de energía dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaServiciosAguaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailEmpresaServiciosAguaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaServiciosAguaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaServiciosAguaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la empresa de servicios de energía dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresaServiciosEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailEmpresaServiciosEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresaServiciosEnergiaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresaServiciosEnergiaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de agentes para la rejilla DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasAgentesForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasAgentesForGrid(LoadOptions, IdsEstados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasAgentesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de empresas colaboradoras para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasColaboradoraForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasColaboradoraForGrid(LoadOptions, IdsEstados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasColaboradoraForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de empresas inmobiliarias para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasInmobiliariasForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasInmobiliariasForGrid(LoadOptions, IdsEstados, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasInmobiliariasForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasServiciosAguaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasServiciosAguaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasServiciosAguaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las empresas de servicio de agua que operan en una provincia concreta dado el codigo postal.
         * @param {string} [CodigoPostal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasServiciosAguaOperables(CodigoPostal?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmpresaServiciosModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasServiciosAguaOperables(CodigoPostal, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasServiciosAguaOperables']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasServiciosEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasServiciosEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasServiciosEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
         * @param {string} [IdEmpresaAgentes] 
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasServiciosOperables(IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmpresaServiciosModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasServiciosOperables(IdEmpresaAgentes, Tipos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasServiciosOperables']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa, operables para la empresa de agentes indicada o, en su defecto, la del usuario que hace la petición.
         * @param {string} [IdEmpresaAgentes] 
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasServiciosOperablesSelector(IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasServiciosOperablesSelector(IdEmpresaAgentes, Tipos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasServiciosOperablesSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa.
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmpresasServiciosSelector(Tipos?: Array<TipoEmpresaServiciosEnum>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmpresasServiciosSelector(Tipos, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEmpresasServiciosSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la estructura documental requerida para una empresa de agentes (configuración y documentos ya adjuntos).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstructuraDocumentalEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstructuraDocumentalEmpresaAgentes(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEstructuraDocumentalEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la estructura documental requerida para una empresa de agentes según su forma jurídica.
         * @param {FormaJuridicaEnum} [FormaJuridica] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstructuraDocumentalEmpresaAgentesByFormaJuridica(FormaJuridica?: FormaJuridicaEnum, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstructuraDocumentalEmpresaAgentesByFormaJuridica(FormaJuridica, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEstructuraDocumentalEmpresaAgentesByFormaJuridica']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la estructura documental de una empresa de servicios, con filtro opcional de tipo de persona (física o jurídica).
         * @param {string} Id 
         * @param {TipoPersonaEnum} [TipoPersona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstructuraDocumentalEmpresaServicios(Id: string, TipoPersona?: TipoPersonaEnum, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstructuraDocumentalOperacionModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstructuraDocumentalEmpresaServicios(Id, TipoPersona, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEstructuraDocumentalEmpresaServicios']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Dada una operación, obtiene su estructura documental.
         * @param {string} Id 
         * @param {boolean} [IncluirArchivosSistema] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstructuraDocumentalOperacionEnergia(Id: string, IncluirArchivosSistema?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstructuraDocumentalOperacionEnergia(Id, IncluirArchivosSistema, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getEstructuraDocumentalOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Genera y descarga el Excel para su importación en Repsol.
         * @param {Array<string>} [RequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportacionExcelRepsol(RequestBody?: Array<string>, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportacionExcelRepsol(RequestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getExportacionExcelRepsol']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una factura por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacturaDetailById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacturaDetailModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacturaDetailById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFacturaDetailById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de facturas para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacturasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacturasForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFacturasForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de facturas del agente creador seleccionado para soporte.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacturasForGridSoporte(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacturasForGridSoporte(IdUsuario, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFacturasForGridSoporte']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacturasInmuebleForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacturasInmuebleForGrid(Id, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFacturasInmuebleForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de facturas para la empresa de agentes del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacturasMyCompanyForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacturasMyCompanyForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getFacturasMyCompanyForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de grupos de criterios de retrocomisión de energía para una empresa dado el id de empresa
         * @param {string} IdEmpresa 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGruposCriteriosRetrocomisionEnergiaByIdEmpresa(IdEmpresa: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityWithDefaultModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGruposCriteriosRetrocomisionEnergiaByIdEmpresa(IdEmpresa, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getGruposCriteriosRetrocomisionEnergiaByIdEmpresa']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle del inmueble dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInmuebleById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailInmuebleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInmuebleById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getInmuebleById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de inmuebles para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdClienteInmobiliario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInmueblesForGrid(LoadOptions?: DXLoadOptions, IdClienteInmobiliario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInmueblesForGrid(LoadOptions, IdClienteInmobiliario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getInmueblesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {TipoSuministroInmuebleEnum} [TipoSuministro] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLecturasInmuebleForGrid(Id: string, TipoSuministro?: TipoSuministroInmuebleEnum, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLecturasInmuebleForGrid(Id, TipoSuministro, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getLecturasInmuebleForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para el agente para la grid de liquidaciones de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiquidacionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiquidacionesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getLiquidacionesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de agentes a los que se ha enviado un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoAgentesComunicado(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgenteComunicadoListModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoAgentesComunicado(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoAgentesComunicado']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de notas de un borrador de operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoNotasBorradorOperacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailNotaBorradorOperacionModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoNotasBorradorOperacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoNotasBorradorOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de notas de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoNotasOperacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailNotaOperacionModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoNotasOperacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoNotasOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de notas de un trámite de energía.
         * @param {string} IdTramite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoNotasTramiteEnergia(IdTramite: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailNotaTramiteEnergiaModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoNotasTramiteEnergia(IdTramite, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getListadoNotasTramiteEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el logo de la empresa si lo hubiera.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogoPortalEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogoPortalEmpresaAgentes(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getLogoPortalEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de marcos de comisiones para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarcosComisionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarcosComisionesForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMarcosComisionesForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de marcos de comisiones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarcosComisionesList(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarcosComisionesList(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getMarcosComisionesList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el modelo de datos con el que confeccionar la siguiente factura para la empresa de agentes del agente que hace la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextFacturaConfig(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacturaConfigModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextFacturaConfig(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getNextFacturaConfig']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las notificaciones para el usuario actual.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificaciones(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotificacionesModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificaciones(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getNotificaciones']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la oferta de Endesa dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfertaEndesaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailOfertaEndesaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfertaEndesaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOfertaEndesaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la oferta de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfertaEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailOfertaEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfertaEnergiaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOfertaEnergiaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las ofertas de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfertasEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfertasEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOfertasEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado paginado de ofertas de energía.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {Array<string>} [FiltrosComercializadoras] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {string} [FiltrosTarifaAcceso] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {Date} [FiltrosFechaInicio] 
         * @param {Date} [FiltrosFechaFin] 
         * @param {string} [FiltrosTexto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfertasEnergiaList(Take?: number, Skip?: number, FiltrosComercializadoras?: Array<string>, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTarifaAcceso?: string, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, FiltrosFechaInicio?: Date, FiltrosFechaFin?: Date, FiltrosTexto?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfertaEnergiaListItemModelPagedResultModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfertasEnergiaList(Take, Skip, FiltrosComercializadoras, FiltrosTipoEnergia, FiltrosTarifaAcceso, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, FiltrosFechaInicio, FiltrosFechaFin, FiltrosTexto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOfertasEnergiaList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las ofertas de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
         * @param {string} Id 
         * @param {TipoPersonaEnum} TipoPersona 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfertasEnergiaOperables(Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfertasEmpresaServiciosModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfertasEnergiaOperables(Id, TipoPersona, IdOperacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOfertasEnergiaOperables']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado paginado de ofertas de energía con retribuciones para backoffice.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {string} [FiltrosEmpresaAgentes] 
         * @param {string} [FiltrosMarcoComisiones] 
         * @param {string} [FiltrosComercializadora] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfertasEnergiaRetribucionesBackofficeList(Take?: number, Skip?: number, FiltrosEmpresaAgentes?: string, FiltrosMarcoComisiones?: string, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfertasEnergiaRetribucionesBackofficeList(Take, Skip, FiltrosEmpresaAgentes, FiltrosMarcoComisiones, FiltrosComercializadora, FiltrosTipoEnergia, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOfertasEnergiaRetribucionesBackofficeList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Listado paginado de ofertas de energía con retribuciones para colaboradores.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {string} [FiltrosComercializadora] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfertasEnergiaRetribucionesColaboradoresList(Take?: number, Skip?: number, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfertasEnergiaRetribucionesColaboradoresList(Take, Skip, FiltrosComercializadora, FiltrosTipoEnergia, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOfertasEnergiaRetribucionesColaboradoresList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de agua.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionAguaDetail(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailOperacionAguaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionAguaDetail(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionAguaDetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionEnergiaDetail(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailOperacionEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionEnergiaDetail(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionEnergiaDetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de una comparación de energía.
         * @param {string} IdComparacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionEnergiaDetailFromComparison(IdComparacion: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailComparacionEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionEnergiaDetailFromComparison(IdComparacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionEnergiaDetailFromComparison']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de un inmueble.
         * @param {string} IdInmueble 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionEnergiaDetailFromProperty(IdInmueble: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailOperacionEnergiaInmuebleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionEnergiaDetailFromProperty(IdInmueble, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionEnergiaDetailFromProperty']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionesAguaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionesAguaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionesAguaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el histórico de estados de las operaciones de agua.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionesAguaHistoricoEstados(LoadOptions?: DXLoadOptions, IdOperacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionesAguaHistoricoEstados(LoadOptions, IdOperacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionesAguaHistoricoEstados']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de un cliente.
         * @param {string} [IdCliente] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionesByIdCliente(IdCliente?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperacionesClienteModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionesByIdCliente(IdCliente, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionesByIdCliente']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de energia para el cliente de un agente para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionesEnergiaAgenteForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionesEnergiaAgenteForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionesEnergiaAgenteForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de energia para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionesEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionesEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el histórico de estados de las operaciones.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperacionesHistoricoEstados(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperacionesHistoricoEstados(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getOperacionesHistoricoEstados']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la plantilla de autorización de tratamiento de datos de un cliente inmobiliario, lista para firmar.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlantillaAutorizacionClienteInmobiliario(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlantillaAutorizacionClienteInmobiliario(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPlantillaAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de las prioridades de ticket para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrioridadesTicketSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrioridadesTicketSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPrioridadesTicketSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de provincias.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvincias(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxIntEntityModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvincias(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getProvincias']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la información pública de la empresa inmobiliaria asociada al usuario que realiza la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicInformationSelfEmpresaInmobiliaria(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicInformationEmpresaInmobiliariaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicInformationSelfEmpresaInmobiliaria(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getPublicInformationSelfEmpresaInmobiliaria']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el rappel de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRappelEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailRappelEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRappelEnergiaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRappelEnergiaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los rappels de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRappelsEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRappelsEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRappelsEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los rappels de energía mensuales asociadas a una factura para la subrejilla de factura de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRappelsMensualesEnergiaFacturaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRappelsMensualesEnergiaFacturaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRappelsMensualesEnergiaFacturaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los rappels de energía mensuales para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRappelsMensualesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRappelsMensualesEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRappelsMensualesEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReajusteMarcoComisionEmpresaAgentes(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecimalNullableResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReajusteMarcoComisionEmpresaAgentes(Id, IdEmpresaServicios, IdMarcoComisiones, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getReajusteMarcoComisionEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de la relación entre un cliente inmobiliario e inmueble dado sus ids.
         * @param {string} Id 
         * @param {string} IdClienteInmobiliario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelacionClienteInmuebleDetail(Id: string, IdClienteInmobiliario: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailRelacionClienteInmuebleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelacionClienteInmuebleDetail(Id, IdClienteInmobiliario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRelacionClienteInmuebleDetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResponsablesSelectorByIdEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResponsablesSelectorByIdEmpresaAgentes(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getResponsablesSelectorByIdEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesAll(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolesRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesAll(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRolesAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene un listado de roles del sistema seleccionables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolesRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getRolesSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el servicio de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicioEndesaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailServicioEndesaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicioEndesaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getServicioEndesaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el servicio de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicioEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailServicioEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicioEnergiaById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getServicioEnergiaById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los servicios de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiciosEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiciosEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getServiciosEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene las ofertas de servicios extras de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
         * @param {string} Id 
         * @param {TipoPersonaEnum} TipoPersona 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiciosEnergiaOperables(Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfertasServicioDistribuidoraModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiciosEnergiaOperables(Id, TipoPersona, IdOperacion, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getServiciosEnergiaOperables']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de subtipos de empresa colaboradora para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubtipoEmpresaColaboradoraSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubtipoEmpresaColaboradoraSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSubtipoEmpresaColaboradoraSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de Subtipo persona para su uso en un selector.
         * @param {TipoPersonaEnum} [TipoPersona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubtipoPersonasSelector(TipoPersona?: TipoPersonaEnum, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxEntityModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubtipoPersonasSelector(TipoPersona, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSubtipoPersonasSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de los subtipos de ticket a partir de un tipo para su uso en un selector.
         * @param {TipoTicketEnum} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubtiposTicketSelectorByIdTipo(IdTipoTicket?: TipoTicketEnum, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubtiposTicketSelectorByIdTipo(IdTipoTicket, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getSubtiposTicketSelectorByIdTipo']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de las tensiones suministro para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTensionSuministroSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailOperacionEnergiaModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTensionSuministroSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTensionSuministroSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle del ticket dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailTicketModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTicketById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de tickets para la grid de DexExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketsForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketsForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTicketsForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el tipo de documento de empresa de servicios dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTipoDocumentoEmpresaServiciosById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailTipoDocumentoEmpresaServiciosModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTipoDocumentoEmpresaServiciosById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTipoDocumentoEmpresaServiciosById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los tipos de documento de empresa de servicios para la grid de Devextreme.
         * @param {string} [IdEmpresaServicios] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTiposDocumentosEmpresaServiciosForGrid(IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTiposDocumentosEmpresaServiciosForGrid(IdEmpresaServicios, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTiposDocumentosEmpresaServiciosForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de los tipos de ticket para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTiposTicketSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTiposTicketSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTiposTicketSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia asociadas a una factura para la subrejilla de factura de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTramitesEnergiaFacturaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTramitesEnergiaFacturaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTramitesEnergiaFacturaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTramitesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTramitesEnergiaForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTramitesEnergiaForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el histórico de estados de los trámites de energia.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTramitesEnergiaHistoricoEstados(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTramitesEnergiaHistoricoEstados(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTramitesEnergiaHistoricoEstados']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia asociadas a un rappel mensual para la grid del detalle de rappel mensual de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTramitesEnergiaRappelMensualForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTramitesEnergiaRappelMensualForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTramitesEnergiaRappelMensualForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTramitesForGridColaboradores(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTramitesForGridColaboradores(IdUsuario, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTramitesForGridColaboradores']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTramitesForGridSoporte(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTramitesForGridSoporte(IdUsuario, LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getTramitesForGridSoporte']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el usuario dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarioById(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailUsuarioModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarioById(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuarioById']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarioCurrentProfile(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarioCurrentProfile(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuarioCurrentProfile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuariosBackofficeSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuariosBackofficeSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuariosBackofficeSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuariosBackofficeSelectorByIdTicket(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuariosBackofficeSelectorByIdTicket(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuariosBackofficeSelectorByIdTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios comerciales (administrador o trabajador)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuariosComercialesSelector(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuariosComercialesSelector(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuariosComercialesSelector']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuariosForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuariosForGrid(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.getUsuariosForGrid']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Realiza la importación de bajas de trámites y servicios a patir del fichero de Endesa.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importEndesaBajasOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importEndesaBajasOperacionEnergia(EsSimulacion, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importEndesaBajasOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Realiza la importación de códigos externos Cosmos a partir del fichero de Endesa, cruzando por CUPS y fecha de venta.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importEndesaCosmosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importEndesaCosmosOperacionEnergia(EsSimulacion, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importEndesaCosmosOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Realiza la importación de nuevos estados de trámites y servicios a partir del fichero de Endesa.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importEndesaNuevosEstadosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importEndesaNuevosEstadosOperacionEnergia(EsSimulacion, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importEndesaNuevosEstadosOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Realiza la importación de nuevos estados de trámites a partir del fichero de Naturgy.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importNaturgyNuevosEstadosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importNaturgyNuevosEstadosOperacionEnergia(EsSimulacion, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.importNaturgyNuevosEstadosOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Envia una solicitud de firma de autorización de tratamiento de datos al cliente inmobiliario.
         * @param {string} Id 
         * @param {IniciarFirmaAutorizacionClienteInmobiliarioModel} [IniciarFirmaAutorizacionClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iniciarFirmaAutorizacionClienteInmobiliario(Id: string, IniciarFirmaAutorizacionClienteInmobiliarioModel?: IniciarFirmaAutorizacionClienteInmobiliarioModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iniciarFirmaAutorizacionClienteInmobiliario(Id, IniciarFirmaAutorizacionClienteInmobiliarioModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.iniciarFirmaAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Inicia el proceso de firma de una operación energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iniciarFirmaBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iniciarFirmaBackofficeOperacionEnergia(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.iniciarFirmaBackofficeOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Inicia el proceso de firma digital del consentimiento previo.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iniciarFirmaConsentimientoPrevioOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iniciarFirmaConsentimientoPrevioOperacionEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.iniciarFirmaConsentimientoPrevioOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Inicia el proceso de firma de una operación energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iniciarProcesoFirmaOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iniciarProcesoFirmaOperacionEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.iniciarProcesoFirmaOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca como incidencia la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marcarIncidenciaOperacionAgua(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marcarIncidenciaOperacionAgua(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.marcarIncidenciaOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca una factura en borrador como pendiente de revisión por parte del colaborador.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markPendingReviewFactura(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markPendingReviewFactura(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.markPendingReviewFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca en curso la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ponerEnCursoOperacionAgua(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ponerEnCursoOperacionAgua(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ponerEnCursoOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un documento de empresa de agentes.
         * @param {string} Id 
         * @param {TipoDocumentoEmpresaAgentesEnum} [TipoDocumento] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentoEmpresaAgentes(Id: string, TipoDocumento?: TipoDocumentoEmpresaAgentesEnum, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentoEmpresaAgentes(Id, TipoDocumento, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postDocumentoEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un tipo de documento a la operación de agua.
         * @param {string} Id 
         * @param {string} [IdTipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentoOperacionAgua(Id: string, IdTipoDocumento?: string, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentoOperacionAgua(Id, IdTipoDocumento, Descripcion, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postDocumentoOperacionAgua']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Adjunta un tipo de documento a la operación de energía.
         * @param {string} Id 
         * @param {TipoDocumentoOperacionEnergiaEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentoOperacionEnergia(Id: string, TipoDocumento?: TipoDocumentoOperacionEnergiaEnum, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentoOperacionEnergia(Id, TipoDocumento, Descripcion, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postDocumentoOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero de forma temporal.
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocumentoTemp(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocumentoTemp(Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.postDocumentoTemp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza el anexo asociado a una oferta de energía.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putAnexoOfertaEnergia(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putAnexoOfertaEnergia(Id, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.putAnexoOfertaEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza el anexo asociado a un servicio de energía.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putAnexoServicioEnergia(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putAnexoServicioEnergia(Id, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.putAnexoServicioEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza el documento de dni asociado a un agente.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDocumentoAgente(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDocumentoAgente(Id, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.putDocumentoAgente']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Actualiza la factura propia asociada a una factura.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFacturaPropia(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFacturaPropia(Id, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.putFacturaPropia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Reactiva una empresa de agentes dada de baja
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateEmpresaAgentes(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.reactivateEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Reactiva un usuario dado de baja.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateUsuario(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateUsuario(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.reactivateUsuario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca como leída las comunicaciones de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readComunicacionesOperacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readComunicacionesOperacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.readComunicacionesOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca un comunicado de portal como leído para el colaborador autenticado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readComunicadoForColaborador(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readComunicadoForColaborador(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.readComunicadoForColaborador']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca como leídos todos los mensajes de un ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readMensajesTicket(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readMensajesTicket(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.readMensajesTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Marca una notificación como leída.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readNotificacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readNotificacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.readNotificacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rechaza una autorización de consentimiento firmada por un cliente inmobiliario.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechazarAutorizacionClienteInmobiliario(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechazarAutorizacionClienteInmobiliario(Id, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rechazarAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rechaza una operación de energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechazarBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechazarBackofficeOperacionEnergia(Id, Comentario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rechazarBackofficeOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rechaza un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCloseTicket(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCloseTicket(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rejectCloseTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rechaza la empresa de agentes
         * @param {string} Id 
         * @param {string} [MotivoRechazo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectEmpresaAgentes(Id: string, MotivoRechazo?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectEmpresaAgentes(Id, MotivoRechazo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rejectEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rechaza una factura.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectFactura(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectFactura(Id, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rejectFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Rechaza una factura.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectPendingReviewFactura(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectPendingReviewFactura(Id, Body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rejectPendingReviewFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Cancela y reinicia una operación de energía al estado inicial.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetOperacionEnergia(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.resetOperacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna al usuario que realiza la petición como responsable de una operacion.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfAssignResponsableOperacion(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfAssignResponsableOperacion(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.selfAssignResponsableOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Asigna al usuario que realiza la petición como responsable de un ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfAssignResponsableTicket(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfAssignResponsableTicket(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.selfAssignResponsableTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Envía la empresa de agentes para firma
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendToSignEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendToSignEmpresaAgentes(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sendToSignEmpresaAgentes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Establece la prioridad de un ticket.
         * @param {string} Id 
         * @param {PrioridadTicketEnum} Prioridad 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrioridadTicket(Id: string, Prioridad: PrioridadTicketEnum, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrioridadTicket(Id, Prioridad, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.setPrioridadTicket']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Liquida una factura.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settleFactura(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settleFactura(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.settleFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Liquida una factura pendiente de revisión por parte del colaborador.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlePendingReviewFactura(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlePendingReviewFactura(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.settlePendingReviewFactura']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Simula las comisiones de oferta para una comparación de energía.
         * @param {string} Id 
         * @param {SimularComisionesComparacionEnergiaRequest} [SimularComisionesComparacionEnergiaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simularComisionesComparacionEnergia(Id: string, SimularComisionesComparacionEnergiaRequest?: SimularComisionesComparacionEnergiaRequest, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimularComisionesComparacionEnergiaResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simularComisionesComparacionEnergia(Id, SimularComisionesComparacionEnergiaRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.simularComisionesComparacionEnergia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube la autorización firmada de tratamiento de datos de un cliente inmobiliario.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subirAutorizacionClienteInmobiliario(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subirAutorizacionClienteInmobiliario(Id, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.subirAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioCheckEmail(Email: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioCheckEmail(Email, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioCheckEmail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioCheckUsername(Username: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioCheckUsername(Username, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioCheckUsername']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Valida una autorización de consentimiento firmada por un cliente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validarAutorizacionClienteInmobiliario(Id: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validarAutorizacionClienteInmobiliario(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.validarAutorizacionClienteInmobiliario']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Valida si un contacto lead de operación es válido, a partir de los datos de titular.
         * @param {TitularModel} [TitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateContactoLeadOperacion(TitularModel?: TitularModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateContactoLeadOperacion(TitularModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.validateContactoLeadOperacion']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Comprueba si el email no se ha usado en otras operaciones asociadas a otros documentos de titular.
         * @param {ValidateEmailTitularModel} [ValidateEmailTitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEmailTitular(ValidateEmailTitularModel?: ValidateEmailTitularModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateEmailResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEmailTitular(ValidateEmailTitularModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.validateEmailTitular']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Comprueba si el móvil no se ha usado en otras operaciones asociadas a otros documentos de titular.
         * @param {ValidateMovilTitularModel} [ValidateMovilTitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateMovilTitular(ValidateMovilTitularModel?: ValidateMovilTitularModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateMovilResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateMovilTitular(ValidateMovilTitularModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.validateMovilTitular']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Webhook para las altas de los contactos Lead.
         * @param {CreateContactoLeadModel} [CreateContactoLeadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookAltaNuevoContadoLead(CreateContactoLeadModel?: CreateContactoLeadModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookAltaNuevoContadoLead(CreateContactoLeadModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.webhookAltaNuevoContadoLead']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ApiApi - factory interface
 * @export
 */
export const ApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Acepta un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptCloseTicket(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.acceptCloseTicket(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Maneja el acceso desde el CRM externo IA Gestion
         * @param {AccesoExternoIaGestionModel} [AccesoExternoIaGestionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accesoExternoAgenteIaGestion(AccesoExternoIaGestionModel?: AccesoExternoIaGestionModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.accesoExternoAgenteIaGestion(AccesoExternoIaGestionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Acepta una operación de energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aceptarBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.aceptarBackofficeOperacionEnergia(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca como activada la operación de agua.
         * @param {string} Id 
         * @param {Date} [FechaActivacion] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activarOperacionAgua(Id: string, FechaActivacion?: Date, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.activarOperacionAgua(Id, FechaActivacion, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Activa un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {ActivateTramiteEnergiaModel} [ActivateTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activarTramiteEnergia(IdOperacion: string, ActivateTramiteEnergiaModel?: ActivateTramiteEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.activarTramiteEnergia(IdOperacion, ActivateTramiteEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade una comunicación a una operación.
         * @param {string} Id 
         * @param {CreateComunicacionOperacionModel} [CreateComunicacionOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComunicacionOperacion(Id: string, CreateComunicacionOperacionModel?: CreateComunicacionOperacionModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addComunicacionOperacion(Id, CreateComunicacionOperacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade una factura a un inmueble.
         * @param {string} Id 
         * @param {AddFacturaInmuebleModel} [AddFacturaInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacturaInmueble(Id: string, AddFacturaInmuebleModel?: AddFacturaInmuebleModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addFacturaInmueble(Id, AddFacturaInmuebleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade una lectura a un inmueble.
         * @param {string} Id 
         * @param {AddLecturaInmuebleModel} [AddLecturaInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLecturaInmueble(Id: string, AddLecturaInmuebleModel?: AddLecturaInmuebleModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addLecturaInmueble(Id, AddLecturaInmuebleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade un mensaje a un ticket.
         * @param {string} Id 
         * @param {CreateMensajeTicketModel} [CreateMensajeTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMessageTicket(Id: string, CreateMensajeTicketModel?: CreateMensajeTicketModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addMessageTicket(Id, CreateMensajeTicketModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade a la operación de agua indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObservacionOperacionAgua(IdOperacion: string, Observacion?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addObservacionOperacionAgua(IdOperacion, Observacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade a la operación indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObservacionOperacionEnergia(IdOperacion: string, Observacion?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addObservacionOperacionEnergia(IdOperacion, Observacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade al trámite de la operación indicada una nueva observación.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {string} [Observacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addObservacionTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Observacion?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addObservacionTramiteEnergia(IdOperacion, TipoSuministro, Observacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Añade una nueva relación de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {AddRelacionClienteInmobiliarioInmuebleModel} [AddRelacionClienteInmobiliarioInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRelacionClienteInmobiliarioInmueble(Id: string, AddRelacionClienteInmobiliarioInmuebleModel?: AddRelacionClienteInmobiliarioInmuebleModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.addRelacionClienteInmobiliarioInmueble(Id, AddRelacionClienteInmobiliarioInmuebleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta el consentimiento previo firmado manualmente.
         * @param {string} Id 
         * @param {File} [Fichero] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjuntarConsentimientoPrevioOperacionEnergia(Id: string, Fichero?: File, options?: any): AxiosPromise<void> {
            return localVarFp.adjuntarConsentimientoPrevioOperacionEnergia(Id, Fichero, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Anula una operación de energía, junto a sus trámites.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anularOperacionEnergia(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.anularOperacionEnergia(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca el trámite de la operación indicada como anulada.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anularTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.anularTramiteEnergia(IdOperacion, TipoSuministro, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aplica reajustes de comisión y/o retrocomisión a los conceptos de trámite/servicio de una factura revisable.
         * @param {string} Id 
         * @param {AplicarReajustesConceptosFacturaModel} [AplicarReajustesConceptosFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aplicarReajustesConceptosFactura(Id: string, AplicarReajustesConceptosFacturaModel?: AplicarReajustesConceptosFacturaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.aplicarReajustesConceptosFactura(Id, AplicarReajustesConceptosFacturaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Solicita un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askCloseTicket(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.askCloseTicket(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna el identificador externo de una operación de energía.
         * @param {string} IdOperacion 
         * @param {AssignExternalIdOperacionEnergiaModel} [AssignExternalIdOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExternalIdOperacionEnergia(IdOperacion: string, AssignExternalIdOperacionEnergiaModel?: AssignExternalIdOperacionEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.assignExternalIdOperacionEnergia(IdOperacion, AssignExternalIdOperacionEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna el identificador externo de un trámite de energía.
         * @param {string} IdTramite 
         * @param {AssignExternalIdTramiteEnergiaModel} [AssignExternalIdTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignExternalIdTramiteEnergia(IdTramite: string, AssignExternalIdTramiteEnergiaModel?: AssignExternalIdTramiteEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.assignExternalIdTramiteEnergia(IdTramite, AssignExternalIdTramiteEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna un usuario como responsable de una operacion.
         * @param {string} Id 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignResponsableOperacion(Id: string, IdUsuario: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.assignResponsableOperacion(Id, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna un usuario como responsable de un ticket.
         * @param {string} Id 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignResponsableTicket(Id: string, IdUsuario: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.assignResponsableTicket(Id, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Autoregistro de una empresa de agentes.
         * @param {TipoEmpresaAgentesEnum} [TipoEmpresaAgentes] 
         * @param {FormaJuridicaEnum} [FormaJuridicaTitular] 
         * @param {string} [RazonSocial] 
         * @param {string} [NifCif] 
         * @param {string} [Email] 
         * @param {string} [DireccionCodigoPostal] 
         * @param {string} [DireccionProvincia] 
         * @param {string} [DireccionMunicipio] 
         * @param {string} [DireccionTipoVia] 
         * @param {string} [DireccionNombreVia] 
         * @param {string} [DireccionNumero] 
         * @param {string} [DireccionEscalera] 
         * @param {string} [DireccionPiso] 
         * @param {string} [DireccionPuerta] 
         * @param {string} [NombreRepresentante] 
         * @param {string} [NifRepresentante] 
         * @param {string} [EmailRepresentante] 
         * @param {string} [TelefonoRepresentante] 
         * @param {Array<DocumentacionAutoregistroPorTipoModel>} [Documentacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoregistroEmpresaAgentes(TipoEmpresaAgentes?: TipoEmpresaAgentesEnum, FormaJuridicaTitular?: FormaJuridicaEnum, RazonSocial?: string, NifCif?: string, Email?: string, DireccionCodigoPostal?: string, DireccionProvincia?: string, DireccionMunicipio?: string, DireccionTipoVia?: string, DireccionNombreVia?: string, DireccionNumero?: string, DireccionEscalera?: string, DireccionPiso?: string, DireccionPuerta?: string, NombreRepresentante?: string, NifRepresentante?: string, EmailRepresentante?: string, TelefonoRepresentante?: string, Documentacion?: Array<DocumentacionAutoregistroPorTipoModel>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.autoregistroEmpresaAgentes(TipoEmpresaAgentes, FormaJuridicaTitular, RazonSocial, NifCif, Email, DireccionCodigoPostal, DireccionProvincia, DireccionMunicipio, DireccionTipoVia, DireccionNombreVia, DireccionNumero, DireccionEscalera, DireccionPiso, DireccionPuerta, NombreRepresentante, NifRepresentante, EmailRepresentante, TelefonoRepresentante, Documentacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca como baja la operación de agua.
         * @param {string} Id 
         * @param {Date} [FechaBaja] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bajaOperacionAgua(Id: string, FechaBaja?: Date, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.bajaOperacionAgua(Id, FechaBaja, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Da de baja un servicio incluido en un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {string} IdServicio 
         * @param {DeactivateServicioIncluidoTramiteEnergiaModel} [DeactivateServicioIncluidoTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bajaServicioIncluidoTramiteEnergia(IdOperacion: string, IdServicio: string, DeactivateServicioIncluidoTramiteEnergiaModel?: DeactivateServicioIncluidoTramiteEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.bajaServicioIncluidoTramiteEnergia(IdOperacion, IdServicio, DeactivateServicioIncluidoTramiteEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Da de baja un trámite de energía de manera manual.
         * @param {string} IdOperacion 
         * @param {DeactivateTramiteEnergiaModel} [DeactivateTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bajaTramiteEnergia(IdOperacion: string, DeactivateTramiteEnergiaModel?: DeactivateTramiteEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.bajaTramiteEnergia(IdOperacion, DeactivateTramiteEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cambia el estado libre del trámite de la operación indicada.
         * @param {string} IdOperacion 
         * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
         * @param {EstadoLibreTramiteEnergiaEnum} [NuevoEstado] 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cambiarEstadoLibreTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, NuevoEstado?: EstadoLibreTramiteEnergiaEnum, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.cambiarEstadoLibreTramiteEnergia(IdOperacion, TipoSuministro, NuevoEstado, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancela un borrador de operación
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBorradorOperacion(Id: string, Body?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.cancelBorradorOperacion(Id, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancela el proceso de firma de docuemntación para el registro de una empresa de agentes.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSignEmpresaAgentes(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.cancelSignEmpresaAgentes(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancela el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarFirmaAutorizacionClienteInmobiliario(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.cancelarFirmaAutorizacionClienteInmobiliario(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca como cancelada la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelarOperacionAgua(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.cancelarOperacionAgua(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comprueba si el email o tel. móvil se ha usado en otras operaciones con distinto documento de identidad.
         * @param {string} [Email] 
         * @param {string} [TelMovil] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPotentialFraudOperacion(Email?: string, TelMovil?: string, options?: any): AxiosPromise<OperacionPotencialmenteFraudulentaRmListResponseDTO> {
            return localVarFp.checkPotentialFraudOperacion(Email, TelMovil, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo agente
         * @param {CreateAgenteModel} [CreateAgenteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgente(CreateAgenteModel?: CreateAgenteModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.createAgente(CreateAgenteModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo agente inmobiliario
         * @param {CreateAgenteInmobiliariaModel} [CreateAgenteInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgenteInmobiliaria(CreateAgenteInmobiliariaModel?: CreateAgenteInmobiliariaModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.createAgenteInmobiliaria(CreateAgenteInmobiliariaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un anexo de empresa de servicios.
         * @param {CreateAnexoEmpresaServiciosDto} [CreateAnexoEmpresaServiciosDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnexoEmpresaServicios(CreateAnexoEmpresaServiciosDto?: CreateAnexoEmpresaServiciosDto, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createAnexoEmpresaServicios(CreateAnexoEmpresaServiciosDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea la autorización de cesión de datos para un contacto lead.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutorizacionCesionDatosContactoLead(Id: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.createAutorizacionCesionDatosContactoLead(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea los borradores de operación
         * @param {CreateBorradoresOperacionModel} [CreateBorradoresOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBorradoresOperacion(CreateBorradoresOperacionModel?: CreateBorradoresOperacionModel, options?: any): AxiosPromise<GuidArrayResponseDTO> {
            return localVarFp.createBorradoresOperacion(CreateBorradoresOperacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo cliente inmobiliario.
         * @param {CreateClienteInmobiliarioModel} [CreateClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClienteInmobiliario(CreateClienteInmobiliarioModel?: CreateClienteInmobiliarioModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createClienteInmobiliario(CreateClienteInmobiliarioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una lista de comisiones de energia por oferta para un marco de comisiones.
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {Array<CreateComisionEnergiaOfertaModel>} [CreateComisionEnergiaOfertaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComisionesEnergiaOferta(Id: string, IdMarco: string, CreateComisionEnergiaOfertaModel?: Array<CreateComisionEnergiaOfertaModel>, options?: any): AxiosPromise<StringIListResponseDTO> {
            return localVarFp.createComisionesEnergiaOferta(Id, IdMarco, CreateComisionEnergiaOfertaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una lista de comisiones de energia por servicio para un marco de comisiones.
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {Array<CreateComisionEnergiaServicioModel>} [CreateComisionEnergiaServicioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComisionesEnergiaServicio(Id: string, IdMarco: string, CreateComisionEnergiaServicioModel?: Array<CreateComisionEnergiaServicioModel>, options?: any): AxiosPromise<StringIListResponseDTO> {
            return localVarFp.createComisionesEnergiaServicio(Id, IdMarco, CreateComisionEnergiaServicioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nueva comparacion de energia.
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparacionEnergia(File?: File, options?: any): AxiosPromise<CreateComparacionEnergiaResponseResponseDTO> {
            return localVarFp.createComparacionEnergia(File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo comunicado.
         * @param {TipoComunicadoEnum} [Tipo] 
         * @param {string} [Asunto] 
         * @param {string} [Cuerpo] 
         * @param {string} [TipoEmpresaAgenteDirigido] 
         * @param {Array<string>} [RolesDirigidos] 
         * @param {Array<string>} [EmpresasAgentesDirigidos] 
         * @param {Array<File>} [Adjuntos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComunicado(Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createComunicado(Tipo, Asunto, Cuerpo, TipoEmpresaAgenteDirigido, RolesDirigidos, EmpresasAgentesDirigidos, Adjuntos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {CreateCriterioRetrocomisionEnergiaModel} [CreateCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCriterioRetrocomisionEnergia(IdEmpresa: string, CreateCriterioRetrocomisionEnergiaModel?: CreateCriterioRetrocomisionEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createCriterioRetrocomisionEnergia(IdEmpresa, CreateCriterioRetrocomisionEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una delegación de inmobiliaria.
         * @param {CreateDelegacionInmobiliariaModel} [CreateDelegacionInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDelegacionInmobiliaria(CreateDelegacionInmobiliariaModel?: CreateDelegacionInmobiliariaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createDelegacionInmobiliaria(CreateDelegacionInmobiliariaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una empresa colaboradora.
         * @param {CreateEmpresaColaboradoraModel} [CreateEmpresaColaboradoraModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmpresaColaboradora(CreateEmpresaColaboradoraModel?: CreateEmpresaColaboradoraModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createEmpresaColaboradora(CreateEmpresaColaboradoraModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una empresa Inmobiliaria.
         * @param {CreateEmpresaInmobiliariaModel} [CreateEmpresaInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmpresaInmobiliaria(CreateEmpresaInmobiliariaModel?: CreateEmpresaInmobiliariaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createEmpresaInmobiliaria(CreateEmpresaInmobiliariaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una empresa de servicios.
         * @param {CreateEmpresaServiciosModel} [CreateEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmpresaServicios(CreateEmpresaServiciosModel?: CreateEmpresaServiciosModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createEmpresaServicios(CreateEmpresaServiciosModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una factura.
         * @param {CreateFacturaModel} [CreateFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactura(CreateFacturaModel?: CreateFacturaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createFactura(CreateFacturaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un grupo de criterios de retrocomisión de energía.
         * @param {string} IdEmpresa 
         * @param {CreateGrupoCriterioRetrocomisionEnergiaModel} [CreateGrupoCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrupoCriterioRetrocomisionEnergia(IdEmpresa: string, CreateGrupoCriterioRetrocomisionEnergiaModel?: CreateGrupoCriterioRetrocomisionEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createGrupoCriterioRetrocomisionEnergia(IdEmpresa, CreateGrupoCriterioRetrocomisionEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo inmueble.
         * @param {CreateInmuebleModel} [CreateInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInmueble(CreateInmuebleModel?: CreateInmuebleModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createInmueble(CreateInmuebleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo marco de comisiones
         * @param {CreateMarcoComisionesModel} [CreateMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarcoComisiones(CreateMarcoComisionesModel?: CreateMarcoComisionesModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.createMarcoComisiones(CreateMarcoComisionesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nota para un borrador de operación.
         * @param {string} Id 
         * @param {CreateNotaBorradorOperacionModel} [CreateNotaBorradorOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotaBorradorOperacion(Id: string, CreateNotaBorradorOperacionModel?: CreateNotaBorradorOperacionModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createNotaBorradorOperacion(Id, CreateNotaBorradorOperacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nota para una operación.
         * @param {string} Id 
         * @param {CreateNotaOperacionModel} [CreateNotaOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotaOperacion(Id: string, CreateNotaOperacionModel?: CreateNotaOperacionModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createNotaOperacion(Id, CreateNotaOperacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una nota para un trámite de energía.
         * @param {string} IdTramite 
         * @param {CreateNotaTramiteEnergiaModel} [CreateNotaTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotaTramiteEnergia(IdTramite: string, CreateNotaTramiteEnergiaModel?: CreateNotaTramiteEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createNotaTramiteEnergia(IdTramite, CreateNotaTramiteEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una oferta de energía de Endesa.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoOferta] 
         * @param {CreateOfertaEndesaModel} [CreateOfertaEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfertaEndesa(Filename?: string, RutaAnexoOferta?: string, CreateOfertaEndesaModel?: CreateOfertaEndesaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createOfertaEndesa(Filename, RutaAnexoOferta, CreateOfertaEndesaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una oferta de energía.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoOferta] 
         * @param {CreateOfertaEnergiaModel} [CreateOfertaEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfertaEnergia(Filename?: string, RutaAnexoOferta?: string, CreateOfertaEnergiaModel?: CreateOfertaEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createOfertaEnergia(Filename, RutaAnexoOferta, CreateOfertaEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una operación de agua.
         * @param {CreateOperacionAguaModel} [CreateOperacionAguaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperacionAgua(CreateOperacionAguaModel?: CreateOperacionAguaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createOperacionAgua(CreateOperacionAguaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea una operación de energía.
         * @param {CreateOperacionEnergiaModel} [CreateOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperacionEnergia(CreateOperacionEnergiaModel?: CreateOperacionEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createOperacionEnergia(CreateOperacionEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un rappel de energía.
         * @param {CreateRappelEnergiaModel} [CreateRappelEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRappelEnergia(CreateRappelEnergiaModel?: CreateRappelEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createRappelEnergia(CreateRappelEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un servicio de endesa.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoServicio] 
         * @param {CreateServicioEndesaModel} [CreateServicioEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServicioEndesa(Filename?: string, RutaAnexoServicio?: string, CreateServicioEndesaModel?: CreateServicioEndesaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createServicioEndesa(Filename, RutaAnexoServicio, CreateServicioEndesaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un servicio de energía.
         * @param {string} [Filename] 
         * @param {string} [RutaAnexoServicio] 
         * @param {CreateServicioEnergiaModel} [CreateServicioEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServicioEnergia(Filename?: string, RutaAnexoServicio?: string, CreateServicioEnergiaModel?: CreateServicioEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createServicioEnergia(Filename, RutaAnexoServicio, CreateServicioEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo ticket.
         * @param {CreateTicketModel} [CreateTicketModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicket(CreateTicketModel?: CreateTicketModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createTicket(CreateTicketModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un tipo de documento para una empresa de servicios.
         * @param {CreateTipoDocumentoEmpresaServiciosModel} [CreateTipoDocumentoEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTipoDocumentoEmpresaServicios(CreateTipoDocumentoEmpresaServiciosModel?: CreateTipoDocumentoEmpresaServiciosModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.createTipoDocumentoEmpresaServicios(CreateTipoDocumentoEmpresaServiciosModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsuario(CreateUserModel?: CreateUserModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.createUsuario(CreateUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un agente.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgente(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteAgente(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un agente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgenteInmobiliaria(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteAgenteInmobiliaria(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un anexo de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnexoEmpresaServicios(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteAnexoEmpresaServicios(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un borrador de operación
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBorradorOperacion(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteBorradorOperacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una comisión de energía por oferta.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComisionEnergiaOferta(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteComisionEnergiaOferta(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una comisión de energía por servicio.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComisionEnergiaServicio(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteComisionEnergiaServicio(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComunicado(Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteComunicado(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCriterioRetrocomisionEnergia(IdEmpresa: string, Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteCriterioRetrocomisionEnergia(IdEmpresa, Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina o da de baja una delegación inmobiliaria en función del valor del parámetro \'borradoFisico\'.
         * @param {string} Id 
         * @param {boolean} [BorradoFisico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDelegacionInmobiliaria(Id: string, BorradoFisico?: boolean, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteDelegacionInmobiliaria(Id, BorradoFisico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un documento adjunto de la empresa de agentes.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentoEmpresaAgentes(Id: string, IdDocumento: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteDocumentoEmpresaAgentes(Id, IdDocumento, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un documento adjuntado de la operación de agua.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentoOperacionAgua(Id: string, IdDocumento: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteDocumentoOperacionAgua(Id, IdDocumento, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un documento adjuntado de la operación de energía.
         * @param {string} Id 
         * @param {string} IdDocumento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentoOperacionEnergia(Id: string, IdDocumento: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteDocumentoOperacionEnergia(Id, IdDocumento, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una empresa de agentes
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaAgentes(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteEmpresaAgentes(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una empresa colaboradora.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaColaboradora(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteEmpresaColaboradora(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una empresa inmobiliaria.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaInmobiliaria(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteEmpresaInmobiliaria(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una empresa de servicios, con parámetro opcional de borrado físico.
         * @param {string} Id 
         * @param {boolean} [BorradoFisico] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmpresaServicios(Id: string, BorradoFisico?: boolean, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteEmpresaServicios(Id, BorradoFisico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una factura de un inmueble.
         * @param {string} IdInmueble 
         * @param {string} IdFactura 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacturaInmueble(IdInmueble: string, IdFactura: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteFacturaInmueble(IdInmueble, IdFactura, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un inmueble.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInmueble(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteInmueble(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una lectura de un inmueble.
         * @param {string} IdInmueble 
         * @param {string} IdLectura 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLecturaInmueble(IdInmueble: string, IdLectura: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteLecturaInmueble(IdInmueble, IdLectura, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un marco de comisiones.
         * @param {string} Id 
         * @param {DeleteMarcoComisionesModel} [DeleteMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarcoComisiones(Id: string, DeleteMarcoComisionesModel?: DeleteMarcoComisionesModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteMarcoComisiones(Id, DeleteMarcoComisionesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina una oferta de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfertaEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteOfertaEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un rappel de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRappelEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteRappelEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un relación existente de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {string} IdRelacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelacionClienteInmobiliarioInmueble(Id: string, IdRelacion: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteRelacionClienteInmobiliarioInmueble(Id, IdRelacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un servicio de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServicioEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteServicioEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un tipo de documento de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTipoDocumentoEmpresaServicios(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteTipoDocumentoEmpresaServicios(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un usuario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsuario(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deleteUsuario(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deshace el estado actual de una operación de energía, devolviéndola al estado previo.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deshacerEstadoOperacionEnergia(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.deshacerEstadoOperacionEnergia(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un enlace temporal al documento indicado
         * @param {string} [Key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentosGenerateTempUrl(Key?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.documentosGenerateTempUrl(Key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Genera un zip con los ficheros asociados a una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFicheroEmpresaServicios(Id: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.downloadFicheroEmpresaServicios(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplica un marco de comisiones.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateMarcoComisiones(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.duplicateMarcoComisiones(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplica una oferta de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateOfertaEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.duplicateOfertaEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplica un servicio de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateServicioEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.duplicateServicioEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un agente existente
         * @param {EditAgenteModel} [EditAgenteModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAgente(EditAgenteModel?: EditAgenteModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editAgente(EditAgenteModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un agente inmobiliario existente
         * @param {EditAgenteInmobiliariaModel} [EditAgenteInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAgenteInmobiliaria(EditAgenteInmobiliariaModel?: EditAgenteInmobiliariaModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editAgenteInmobiliaria(EditAgenteInmobiliariaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un anexo de empresa de servicios.
         * @param {EditAnexoEmpresaServiciosDto} [EditAnexoEmpresaServiciosDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAnexoEmpresaServicios(EditAnexoEmpresaServiciosDto?: EditAnexoEmpresaServiciosDto, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editAnexoEmpresaServicios(EditAnexoEmpresaServiciosDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un cliente inmobiliario existente
         * @param {EditClienteInmobiliarioModel} [EditClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editClienteInmobiliario(EditClienteInmobiliarioModel?: EditClienteInmobiliarioModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editClienteInmobiliario(EditClienteInmobiliarioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza una comisión de energia por oferta.
         * @param {EditComisionEnergiaOfertaModel} [EditComisionEnergiaOfertaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComisionEnergiaOferta(EditComisionEnergiaOfertaModel?: EditComisionEnergiaOfertaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editComisionEnergiaOferta(EditComisionEnergiaOfertaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza una comisión de energia por servicio.
         * @param {EditComisionEnergiaServicioModel} [EditComisionEnergiaServicioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComisionEnergiaServicio(EditComisionEnergiaServicioModel?: EditComisionEnergiaServicioModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editComisionEnergiaServicio(EditComisionEnergiaServicioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un comunicado existente.
         * @param {string} [Id] 
         * @param {Array<string>} [IdsAdjuntosExistentes] 
         * @param {TipoComunicadoEnum} [Tipo] 
         * @param {string} [Asunto] 
         * @param {string} [Cuerpo] 
         * @param {string} [TipoEmpresaAgenteDirigido] 
         * @param {Array<string>} [RolesDirigidos] 
         * @param {Array<string>} [EmpresasAgentesDirigidos] 
         * @param {Array<File>} [Adjuntos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editComunicado(Id?: string, IdsAdjuntosExistentes?: Array<string>, Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editComunicado(Id, IdsAdjuntosExistentes, Tipo, Asunto, Cuerpo, TipoEmpresaAgenteDirigido, RolesDirigidos, EmpresasAgentesDirigidos, Adjuntos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un criterio de retrocomisión de energia.
         * @param {string} IdEmpresa 
         * @param {EditCriterioRetrocomisionEnergiaModel} [EditCriterioRetrocomisionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCriterioRetrocomisionEnergia(IdEmpresa: string, EditCriterioRetrocomisionEnergiaModel?: EditCriterioRetrocomisionEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editCriterioRetrocomisionEnergia(IdEmpresa, EditCriterioRetrocomisionEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita los datos personales del agente actual
         * @param {EditAgentePersonalDataModel} [EditAgentePersonalDataModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCurrentAgentePersonalData(EditAgentePersonalDataModel?: EditAgentePersonalDataModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editCurrentAgentePersonalData(EditAgentePersonalDataModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una empresa de servicios.
         * @param {EditDelegacionInmobiliariaModel} [EditDelegacionInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDelegacionInmobiliaria(EditDelegacionInmobiliariaModel?: EditDelegacionInmobiliariaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editDelegacionInmobiliaria(EditDelegacionInmobiliariaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una empresa colaboradora.
         * @param {EditEmpresaColaboradoraModel} [EditEmpresaColaboradoraModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEmpresaColaboradora(EditEmpresaColaboradoraModel?: EditEmpresaColaboradoraModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editEmpresaColaboradora(EditEmpresaColaboradoraModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una empresa Inmobiliaria.
         * @param {EditEmpresaInmobiliariaModel} [EditEmpresaInmobiliariaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEmpresaInmobiliaria(EditEmpresaInmobiliariaModel?: EditEmpresaInmobiliariaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editEmpresaInmobiliaria(EditEmpresaInmobiliariaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una empresa de servicios.
         * @param {EditEmpresaServiciosModel} [EditEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEmpresaServicios(EditEmpresaServiciosModel?: EditEmpresaServiciosModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editEmpresaServicios(EditEmpresaServiciosModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un inmueble existente
         * @param {EditInmuebleModel} [EditInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInmueble(EditInmuebleModel?: EditInmuebleModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editInmueble(EditInmuebleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un marco de comisiones existente
         * @param {EditMarcoComisionesModel} [EditMarcoComisionesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMarcoComisiones(EditMarcoComisionesModel?: EditMarcoComisionesModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editMarcoComisiones(EditMarcoComisionesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza el marco de comisiones de una empresa de agentes.
         * @param {string} Id 
         * @param {EditMarcoComisionesEmpresaAgentesModel} [EditMarcoComisionesEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMarcoComisionesEmpresaAgentes(Id: string, EditMarcoComisionesEmpresaAgentesModel?: EditMarcoComisionesEmpresaAgentesModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editMarcoComisionesEmpresaAgentes(Id, EditMarcoComisionesEmpresaAgentesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una nota de un borrador de operación.
         * @param {string} Id 
         * @param {EditNotaBorradorOperacionModel} [EditNotaBorradorOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotaBorradorOperacion(Id: string, EditNotaBorradorOperacionModel?: EditNotaBorradorOperacionModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editNotaBorradorOperacion(Id, EditNotaBorradorOperacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una nota de una operación.
         * @param {string} Id 
         * @param {EditNotaOperacionModel} [EditNotaOperacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotaOperacion(Id: string, EditNotaOperacionModel?: EditNotaOperacionModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editNotaOperacion(Id, EditNotaOperacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una nota de un trámite de energía.
         * @param {string} Id 
         * @param {EditNotaTramiteEnergiaModel} [EditNotaTramiteEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotaTramiteEnergia(Id: string, EditNotaTramiteEnergiaModel?: EditNotaTramiteEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editNotaTramiteEnergia(Id, EditNotaTramiteEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una oferta de Endesa.
         * @param {EditOfertaEndesaModel} [EditOfertaEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOfertaEndesa(EditOfertaEndesaModel?: EditOfertaEndesaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editOfertaEndesa(EditOfertaEndesaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una oferta de energía.
         * @param {EditOfertaEnergiaModel} [EditOfertaEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOfertaEnergia(EditOfertaEnergiaModel?: EditOfertaEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editOfertaEnergia(EditOfertaEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una operación de agua.
         * @param {EditOperacionAguaModel} [EditOperacionAguaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOperacionAgua(EditOperacionAguaModel?: EditOperacionAguaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editOperacionAgua(EditOperacionAguaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una operación de energía.
         * @param {EditOperacionEnergiaModel} [EditOperacionEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOperacionEnergia(EditOperacionEnergiaModel?: EditOperacionEnergiaModel, options?: any): AxiosPromise<EditOperacionEnergiaDtoResponseDTO> {
            return localVarFp.editOperacionEnergia(EditOperacionEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un rappel de energía.
         * @param {EditRappelEnergiaModel} [EditRappelEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRappelEnergia(EditRappelEnergiaModel?: EditRappelEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editRappelEnergia(EditRappelEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece o elimina el reajuste de comisión de oferta de energía para una empresa de agentes.
         * @param {string} Id 
         * @param {EditReajusteComisionEnergiaOfertaEmpresaAgentesModel} [EditReajusteComisionEnergiaOfertaEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReajusteComisionEnergiaOfertaEmpresaAgentes(Id: string, EditReajusteComisionEnergiaOfertaEmpresaAgentesModel?: EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editReajusteComisionEnergiaOfertaEmpresaAgentes(Id, EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece o elimina el reajuste de comisión de servicio de energía para una empresa de agentes.
         * @param {string} Id 
         * @param {EditReajusteComisionEnergiaServicioEmpresaAgentesModel} [EditReajusteComisionEnergiaServicioEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReajusteComisionEnergiaServicioEmpresaAgentes(Id: string, EditReajusteComisionEnergiaServicioEmpresaAgentesModel?: EditReajusteComisionEnergiaServicioEmpresaAgentesModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editReajusteComisionEnergiaServicioEmpresaAgentes(Id, EditReajusteComisionEnergiaServicioEmpresaAgentesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece o elimina el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
         * @param {string} Id 
         * @param {EditReajusteMarcoComisionEmpresaAgentesModel} [EditReajusteMarcoComisionEmpresaAgentesModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReajusteMarcoComisionEmpresaAgentes(Id: string, EditReajusteMarcoComisionEmpresaAgentesModel?: EditReajusteMarcoComisionEmpresaAgentesModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editReajusteMarcoComisionEmpresaAgentes(Id, EditReajusteMarcoComisionEmpresaAgentesModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una relación existente de cliente inmobiliario con un inmueble.
         * @param {string} Id 
         * @param {EditRelacionClienteInmobiliarioInmuebleModel} [EditRelacionClienteInmobiliarioInmuebleModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRelacionClienteInmobiliarioInmueble(Id: string, EditRelacionClienteInmobiliarioInmuebleModel?: EditRelacionClienteInmobiliarioInmuebleModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editRelacionClienteInmobiliarioInmueble(Id, EditRelacionClienteInmobiliarioInmuebleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un servicio de Endesa.
         * @param {EditServicioEndesaModel} [EditServicioEndesaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServicioEndesa(EditServicioEndesaModel?: EditServicioEndesaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editServicioEndesa(EditServicioEndesaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un servicio de energía.
         * @param {EditServicioEnergiaModel} [EditServicioEnergiaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServicioEnergia(EditServicioEnergiaModel?: EditServicioEnergiaModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editServicioEnergia(EditServicioEnergiaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un tipo de documento de empresa de servicios.
         * @param {EditTipoDocumentoEmpresaServiciosModel} [EditTipoDocumentoEmpresaServiciosModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTipoDocumentoEmpresaServicios(EditTipoDocumentoEmpresaServiciosModel?: EditTipoDocumentoEmpresaServiciosModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.editTipoDocumentoEmpresaServicios(EditTipoDocumentoEmpresaServiciosModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUsuario(EditUserModel?: EditUserModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.editUsuario(EditUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envía un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarComunicado(Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.enviarComunicado(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envia una operación de energía a backoffice.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarOperacionEnergiaBackoffice(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.enviarOperacionEnergiaBackoffice(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envia un recordatorio para la firma de la autorización de tratamiento de datos de cliente inmobiliario
         * @param {string} Id 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarRecordatorioFirmaAutorizacionClienteInmobiliario(Id: string, Email?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.enviarRecordatorioFirmaAutorizacionClienteInmobiliario(Id, Email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comprueba si existe un contacto lead cuyo teléfono coincide con el indicado.
         * @param {ExistsContactoLeadByMobileModel} [ExistsContactoLeadByMobileModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsContactoLeadByMobile(ExistsContactoLeadByMobileModel?: ExistsContactoLeadByMobileModel, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.existsContactoLeadByMobile(ExistsContactoLeadByMobileModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones para una empresa de agentes desde backoffice.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraEmpresaAgentesExcel(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.exportComisionesComercializadoraEmpresaAgentesExcel(Id, IdEmpresaServicios, IdMarcoComisiones, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones a PDF para una empresa de agentes desde backoffice.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraEmpresaAgentesPdf(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.exportComisionesComercializadoraEmpresaAgentesPdf(Id, IdEmpresaServicios, IdMarcoComisiones, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones para la empresa de agentes del colaborador autenticado.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraMiEmpresaExcel(IdEmpresaServicios?: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.exportComisionesComercializadoraMiEmpresaExcel(IdEmpresaServicios, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exporta las condiciones económicas de comisiones a PDF para la empresa de agentes del colaborador autenticado.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportComisionesComercializadoraMiEmpresaPdf(IdEmpresaServicios?: string, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.exportComisionesComercializadoraMiEmpresaPdf(IdEmpresaServicios, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet(FeatureName: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.featuresGet(FeatureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList(options?: any): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.featuresList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarProcesoFirmaAutorizacionClienteInmobiliario(Id?: string, DocumentosFirmados?: Array<File>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.finalizarProcesoFirmaAutorizacionClienteInmobiliario(Id, DocumentosFirmados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de contrato de una empresa de agentes.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarProcesoFirmaEmpresaAgentes(Id?: string, DocumentosFirmados?: Array<File>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.finalizarProcesoFirmaEmpresaAgentes(Id, DocumentosFirmados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarProcesoFirmaOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.finalizarProcesoFirmaOperacionEnergia(Id, DocumentosFirmados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finaliza el proceso de firma de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmaAutorizacionOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.firmaAutorizacionOperacionEnergia(Id, DocumentosFirmados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finaliza el proceso de firma del consentimiento previo de una operación energía.
         * @param {string} [Id] 
         * @param {Array<File>} [DocumentosFirmados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmaConsentimientoPrevioOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.firmaConsentimientoPrevioOperacionEnergia(Id, DocumentosFirmados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece una operación de energía como firmada.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmarOperacionEnergia(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.firmarOperacionEnergia(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Genera el consentimiento previo de una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generarConsentimientoPrevioOperacionEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.generarConsentimientoPrevioOperacionEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Genera el contrato de una operación energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generarContratoOperacionEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.generarContratoOperacionEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Genera y descarga el borrador de una factura.
         * @param {CreateFacturaModel} [CreateFacturaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBorradorFactura(CreateFacturaModel?: CreateFacturaModel, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.generateBorradorFactura(CreateFacturaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una comparación dado su id
         * @param {string} Id 
         * @param {Array<number>} [RequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateComparacionEnergiaPdf(Id: string, RequestBody?: Array<number>, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.generateComparacionEnergiaPdf(Id, RequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el agente dado su id de usuario
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgenteById(Id: string, options?: any): AxiosPromise<DetailAgenteModelResponseDTO> {
            return localVarFp.getAgenteById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el agente de inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgenteInmobiliariaById(Id: string, options?: any): AxiosPromise<DetailAgenteInmobiliariaModelResponseDTO> {
            return localVarFp.getAgenteInmobiliariaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de agentes para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getAgentesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de agentes de inmobiliaria dada la delegación
         * @param {string} [IdDelegacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesInmobiliariaByDelegacionSelector(IdDelegacion?: string, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getAgentesInmobiliariaByDelegacionSelector(IdDelegacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de agentes de inmobiliaria para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesInmobiliariaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getAgentesInmobiliariaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de agentes para selectores de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentesSelector(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getAgentesSelector(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de un anexo de empresa de servicios.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnexoEmpresaServiciosById(Id: string, options?: any): AxiosPromise<AnexoEmpresaServiciosDetailDtoResponseDTO> {
            return localVarFp.getAnexoEmpresaServiciosById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los anexos de empresa de servicios para la grid de Devextreme.
         * @param {string} [IdEmpresaServicios] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnexosEmpresaServiciosForGrid(IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getAnexosEmpresaServiciosForGrid(IdEmpresaServicios, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de un borrador de operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorradorOperacionDetail(Id: string, options?: any): AxiosPromise<DetailBorradorOperacionModelResponseDTO> {
            return localVarFp.getBorradorOperacionDetail(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de borradores de operaciones de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorradoresOperacionAguaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getBorradoresOperacionAguaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de borradores de operaciones de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorradoresOperacionEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getBorradoresOperacionEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle del cliente inmobiliario dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClienteInmobiliarioById(Id: string, options?: any): AxiosPromise<DetailClienteInmobiliarioModelResponseDTO> {
            return localVarFp.getClienteInmobiliarioById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle del cliente inmobiliario dado su id.
         * @param {string} Id 
         * @param {string} IdRelacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClienteInmuebleById(Id: string, IdRelacion: string, options?: any): AxiosPromise<DetailClienteInmuebleModelResponseDTO> {
            return localVarFp.getClienteInmuebleById(Id, IdRelacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos más recientes de un cliente dado su documento de identidad o CIF para las operaciones del usuario actual
         * @param {string} [DocumentoIdentidad] 
         * @param {string} [Cif] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClienteLatestInfoForCurrentUser(DocumentoIdentidad?: string, Cif?: string, options?: any): AxiosPromise<ClienteLatestInfoModelResponseDTO> {
            return localVarFp.getClienteLatestInfoForCurrentUser(DocumentoIdentidad, Cif, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de clientes de un agente para la grid de Devextreme a partir de sus operaciones.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesAgenteForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getClientesAgenteForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de clientes de la empresa inmobiliaria del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdInmueble] 
         * @param {boolean} [PuedeCrearBorrador] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesEmpresaInmobiliariaForGrid(LoadOptions?: DXLoadOptions, IdInmueble?: string, PuedeCrearBorrador?: boolean, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getClientesEmpresaInmobiliariaForGrid(LoadOptions, IdInmueble, PuedeCrearBorrador, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de clientes para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getClientesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de relaciones de clientes inmobiliarios con un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {TipoRelacionClienteInmobiliarioEnum} [TipoRelacion] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientesInmuebleForGrid(Id: string, TipoRelacion?: TipoRelacionClienteInmobiliarioEnum, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getClientesInmuebleForGrid(Id, TipoRelacion, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de CNAEs para su uso en un selector.
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCnaeSelector(IdEmpresaServicios?: string, options?: any): AxiosPromise<DetailOperacionEnergiaModelResponseDTO> {
            return localVarFp.getCnaeSelector(IdEmpresaServicios, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de los cometidos de agentes de inmobiliaria para su uso en un selector.
         * @param {object} [Model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCometidoAgentesInmobiliariaSelector(Model?: object, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getCometidoAgentesInmobiliariaSelector(Model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las comisiones por marco de comision para una oferta dado el id de oferta
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComisionesPorMarcoByIdOferta(Id: string, IdMarco: string, options?: any): AxiosPromise<ComisionEnergiaOfertaModelIListResponseDTO> {
            return localVarFp.getComisionesPorMarcoByIdOferta(Id, IdMarco, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las comisiones por marco de comision para un servicio dado el id de servicio
         * @param {string} Id 
         * @param {string} IdMarco 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComisionesPorMarcoByIdServicio(Id: string, IdMarco: string, options?: any): AxiosPromise<ComisionEnergiaServicioModelIListResponseDTO> {
            return localVarFp.getComisionesPorMarcoByIdServicio(Id, IdMarco, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de comparaciones de energia del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparacionesEnergiaAgenteForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getComparacionesEnergiaAgenteForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de comunicaciones de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicacionesOperacionById(Id: string, options?: any): AxiosPromise<ComunicacionesOperacionModelResponseDTO> {
            return localVarFp.getComunicacionesOperacionById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de un comunicado por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadoDetail(Id: string, options?: any): AxiosPromise<DetailComunicadoModelResponseDTO> {
            return localVarFp.getComunicadoDetail(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de un comunicado dirigido al colaborador autenticado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadoDetailForColaborador(Id: string, options?: any): AxiosPromise<DetailComunicadoColaboradorModelResponseDTO> {
            return localVarFp.getComunicadoDetailForColaborador(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Consulta si un comunicado ha sido leído por un agente a partir de su email.
         * @param {string} Id 
         * @param {string} [Email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadoLecturaAgente(Id: string, Email?: string, options?: any): AxiosPromise<ConsultaLecturaComunicadoAgenteModelResponseDTO> {
            return localVarFp.getComunicadoLecturaAgente(Id, Email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de comunicados para la grid de DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadosForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getComunicadosForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de comunicados para la grid de DevExtreme de un colaborador.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadosForGridColaborador(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getComunicadosForGridColaborador(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los ids de los comunicados de portal sin leer del colaborador autenticado.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComunicadosPortalSinLeerForColaborador(options?: any): AxiosPromise<GuidListResponseDTO> {
            return localVarFp.getComunicadosPortalSinLeerForColaborador(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de contactos lead para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactosLeadForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getContactosLeadForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de agentes, con rol de coordinador de delegación, para una empresa inmobiliaria dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoordinadoresDelegacionSelector(Id: string, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getCoordinadoresDelegacionSelector(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el criterio de retrocomision de energia para una empresa y dado su id
         * @param {string} IdEmpresa 
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriterioRetrocomisionEnergiaById(IdEmpresa: string, Id: string, options?: any): AxiosPromise<DetailCriterioRetrocomisionEnergiaModelResponseDTO> {
            return localVarFp.getCriterioRetrocomisionEnergiaById(IdEmpresa, Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de criterios de retrocomision de energia para una empresa y un grupo de configuración
         * @param {string} Id 
         * @param {string} [IdGrupo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteriosRetrocomisionEnergiaByIdEmpresa(Id: string, IdGrupo?: string, options?: any): AxiosPromise<DetailCriterioRetrocomisionEnergiaModelIListResponseDTO> {
            return localVarFp.getCriteriosRetrocomisionEnergiaByIdEmpresa(Id, IdGrupo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos personales del agente actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAgentePersonalData(options?: any): AxiosPromise<GetAgentePersonalDataModelResponseDTO> {
            return localVarFp.getCurrentAgentePersonalData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los datos de un punto de suministro a partir de su Cups.
         * @param {string} Codigo 
         * @param {string} [IdEmpresaServicios] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosPuntoSuministro(Codigo: string, IdEmpresaServicios?: string, options?: any): AxiosPromise<DatosSuministroResponseResponseDTO> {
            return localVarFp.getDatosPuntoSuministro(Codigo, IdEmpresaServicios, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la delegación inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionInmobiliariaById(Id: string, options?: any): AxiosPromise<DetailDelegacionInmobiliariaModelResponseDTO> {
            return localVarFp.getDelegacionInmobiliariaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
         * @param {object} [Model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionInmobiliariaSelector(Model?: object, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getDelegacionInmobiliariaSelector(Model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
         * @param {string} IdInmobiliaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionInmobiliariaSelectorByInmobiliaria(IdInmobiliaria: string, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getDelegacionInmobiliariaSelectorByInmobiliaria(IdInmobiliaria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de delegaciones inmobiliarias para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelegacionesInmobiliariasForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getDelegacionesInmobiliariasForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
         * @param {string} [IdEmpresaServicios] 
         * @param {Array<string>} [IdsOfertaEnergia] 
         * @param {Array<string>} [IdsServicioEnergia] 
         * @param {string} [IdOperacionEnergia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDescuentosEnergiaAplicables(IdEmpresaServicios?: string, IdsOfertaEnergia?: Array<string>, IdsServicioEnergia?: Array<string>, IdOperacionEnergia?: string, options?: any): AxiosPromise<DescuentosEnergiaAplicablesModelResponseDTO> {
            return localVarFp.getDescuentosEnergiaAplicables(IdEmpresaServicios, IdsOfertaEnergia, IdsServicioEnergia, IdOperacionEnergia, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una comparación dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailComparacionEnergiaById(Id: string, options?: any): AxiosPromise<DetailComparacionEnergiaOfertaModelListResponseDTO> {
            return localVarFp.getDetailComparacionEnergiaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Documentos de firma que deben aportarse firmados a mano (misma lógica que la firma digital).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosFirmaManualOperacionEnergia(Id: string, options?: any): AxiosPromise<EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO> {
            return localVarFp.getDocumentosFirmaManualOperacionEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una empresa de agentes por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaAgentesDetail(Id: string, options?: any): AxiosPromise<DetailEmpresaAgentesModelResponseDTO> {
            return localVarFp.getEmpresaAgentesDetail(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de las empresas de agentes para su uso en un selector.
         * @param {Array<string>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaAgentesSelector(Tipos?: Array<string>, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getEmpresaAgentesSelector(Tipos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la empresa colaboradora dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaColaboradoraById(Id: string, options?: any): AxiosPromise<DetailEmpresaColaboradoraModelResponseDTO> {
            return localVarFp.getEmpresaColaboradoraById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la empresa colaboradora dado el usuario que lo solicita
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaColaboradoraByUserId(options?: any): AxiosPromise<DetailEmpresaColaboradoraModelResponseDTO> {
            return localVarFp.getEmpresaColaboradoraByUserId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la empresa inmobiliaria dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaInmobiliariaById(Id: string, options?: any): AxiosPromise<DetailEmpresaInmobiliariaModelResponseDTO> {
            return localVarFp.getEmpresaInmobiliariaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de la empresa inmobiliaria asociada al usuario que realiza la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaInmobiliariaUsuarioRequest(options?: any): AxiosPromise<DetailEmpresaInmobiliariaModelResponseDTO> {
            return localVarFp.getEmpresaInmobiliariaUsuarioRequest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la empresa de servicios de energía dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaServiciosAguaById(Id: string, options?: any): AxiosPromise<DetailEmpresaServiciosAguaModelResponseDTO> {
            return localVarFp.getEmpresaServiciosAguaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la empresa de servicios de energía dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresaServiciosEnergiaById(Id: string, options?: any): AxiosPromise<DetailEmpresaServiciosEnergiaModelResponseDTO> {
            return localVarFp.getEmpresaServiciosEnergiaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de agentes para la rejilla DevExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasAgentesForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getEmpresasAgentesForGrid(LoadOptions, IdsEstados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de empresas colaboradoras para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasColaboradoraForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getEmpresasColaboradoraForGrid(LoadOptions, IdsEstados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de empresas inmobiliarias para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasInmobiliariasForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getEmpresasInmobiliariasForGrid(LoadOptions, IdsEstados, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosAguaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getEmpresasServiciosAguaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las empresas de servicio de agua que operan en una provincia concreta dado el codigo postal.
         * @param {string} [CodigoPostal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosAguaOperables(CodigoPostal?: string, options?: any): AxiosPromise<EmpresaServiciosModelListResponseDTO> {
            return localVarFp.getEmpresasServiciosAguaOperables(CodigoPostal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getEmpresasServiciosEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
         * @param {string} [IdEmpresaAgentes] 
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosOperables(IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options?: any): AxiosPromise<EmpresaServiciosModelListResponseDTO> {
            return localVarFp.getEmpresasServiciosOperables(IdEmpresaAgentes, Tipos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa, operables para la empresa de agentes indicada o, en su defecto, la del usuario que hace la petición.
         * @param {string} [IdEmpresaAgentes] 
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosOperablesSelector(IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getEmpresasServiciosOperablesSelector(IdEmpresaAgentes, Tipos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa.
         * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmpresasServiciosSelector(Tipos?: Array<TipoEmpresaServiciosEnum>, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getEmpresasServiciosSelector(Tipos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la estructura documental requerida para una empresa de agentes (configuración y documentos ya adjuntos).
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalEmpresaAgentes(Id: string, options?: any): AxiosPromise<EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO> {
            return localVarFp.getEstructuraDocumentalEmpresaAgentes(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la estructura documental requerida para una empresa de agentes según su forma jurídica.
         * @param {FormaJuridicaEnum} [FormaJuridica] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalEmpresaAgentesByFormaJuridica(FormaJuridica?: FormaJuridicaEnum, options?: any): AxiosPromise<EstructuraDocumentalEmpresaAgentesModelArrayResponseDTO> {
            return localVarFp.getEstructuraDocumentalEmpresaAgentesByFormaJuridica(FormaJuridica, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la estructura documental de una empresa de servicios, con filtro opcional de tipo de persona (física o jurídica).
         * @param {string} Id 
         * @param {TipoPersonaEnum} [TipoPersona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalEmpresaServicios(Id: string, TipoPersona?: TipoPersonaEnum, options?: any): AxiosPromise<EstructuraDocumentalOperacionModelArrayResponseDTO> {
            return localVarFp.getEstructuraDocumentalEmpresaServicios(Id, TipoPersona, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dada una operación, obtiene su estructura documental.
         * @param {string} Id 
         * @param {boolean} [IncluirArchivosSistema] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstructuraDocumentalOperacionEnergia(Id: string, IncluirArchivosSistema?: boolean, options?: any): AxiosPromise<EstructuraDocumentalOperacionEnergiaModelArrayResponseDTO> {
            return localVarFp.getEstructuraDocumentalOperacionEnergia(Id, IncluirArchivosSistema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Genera y descarga el Excel para su importación en Repsol.
         * @param {Array<string>} [RequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportacionExcelRepsol(RequestBody?: Array<string>, options?: any): AxiosPromise<FileStreamResultResponseDTO> {
            return localVarFp.getExportacionExcelRepsol(RequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una factura por su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturaDetailById(Id: string, options?: any): AxiosPromise<FacturaDetailModelResponseDTO> {
            return localVarFp.getFacturaDetailById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de facturas para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getFacturasForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de facturas del agente creador seleccionado para soporte.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasForGridSoporte(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getFacturasForGridSoporte(IdUsuario, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasInmuebleForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getFacturasInmuebleForGrid(Id, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de facturas para la empresa de agentes del agente que hace la petición para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacturasMyCompanyForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getFacturasMyCompanyForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de grupos de criterios de retrocomisión de energía para una empresa dado el id de empresa
         * @param {string} IdEmpresa 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGruposCriteriosRetrocomisionEnergiaByIdEmpresa(IdEmpresa: string, options?: any): AxiosPromise<SelectBoxGuidEntityWithDefaultModelArrayResponseDTO> {
            return localVarFp.getGruposCriteriosRetrocomisionEnergiaByIdEmpresa(IdEmpresa, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle del inmueble dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInmuebleById(Id: string, options?: any): AxiosPromise<DetailInmuebleModelResponseDTO> {
            return localVarFp.getInmuebleById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de inmuebles para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdClienteInmobiliario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInmueblesForGrid(LoadOptions?: DXLoadOptions, IdClienteInmobiliario?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getInmueblesForGrid(LoadOptions, IdClienteInmobiliario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
         * @param {string} Id 
         * @param {TipoSuministroInmuebleEnum} [TipoSuministro] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLecturasInmuebleForGrid(Id: string, TipoSuministro?: TipoSuministroInmuebleEnum, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getLecturasInmuebleForGrid(Id, TipoSuministro, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para el agente para la grid de liquidaciones de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiquidacionesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getLiquidacionesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de agentes a los que se ha enviado un comunicado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoAgentesComunicado(Id: string, options?: any): AxiosPromise<AgenteComunicadoListModelArrayResponseDTO> {
            return localVarFp.getListadoAgentesComunicado(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de notas de un borrador de operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoNotasBorradorOperacion(Id: string, options?: any): AxiosPromise<DetailNotaBorradorOperacionModelListResponseDTO> {
            return localVarFp.getListadoNotasBorradorOperacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de notas de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoNotasOperacion(Id: string, options?: any): AxiosPromise<DetailNotaOperacionModelListResponseDTO> {
            return localVarFp.getListadoNotasOperacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de notas de un trámite de energía.
         * @param {string} IdTramite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoNotasTramiteEnergia(IdTramite: string, options?: any): AxiosPromise<DetailNotaTramiteEnergiaModelListResponseDTO> {
            return localVarFp.getListadoNotasTramiteEnergia(IdTramite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el logo de la empresa si lo hubiera.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogoPortalEmpresaAgentes(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.getLogoPortalEmpresaAgentes(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de marcos de comisiones para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarcosComisionesForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getMarcosComisionesForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de marcos de comisiones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarcosComisionesList(options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getMarcosComisionesList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el modelo de datos con el que confeccionar la siguiente factura para la empresa de agentes del agente que hace la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextFacturaConfig(options?: any): AxiosPromise<FacturaConfigModelResponseDTO> {
            return localVarFp.getNextFacturaConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las notificaciones para el usuario actual.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificaciones(options?: any): AxiosPromise<GetNotificacionesModelResponseDTO> {
            return localVarFp.getNotificaciones(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la oferta de Endesa dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertaEndesaById(Id: string, options?: any): AxiosPromise<DetailOfertaEndesaModelResponseDTO> {
            return localVarFp.getOfertaEndesaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la oferta de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertaEnergiaById(Id: string, options?: any): AxiosPromise<DetailOfertaEnergiaModelResponseDTO> {
            return localVarFp.getOfertaEnergiaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las ofertas de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getOfertasEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado paginado de ofertas de energía.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {Array<string>} [FiltrosComercializadoras] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {string} [FiltrosTarifaAcceso] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {Date} [FiltrosFechaInicio] 
         * @param {Date} [FiltrosFechaFin] 
         * @param {string} [FiltrosTexto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaList(Take?: number, Skip?: number, FiltrosComercializadoras?: Array<string>, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTarifaAcceso?: string, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, FiltrosFechaInicio?: Date, FiltrosFechaFin?: Date, FiltrosTexto?: string, options?: any): AxiosPromise<OfertaEnergiaListItemModelPagedResultModelResponseDTO> {
            return localVarFp.getOfertasEnergiaList(Take, Skip, FiltrosComercializadoras, FiltrosTipoEnergia, FiltrosTarifaAcceso, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, FiltrosFechaInicio, FiltrosFechaFin, FiltrosTexto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las ofertas de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
         * @param {string} Id 
         * @param {TipoPersonaEnum} TipoPersona 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaOperables(Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options?: any): AxiosPromise<OfertasEmpresaServiciosModelListResponseDTO> {
            return localVarFp.getOfertasEnergiaOperables(Id, TipoPersona, IdOperacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado paginado de ofertas de energía con retribuciones para backoffice.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {string} [FiltrosEmpresaAgentes] 
         * @param {string} [FiltrosMarcoComisiones] 
         * @param {string} [FiltrosComercializadora] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaRetribucionesBackofficeList(Take?: number, Skip?: number, FiltrosEmpresaAgentes?: string, FiltrosMarcoComisiones?: string, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options?: any): AxiosPromise<OfertaEnergiaRetribucionesBackofficeListItemModelPagedResultModelResponseDTO> {
            return localVarFp.getOfertasEnergiaRetribucionesBackofficeList(Take, Skip, FiltrosEmpresaAgentes, FiltrosMarcoComisiones, FiltrosComercializadora, FiltrosTipoEnergia, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado paginado de ofertas de energía con retribuciones para colaboradores.
         * @param {number} [Take] 
         * @param {number} [Skip] 
         * @param {string} [FiltrosComercializadora] 
         * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
         * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
         * @param {boolean} [FiltrosConAutoconsumo] 
         * @param {number} [FiltrosPotenciaMin] 
         * @param {number} [FiltrosPotenciaMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfertasEnergiaRetribucionesColaboradoresList(Take?: number, Skip?: number, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options?: any): AxiosPromise<OfertaEnergiaRetribucionesColaboradoresListItemModelPagedResultModelResponseDTO> {
            return localVarFp.getOfertasEnergiaRetribucionesColaboradoresList(Take, Skip, FiltrosComercializadora, FiltrosTipoEnergia, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de agua.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionAguaDetail(Id: string, options?: any): AxiosPromise<DetailOperacionAguaModelResponseDTO> {
            return localVarFp.getOperacionAguaDetail(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionEnergiaDetail(Id: string, options?: any): AxiosPromise<DetailOperacionEnergiaModelResponseDTO> {
            return localVarFp.getOperacionEnergiaDetail(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de una comparación de energía.
         * @param {string} IdComparacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionEnergiaDetailFromComparison(IdComparacion: string, options?: any): AxiosPromise<DetailComparacionEnergiaModelResponseDTO> {
            return localVarFp.getOperacionEnergiaDetailFromComparison(IdComparacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de un inmueble.
         * @param {string} IdInmueble 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionEnergiaDetailFromProperty(IdInmueble: string, options?: any): AxiosPromise<DetailOperacionEnergiaInmuebleModelResponseDTO> {
            return localVarFp.getOperacionEnergiaDetailFromProperty(IdInmueble, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de agua para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesAguaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getOperacionesAguaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el histórico de estados de las operaciones de agua.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesAguaHistoricoEstados(LoadOptions?: DXLoadOptions, IdOperacion?: string, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getOperacionesAguaHistoricoEstados(LoadOptions, IdOperacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de un cliente.
         * @param {string} [IdCliente] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesByIdCliente(IdCliente?: string, options?: any): AxiosPromise<OperacionesClienteModelResponseDTO> {
            return localVarFp.getOperacionesByIdCliente(IdCliente, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de energia para el cliente de un agente para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesEnergiaAgenteForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getOperacionesEnergiaAgenteForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de operaciones de energia para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getOperacionesEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el histórico de estados de las operaciones.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperacionesHistoricoEstados(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getOperacionesHistoricoEstados(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la plantilla de autorización de tratamiento de datos de un cliente inmobiliario, lista para firmar.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlantillaAutorizacionClienteInmobiliario(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.getPlantillaAutorizacionClienteInmobiliario(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de las prioridades de ticket para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrioridadesTicketSelector(options?: any): AxiosPromise<SelectBoxEntityModelArrayResponseDTO> {
            return localVarFp.getPrioridadesTicketSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de provincias.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvincias(options?: any): AxiosPromise<SelectBoxIntEntityModelListResponseDTO> {
            return localVarFp.getProvincias(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la información pública de la empresa inmobiliaria asociada al usuario que realiza la petición
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicInformationSelfEmpresaInmobiliaria(options?: any): AxiosPromise<PublicInformationEmpresaInmobiliariaModelResponseDTO> {
            return localVarFp.getPublicInformationSelfEmpresaInmobiliaria(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el rappel de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelEnergiaById(Id: string, options?: any): AxiosPromise<DetailRappelEnergiaModelResponseDTO> {
            return localVarFp.getRappelEnergiaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los rappels de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelsEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRappelsEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los rappels de energía mensuales asociadas a una factura para la subrejilla de factura de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelsMensualesEnergiaFacturaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRappelsMensualesEnergiaFacturaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los rappels de energía mensuales para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRappelsMensualesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getRappelsMensualesEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
         * @param {string} Id 
         * @param {string} [IdEmpresaServicios] 
         * @param {string} [IdMarcoComisiones] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReajusteMarcoComisionEmpresaAgentes(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: any): AxiosPromise<DecimalNullableResponseDTO> {
            return localVarFp.getReajusteMarcoComisionEmpresaAgentes(Id, IdEmpresaServicios, IdMarcoComisiones, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de la relación entre un cliente inmobiliario e inmueble dado sus ids.
         * @param {string} Id 
         * @param {string} IdClienteInmobiliario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelacionClienteInmuebleDetail(Id: string, IdClienteInmobiliario: string, options?: any): AxiosPromise<DetailRelacionClienteInmuebleModelResponseDTO> {
            return localVarFp.getRelacionClienteInmuebleDetail(Id, IdClienteInmobiliario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsablesSelectorByIdEmpresaAgentes(Id: string, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getResponsablesSelectorByIdEmpresaAgentes(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesAll(options?: any): AxiosPromise<RolesRmListResponseDTO> {
            return localVarFp.getRolesAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene un listado de roles del sistema seleccionables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesSelector(options?: any): AxiosPromise<RolesRmListResponseDTO> {
            return localVarFp.getRolesSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el servicio de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicioEndesaById(Id: string, options?: any): AxiosPromise<DetailServicioEndesaModelResponseDTO> {
            return localVarFp.getServicioEndesaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el servicio de energia dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicioEnergiaById(Id: string, options?: any): AxiosPromise<DetailServicioEnergiaModelResponseDTO> {
            return localVarFp.getServicioEnergiaById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los servicios de energía para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiciosEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getServiciosEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene las ofertas de servicios extras de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
         * @param {string} Id 
         * @param {TipoPersonaEnum} TipoPersona 
         * @param {string} [IdOperacion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiciosEnergiaOperables(Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options?: any): AxiosPromise<OfertasServicioDistribuidoraModelListResponseDTO> {
            return localVarFp.getServiciosEnergiaOperables(Id, TipoPersona, IdOperacion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de subtipos de empresa colaboradora para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtipoEmpresaColaboradoraSelector(options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getSubtipoEmpresaColaboradoraSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de Subtipo persona para su uso en un selector.
         * @param {TipoPersonaEnum} [TipoPersona] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtipoPersonasSelector(TipoPersona?: TipoPersonaEnum, options?: any): AxiosPromise<SelectBoxEntityModelListResponseDTO> {
            return localVarFp.getSubtipoPersonasSelector(TipoPersona, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de los subtipos de ticket a partir de un tipo para su uso en un selector.
         * @param {TipoTicketEnum} [IdTipoTicket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubtiposTicketSelectorByIdTipo(IdTipoTicket?: TipoTicketEnum, options?: any): AxiosPromise<SelectBoxEntityModelArrayResponseDTO> {
            return localVarFp.getSubtiposTicketSelectorByIdTipo(IdTipoTicket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de las tensiones suministro para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTensionSuministroSelector(options?: any): AxiosPromise<DetailOperacionEnergiaModelResponseDTO> {
            return localVarFp.getTensionSuministroSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle del ticket dado su id.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketById(Id: string, options?: any): AxiosPromise<DetailTicketModelResponseDTO> {
            return localVarFp.getTicketById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de tickets para la grid de DexExtreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTicketsForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el tipo de documento de empresa de servicios dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipoDocumentoEmpresaServiciosById(Id: string, options?: any): AxiosPromise<DetailTipoDocumentoEmpresaServiciosModelResponseDTO> {
            return localVarFp.getTipoDocumentoEmpresaServiciosById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los tipos de documento de empresa de servicios para la grid de Devextreme.
         * @param {string} [IdEmpresaServicios] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposDocumentosEmpresaServiciosForGrid(IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTiposDocumentosEmpresaServiciosForGrid(IdEmpresaServicios, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de los tipos de ticket para su uso en un selector.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiposTicketSelector(options?: any): AxiosPromise<SelectBoxEntityModelArrayResponseDTO> {
            return localVarFp.getTiposTicketSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia asociadas a una factura para la subrejilla de factura de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaFacturaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTramitesEnergiaFacturaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTramitesEnergiaForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el histórico de estados de los trámites de energia.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaHistoricoEstados(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTramitesEnergiaHistoricoEstados(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia asociadas a un rappel mensual para la grid del detalle de rappel mensual de Devextreme.
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesEnergiaRappelMensualForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTramitesEnergiaRappelMensualForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesForGridColaboradores(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTramitesForGridColaboradores(IdUsuario, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
         * @param {string} [IdUsuario] 
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTramitesForGridSoporte(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getTramitesForGridSoporte(IdUsuario, LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el usuario dado su id
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioById(Id: string, options?: any): AxiosPromise<DetailUsuarioModelResponseDTO> {
            return localVarFp.getUsuarioById(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioCurrentProfile(options?: any): AxiosPromise<UserProfileResponseResponseDTO> {
            return localVarFp.getUsuarioCurrentProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosBackofficeSelector(options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getUsuariosBackofficeSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios de backoffice
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosBackofficeSelectorByIdTicket(Id: string, options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getUsuariosBackofficeSelectorByIdTicket(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios comerciales (administrador o trabajador)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosComercialesSelector(options?: any): AxiosPromise<SelectBoxGuidEntityModelArrayResponseDTO> {
            return localVarFp.getUsuariosComercialesSelector(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el listado de usuarios para la grid de DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosForGrid(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.getUsuariosForGrid(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Realiza la importación de bajas de trámites y servicios a patir del fichero de Endesa.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEndesaBajasOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: any): AxiosPromise<ImportResultDtoResponseDTO> {
            return localVarFp.importEndesaBajasOperacionEnergia(EsSimulacion, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Realiza la importación de códigos externos Cosmos a partir del fichero de Endesa, cruzando por CUPS y fecha de venta.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEndesaCosmosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: any): AxiosPromise<ImportResultDtoResponseDTO> {
            return localVarFp.importEndesaCosmosOperacionEnergia(EsSimulacion, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Realiza la importación de nuevos estados de trámites y servicios a partir del fichero de Endesa.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEndesaNuevosEstadosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: any): AxiosPromise<ImportResultDtoResponseDTO> {
            return localVarFp.importEndesaNuevosEstadosOperacionEnergia(EsSimulacion, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Realiza la importación de nuevos estados de trámites a partir del fichero de Naturgy.
         * @param {boolean} [EsSimulacion] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importNaturgyNuevosEstadosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: any): AxiosPromise<ImportResultDtoResponseDTO> {
            return localVarFp.importNaturgyNuevosEstadosOperacionEnergia(EsSimulacion, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envia una solicitud de firma de autorización de tratamiento de datos al cliente inmobiliario.
         * @param {string} Id 
         * @param {IniciarFirmaAutorizacionClienteInmobiliarioModel} [IniciarFirmaAutorizacionClienteInmobiliarioModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarFirmaAutorizacionClienteInmobiliario(Id: string, IniciarFirmaAutorizacionClienteInmobiliarioModel?: IniciarFirmaAutorizacionClienteInmobiliarioModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.iniciarFirmaAutorizacionClienteInmobiliario(Id, IniciarFirmaAutorizacionClienteInmobiliarioModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inicia el proceso de firma de una operación energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarFirmaBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.iniciarFirmaBackofficeOperacionEnergia(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inicia el proceso de firma digital del consentimiento previo.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarFirmaConsentimientoPrevioOperacionEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.iniciarFirmaConsentimientoPrevioOperacionEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inicia el proceso de firma de una operación energía.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iniciarProcesoFirmaOperacionEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.iniciarProcesoFirmaOperacionEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca como incidencia la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marcarIncidenciaOperacionAgua(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.marcarIncidenciaOperacionAgua(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca una factura en borrador como pendiente de revisión por parte del colaborador.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markPendingReviewFactura(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.markPendingReviewFactura(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca en curso la operación de agua.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ponerEnCursoOperacionAgua(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.ponerEnCursoOperacionAgua(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un documento de empresa de agentes.
         * @param {string} Id 
         * @param {TipoDocumentoEmpresaAgentesEnum} [TipoDocumento] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoEmpresaAgentes(Id: string, TipoDocumento?: TipoDocumentoEmpresaAgentesEnum, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postDocumentoEmpresaAgentes(Id, TipoDocumento, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un tipo de documento a la operación de agua.
         * @param {string} Id 
         * @param {string} [IdTipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoOperacionAgua(Id: string, IdTipoDocumento?: string, Descripcion?: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postDocumentoOperacionAgua(Id, IdTipoDocumento, Descripcion, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adjunta un tipo de documento a la operación de energía.
         * @param {string} Id 
         * @param {TipoDocumentoOperacionEnergiaEnum} [TipoDocumento] 
         * @param {string} [Descripcion] 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoOperacionEnergia(Id: string, TipoDocumento?: TipoDocumentoOperacionEnergiaEnum, Descripcion?: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postDocumentoOperacionEnergia(Id, TipoDocumento, Descripcion, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero de forma temporal.
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocumentoTemp(Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.postDocumentoTemp(Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza el anexo asociado a una oferta de energía.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAnexoOfertaEnergia(Id: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.putAnexoOfertaEnergia(Id, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza el anexo asociado a un servicio de energía.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAnexoServicioEnergia(Id: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.putAnexoServicioEnergia(Id, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza el documento de dni asociado a un agente.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDocumentoAgente(Id: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.putDocumentoAgente(Id, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualiza la factura propia asociada a una factura.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFacturaPropia(Id: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.putFacturaPropia(Id, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reactiva una empresa de agentes dada de baja
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateEmpresaAgentes(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.reactivateEmpresaAgentes(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reactiva un usuario dado de baja.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateUsuario(Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.reactivateUsuario(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca como leída las comunicaciones de una operación.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readComunicacionesOperacion(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.readComunicacionesOperacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca un comunicado de portal como leído para el colaborador autenticado.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readComunicadoForColaborador(Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.readComunicadoForColaborador(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca como leídos todos los mensajes de un ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMensajesTicket(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.readMensajesTicket(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marca una notificación como leída.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readNotificacion(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.readNotificacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rechaza una autorización de consentimiento firmada por un cliente inmobiliario.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazarAutorizacionClienteInmobiliario(Id: string, Body?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.rechazarAutorizacionClienteInmobiliario(Id, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rechaza una operación de energía desde backoffice.
         * @param {string} Id 
         * @param {string} [Comentario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazarBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.rechazarBackofficeOperacionEnergia(Id, Comentario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rechaza un cierre de ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCloseTicket(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.rejectCloseTicket(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rechaza la empresa de agentes
         * @param {string} Id 
         * @param {string} [MotivoRechazo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectEmpresaAgentes(Id: string, MotivoRechazo?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.rejectEmpresaAgentes(Id, MotivoRechazo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rechaza una factura.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectFactura(Id: string, Body?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.rejectFactura(Id, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rechaza una factura.
         * @param {string} Id 
         * @param {string} [Body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPendingReviewFactura(Id: string, Body?: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.rejectPendingReviewFactura(Id, Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancela y reinicia una operación de energía al estado inicial.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOperacionEnergia(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.resetOperacionEnergia(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna al usuario que realiza la petición como responsable de una operacion.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfAssignResponsableOperacion(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.selfAssignResponsableOperacion(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asigna al usuario que realiza la petición como responsable de un ticket.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfAssignResponsableTicket(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.selfAssignResponsableTicket(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Envía la empresa de agentes para firma
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToSignEmpresaAgentes(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.sendToSignEmpresaAgentes(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Establece la prioridad de un ticket.
         * @param {string} Id 
         * @param {PrioridadTicketEnum} Prioridad 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrioridadTicket(Id: string, Prioridad: PrioridadTicketEnum, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.setPrioridadTicket(Id, Prioridad, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Liquida una factura.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settleFactura(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.settleFactura(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Liquida una factura pendiente de revisión por parte del colaborador.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlePendingReviewFactura(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.settlePendingReviewFactura(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Simula las comisiones de oferta para una comparación de energía.
         * @param {string} Id 
         * @param {SimularComisionesComparacionEnergiaRequest} [SimularComisionesComparacionEnergiaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simularComisionesComparacionEnergia(Id: string, SimularComisionesComparacionEnergiaRequest?: SimularComisionesComparacionEnergiaRequest, options?: any): AxiosPromise<SimularComisionesComparacionEnergiaResponseResponseDTO> {
            return localVarFp.simularComisionesComparacionEnergia(Id, SimularComisionesComparacionEnergiaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube la autorización firmada de tratamiento de datos de un cliente inmobiliario.
         * @param {string} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subirAutorizacionClienteInmobiliario(Id: string, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.subirAutorizacionClienteInmobiliario(Id, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {string} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckEmail(Email: string, IdUsuario: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.usuarioCheckEmail(Email, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckUsername(Username: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.usuarioCheckUsername(Username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Valida una autorización de consentimiento firmada por un cliente inmobiliario.
         * @param {string} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarAutorizacionClienteInmobiliario(Id: string, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.validarAutorizacionClienteInmobiliario(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Valida si un contacto lead de operación es válido, a partir de los datos de titular.
         * @param {TitularModel} [TitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactoLeadOperacion(TitularModel?: TitularModel, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.validateContactoLeadOperacion(TitularModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comprueba si el email no se ha usado en otras operaciones asociadas a otros documentos de titular.
         * @param {ValidateEmailTitularModel} [ValidateEmailTitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailTitular(ValidateEmailTitularModel?: ValidateEmailTitularModel, options?: any): AxiosPromise<ValidateEmailResponseResponseDTO> {
            return localVarFp.validateEmailTitular(ValidateEmailTitularModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comprueba si el móvil no se ha usado en otras operaciones asociadas a otros documentos de titular.
         * @param {ValidateMovilTitularModel} [ValidateMovilTitularModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMovilTitular(ValidateMovilTitularModel?: ValidateMovilTitularModel, options?: any): AxiosPromise<ValidateMovilResponseResponseDTO> {
            return localVarFp.validateMovilTitular(ValidateMovilTitularModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Webhook para las altas de los contactos Lead.
         * @param {CreateContactoLeadModel} [CreateContactoLeadModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAltaNuevoContadoLead(CreateContactoLeadModel?: CreateContactoLeadModel, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.webhookAltaNuevoContadoLead(CreateContactoLeadModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
export class ApiApi extends BaseAPI {
    /**
     * 
     * @summary Acepta un cierre de ticket.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public acceptCloseTicket(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).acceptCloseTicket(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Maneja el acceso desde el CRM externo IA Gestion
     * @param {AccesoExternoIaGestionModel} [AccesoExternoIaGestionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public accesoExternoAgenteIaGestion(AccesoExternoIaGestionModel?: AccesoExternoIaGestionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).accesoExternoAgenteIaGestion(AccesoExternoIaGestionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Acepta una operación de energía desde backoffice.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public aceptarBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).aceptarBackofficeOperacionEnergia(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca como activada la operación de agua.
     * @param {string} Id 
     * @param {Date} [FechaActivacion] 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public activarOperacionAgua(Id: string, FechaActivacion?: Date, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).activarOperacionAgua(Id, FechaActivacion, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Activa un trámite de energía de manera manual.
     * @param {string} IdOperacion 
     * @param {ActivateTramiteEnergiaModel} [ActivateTramiteEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public activarTramiteEnergia(IdOperacion: string, ActivateTramiteEnergiaModel?: ActivateTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).activarTramiteEnergia(IdOperacion, ActivateTramiteEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade una comunicación a una operación.
     * @param {string} Id 
     * @param {CreateComunicacionOperacionModel} [CreateComunicacionOperacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addComunicacionOperacion(Id: string, CreateComunicacionOperacionModel?: CreateComunicacionOperacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addComunicacionOperacion(Id, CreateComunicacionOperacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade una factura a un inmueble.
     * @param {string} Id 
     * @param {AddFacturaInmuebleModel} [AddFacturaInmuebleModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addFacturaInmueble(Id: string, AddFacturaInmuebleModel?: AddFacturaInmuebleModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addFacturaInmueble(Id, AddFacturaInmuebleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade una lectura a un inmueble.
     * @param {string} Id 
     * @param {AddLecturaInmuebleModel} [AddLecturaInmuebleModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addLecturaInmueble(Id: string, AddLecturaInmuebleModel?: AddLecturaInmuebleModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addLecturaInmueble(Id, AddLecturaInmuebleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade un mensaje a un ticket.
     * @param {string} Id 
     * @param {CreateMensajeTicketModel} [CreateMensajeTicketModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addMessageTicket(Id: string, CreateMensajeTicketModel?: CreateMensajeTicketModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addMessageTicket(Id, CreateMensajeTicketModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade a la operación de agua indicada una nueva observación.
     * @param {string} IdOperacion 
     * @param {string} [Observacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addObservacionOperacionAgua(IdOperacion: string, Observacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addObservacionOperacionAgua(IdOperacion, Observacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade a la operación indicada una nueva observación.
     * @param {string} IdOperacion 
     * @param {string} [Observacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addObservacionOperacionEnergia(IdOperacion: string, Observacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addObservacionOperacionEnergia(IdOperacion, Observacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade al trámite de la operación indicada una nueva observación.
     * @param {string} IdOperacion 
     * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
     * @param {string} [Observacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addObservacionTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Observacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addObservacionTramiteEnergia(IdOperacion, TipoSuministro, Observacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Añade una nueva relación de cliente inmobiliario con un inmueble.
     * @param {string} Id 
     * @param {AddRelacionClienteInmobiliarioInmuebleModel} [AddRelacionClienteInmobiliarioInmuebleModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public addRelacionClienteInmobiliarioInmueble(Id: string, AddRelacionClienteInmobiliarioInmuebleModel?: AddRelacionClienteInmobiliarioInmuebleModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).addRelacionClienteInmobiliarioInmueble(Id, AddRelacionClienteInmobiliarioInmuebleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta el consentimiento previo firmado manualmente.
     * @param {string} Id 
     * @param {File} [Fichero] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public adjuntarConsentimientoPrevioOperacionEnergia(Id: string, Fichero?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).adjuntarConsentimientoPrevioOperacionEnergia(Id, Fichero, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Anula una operación de energía, junto a sus trámites.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public anularOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).anularOperacionEnergia(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca el trámite de la operación indicada como anulada.
     * @param {string} IdOperacion 
     * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public anularTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).anularTramiteEnergia(IdOperacion, TipoSuministro, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aplica reajustes de comisión y/o retrocomisión a los conceptos de trámite/servicio de una factura revisable.
     * @param {string} Id 
     * @param {AplicarReajustesConceptosFacturaModel} [AplicarReajustesConceptosFacturaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public aplicarReajustesConceptosFactura(Id: string, AplicarReajustesConceptosFacturaModel?: AplicarReajustesConceptosFacturaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).aplicarReajustesConceptosFactura(Id, AplicarReajustesConceptosFacturaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Solicita un cierre de ticket.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public askCloseTicket(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).askCloseTicket(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna el identificador externo de una operación de energía.
     * @param {string} IdOperacion 
     * @param {AssignExternalIdOperacionEnergiaModel} [AssignExternalIdOperacionEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public assignExternalIdOperacionEnergia(IdOperacion: string, AssignExternalIdOperacionEnergiaModel?: AssignExternalIdOperacionEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).assignExternalIdOperacionEnergia(IdOperacion, AssignExternalIdOperacionEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna el identificador externo de un trámite de energía.
     * @param {string} IdTramite 
     * @param {AssignExternalIdTramiteEnergiaModel} [AssignExternalIdTramiteEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public assignExternalIdTramiteEnergia(IdTramite: string, AssignExternalIdTramiteEnergiaModel?: AssignExternalIdTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).assignExternalIdTramiteEnergia(IdTramite, AssignExternalIdTramiteEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna un usuario como responsable de una operacion.
     * @param {string} Id 
     * @param {string} IdUsuario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public assignResponsableOperacion(Id: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).assignResponsableOperacion(Id, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna un usuario como responsable de un ticket.
     * @param {string} Id 
     * @param {string} IdUsuario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public assignResponsableTicket(Id: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).assignResponsableTicket(Id, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Autoregistro de una empresa de agentes.
     * @param {TipoEmpresaAgentesEnum} [TipoEmpresaAgentes] 
     * @param {FormaJuridicaEnum} [FormaJuridicaTitular] 
     * @param {string} [RazonSocial] 
     * @param {string} [NifCif] 
     * @param {string} [Email] 
     * @param {string} [DireccionCodigoPostal] 
     * @param {string} [DireccionProvincia] 
     * @param {string} [DireccionMunicipio] 
     * @param {string} [DireccionTipoVia] 
     * @param {string} [DireccionNombreVia] 
     * @param {string} [DireccionNumero] 
     * @param {string} [DireccionEscalera] 
     * @param {string} [DireccionPiso] 
     * @param {string} [DireccionPuerta] 
     * @param {string} [NombreRepresentante] 
     * @param {string} [NifRepresentante] 
     * @param {string} [EmailRepresentante] 
     * @param {string} [TelefonoRepresentante] 
     * @param {Array<DocumentacionAutoregistroPorTipoModel>} [Documentacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public autoregistroEmpresaAgentes(TipoEmpresaAgentes?: TipoEmpresaAgentesEnum, FormaJuridicaTitular?: FormaJuridicaEnum, RazonSocial?: string, NifCif?: string, Email?: string, DireccionCodigoPostal?: string, DireccionProvincia?: string, DireccionMunicipio?: string, DireccionTipoVia?: string, DireccionNombreVia?: string, DireccionNumero?: string, DireccionEscalera?: string, DireccionPiso?: string, DireccionPuerta?: string, NombreRepresentante?: string, NifRepresentante?: string, EmailRepresentante?: string, TelefonoRepresentante?: string, Documentacion?: Array<DocumentacionAutoregistroPorTipoModel>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).autoregistroEmpresaAgentes(TipoEmpresaAgentes, FormaJuridicaTitular, RazonSocial, NifCif, Email, DireccionCodigoPostal, DireccionProvincia, DireccionMunicipio, DireccionTipoVia, DireccionNombreVia, DireccionNumero, DireccionEscalera, DireccionPiso, DireccionPuerta, NombreRepresentante, NifRepresentante, EmailRepresentante, TelefonoRepresentante, Documentacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca como baja la operación de agua.
     * @param {string} Id 
     * @param {Date} [FechaBaja] 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public bajaOperacionAgua(Id: string, FechaBaja?: Date, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).bajaOperacionAgua(Id, FechaBaja, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Da de baja un servicio incluido en un trámite de energía de manera manual.
     * @param {string} IdOperacion 
     * @param {string} IdServicio 
     * @param {DeactivateServicioIncluidoTramiteEnergiaModel} [DeactivateServicioIncluidoTramiteEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public bajaServicioIncluidoTramiteEnergia(IdOperacion: string, IdServicio: string, DeactivateServicioIncluidoTramiteEnergiaModel?: DeactivateServicioIncluidoTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).bajaServicioIncluidoTramiteEnergia(IdOperacion, IdServicio, DeactivateServicioIncluidoTramiteEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Da de baja un trámite de energía de manera manual.
     * @param {string} IdOperacion 
     * @param {DeactivateTramiteEnergiaModel} [DeactivateTramiteEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public bajaTramiteEnergia(IdOperacion: string, DeactivateTramiteEnergiaModel?: DeactivateTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).bajaTramiteEnergia(IdOperacion, DeactivateTramiteEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cambia el estado libre del trámite de la operación indicada.
     * @param {string} IdOperacion 
     * @param {TipoSuministroTramiteEnergiaEnum} [TipoSuministro] 
     * @param {EstadoLibreTramiteEnergiaEnum} [NuevoEstado] 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cambiarEstadoLibreTramiteEnergia(IdOperacion: string, TipoSuministro?: TipoSuministroTramiteEnergiaEnum, NuevoEstado?: EstadoLibreTramiteEnergiaEnum, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cambiarEstadoLibreTramiteEnergia(IdOperacion, TipoSuministro, NuevoEstado, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancela un borrador de operación
     * @param {string} Id 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cancelBorradorOperacion(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cancelBorradorOperacion(Id, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancela el proceso de firma de docuemntación para el registro de una empresa de agentes.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cancelSignEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cancelSignEmpresaAgentes(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancela el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cancelarFirmaAutorizacionClienteInmobiliario(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cancelarFirmaAutorizacionClienteInmobiliario(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca como cancelada la operación de agua.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public cancelarOperacionAgua(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).cancelarOperacionAgua(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comprueba si el email o tel. móvil se ha usado en otras operaciones con distinto documento de identidad.
     * @param {string} [Email] 
     * @param {string} [TelMovil] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public checkPotentialFraudOperacion(Email?: string, TelMovil?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).checkPotentialFraudOperacion(Email, TelMovil, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo agente
     * @param {CreateAgenteModel} [CreateAgenteModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createAgente(CreateAgenteModel?: CreateAgenteModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createAgente(CreateAgenteModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo agente inmobiliario
     * @param {CreateAgenteInmobiliariaModel} [CreateAgenteInmobiliariaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createAgenteInmobiliaria(CreateAgenteInmobiliariaModel?: CreateAgenteInmobiliariaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createAgenteInmobiliaria(CreateAgenteInmobiliariaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un anexo de empresa de servicios.
     * @param {CreateAnexoEmpresaServiciosDto} [CreateAnexoEmpresaServiciosDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createAnexoEmpresaServicios(CreateAnexoEmpresaServiciosDto?: CreateAnexoEmpresaServiciosDto, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createAnexoEmpresaServicios(CreateAnexoEmpresaServiciosDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea la autorización de cesión de datos para un contacto lead.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createAutorizacionCesionDatosContactoLead(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createAutorizacionCesionDatosContactoLead(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea los borradores de operación
     * @param {CreateBorradoresOperacionModel} [CreateBorradoresOperacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createBorradoresOperacion(CreateBorradoresOperacionModel?: CreateBorradoresOperacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createBorradoresOperacion(CreateBorradoresOperacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo cliente inmobiliario.
     * @param {CreateClienteInmobiliarioModel} [CreateClienteInmobiliarioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createClienteInmobiliario(CreateClienteInmobiliarioModel?: CreateClienteInmobiliarioModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createClienteInmobiliario(CreateClienteInmobiliarioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una lista de comisiones de energia por oferta para un marco de comisiones.
     * @param {string} Id 
     * @param {string} IdMarco 
     * @param {Array<CreateComisionEnergiaOfertaModel>} [CreateComisionEnergiaOfertaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createComisionesEnergiaOferta(Id: string, IdMarco: string, CreateComisionEnergiaOfertaModel?: Array<CreateComisionEnergiaOfertaModel>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createComisionesEnergiaOferta(Id, IdMarco, CreateComisionEnergiaOfertaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una lista de comisiones de energia por servicio para un marco de comisiones.
     * @param {string} Id 
     * @param {string} IdMarco 
     * @param {Array<CreateComisionEnergiaServicioModel>} [CreateComisionEnergiaServicioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createComisionesEnergiaServicio(Id: string, IdMarco: string, CreateComisionEnergiaServicioModel?: Array<CreateComisionEnergiaServicioModel>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createComisionesEnergiaServicio(Id, IdMarco, CreateComisionEnergiaServicioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nueva comparacion de energia.
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createComparacionEnergia(File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createComparacionEnergia(File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo comunicado.
     * @param {TipoComunicadoEnum} [Tipo] 
     * @param {string} [Asunto] 
     * @param {string} [Cuerpo] 
     * @param {string} [TipoEmpresaAgenteDirigido] 
     * @param {Array<string>} [RolesDirigidos] 
     * @param {Array<string>} [EmpresasAgentesDirigidos] 
     * @param {Array<File>} [Adjuntos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createComunicado(Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createComunicado(Tipo, Asunto, Cuerpo, TipoEmpresaAgenteDirigido, RolesDirigidos, EmpresasAgentesDirigidos, Adjuntos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un criterio de retrocomisión de energia.
     * @param {string} IdEmpresa 
     * @param {CreateCriterioRetrocomisionEnergiaModel} [CreateCriterioRetrocomisionEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createCriterioRetrocomisionEnergia(IdEmpresa: string, CreateCriterioRetrocomisionEnergiaModel?: CreateCriterioRetrocomisionEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createCriterioRetrocomisionEnergia(IdEmpresa, CreateCriterioRetrocomisionEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una delegación de inmobiliaria.
     * @param {CreateDelegacionInmobiliariaModel} [CreateDelegacionInmobiliariaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createDelegacionInmobiliaria(CreateDelegacionInmobiliariaModel?: CreateDelegacionInmobiliariaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createDelegacionInmobiliaria(CreateDelegacionInmobiliariaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una empresa colaboradora.
     * @param {CreateEmpresaColaboradoraModel} [CreateEmpresaColaboradoraModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createEmpresaColaboradora(CreateEmpresaColaboradoraModel?: CreateEmpresaColaboradoraModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createEmpresaColaboradora(CreateEmpresaColaboradoraModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una empresa Inmobiliaria.
     * @param {CreateEmpresaInmobiliariaModel} [CreateEmpresaInmobiliariaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createEmpresaInmobiliaria(CreateEmpresaInmobiliariaModel?: CreateEmpresaInmobiliariaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createEmpresaInmobiliaria(CreateEmpresaInmobiliariaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una empresa de servicios.
     * @param {CreateEmpresaServiciosModel} [CreateEmpresaServiciosModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createEmpresaServicios(CreateEmpresaServiciosModel?: CreateEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createEmpresaServicios(CreateEmpresaServiciosModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una factura.
     * @param {CreateFacturaModel} [CreateFacturaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createFactura(CreateFacturaModel?: CreateFacturaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createFactura(CreateFacturaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un grupo de criterios de retrocomisión de energía.
     * @param {string} IdEmpresa 
     * @param {CreateGrupoCriterioRetrocomisionEnergiaModel} [CreateGrupoCriterioRetrocomisionEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createGrupoCriterioRetrocomisionEnergia(IdEmpresa: string, CreateGrupoCriterioRetrocomisionEnergiaModel?: CreateGrupoCriterioRetrocomisionEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createGrupoCriterioRetrocomisionEnergia(IdEmpresa, CreateGrupoCriterioRetrocomisionEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo inmueble.
     * @param {CreateInmuebleModel} [CreateInmuebleModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createInmueble(CreateInmuebleModel?: CreateInmuebleModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createInmueble(CreateInmuebleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo marco de comisiones
     * @param {CreateMarcoComisionesModel} [CreateMarcoComisionesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createMarcoComisiones(CreateMarcoComisionesModel?: CreateMarcoComisionesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createMarcoComisiones(CreateMarcoComisionesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nota para un borrador de operación.
     * @param {string} Id 
     * @param {CreateNotaBorradorOperacionModel} [CreateNotaBorradorOperacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createNotaBorradorOperacion(Id: string, CreateNotaBorradorOperacionModel?: CreateNotaBorradorOperacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createNotaBorradorOperacion(Id, CreateNotaBorradorOperacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nota para una operación.
     * @param {string} Id 
     * @param {CreateNotaOperacionModel} [CreateNotaOperacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createNotaOperacion(Id: string, CreateNotaOperacionModel?: CreateNotaOperacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createNotaOperacion(Id, CreateNotaOperacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una nota para un trámite de energía.
     * @param {string} IdTramite 
     * @param {CreateNotaTramiteEnergiaModel} [CreateNotaTramiteEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createNotaTramiteEnergia(IdTramite: string, CreateNotaTramiteEnergiaModel?: CreateNotaTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createNotaTramiteEnergia(IdTramite, CreateNotaTramiteEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una oferta de energía de Endesa.
     * @param {string} [Filename] 
     * @param {string} [RutaAnexoOferta] 
     * @param {CreateOfertaEndesaModel} [CreateOfertaEndesaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createOfertaEndesa(Filename?: string, RutaAnexoOferta?: string, CreateOfertaEndesaModel?: CreateOfertaEndesaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createOfertaEndesa(Filename, RutaAnexoOferta, CreateOfertaEndesaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una oferta de energía.
     * @param {string} [Filename] 
     * @param {string} [RutaAnexoOferta] 
     * @param {CreateOfertaEnergiaModel} [CreateOfertaEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createOfertaEnergia(Filename?: string, RutaAnexoOferta?: string, CreateOfertaEnergiaModel?: CreateOfertaEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createOfertaEnergia(Filename, RutaAnexoOferta, CreateOfertaEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una operación de agua.
     * @param {CreateOperacionAguaModel} [CreateOperacionAguaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createOperacionAgua(CreateOperacionAguaModel?: CreateOperacionAguaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createOperacionAgua(CreateOperacionAguaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea una operación de energía.
     * @param {CreateOperacionEnergiaModel} [CreateOperacionEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createOperacionEnergia(CreateOperacionEnergiaModel?: CreateOperacionEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createOperacionEnergia(CreateOperacionEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un rappel de energía.
     * @param {CreateRappelEnergiaModel} [CreateRappelEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createRappelEnergia(CreateRappelEnergiaModel?: CreateRappelEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createRappelEnergia(CreateRappelEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un servicio de endesa.
     * @param {string} [Filename] 
     * @param {string} [RutaAnexoServicio] 
     * @param {CreateServicioEndesaModel} [CreateServicioEndesaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createServicioEndesa(Filename?: string, RutaAnexoServicio?: string, CreateServicioEndesaModel?: CreateServicioEndesaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createServicioEndesa(Filename, RutaAnexoServicio, CreateServicioEndesaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un servicio de energía.
     * @param {string} [Filename] 
     * @param {string} [RutaAnexoServicio] 
     * @param {CreateServicioEnergiaModel} [CreateServicioEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createServicioEnergia(Filename?: string, RutaAnexoServicio?: string, CreateServicioEnergiaModel?: CreateServicioEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createServicioEnergia(Filename, RutaAnexoServicio, CreateServicioEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo ticket.
     * @param {CreateTicketModel} [CreateTicketModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createTicket(CreateTicketModel?: CreateTicketModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createTicket(CreateTicketModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un tipo de documento para una empresa de servicios.
     * @param {CreateTipoDocumentoEmpresaServiciosModel} [CreateTipoDocumentoEmpresaServiciosModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createTipoDocumentoEmpresaServicios(CreateTipoDocumentoEmpresaServiciosModel?: CreateTipoDocumentoEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createTipoDocumentoEmpresaServicios(CreateTipoDocumentoEmpresaServiciosModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo usuario
     * @param {CreateUserModel} [CreateUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createUsuario(CreateUserModel?: CreateUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).createUsuario(CreateUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un agente.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteAgente(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteAgente(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un agente inmobiliario.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteAgenteInmobiliaria(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteAgenteInmobiliaria(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un anexo de empresa de servicios.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteAnexoEmpresaServicios(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteAnexoEmpresaServicios(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un borrador de operación
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteBorradorOperacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteBorradorOperacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una comisión de energía por oferta.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteComisionEnergiaOferta(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteComisionEnergiaOferta(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una comisión de energía por servicio.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteComisionEnergiaServicio(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteComisionEnergiaServicio(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un comunicado.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteComunicado(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteComunicado(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un criterio de retrocomisión de energia.
     * @param {string} IdEmpresa 
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteCriterioRetrocomisionEnergia(IdEmpresa: string, Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteCriterioRetrocomisionEnergia(IdEmpresa, Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina o da de baja una delegación inmobiliaria en función del valor del parámetro \'borradoFisico\'.
     * @param {string} Id 
     * @param {boolean} [BorradoFisico] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteDelegacionInmobiliaria(Id: string, BorradoFisico?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteDelegacionInmobiliaria(Id, BorradoFisico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un documento adjunto de la empresa de agentes.
     * @param {string} Id 
     * @param {string} IdDocumento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteDocumentoEmpresaAgentes(Id: string, IdDocumento: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteDocumentoEmpresaAgentes(Id, IdDocumento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un documento adjuntado de la operación de agua.
     * @param {string} Id 
     * @param {string} IdDocumento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteDocumentoOperacionAgua(Id: string, IdDocumento: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteDocumentoOperacionAgua(Id, IdDocumento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un documento adjuntado de la operación de energía.
     * @param {string} Id 
     * @param {string} IdDocumento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteDocumentoOperacionEnergia(Id: string, IdDocumento: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteDocumentoOperacionEnergia(Id, IdDocumento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una empresa de agentes
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteEmpresaAgentes(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una empresa colaboradora.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteEmpresaColaboradora(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteEmpresaColaboradora(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una empresa inmobiliaria.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteEmpresaInmobiliaria(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteEmpresaInmobiliaria(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una empresa de servicios, con parámetro opcional de borrado físico.
     * @param {string} Id 
     * @param {boolean} [BorradoFisico] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteEmpresaServicios(Id: string, BorradoFisico?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteEmpresaServicios(Id, BorradoFisico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una factura de un inmueble.
     * @param {string} IdInmueble 
     * @param {string} IdFactura 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteFacturaInmueble(IdInmueble: string, IdFactura: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteFacturaInmueble(IdInmueble, IdFactura, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un inmueble.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteInmueble(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteInmueble(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una lectura de un inmueble.
     * @param {string} IdInmueble 
     * @param {string} IdLectura 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteLecturaInmueble(IdInmueble: string, IdLectura: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteLecturaInmueble(IdInmueble, IdLectura, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un marco de comisiones.
     * @param {string} Id 
     * @param {DeleteMarcoComisionesModel} [DeleteMarcoComisionesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteMarcoComisiones(Id: string, DeleteMarcoComisionesModel?: DeleteMarcoComisionesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteMarcoComisiones(Id, DeleteMarcoComisionesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina una oferta de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteOfertaEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteOfertaEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un rappel de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteRappelEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteRappelEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un relación existente de cliente inmobiliario con un inmueble.
     * @param {string} Id 
     * @param {string} IdRelacion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteRelacionClienteInmobiliarioInmueble(Id: string, IdRelacion: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteRelacionClienteInmobiliarioInmueble(Id, IdRelacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un servicio de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteServicioEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteServicioEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un tipo de documento de empresa de servicios.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteTipoDocumentoEmpresaServicios(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteTipoDocumentoEmpresaServicios(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un usuario.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deleteUsuario(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deleteUsuario(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deshace el estado actual de una operación de energía, devolviéndola al estado previo.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public deshacerEstadoOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).deshacerEstadoOperacionEnergia(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un enlace temporal al documento indicado
     * @param {string} [Key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public documentosGenerateTempUrl(Key?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).documentosGenerateTempUrl(Key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Genera un zip con los ficheros asociados a una operación de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public downloadFicheroEmpresaServicios(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).downloadFicheroEmpresaServicios(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplica un marco de comisiones.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public duplicateMarcoComisiones(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).duplicateMarcoComisiones(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplica una oferta de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public duplicateOfertaEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).duplicateOfertaEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplica un servicio de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public duplicateServicioEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).duplicateServicioEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un agente existente
     * @param {EditAgenteModel} [EditAgenteModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editAgente(EditAgenteModel?: EditAgenteModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editAgente(EditAgenteModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un agente inmobiliario existente
     * @param {EditAgenteInmobiliariaModel} [EditAgenteInmobiliariaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editAgenteInmobiliaria(EditAgenteInmobiliariaModel?: EditAgenteInmobiliariaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editAgenteInmobiliaria(EditAgenteInmobiliariaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un anexo de empresa de servicios.
     * @param {EditAnexoEmpresaServiciosDto} [EditAnexoEmpresaServiciosDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editAnexoEmpresaServicios(EditAnexoEmpresaServiciosDto?: EditAnexoEmpresaServiciosDto, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editAnexoEmpresaServicios(EditAnexoEmpresaServiciosDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un cliente inmobiliario existente
     * @param {EditClienteInmobiliarioModel} [EditClienteInmobiliarioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editClienteInmobiliario(EditClienteInmobiliarioModel?: EditClienteInmobiliarioModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editClienteInmobiliario(EditClienteInmobiliarioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza una comisión de energia por oferta.
     * @param {EditComisionEnergiaOfertaModel} [EditComisionEnergiaOfertaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editComisionEnergiaOferta(EditComisionEnergiaOfertaModel?: EditComisionEnergiaOfertaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editComisionEnergiaOferta(EditComisionEnergiaOfertaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza una comisión de energia por servicio.
     * @param {EditComisionEnergiaServicioModel} [EditComisionEnergiaServicioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editComisionEnergiaServicio(EditComisionEnergiaServicioModel?: EditComisionEnergiaServicioModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editComisionEnergiaServicio(EditComisionEnergiaServicioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un comunicado existente.
     * @param {string} [Id] 
     * @param {Array<string>} [IdsAdjuntosExistentes] 
     * @param {TipoComunicadoEnum} [Tipo] 
     * @param {string} [Asunto] 
     * @param {string} [Cuerpo] 
     * @param {string} [TipoEmpresaAgenteDirigido] 
     * @param {Array<string>} [RolesDirigidos] 
     * @param {Array<string>} [EmpresasAgentesDirigidos] 
     * @param {Array<File>} [Adjuntos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editComunicado(Id?: string, IdsAdjuntosExistentes?: Array<string>, Tipo?: TipoComunicadoEnum, Asunto?: string, Cuerpo?: string, TipoEmpresaAgenteDirigido?: string, RolesDirigidos?: Array<string>, EmpresasAgentesDirigidos?: Array<string>, Adjuntos?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editComunicado(Id, IdsAdjuntosExistentes, Tipo, Asunto, Cuerpo, TipoEmpresaAgenteDirigido, RolesDirigidos, EmpresasAgentesDirigidos, Adjuntos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un criterio de retrocomisión de energia.
     * @param {string} IdEmpresa 
     * @param {EditCriterioRetrocomisionEnergiaModel} [EditCriterioRetrocomisionEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editCriterioRetrocomisionEnergia(IdEmpresa: string, EditCriterioRetrocomisionEnergiaModel?: EditCriterioRetrocomisionEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editCriterioRetrocomisionEnergia(IdEmpresa, EditCriterioRetrocomisionEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita los datos personales del agente actual
     * @param {EditAgentePersonalDataModel} [EditAgentePersonalDataModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editCurrentAgentePersonalData(EditAgentePersonalDataModel?: EditAgentePersonalDataModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editCurrentAgentePersonalData(EditAgentePersonalDataModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una empresa de servicios.
     * @param {EditDelegacionInmobiliariaModel} [EditDelegacionInmobiliariaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editDelegacionInmobiliaria(EditDelegacionInmobiliariaModel?: EditDelegacionInmobiliariaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editDelegacionInmobiliaria(EditDelegacionInmobiliariaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una empresa colaboradora.
     * @param {EditEmpresaColaboradoraModel} [EditEmpresaColaboradoraModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editEmpresaColaboradora(EditEmpresaColaboradoraModel?: EditEmpresaColaboradoraModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editEmpresaColaboradora(EditEmpresaColaboradoraModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una empresa Inmobiliaria.
     * @param {EditEmpresaInmobiliariaModel} [EditEmpresaInmobiliariaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editEmpresaInmobiliaria(EditEmpresaInmobiliariaModel?: EditEmpresaInmobiliariaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editEmpresaInmobiliaria(EditEmpresaInmobiliariaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una empresa de servicios.
     * @param {EditEmpresaServiciosModel} [EditEmpresaServiciosModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editEmpresaServicios(EditEmpresaServiciosModel?: EditEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editEmpresaServicios(EditEmpresaServiciosModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un inmueble existente
     * @param {EditInmuebleModel} [EditInmuebleModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editInmueble(EditInmuebleModel?: EditInmuebleModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editInmueble(EditInmuebleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un marco de comisiones existente
     * @param {EditMarcoComisionesModel} [EditMarcoComisionesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editMarcoComisiones(EditMarcoComisionesModel?: EditMarcoComisionesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editMarcoComisiones(EditMarcoComisionesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza el marco de comisiones de una empresa de agentes.
     * @param {string} Id 
     * @param {EditMarcoComisionesEmpresaAgentesModel} [EditMarcoComisionesEmpresaAgentesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editMarcoComisionesEmpresaAgentes(Id: string, EditMarcoComisionesEmpresaAgentesModel?: EditMarcoComisionesEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editMarcoComisionesEmpresaAgentes(Id, EditMarcoComisionesEmpresaAgentesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una nota de un borrador de operación.
     * @param {string} Id 
     * @param {EditNotaBorradorOperacionModel} [EditNotaBorradorOperacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editNotaBorradorOperacion(Id: string, EditNotaBorradorOperacionModel?: EditNotaBorradorOperacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editNotaBorradorOperacion(Id, EditNotaBorradorOperacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una nota de una operación.
     * @param {string} Id 
     * @param {EditNotaOperacionModel} [EditNotaOperacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editNotaOperacion(Id: string, EditNotaOperacionModel?: EditNotaOperacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editNotaOperacion(Id, EditNotaOperacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una nota de un trámite de energía.
     * @param {string} Id 
     * @param {EditNotaTramiteEnergiaModel} [EditNotaTramiteEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editNotaTramiteEnergia(Id: string, EditNotaTramiteEnergiaModel?: EditNotaTramiteEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editNotaTramiteEnergia(Id, EditNotaTramiteEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una oferta de Endesa.
     * @param {EditOfertaEndesaModel} [EditOfertaEndesaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editOfertaEndesa(EditOfertaEndesaModel?: EditOfertaEndesaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editOfertaEndesa(EditOfertaEndesaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una oferta de energía.
     * @param {EditOfertaEnergiaModel} [EditOfertaEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editOfertaEnergia(EditOfertaEnergiaModel?: EditOfertaEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editOfertaEnergia(EditOfertaEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una operación de agua.
     * @param {EditOperacionAguaModel} [EditOperacionAguaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editOperacionAgua(EditOperacionAguaModel?: EditOperacionAguaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editOperacionAgua(EditOperacionAguaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una operación de energía.
     * @param {EditOperacionEnergiaModel} [EditOperacionEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editOperacionEnergia(EditOperacionEnergiaModel?: EditOperacionEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editOperacionEnergia(EditOperacionEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un rappel de energía.
     * @param {EditRappelEnergiaModel} [EditRappelEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editRappelEnergia(EditRappelEnergiaModel?: EditRappelEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editRappelEnergia(EditRappelEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece o elimina el reajuste de comisión de oferta de energía para una empresa de agentes.
     * @param {string} Id 
     * @param {EditReajusteComisionEnergiaOfertaEmpresaAgentesModel} [EditReajusteComisionEnergiaOfertaEmpresaAgentesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editReajusteComisionEnergiaOfertaEmpresaAgentes(Id: string, EditReajusteComisionEnergiaOfertaEmpresaAgentesModel?: EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editReajusteComisionEnergiaOfertaEmpresaAgentes(Id, EditReajusteComisionEnergiaOfertaEmpresaAgentesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece o elimina el reajuste de comisión de servicio de energía para una empresa de agentes.
     * @param {string} Id 
     * @param {EditReajusteComisionEnergiaServicioEmpresaAgentesModel} [EditReajusteComisionEnergiaServicioEmpresaAgentesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editReajusteComisionEnergiaServicioEmpresaAgentes(Id: string, EditReajusteComisionEnergiaServicioEmpresaAgentesModel?: EditReajusteComisionEnergiaServicioEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editReajusteComisionEnergiaServicioEmpresaAgentes(Id, EditReajusteComisionEnergiaServicioEmpresaAgentesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece o elimina el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
     * @param {string} Id 
     * @param {EditReajusteMarcoComisionEmpresaAgentesModel} [EditReajusteMarcoComisionEmpresaAgentesModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editReajusteMarcoComisionEmpresaAgentes(Id: string, EditReajusteMarcoComisionEmpresaAgentesModel?: EditReajusteMarcoComisionEmpresaAgentesModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editReajusteMarcoComisionEmpresaAgentes(Id, EditReajusteMarcoComisionEmpresaAgentesModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una relación existente de cliente inmobiliario con un inmueble.
     * @param {string} Id 
     * @param {EditRelacionClienteInmobiliarioInmuebleModel} [EditRelacionClienteInmobiliarioInmuebleModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editRelacionClienteInmobiliarioInmueble(Id: string, EditRelacionClienteInmobiliarioInmuebleModel?: EditRelacionClienteInmobiliarioInmuebleModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editRelacionClienteInmobiliarioInmueble(Id, EditRelacionClienteInmobiliarioInmuebleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un servicio de Endesa.
     * @param {EditServicioEndesaModel} [EditServicioEndesaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editServicioEndesa(EditServicioEndesaModel?: EditServicioEndesaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editServicioEndesa(EditServicioEndesaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un servicio de energía.
     * @param {EditServicioEnergiaModel} [EditServicioEnergiaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editServicioEnergia(EditServicioEnergiaModel?: EditServicioEnergiaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editServicioEnergia(EditServicioEnergiaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un tipo de documento de empresa de servicios.
     * @param {EditTipoDocumentoEmpresaServiciosModel} [EditTipoDocumentoEmpresaServiciosModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editTipoDocumentoEmpresaServicios(EditTipoDocumentoEmpresaServiciosModel?: EditTipoDocumentoEmpresaServiciosModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editTipoDocumentoEmpresaServicios(EditTipoDocumentoEmpresaServiciosModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un usuario existente
     * @param {EditUserModel} [EditUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public editUsuario(EditUserModel?: EditUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).editUsuario(EditUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envía un comunicado.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public enviarComunicado(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).enviarComunicado(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envia una operación de energía a backoffice.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public enviarOperacionEnergiaBackoffice(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).enviarOperacionEnergiaBackoffice(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envia un recordatorio para la firma de la autorización de tratamiento de datos de cliente inmobiliario
     * @param {string} Id 
     * @param {string} [Email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public enviarRecordatorioFirmaAutorizacionClienteInmobiliario(Id: string, Email?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).enviarRecordatorioFirmaAutorizacionClienteInmobiliario(Id, Email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comprueba si existe un contacto lead cuyo teléfono coincide con el indicado.
     * @param {ExistsContactoLeadByMobileModel} [ExistsContactoLeadByMobileModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public existsContactoLeadByMobile(ExistsContactoLeadByMobileModel?: ExistsContactoLeadByMobileModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).existsContactoLeadByMobile(ExistsContactoLeadByMobileModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exporta las condiciones económicas de comisiones para una empresa de agentes desde backoffice.
     * @param {string} Id 
     * @param {string} [IdEmpresaServicios] 
     * @param {string} [IdMarcoComisiones] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public exportComisionesComercializadoraEmpresaAgentesExcel(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).exportComisionesComercializadoraEmpresaAgentesExcel(Id, IdEmpresaServicios, IdMarcoComisiones, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exporta las condiciones económicas de comisiones a PDF para una empresa de agentes desde backoffice.
     * @param {string} Id 
     * @param {string} [IdEmpresaServicios] 
     * @param {string} [IdMarcoComisiones] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public exportComisionesComercializadoraEmpresaAgentesPdf(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).exportComisionesComercializadoraEmpresaAgentesPdf(Id, IdEmpresaServicios, IdMarcoComisiones, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exporta las condiciones económicas de comisiones para la empresa de agentes del colaborador autenticado.
     * @param {string} [IdEmpresaServicios] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public exportComisionesComercializadoraMiEmpresaExcel(IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).exportComisionesComercializadoraMiEmpresaExcel(IdEmpresaServicios, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exporta las condiciones económicas de comisiones a PDF para la empresa de agentes del colaborador autenticado.
     * @param {string} [IdEmpresaServicios] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public exportComisionesComercializadoraMiEmpresaPdf(IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).exportComisionesComercializadoraMiEmpresaPdf(IdEmpresaServicios, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene valor de activación de una feature
     * @param {string} FeatureName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).featuresGet(FeatureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de feature flags y valor de activación
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public featuresList(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).featuresList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finaliza el proceso de firma de una autorización de tratamiento de datos de cliente inmobiliario.
     * @param {string} [Id] 
     * @param {Array<File>} [DocumentosFirmados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public finalizarProcesoFirmaAutorizacionClienteInmobiliario(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).finalizarProcesoFirmaAutorizacionClienteInmobiliario(Id, DocumentosFirmados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finaliza el proceso de firma de contrato de una empresa de agentes.
     * @param {string} [Id] 
     * @param {Array<File>} [DocumentosFirmados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public finalizarProcesoFirmaEmpresaAgentes(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).finalizarProcesoFirmaEmpresaAgentes(Id, DocumentosFirmados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finaliza el proceso de firma de una operación energía.
     * @param {string} [Id] 
     * @param {Array<File>} [DocumentosFirmados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public finalizarProcesoFirmaOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).finalizarProcesoFirmaOperacionEnergia(Id, DocumentosFirmados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finaliza el proceso de firma de una operación energía.
     * @param {string} [Id] 
     * @param {Array<File>} [DocumentosFirmados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public firmaAutorizacionOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).firmaAutorizacionOperacionEnergia(Id, DocumentosFirmados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finaliza el proceso de firma del consentimiento previo de una operación energía.
     * @param {string} [Id] 
     * @param {Array<File>} [DocumentosFirmados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public firmaConsentimientoPrevioOperacionEnergia(Id?: string, DocumentosFirmados?: Array<File>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).firmaConsentimientoPrevioOperacionEnergia(Id, DocumentosFirmados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece una operación de energía como firmada.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public firmarOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).firmarOperacionEnergia(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Genera el consentimiento previo de una operación de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public generarConsentimientoPrevioOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).generarConsentimientoPrevioOperacionEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Genera el contrato de una operación energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public generarContratoOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).generarContratoOperacionEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Genera y descarga el borrador de una factura.
     * @param {CreateFacturaModel} [CreateFacturaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public generateBorradorFactura(CreateFacturaModel?: CreateFacturaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).generateBorradorFactura(CreateFacturaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una comparación dado su id
     * @param {string} Id 
     * @param {Array<number>} [RequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public generateComparacionEnergiaPdf(Id: string, RequestBody?: Array<number>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).generateComparacionEnergiaPdf(Id, RequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el agente dado su id de usuario
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAgenteById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAgenteById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el agente de inmobiliaria dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAgenteInmobiliariaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAgenteInmobiliariaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de agentes para la grid de DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAgentesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAgentesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de agentes de inmobiliaria dada la delegación
     * @param {string} [IdDelegacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAgentesInmobiliariaByDelegacionSelector(IdDelegacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAgentesInmobiliariaByDelegacionSelector(IdDelegacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de agentes de inmobiliaria para la grid de DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAgentesInmobiliariaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAgentesInmobiliariaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de agentes para selectores de DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAgentesSelector(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAgentesSelector(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de un anexo de empresa de servicios.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAnexoEmpresaServiciosById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAnexoEmpresaServiciosById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los anexos de empresa de servicios para la grid de Devextreme.
     * @param {string} [IdEmpresaServicios] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getAnexosEmpresaServiciosForGrid(IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getAnexosEmpresaServiciosForGrid(IdEmpresaServicios, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de un borrador de operación.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getBorradorOperacionDetail(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getBorradorOperacionDetail(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de borradores de operaciones de agua para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getBorradoresOperacionAguaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getBorradoresOperacionAguaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de borradores de operaciones de energía para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getBorradoresOperacionEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getBorradoresOperacionEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle del cliente inmobiliario dado su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getClienteInmobiliarioById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getClienteInmobiliarioById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle del cliente inmobiliario dado su id.
     * @param {string} Id 
     * @param {string} IdRelacion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getClienteInmuebleById(Id: string, IdRelacion: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getClienteInmuebleById(Id, IdRelacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos más recientes de un cliente dado su documento de identidad o CIF para las operaciones del usuario actual
     * @param {string} [DocumentoIdentidad] 
     * @param {string} [Cif] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getClienteLatestInfoForCurrentUser(DocumentoIdentidad?: string, Cif?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getClienteLatestInfoForCurrentUser(DocumentoIdentidad, Cif, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de clientes de un agente para la grid de Devextreme a partir de sus operaciones.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getClientesAgenteForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getClientesAgenteForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de clientes de la empresa inmobiliaria del agente que hace la petición para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdInmueble] 
     * @param {boolean} [PuedeCrearBorrador] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getClientesEmpresaInmobiliariaForGrid(LoadOptions?: DXLoadOptions, IdInmueble?: string, PuedeCrearBorrador?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getClientesEmpresaInmobiliariaForGrid(LoadOptions, IdInmueble, PuedeCrearBorrador, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de clientes para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getClientesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getClientesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de relaciones de clientes inmobiliarios con un inmueble para la grid de Devextreme.
     * @param {string} Id 
     * @param {TipoRelacionClienteInmobiliarioEnum} [TipoRelacion] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getClientesInmuebleForGrid(Id: string, TipoRelacion?: TipoRelacionClienteInmobiliarioEnum, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getClientesInmuebleForGrid(Id, TipoRelacion, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de CNAEs para su uso en un selector.
     * @param {string} [IdEmpresaServicios] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCnaeSelector(IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCnaeSelector(IdEmpresaServicios, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de los cometidos de agentes de inmobiliaria para su uso en un selector.
     * @param {object} [Model] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCometidoAgentesInmobiliariaSelector(Model?: object, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCometidoAgentesInmobiliariaSelector(Model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las comisiones por marco de comision para una oferta dado el id de oferta
     * @param {string} Id 
     * @param {string} IdMarco 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComisionesPorMarcoByIdOferta(Id: string, IdMarco: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComisionesPorMarcoByIdOferta(Id, IdMarco, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las comisiones por marco de comision para un servicio dado el id de servicio
     * @param {string} Id 
     * @param {string} IdMarco 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComisionesPorMarcoByIdServicio(Id: string, IdMarco: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComisionesPorMarcoByIdServicio(Id, IdMarco, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de comparaciones de energia del agente que hace la petición para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComparacionesEnergiaAgenteForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComparacionesEnergiaAgenteForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de comunicaciones de una operación.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComunicacionesOperacionById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComunicacionesOperacionById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de un comunicado por su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComunicadoDetail(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComunicadoDetail(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de un comunicado dirigido al colaborador autenticado.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComunicadoDetailForColaborador(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComunicadoDetailForColaborador(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Consulta si un comunicado ha sido leído por un agente a partir de su email.
     * @param {string} Id 
     * @param {string} [Email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComunicadoLecturaAgente(Id: string, Email?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComunicadoLecturaAgente(Id, Email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de comunicados para la grid de DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComunicadosForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComunicadosForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de comunicados para la grid de DevExtreme de un colaborador.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComunicadosForGridColaborador(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComunicadosForGridColaborador(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los ids de los comunicados de portal sin leer del colaborador autenticado.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getComunicadosPortalSinLeerForColaborador(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getComunicadosPortalSinLeerForColaborador(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de contactos lead para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getContactosLeadForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getContactosLeadForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de agentes, con rol de coordinador de delegación, para una empresa inmobiliaria dado su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCoordinadoresDelegacionSelector(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCoordinadoresDelegacionSelector(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el criterio de retrocomision de energia para una empresa y dado su id
     * @param {string} IdEmpresa 
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCriterioRetrocomisionEnergiaById(IdEmpresa: string, Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCriterioRetrocomisionEnergiaById(IdEmpresa, Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de criterios de retrocomision de energia para una empresa y un grupo de configuración
     * @param {string} Id 
     * @param {string} [IdGrupo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCriteriosRetrocomisionEnergiaByIdEmpresa(Id: string, IdGrupo?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCriteriosRetrocomisionEnergiaByIdEmpresa(Id, IdGrupo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos personales del agente actual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getCurrentAgentePersonalData(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getCurrentAgentePersonalData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los datos de un punto de suministro a partir de su Cups.
     * @param {string} Codigo 
     * @param {string} [IdEmpresaServicios] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDatosPuntoSuministro(Codigo: string, IdEmpresaServicios?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDatosPuntoSuministro(Codigo, IdEmpresaServicios, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la delegación inmobiliaria dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDelegacionInmobiliariaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDelegacionInmobiliariaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
     * @param {object} [Model] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDelegacionInmobiliariaSelector(Model?: object, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDelegacionInmobiliariaSelector(Model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de las delegaciones de inmobiliaria para su uso en un selector.
     * @param {string} IdInmobiliaria 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDelegacionInmobiliariaSelectorByInmobiliaria(IdInmobiliaria: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDelegacionInmobiliariaSelectorByInmobiliaria(IdInmobiliaria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de delegaciones inmobiliarias para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDelegacionesInmobiliariasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDelegacionesInmobiliariasForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
     * @param {string} [IdEmpresaServicios] 
     * @param {Array<string>} [IdsOfertaEnergia] 
     * @param {Array<string>} [IdsServicioEnergia] 
     * @param {string} [IdOperacionEnergia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDescuentosEnergiaAplicables(IdEmpresaServicios?: string, IdsOfertaEnergia?: Array<string>, IdsServicioEnergia?: Array<string>, IdOperacionEnergia?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDescuentosEnergiaAplicables(IdEmpresaServicios, IdsOfertaEnergia, IdsServicioEnergia, IdOperacionEnergia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una comparación dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDetailComparacionEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDetailComparacionEnergiaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Documentos de firma que deben aportarse firmados a mano (misma lógica que la firma digital).
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getDocumentosFirmaManualOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getDocumentosFirmaManualOperacionEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una empresa de agentes por su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaAgentesDetail(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaAgentesDetail(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de las empresas de agentes para su uso en un selector.
     * @param {Array<string>} [Tipos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaAgentesSelector(Tipos?: Array<string>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaAgentesSelector(Tipos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la empresa colaboradora dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaColaboradoraById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaColaboradoraById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la empresa colaboradora dado el usuario que lo solicita
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaColaboradoraByUserId(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaColaboradoraByUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la empresa inmobiliaria dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaInmobiliariaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaInmobiliariaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de la empresa inmobiliaria asociada al usuario que realiza la petición
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaInmobiliariaUsuarioRequest(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaInmobiliariaUsuarioRequest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la empresa de servicios de energía dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaServiciosAguaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaServiciosAguaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la empresa de servicios de energía dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresaServiciosEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresaServiciosEnergiaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de empresas de agentes para la rejilla DevExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasAgentesForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasAgentesForGrid(LoadOptions, IdsEstados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de empresas colaboradoras para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasColaboradoraForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasColaboradoraForGrid(LoadOptions, IdsEstados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de empresas inmobiliarias para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {Array<EstadoEmpresaAgentesEnum>} [IdsEstados] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasInmobiliariasForGrid(LoadOptions?: DXLoadOptions, IdsEstados?: Array<EstadoEmpresaAgentesEnum>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasInmobiliariasForGrid(LoadOptions, IdsEstados, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de empresas de servicio de agua para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasServiciosAguaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasServiciosAguaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las empresas de servicio de agua que operan en una provincia concreta dado el codigo postal.
     * @param {string} [CodigoPostal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasServiciosAguaOperables(CodigoPostal?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasServiciosAguaOperables(CodigoPostal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de empresas de servicio de energía para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasServiciosEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasServiciosEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las empresas de servicio dado el tipo de empresa indicado.
     * @param {string} [IdEmpresaAgentes] 
     * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasServiciosOperables(IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasServiciosOperables(IdEmpresaAgentes, Tipos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa, operables para la empresa de agentes indicada o, en su defecto, la del usuario que hace la petición.
     * @param {string} [IdEmpresaAgentes] 
     * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasServiciosOperablesSelector(IdEmpresaAgentes?: string, Tipos?: Array<TipoEmpresaServiciosEnum>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasServiciosOperablesSelector(IdEmpresaAgentes, Tipos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de empresas de servicio con un filtro opcional de tipos de empresa.
     * @param {Array<TipoEmpresaServiciosEnum>} [Tipos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEmpresasServiciosSelector(Tipos?: Array<TipoEmpresaServiciosEnum>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEmpresasServiciosSelector(Tipos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la estructura documental requerida para una empresa de agentes (configuración y documentos ya adjuntos).
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEstructuraDocumentalEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEstructuraDocumentalEmpresaAgentes(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la estructura documental requerida para una empresa de agentes según su forma jurídica.
     * @param {FormaJuridicaEnum} [FormaJuridica] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEstructuraDocumentalEmpresaAgentesByFormaJuridica(FormaJuridica?: FormaJuridicaEnum, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEstructuraDocumentalEmpresaAgentesByFormaJuridica(FormaJuridica, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la estructura documental de una empresa de servicios, con filtro opcional de tipo de persona (física o jurídica).
     * @param {string} Id 
     * @param {TipoPersonaEnum} [TipoPersona] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEstructuraDocumentalEmpresaServicios(Id: string, TipoPersona?: TipoPersonaEnum, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEstructuraDocumentalEmpresaServicios(Id, TipoPersona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dada una operación, obtiene su estructura documental.
     * @param {string} Id 
     * @param {boolean} [IncluirArchivosSistema] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getEstructuraDocumentalOperacionEnergia(Id: string, IncluirArchivosSistema?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getEstructuraDocumentalOperacionEnergia(Id, IncluirArchivosSistema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Genera y descarga el Excel para su importación en Repsol.
     * @param {Array<string>} [RequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getExportacionExcelRepsol(RequestBody?: Array<string>, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getExportacionExcelRepsol(RequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una factura por su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFacturaDetailById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFacturaDetailById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de facturas para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFacturasForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFacturasForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de facturas del agente creador seleccionado para soporte.
     * @param {string} [IdUsuario] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFacturasForGridSoporte(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFacturasForGridSoporte(IdUsuario, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
     * @param {string} Id 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFacturasInmuebleForGrid(Id: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFacturasInmuebleForGrid(Id, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de facturas para la empresa de agentes del agente que hace la petición para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getFacturasMyCompanyForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getFacturasMyCompanyForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de grupos de criterios de retrocomisión de energía para una empresa dado el id de empresa
     * @param {string} IdEmpresa 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getGruposCriteriosRetrocomisionEnergiaByIdEmpresa(IdEmpresa: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getGruposCriteriosRetrocomisionEnergiaByIdEmpresa(IdEmpresa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle del inmueble dado su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getInmuebleById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getInmuebleById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de inmuebles para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdClienteInmobiliario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getInmueblesForGrid(LoadOptions?: DXLoadOptions, IdClienteInmobiliario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getInmueblesForGrid(LoadOptions, IdClienteInmobiliario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de facturas de un inmueble para la grid de Devextreme.
     * @param {string} Id 
     * @param {TipoSuministroInmuebleEnum} [TipoSuministro] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getLecturasInmuebleForGrid(Id: string, TipoSuministro?: TipoSuministroInmuebleEnum, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getLecturasInmuebleForGrid(Id, TipoSuministro, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de trámites de energia para el agente para la grid de liquidaciones de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getLiquidacionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getLiquidacionesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de agentes a los que se ha enviado un comunicado.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoAgentesComunicado(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoAgentesComunicado(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de notas de un borrador de operación.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoNotasBorradorOperacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoNotasBorradorOperacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de notas de una operación.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoNotasOperacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoNotasOperacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de notas de un trámite de energía.
     * @param {string} IdTramite 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getListadoNotasTramiteEnergia(IdTramite: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getListadoNotasTramiteEnergia(IdTramite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el logo de la empresa si lo hubiera.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getLogoPortalEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getLogoPortalEmpresaAgentes(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de marcos de comisiones para la grid de DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMarcosComisionesForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMarcosComisionesForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de marcos de comisiones.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getMarcosComisionesList(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getMarcosComisionesList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el modelo de datos con el que confeccionar la siguiente factura para la empresa de agentes del agente que hace la petición
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getNextFacturaConfig(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getNextFacturaConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las notificaciones para el usuario actual.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getNotificaciones(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getNotificaciones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la oferta de Endesa dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOfertaEndesaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOfertaEndesaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la oferta de energia dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOfertaEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOfertaEnergiaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las ofertas de energía para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOfertasEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOfertasEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado paginado de ofertas de energía.
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {Array<string>} [FiltrosComercializadoras] 
     * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
     * @param {string} [FiltrosTarifaAcceso] 
     * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
     * @param {boolean} [FiltrosConAutoconsumo] 
     * @param {number} [FiltrosPotenciaMin] 
     * @param {number} [FiltrosPotenciaMax] 
     * @param {Date} [FiltrosFechaInicio] 
     * @param {Date} [FiltrosFechaFin] 
     * @param {string} [FiltrosTexto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOfertasEnergiaList(Take?: number, Skip?: number, FiltrosComercializadoras?: Array<string>, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTarifaAcceso?: string, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, FiltrosFechaInicio?: Date, FiltrosFechaFin?: Date, FiltrosTexto?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOfertasEnergiaList(Take, Skip, FiltrosComercializadoras, FiltrosTipoEnergia, FiltrosTarifaAcceso, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, FiltrosFechaInicio, FiltrosFechaFin, FiltrosTexto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las ofertas de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
     * @param {string} Id 
     * @param {TipoPersonaEnum} TipoPersona 
     * @param {string} [IdOperacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOfertasEnergiaOperables(Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOfertasEnergiaOperables(Id, TipoPersona, IdOperacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado paginado de ofertas de energía con retribuciones para backoffice.
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {string} [FiltrosEmpresaAgentes] 
     * @param {string} [FiltrosMarcoComisiones] 
     * @param {string} [FiltrosComercializadora] 
     * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
     * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
     * @param {boolean} [FiltrosConAutoconsumo] 
     * @param {number} [FiltrosPotenciaMin] 
     * @param {number} [FiltrosPotenciaMax] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOfertasEnergiaRetribucionesBackofficeList(Take?: number, Skip?: number, FiltrosEmpresaAgentes?: string, FiltrosMarcoComisiones?: string, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOfertasEnergiaRetribucionesBackofficeList(Take, Skip, FiltrosEmpresaAgentes, FiltrosMarcoComisiones, FiltrosComercializadora, FiltrosTipoEnergia, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado paginado de ofertas de energía con retribuciones para colaboradores.
     * @param {number} [Take] 
     * @param {number} [Skip] 
     * @param {string} [FiltrosComercializadora] 
     * @param {TipoSuministroTramiteEnergiaEnum} [FiltrosTipoEnergia] 
     * @param {TipoPersonaEnum} [FiltrosTipoPersona] 
     * @param {boolean} [FiltrosConAutoconsumo] 
     * @param {number} [FiltrosPotenciaMin] 
     * @param {number} [FiltrosPotenciaMax] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOfertasEnergiaRetribucionesColaboradoresList(Take?: number, Skip?: number, FiltrosComercializadora?: string, FiltrosTipoEnergia?: TipoSuministroTramiteEnergiaEnum, FiltrosTipoPersona?: TipoPersonaEnum, FiltrosConAutoconsumo?: boolean, FiltrosPotenciaMin?: number, FiltrosPotenciaMax?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOfertasEnergiaRetribucionesColaboradoresList(Take, Skip, FiltrosComercializadora, FiltrosTipoEnergia, FiltrosTipoPersona, FiltrosConAutoconsumo, FiltrosPotenciaMin, FiltrosPotenciaMax, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una operación de agua.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionAguaDetail(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionAguaDetail(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una operación de energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionEnergiaDetail(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionEnergiaDetail(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de una comparación de energía.
     * @param {string} IdComparacion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionEnergiaDetailFromComparison(IdComparacion: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionEnergiaDetailFromComparison(IdComparacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de una operación de energía a partir de los datos extraídos de un inmueble.
     * @param {string} IdInmueble 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionEnergiaDetailFromProperty(IdInmueble: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionEnergiaDetailFromProperty(IdInmueble, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de operaciones de agua para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionesAguaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionesAguaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el histórico de estados de las operaciones de agua.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {string} [IdOperacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionesAguaHistoricoEstados(LoadOptions?: DXLoadOptions, IdOperacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionesAguaHistoricoEstados(LoadOptions, IdOperacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de operaciones de un cliente.
     * @param {string} [IdCliente] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionesByIdCliente(IdCliente?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionesByIdCliente(IdCliente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de operaciones de energia para el cliente de un agente para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionesEnergiaAgenteForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionesEnergiaAgenteForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de operaciones de energia para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionesEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el histórico de estados de las operaciones.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getOperacionesHistoricoEstados(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getOperacionesHistoricoEstados(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la plantilla de autorización de tratamiento de datos de un cliente inmobiliario, lista para firmar.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPlantillaAutorizacionClienteInmobiliario(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPlantillaAutorizacionClienteInmobiliario(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de las prioridades de ticket para su uso en un selector.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPrioridadesTicketSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPrioridadesTicketSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de provincias.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getProvincias(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getProvincias(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la información pública de la empresa inmobiliaria asociada al usuario que realiza la petición
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getPublicInformationSelfEmpresaInmobiliaria(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getPublicInformationSelfEmpresaInmobiliaria(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el rappel de energia dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRappelEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRappelEnergiaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los rappels de energía para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRappelsEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRappelsEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los rappels de energía mensuales asociadas a una factura para la subrejilla de factura de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRappelsMensualesEnergiaFacturaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRappelsMensualesEnergiaFacturaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los rappels de energía mensuales para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRappelsMensualesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRappelsMensualesEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el porcentaje de reajuste de marco de comisiones para una empresa de agentes, empresa de servicios y marco de comisiones.
     * @param {string} Id 
     * @param {string} [IdEmpresaServicios] 
     * @param {string} [IdMarcoComisiones] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getReajusteMarcoComisionEmpresaAgentes(Id: string, IdEmpresaServicios?: string, IdMarcoComisiones?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getReajusteMarcoComisionEmpresaAgentes(Id, IdEmpresaServicios, IdMarcoComisiones, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de la relación entre un cliente inmobiliario e inmueble dado sus ids.
     * @param {string} Id 
     * @param {string} IdClienteInmobiliario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRelacionClienteInmuebleDetail(Id: string, IdClienteInmobiliario: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRelacionClienteInmuebleDetail(Id, IdClienteInmobiliario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios de backoffice
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getResponsablesSelectorByIdEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getResponsablesSelectorByIdEmpresaAgentes(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de roles del sistema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRolesAll(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRolesAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene un listado de roles del sistema seleccionables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getRolesSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getRolesSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el servicio de energia dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getServicioEndesaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getServicioEndesaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el servicio de energia dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getServicioEnergiaById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getServicioEnergiaById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los servicios de energía para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getServiciosEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getServiciosEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene las ofertas de servicios extras de una empresa servicios y opcionalmente las que ya tiene una operacion asignadas.
     * @param {string} Id 
     * @param {TipoPersonaEnum} TipoPersona 
     * @param {string} [IdOperacion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getServiciosEnergiaOperables(Id: string, TipoPersona: TipoPersonaEnum, IdOperacion?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getServiciosEnergiaOperables(Id, TipoPersona, IdOperacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de subtipos de empresa colaboradora para su uso en un selector.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSubtipoEmpresaColaboradoraSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSubtipoEmpresaColaboradoraSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de Subtipo persona para su uso en un selector.
     * @param {TipoPersonaEnum} [TipoPersona] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSubtipoPersonasSelector(TipoPersona?: TipoPersonaEnum, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSubtipoPersonasSelector(TipoPersona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de los subtipos de ticket a partir de un tipo para su uso en un selector.
     * @param {TipoTicketEnum} [IdTipoTicket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getSubtiposTicketSelectorByIdTipo(IdTipoTicket?: TipoTicketEnum, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getSubtiposTicketSelectorByIdTipo(IdTipoTicket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de las tensiones suministro para su uso en un selector.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTensionSuministroSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTensionSuministroSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle del ticket dado su id.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTicketById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTicketById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de tickets para la grid de DexExtreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTicketsForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTicketsForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el tipo de documento de empresa de servicios dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTipoDocumentoEmpresaServiciosById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTipoDocumentoEmpresaServiciosById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los tipos de documento de empresa de servicios para la grid de Devextreme.
     * @param {string} [IdEmpresaServicios] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTiposDocumentosEmpresaServiciosForGrid(IdEmpresaServicios?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTiposDocumentosEmpresaServiciosForGrid(IdEmpresaServicios, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de los tipos de ticket para su uso en un selector.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTiposTicketSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTiposTicketSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de trámites de energia asociadas a una factura para la subrejilla de factura de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTramitesEnergiaFacturaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTramitesEnergiaFacturaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTramitesEnergiaForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTramitesEnergiaForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el histórico de estados de los trámites de energia.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTramitesEnergiaHistoricoEstados(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTramitesEnergiaHistoricoEstados(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de trámites de energia asociadas a un rappel mensual para la grid del detalle de rappel mensual de Devextreme.
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTramitesEnergiaRappelMensualForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTramitesEnergiaRappelMensualForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
     * @param {string} [IdUsuario] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTramitesForGridColaboradores(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTramitesForGridColaboradores(IdUsuario, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de trámites de energia para la grid de Devextreme.
     * @param {string} [IdUsuario] 
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getTramitesForGridSoporte(IdUsuario?: string, LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getTramitesForGridSoporte(IdUsuario, LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el usuario dado su id
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuarioById(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuarioById(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el perfil del usuario actual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuarioCurrentProfile(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuarioCurrentProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios de backoffice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuariosBackofficeSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuariosBackofficeSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios de backoffice
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuariosBackofficeSelectorByIdTicket(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuariosBackofficeSelectorByIdTicket(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios comerciales (administrador o trabajador)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuariosComercialesSelector(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuariosComercialesSelector(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el listado de usuarios para la grid de DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public getUsuariosForGrid(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).getUsuariosForGrid(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Realiza la importación de bajas de trámites y servicios a patir del fichero de Endesa.
     * @param {boolean} [EsSimulacion] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importEndesaBajasOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importEndesaBajasOperacionEnergia(EsSimulacion, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Realiza la importación de códigos externos Cosmos a partir del fichero de Endesa, cruzando por CUPS y fecha de venta.
     * @param {boolean} [EsSimulacion] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importEndesaCosmosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importEndesaCosmosOperacionEnergia(EsSimulacion, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Realiza la importación de nuevos estados de trámites y servicios a partir del fichero de Endesa.
     * @param {boolean} [EsSimulacion] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importEndesaNuevosEstadosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importEndesaNuevosEstadosOperacionEnergia(EsSimulacion, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Realiza la importación de nuevos estados de trámites a partir del fichero de Naturgy.
     * @param {boolean} [EsSimulacion] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public importNaturgyNuevosEstadosOperacionEnergia(EsSimulacion?: boolean, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).importNaturgyNuevosEstadosOperacionEnergia(EsSimulacion, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envia una solicitud de firma de autorización de tratamiento de datos al cliente inmobiliario.
     * @param {string} Id 
     * @param {IniciarFirmaAutorizacionClienteInmobiliarioModel} [IniciarFirmaAutorizacionClienteInmobiliarioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public iniciarFirmaAutorizacionClienteInmobiliario(Id: string, IniciarFirmaAutorizacionClienteInmobiliarioModel?: IniciarFirmaAutorizacionClienteInmobiliarioModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).iniciarFirmaAutorizacionClienteInmobiliario(Id, IniciarFirmaAutorizacionClienteInmobiliarioModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inicia el proceso de firma de una operación energía desde backoffice.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public iniciarFirmaBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).iniciarFirmaBackofficeOperacionEnergia(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inicia el proceso de firma digital del consentimiento previo.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public iniciarFirmaConsentimientoPrevioOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).iniciarFirmaConsentimientoPrevioOperacionEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inicia el proceso de firma de una operación energía.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public iniciarProcesoFirmaOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).iniciarProcesoFirmaOperacionEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca como incidencia la operación de agua.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public marcarIncidenciaOperacionAgua(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).marcarIncidenciaOperacionAgua(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca una factura en borrador como pendiente de revisión por parte del colaborador.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public markPendingReviewFactura(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).markPendingReviewFactura(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca en curso la operación de agua.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ponerEnCursoOperacionAgua(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ponerEnCursoOperacionAgua(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un documento de empresa de agentes.
     * @param {string} Id 
     * @param {TipoDocumentoEmpresaAgentesEnum} [TipoDocumento] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postDocumentoEmpresaAgentes(Id: string, TipoDocumento?: TipoDocumentoEmpresaAgentesEnum, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postDocumentoEmpresaAgentes(Id, TipoDocumento, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un tipo de documento a la operación de agua.
     * @param {string} Id 
     * @param {string} [IdTipoDocumento] 
     * @param {string} [Descripcion] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postDocumentoOperacionAgua(Id: string, IdTipoDocumento?: string, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postDocumentoOperacionAgua(Id, IdTipoDocumento, Descripcion, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adjunta un tipo de documento a la operación de energía.
     * @param {string} Id 
     * @param {TipoDocumentoOperacionEnergiaEnum} [TipoDocumento] 
     * @param {string} [Descripcion] 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postDocumentoOperacionEnergia(Id: string, TipoDocumento?: TipoDocumentoOperacionEnergiaEnum, Descripcion?: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postDocumentoOperacionEnergia(Id, TipoDocumento, Descripcion, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero de forma temporal.
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public postDocumentoTemp(Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).postDocumentoTemp(Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza el anexo asociado a una oferta de energía.
     * @param {string} Id 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public putAnexoOfertaEnergia(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).putAnexoOfertaEnergia(Id, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza el anexo asociado a un servicio de energía.
     * @param {string} Id 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public putAnexoServicioEnergia(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).putAnexoServicioEnergia(Id, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza el documento de dni asociado a un agente.
     * @param {string} Id 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public putDocumentoAgente(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).putDocumentoAgente(Id, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualiza la factura propia asociada a una factura.
     * @param {string} Id 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public putFacturaPropia(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).putFacturaPropia(Id, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reactiva una empresa de agentes dada de baja
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public reactivateEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).reactivateEmpresaAgentes(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reactiva un usuario dado de baja.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public reactivateUsuario(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).reactivateUsuario(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca como leída las comunicaciones de una operación.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public readComunicacionesOperacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).readComunicacionesOperacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca un comunicado de portal como leído para el colaborador autenticado.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public readComunicadoForColaborador(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).readComunicadoForColaborador(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca como leídos todos los mensajes de un ticket.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public readMensajesTicket(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).readMensajesTicket(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marca una notificación como leída.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public readNotificacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).readNotificacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rechaza una autorización de consentimiento firmada por un cliente inmobiliario.
     * @param {string} Id 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rechazarAutorizacionClienteInmobiliario(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rechazarAutorizacionClienteInmobiliario(Id, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rechaza una operación de energía desde backoffice.
     * @param {string} Id 
     * @param {string} [Comentario] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rechazarBackofficeOperacionEnergia(Id: string, Comentario?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rechazarBackofficeOperacionEnergia(Id, Comentario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rechaza un cierre de ticket.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rejectCloseTicket(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rejectCloseTicket(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rechaza la empresa de agentes
     * @param {string} Id 
     * @param {string} [MotivoRechazo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rejectEmpresaAgentes(Id: string, MotivoRechazo?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rejectEmpresaAgentes(Id, MotivoRechazo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rechaza una factura.
     * @param {string} Id 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rejectFactura(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rejectFactura(Id, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rechaza una factura.
     * @param {string} Id 
     * @param {string} [Body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rejectPendingReviewFactura(Id: string, Body?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rejectPendingReviewFactura(Id, Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancela y reinicia una operación de energía al estado inicial.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public resetOperacionEnergia(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).resetOperacionEnergia(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna al usuario que realiza la petición como responsable de una operacion.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public selfAssignResponsableOperacion(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).selfAssignResponsableOperacion(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asigna al usuario que realiza la petición como responsable de un ticket.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public selfAssignResponsableTicket(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).selfAssignResponsableTicket(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Envía la empresa de agentes para firma
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sendToSignEmpresaAgentes(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sendToSignEmpresaAgentes(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Establece la prioridad de un ticket.
     * @param {string} Id 
     * @param {PrioridadTicketEnum} Prioridad 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public setPrioridadTicket(Id: string, Prioridad: PrioridadTicketEnum, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).setPrioridadTicket(Id, Prioridad, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Liquida una factura.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public settleFactura(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).settleFactura(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Liquida una factura pendiente de revisión por parte del colaborador.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public settlePendingReviewFactura(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).settlePendingReviewFactura(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Simula las comisiones de oferta para una comparación de energía.
     * @param {string} Id 
     * @param {SimularComisionesComparacionEnergiaRequest} [SimularComisionesComparacionEnergiaRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public simularComisionesComparacionEnergia(Id: string, SimularComisionesComparacionEnergiaRequest?: SimularComisionesComparacionEnergiaRequest, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).simularComisionesComparacionEnergia(Id, SimularComisionesComparacionEnergiaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube la autorización firmada de tratamiento de datos de un cliente inmobiliario.
     * @param {string} Id 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public subirAutorizacionClienteInmobiliario(Id: string, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).subirAutorizacionClienteInmobiliario(Id, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un email de usuario está disponible
     * @param {string} Email 
     * @param {string} IdUsuario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioCheckEmail(Email: string, IdUsuario: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioCheckEmail(Email, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un nombre de usuario está disponible
     * @param {string} Username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioCheckUsername(Username: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioCheckUsername(Username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Valida una autorización de consentimiento firmada por un cliente inmobiliario.
     * @param {string} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public validarAutorizacionClienteInmobiliario(Id: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).validarAutorizacionClienteInmobiliario(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Valida si un contacto lead de operación es válido, a partir de los datos de titular.
     * @param {TitularModel} [TitularModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public validateContactoLeadOperacion(TitularModel?: TitularModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).validateContactoLeadOperacion(TitularModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comprueba si el email no se ha usado en otras operaciones asociadas a otros documentos de titular.
     * @param {ValidateEmailTitularModel} [ValidateEmailTitularModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public validateEmailTitular(ValidateEmailTitularModel?: ValidateEmailTitularModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).validateEmailTitular(ValidateEmailTitularModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comprueba si el móvil no se ha usado en otras operaciones asociadas a otros documentos de titular.
     * @param {ValidateMovilTitularModel} [ValidateMovilTitularModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public validateMovilTitular(ValidateMovilTitularModel?: ValidateMovilTitularModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).validateMovilTitular(ValidateMovilTitularModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Webhook para las altas de los contactos Lead.
     * @param {CreateContactoLeadModel} [CreateContactoLeadModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public webhookAltaNuevoContadoLead(CreateContactoLeadModel?: CreateContactoLeadModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).webhookAltaNuevoContadoLead(CreateContactoLeadModel, options).then((request) => request(this.axios, this.basePath));
    }
}



